var Rf = Object.defineProperty, Ff = Object.defineProperties;
var If = Object.getOwnPropertyDescriptors;
var Xr = Object.getOwnPropertySymbols;
var Ws = Object.prototype.hasOwnProperty, Hs = Object.prototype.propertyIsEnumerable;
var ko = (n, r, e) => r in n ? Rf(n, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[r] = e, w = (n, r) => {
  for (var e in r || (r = {}))
    Ws.call(r, e) && ko(n, e, r[e]);
  if (Xr)
    for (var e of Xr(r))
      Hs.call(r, e) && ko(n, e, r[e]);
  return n;
}, E = (n, r) => Ff(n, If(r));
var Re = (n, r) => {
  var e = {};
  for (var t in n)
    Ws.call(n, t) && r.indexOf(t) < 0 && (e[t] = n[t]);
  if (n != null && Xr)
    for (var t of Xr(n))
      r.indexOf(t) < 0 && Hs.call(n, t) && (e[t] = n[t]);
  return e;
};
var B = (n, r, e) => (ko(n, typeof r != "symbol" ? r + "" : r, e), e);
var Ee = (n, r, e) => new Promise((t, a) => {
  var o = (l) => {
    try {
      s(e.next(l));
    } catch (c) {
      a(c);
    }
  }, i = (l) => {
    try {
      s(e.throw(l));
    } catch (c) {
      a(c);
    }
  }, s = (l) => l.done ? t(l.value) : Promise.resolve(l.value).then(o, i);
  s((e = e.apply(n, r)).next());
});
import { g as Lf, a as Yf, l as Pl, b as Wf, d as Hf, c as $f, e as Bf, f as Qf, h as Uf, i as Al, j as Ol, k as Nl, s as sr, B as qf, _ as cn, r as jf, m as Rl, u as zf, n as Te, P as V, o as Fl, p as xn, q as Il, t as Vf, v as Gf, w as Kf, x as Xf, y as xo, z as $s, A as Jf, C as Zf, D as ep, E as Ir, F as tp, G as _t, H as np, I as rp, J as Ll, K as ap, L as op, U as Bs, M as Ye, N as Yl, O as ip, Q as Qs, Y as Us, R as sp, S as Dt, T as mt, V as hn, W as Wl, X as se, Z as ve, $ as qs, a0 as Ei, a1 as cp, a2 as Hl, a3 as lp, a4 as $l, a5 as Bl, a6 as ja, a7 as Ql, a8 as Jr, a9 as up, aa as Mi, ab as Ul, ac as ql, ad as dp, ae as fp, af as pp, ag as hp, ah as mp, ai as jn, aj as gp, ak as yp, al as Z, am as bp, an as Pi, ao as jl, ap as vp, aq as wp, ar as Ai, as as _p, at as js, au as Dp, av as kp, aw as xp, ax as Cp, ay as zl, az as Vl, aA as Tp, aB as Sp, aC as Ep, aD as Mp, aE as za, aF as Gl, aG as Pp, aH as Oi, aI as Ap, aJ as Op, aK as Np, aL as Rp, aM as Kl, aN as Xl, aO as zs, aP as Co, aQ as To, aR as Vs, aS as Jl, aT as Fp, aU as Ip, aV as Zl, aW as eu, aX as Da, aY as Lp, aZ as Yp, a_ as Wp, a$ as ti, b0 as ni, b1 as tu, b2 as Hp, b3 as $p, b4 as Bp, b5 as Qp, b6 as Ze, b7 as et, b8 as Up, b9 as nu, ba as qp } from "./table-widget-CLL1iN3H.js";
import { bd as AT, bj as OT, bk as NT, bc as RT, bh as FT, bg as IT, be as LT, bl as YT, bb as WT, bi as HT, bf as $T } from "./table-widget-CLL1iN3H.js";
import { i as ru, A as au, c as Le, g as jp, a as zp, b as Vp, d as Ni, C as qe, e as Ri, s as Gp, f as Ln, M as Dn, m as ka, T as ne, h as So, j as Gs, k as ou, o as Ks, l as Mn, t as iu, n as su, p as Kp, q as Xp, r as kt, u as Xs, v as xt, w as cu, x as Jp, y as Zp, z as eh, D as ri, B as th, E as Ie, F as Sr, G as Wt, H as Va, I as Lr, J as lu, K as nh, L as rh, N as ah, O as Eo, P as Mo, Q as oh, R as ih, S as Fi, U as sh, V as ch, W as Ii, X as lh, Y as uh, Z as We, _ as dh, $ as fh, a0 as uu, a1 as ph, a2 as hh, a3 as du, a4 as mh, a5 as gh, a6 as yh, a7 as fu, a8 as bh, a9 as vh, aa as Js, ab as wh, ac as _h, ad as Dh, ae as Zs, af as pu, ag as kh, ah as xh, ai as Ch, aj as Th, ak as Sh, al as hu, am as Eh, an as vt, ao as Mh, ap as Ph, aq as Ah, ar as Li, as as xa, at as Oh, au as Nh, av as ec, aw as G, ax as tc, ay as Rh, az as Fh, aA as Ih, aB as Lh, aC as nc, aD as Yh, aE as Wh, aF as Hh, aG as $h, aH as Bh, aI as Qh, aJ as Uh, aK as qh, aL as jh, aM as zh, aN as Mt, aO as rc, aP as Qt, aQ as Ca, aR as mu, aS as gu, aT as yu, aU as bu, aV as vu, aW as Ga, aX as Vh, aY as Yi, aZ as ac, a_ as pt, a$ as Gh, b0 as Kh, b1 as Xh, b2 as Jh, b3 as Zh, b4 as em, b5 as Ta, b6 as tm, b7 as wu, b8 as nm, b9 as rm } from "./get-widget-options-DTIulxC2.js";
import { jsxs as J, jsx as y, Fragment as Zt } from "react/jsx-runtime";
import * as j from "react";
import P, { useState as me, useEffect as ge, useCallback as le, useReducer as Ht, useMemo as pe, useRef as it, createContext as am, useContext as om, forwardRef as im, createRef as Xt, createElement as _u, Component as Me, useLayoutEffect as Du, cloneElement as ku } from "react";
import * as sm from "react-dom";
import cm, { findDOMNode as lm } from "react-dom";
const um = {
  errorPrefix: "[request-error]",
  errors: {
    networkError: "Network error. Probably you forgot to add your domain to 'CORS Allowed Origins' in Sisense Admin Panel -> Security Settings.",
    ssoNotEnabled: "SSO is not enabled on target instance, please choose another authentication method.",
    ssoNoLoginUrl: "Can not fetch login URL on target instance. Check SSO settings.",
    passwordAuthFailed: "$t(errorPrefix) Username and password authentication was not successful. Check credentials.",
    tokenAuthFailed: "$t(errorPrefix) Token authentication was not successful. Check credentials.",
    responseError_onlyStatus: "$t(errorPrefix) Status: {{status}}",
    responseError_withStatusText: "$t(errorPrefix) Status: {{status}} - {{statusText}}"
  }
}, dm = {
  errorPrefix: "[request-error]",
  errors: {
    networkError: "Помилка мережі. Можливо ви забули додати свій домен до «CORS Allowed Origins» в панелі адміністратора Sisense -> Security Settings.",
    ssoNotEnabled: "SSO не ввімкнено на цьому сервері, будь ласка, виберіть інший метод аутентифікації",
    ssoNoLoginUrl: "Неможливо отримати loginUrl з сервера. Перевірте налаштування SSO.",
    passwordAuthFailed: "$t(errorPrefix) Помилка автентифікації за допомогою імені користувача та пароля. Перевірте дані для входу.",
    tokenAuthFailed: "$t(errorPrefix) Помилка автентифікації за допомогою токена. Перевірте дані для входу.",
    responseError_onlyStatus: "$t(errorPrefix) Статус: {{status}}",
    responseError_withStatusText: "$t(errorPrefix) Статус: {{status}} - {{statusText}}"
  }
}, xu = "sdkRestClient", fm = {
  en: um,
  uk: dm
};
function pm() {
  return ru({
    resource: fm,
    language: "en",
    namespace: xu
  });
}
const { i18nextInstance: hm } = pm();
class Yr {
  constructor(r) {
    this._valid = !0, this._authenticating = !1, this._tried = !1, this._result = new Promise((e) => {
      this._resolve = e;
    }), this.type = r;
  }
  isValid() {
    return this._valid;
  }
  invalidate() {
    this._valid = !1;
  }
  authenticate() {
    return this._result;
  }
  isAuthenticating() {
    return this._authenticating;
  }
  authenticated() {
    return this._result;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  applyHeader(r) {
  }
}
const Ka = (n, r) => {
  for (const [e, t] of Object.entries(r))
    Array.isArray(n) ? n.push([e, t]) : typeof n.set == "function" ? n.set(e, t) : n[e] = t;
}, mm = (n, r) => {
  const e = new URL(n);
  for (const [t, a] of Object.entries(r))
    e.searchParams.append(t, a);
  return e.toString().replace(/\/([?&])/, "$1");
}, gm = (n, r) => n === null || r === null;
class ym extends Yr {
  constructor(r, e) {
    super("bearer"), this.bearer = e, this._resolve(!0);
  }
  applyHeader(r) {
    const e = "Bearer " + this.bearer;
    Ka(r, { Authorization: e });
  }
  authenticate() {
    return this._result;
  }
  authenticated() {
    return this._result;
  }
}
function bm(n) {
  return n.type === "bearer";
}
let Pn = class extends au {
  constructor(r, e) {
    super(xu, {
      key: r,
      interpolationOptions: e
    }, hm.t);
  }
  get status() {
    return this.interpolationOptions.status;
  }
};
var vm = function(n, r, e, t) {
  function a(o) {
    return o instanceof e ? o : new e(function(i) {
      i(o);
    });
  }
  return new (e || (e = Promise))(function(o, i) {
    function s(u) {
      try {
        c(t.next(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      try {
        c(t.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function c(u) {
      u.done ? o(u.value) : a(u.value).then(s, l);
    }
    c((t = t.apply(n, r || [])).next());
  });
};
class wm extends Yr {
  constructor(r, e) {
    super("wat"), this.url = `${r}${r.endsWith("/") ? "" : "/"}api/v1/wat/sessionToken`, this.body = `{"webAccessToken": "${e}"}`;
  }
  authenticate() {
    return vm(this, void 0, void 0, function* () {
      if (this._tried)
        return this._result;
      this._tried = !0;
      try {
        this._authenticating = !0;
        const r = yield fetch(this.url, {
          method: "POST",
          headers: {
            accept: "application/json",
            "Content-Type": "application/json"
          },
          body: this.body
        }).catch(Xa);
        if (r.ok) {
          const e = yield r.json();
          this._initialiser = e.initialiser, this._webSessionToken = e.webSessionToken, this._resolve(!0);
        }
      } catch (r) {
        throw new Pn("errors.tokenAuthFailed");
      } finally {
        this._resolve(!1), this._authenticating = !1;
      }
      return this._result;
    });
  }
  applyHeader(r) {
    if (this._webSessionToken && this._initialiser) {
      const e = this._webSessionToken, t = this._initialiser;
      Ka(r, { Authorization: e, Initialiser: t });
    }
  }
}
function Cu(n) {
  return n.type === "wat";
}
var Po = function(n, r, e, t) {
  function a(o) {
    return o instanceof e ? o : new e(function(i) {
      i(o);
    });
  }
  return new (e || (e = Promise))(function(o, i) {
    function s(u) {
      try {
        c(t.next(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      try {
        c(t.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function c(u) {
      u.done ? o(u.value) : a(u.value).then(s, l);
    }
    c((t = t.apply(n, r || [])).next());
  });
};
class _m extends Yr {
  constructor(r, e = !1) {
    super("sso"), this.url = r, this._enableSilentPreAuth = e;
  }
  authenticate(r = !0) {
    var e;
    return Po(this, void 0, void 0, function* () {
      try {
        this._authenticating = !0;
        const { isAuthenticated: t, loginUrl: a } = yield this.checkAuthentication();
        if (t)
          return this._resolve(!0), yield this._result;
        if (this._enableSilentPreAuth && r) {
          yield this.authenticateSilent(a);
          const { isAuthenticated: o } = yield this.checkAuthentication();
          if (o)
            return this._resolve(!0), yield this._result;
        }
        (e = window == null ? void 0 : window.location) === null || e === void 0 || e.replace(a);
      } finally {
        this._resolve(!1), this._authenticating = !1;
      }
      return this._result;
    });
  }
  authenticateSilent(r) {
    return Po(this, void 0, void 0, function* () {
      const e = document.createElement("iframe");
      e.style.display = "none", document.body.appendChild(e), e.src = `${r}?return_to=${window.location.href}`, yield new Promise((t) => {
        e.onload = () => {
          t(!0);
        };
      }), document.body.removeChild(e);
    });
  }
  checkAuthentication() {
    return Po(this, void 0, void 0, function* () {
      const r = `${this.url}${this.url.endsWith("/") ? "" : "/"}api/auth/isauth`, t = yield (yield fetch(r, {
        headers: { Internal: "true" },
        credentials: "include"
      }).catch(Xa)).json();
      if (!t.isAuthenticated) {
        if (!t.ssoEnabled)
          throw new Pn("errors.ssoNotEnabled");
        if (!t.loginUrl)
          throw new Pn("errors.ssoNoLoginUrl");
      }
      return {
        isAuthenticated: t.isAuthenticated,
        loginUrl: `${t.loginUrl}?return_to=${window.location.href}`
      };
    });
  }
}
function Tu(n) {
  return n.type === "sso";
}
function Dm(n) {
  if (!n.ok)
    throw new Pn("errors.responseError", {
      status: n.status.toString(),
      statusText: n.statusText,
      context: n.statusText ? "withStatusText" : "onlyStatus"
    });
  return n;
}
function km(n, r) {
  if (r.invalidate(), Mm(r))
    throw new Pn("errors.passwordAuthFailed");
  if (bm(r) || Cu(r))
    throw new Pn("errors.tokenAuthFailed");
  return Tu(r) && !r.isAuthenticating() && r.authenticate(), n;
}
function xm(n) {
  return n.message === "Failed to fetch" && n.name === "TypeError";
}
function Cm() {
  return Promise.reject(new Pn("errors.networkError"));
}
const Tm = (n) => (r) => r.status === 401 ? km(r, n) : r.ok ? r : Dm(r), Xa = (n) => xm(n) ? Cm() : Promise.reject(n);
var Sm = function(n, r, e, t) {
  function a(o) {
    return o instanceof e ? o : new e(function(i) {
      i(o);
    });
  }
  return new (e || (e = Promise))(function(o, i) {
    function s(u) {
      try {
        c(t.next(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      try {
        c(t.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function c(u) {
      u.done ? o(u.value) : a(u.value).then(s, l);
    }
    c((t = t.apply(n, r || [])).next());
  });
};
class Em extends Yr {
  constructor(r, e, t) {
    super("password"), this._authheader = "", this.url = `${r}${r.endsWith("/") ? "" : "/"}api/v1/authentication/login`;
    const a = encodeURIComponent(e), o = encodeURIComponent(t);
    this.body = `username=${a}&password=${o}`;
  }
  authenticate() {
    return Sm(this, void 0, void 0, function* () {
      if (this._tried)
        return this._result;
      this._tried = !0;
      try {
        this._authenticating = !0;
        const r = yield fetch(this.url, {
          method: "POST",
          headers: {
            accept: "application/json",
            "Content-Type": "application/x-www-form-urlencoded"
          },
          body: this.body
        }).catch(Xa);
        if (r.ok) {
          const e = yield r.json();
          this._authheader = e.access_token;
        }
      } finally {
        this._resolve(!!this._authheader), this._authenticating = !1;
      }
      return this._result;
    });
  }
  applyHeader(r) {
    const e = "Bearer " + this._authheader;
    Ka(r, { Authorization: e });
  }
}
function Mm(n) {
  return n.type === "password";
}
class Pm extends Yr {
  constructor() {
    super("fusion");
  }
  authenticate() {
    var r, e, t, a, o;
    const i = !!(!((e = (r = window.prism) === null || r === void 0 ? void 0 : r.user) === null || e === void 0) && e._id);
    this._resolve(i);
    const s = (o = (a = (t = window.document) === null || t === void 0 ? void 0 : t.cookie) === null || a === void 0 ? void 0 : a.match(/(?:^|;\s*)XSRF-TOKEN=([^;]+)/)) === null || o === void 0 ? void 0 : o[1];
    return s && (this.antiCsrfToken = s), this._result;
  }
  applyHeader(r) {
    this.antiCsrfToken && Ka(r, {
      "X-Xsrf-Token": this.antiCsrfToken
    });
  }
}
function Am({ url: n, username: r, password: e, token: t, wat: a, ssoEnabled: o = !1, enableSilentPreAuth: i = !1, useFusionAuth: s = !1 }) {
  return o ? new _m(n, i) : r && e ? new Em(n, r, e) : t ? new ym(n, t) : a ? new wm(n, a) : s ? new Pm() : null;
}
var Om = function(n, r, e, t) {
  function a(o) {
    return o instanceof e ? o : new e(function(i) {
      i(o);
    });
  }
  return new (e || (e = Promise))(function(o, i) {
    function s(u) {
      try {
        c(t.next(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      try {
        c(t.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function c(u) {
      u.done ? o(u.value) : a(u.value).then(s, l);
    }
    c((t = t.apply(n, r || [])).next());
  });
};
class Nm {
  constructor(r, e, t) {
    r.endsWith("/") || (r += "/"), this.url = r, this.auth = e, this.env = t;
  }
  login() {
    return this.auth.authenticate();
  }
  call(r, e, t) {
    return Om(this, void 0, void 0, function* () {
      this.auth.isAuthenticating() && (yield this.auth.authenticated()), e.headers = e.headers || {}, Tu(this.auth) && (e.credentials = "include"), this.auth.applyHeader(e.headers);
      const a = t != null && t.skipTrackingParam ? r : mm(r, {
        trc: this.env
      }), o = yield fetch(a, e).then(Tm(this.auth)).catch(Xa);
      if (!(o.status === 204 || // No content
      o.status === 304))
        return t != null && t.returnBlob ? o.blob() : o.json().catch((i) => {
          var s, l;
          if (!(!((l = (s = i == null ? void 0 : i.message) === null || s === void 0 ? void 0 : s.includes) === null || l === void 0) && l.call(s, "Unexpected end of JSON input")))
            throw i;
        });
    });
  }
  // eslint-disable-next-line max-params
  post(r, e, t = {}, a, o) {
    const i = Object.assign({ method: "POST", body: o != null && o.nonJSONBody ? e : JSON.stringify(e), headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json;charset=UTF-8"
    }, signal: a }, t);
    return this.call(this.url + r, i, o);
  }
  patch(r, e, t = {}, a, o) {
    const i = Object.assign({ method: "PATCH", body: o != null && o.nonJSONBody ? e : JSON.stringify(e), headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json;charset=UTF-8"
    }, signal: a }, t);
    return this.call(this.url + r, i, o);
  }
  get(r, e = {}, t) {
    return this.call(this.url + r, Object.assign(Object.assign({}, e), { method: "GET" }), t);
  }
  delete(r, e = {}, t) {
    return this.call(this.url + r, Object.assign(Object.assign({}, e), { method: "DELETE" }), t);
  }
}
const Rm = {
  errors: {
    invalidAttribute: "Invalid attribute {{attributeName}}. Hint: attributes for query should be extracted from the data model generated by the CLI tool.",
    noDimensionsOrMeasures: "Neither dimensions nor measures found. Query should have at least one dimension or measure.",
    invalidMeasure: 'Invalid measure "{{measureName}}". Hint: measures for the query can be constructed using the "measureFactory" functions.',
    invalidFilter: 'Invalid filter "{{filterName}}". Hint: filters for the query can be constructed using the "filterFactory" functions.',
    invalidHighlight: 'Invalid highlight "{{highlightName}}". Hint: highlights for the query can be constructed using the "filterFactory" functions.',
    invalidCountNegative: 'Invalid count "{{count}}". Count should be non-negative.',
    invalidOffset: 'Invalid offset "{{offset}}". Offset should be non-negative.',
    missingHttpClient: "Query requires httpClient to work properly.",
    missingPostMethod: 'httpClient must provide "post" method.',
    noJaqlResponse: "No jaql response received from the server",
    dataSourceNotFound: 'Failed to get fields for data source "{{dataSource}}". Please make sure the data source exists and is accessible.'
  }
}, Fm = {
  errors: {
    invalidAttribute: "Недійсний атрибут {{attributeName}}. Підказка: атрибути для запиту повинні бути витягнуті з моделі даних, створеної за допомогою CLI-інструменту.",
    noDimensionsOrMeasures: "Не знайдено ні вимірів, ні показників. Запит повинен мати щонайменше один вимір або показник.",
    invalidMeasure: 'Недійсний показник "{{measureName}}". Підказка: показники для запиту можна створити за допомогою функцій "measureFactory".',
    invalidFilter: 'Недійсний фільтр "{{filterName}}". Підказка: фільтри для запиту можна створити за допомогою функцій "filterFactory".',
    invalidHighlight: 'Недійсне виділення "{{highlightName}}". Підказка: виділення для запиту можна створити за допомогою функцій "filterFactory".',
    invalidCountNegative: `Недійсний count "{{count}}". Count повинен бути не від'ємним.`,
    invalidOffset: `Недійсний offset "{{offset}}". Offset повинен бути не від'ємним.`,
    missingHttpClient: "Для запиту потрібен httpClient, щоб працювати належним чином.",
    missingPostMethod: 'httpClient повинен мати метод "post".',
    noJaqlResponse: "Відповіді, що містить jaql, від сервера не отримано",
    dataSourceNotFound: 'Не вдалося отримати поля для джерела даних "{{dataSource}}". Переконайтесь що джерело існує і доступне.'
  }
}, Su = "sdkQueryClient", Im = {
  en: Rm,
  uk: Fm
};
function Lm() {
  return ru({
    resource: Im,
    language: "en",
    namespace: Su
  });
}
const { i18nextInstance: Ym } = Lm();
var rt = {}, Eu = {}, Ja = {}, Wi = {};
(function(n) {
  var r = Le && Le.__awaiter || function(a, o, i, s) {
    function l(c) {
      return c instanceof i ? c : new i(function(u) {
        u(c);
      });
    }
    return new (i || (i = Promise))(function(c, u) {
      function d(h) {
        try {
          p(s.next(h));
        } catch (m) {
          u(m);
        }
      }
      function f(h) {
        try {
          p(s.throw(h));
        } catch (m) {
          u(m);
        }
      }
      function p(h) {
        h.done ? c(h.value) : l(h.value).then(d, f);
      }
      p((s = s.apply(a, o || [])).next());
    });
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), n.Task = n.ExecutionResultStatus = void 0;
  var e;
  (function(a) {
    a.SUCCESS = "SUCCESS", a.ERROR = "ERROR";
  })(e = n.ExecutionResultStatus || (n.ExecutionResultStatus = {}));
  class t {
    constructor(o, i, s) {
      this.steps = o, this.passport = i, this.addons = s, this.statistics = {
        startTime: /* @__PURE__ */ new Date(),
        steps: [],
        runtimeInfo: {}
      }, this.currentStep = void 0;
    }
    /**
     * Run task
     *
     * @param inputValue
     */
    run(o) {
      return r(this, void 0, void 0, function* () {
        let i = o, s;
        for (let c = 0; c < this.steps.length; c += 1) {
          this.currentStep = this.steps[c];
          const { resultValue: u, info: d } = yield this.currentStep.run(this, i);
          if (this.statistics.steps.push(d), d.success)
            i = u;
          else {
            s = d.error;
            break;
          }
        }
        const l = this.statistics.steps.length === this.steps.length && this.statistics.steps.every((c) => c.success);
        return this.statistics.endTime = /* @__PURE__ */ new Date(), {
          status: l ? e.SUCCESS : e.ERROR,
          error: s,
          result: l ? i : void 0,
          statistics: this.statistics
        };
      });
    }
    /**
     * Cancels task
     *
     * @param reason
     */
    cancel(o) {
      var i;
      return r(this, void 0, void 0, function* () {
        yield (i = this.currentStep) === null || i === void 0 ? void 0 : i.cancel(this, o);
      });
    }
    addRuntimeInfo(o, i) {
      this.statistics.runtimeInfo[o] = i;
    }
    emitAddonEvent(o, ...i) {
      var s;
      const l = o.split("."), c = l[0], u = l[1], d = (s = this.addons) === null || s === void 0 ? void 0 : s.find((p) => p.addonName === c), f = (d == null ? void 0 : d.events)[u];
      f(...i);
    }
  }
  n.Task = t;
})(Wi);
var Ao = Le && Le.__awaiter || function(n, r, e, t) {
  function a(o) {
    return o instanceof e ? o : new e(function(i) {
      i(o);
    });
  }
  return new (e || (e = Promise))(function(o, i) {
    function s(u) {
      try {
        c(t.next(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      try {
        c(t.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function c(u) {
      u.done ? o(u.value) : a(u.value).then(s, l);
    }
    c((t = t.apply(n, r || [])).next());
  });
};
Object.defineProperty(Ja, "__esModule", { value: !0 });
Ja.AbstractTaskManager = void 0;
const Wm = Wi;
class Hm {
  constructor(r) {
    this.runningTasks = /* @__PURE__ */ new Map(), this.addons = r || [];
  }
  runTask(r) {
    return Ao(this, void 0, void 0, function* () {
      const { taskId: e } = r.passport;
      this.runningTasks.set(e, r);
      const t = yield r.run();
      return this.runningTasks.delete(e), t;
    });
  }
  createFlow(r) {
    return (e) => Ao(this, void 0, void 0, function* () {
      const t = new Wm.Task(r, e, this.addons);
      return this.runTask(t);
    });
  }
  cancel(r, e) {
    return Ao(this, void 0, void 0, function* () {
      const t = this.runningTasks.get(r);
      t && (yield t.cancel(e));
    });
  }
}
Ja.AbstractTaskManager = Hm;
var Za = {}, Wr = {};
Object.defineProperty(Wr, "__esModule", { value: !0 });
Wr.TaskCanceledError = void 0;
class $m extends Error {
  constructor(r) {
    const e = `Task was canceled due to: "${r}"`;
    super(e);
  }
}
Wr.TaskCanceledError = $m;
var oc = Le && Le.__awaiter || function(n, r, e, t) {
  function a(o) {
    return o instanceof e ? o : new e(function(i) {
      i(o);
    });
  }
  return new (e || (e = Promise))(function(o, i) {
    function s(u) {
      try {
        c(t.next(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      try {
        c(t.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function c(u) {
      u.done ? o(u.value) : a(u.value).then(s, l);
    }
    c((t = t.apply(n, r || [])).next());
  });
};
Object.defineProperty(Za, "__esModule", { value: !0 });
Za.Step = void 0;
const Bm = Wr;
class Qm {
  constructor(r, e, t) {
    this.taskSelfResolvers = /* @__PURE__ */ new Map(), this.taskStepInfos = /* @__PURE__ */ new Map(), this.name = r, this.runLogic = e, this.cancelLogic = t;
  }
  run(r, e) {
    return oc(this, void 0, void 0, function* () {
      return this.addStepInfo(r, { name: this.name }), new Promise((t) => {
        const a = /* @__PURE__ */ new Date(), o = (i, s) => {
          const l = /* @__PURE__ */ new Date(), c = l.getTime() - a.getTime();
          this.addStepInfo(r, { startTime: a, endTime: l, duration: c }), this.addStepInfo(r, s ? { success: !1, error: s } : { success: !0 }), t({ resultValue: i, info: this.getStepInfo(r) });
        };
        this.taskSelfResolvers.set(r, o), this.runLogic(r, e).then((i) => o(i)).finally(() => {
          this.taskSelfResolvers.delete(r), this.taskStepInfos.delete(r);
        }).catch((i) => o(void 0, i));
      });
    });
  }
  cancel(r, e) {
    return oc(this, void 0, void 0, function* () {
      this.addStepInfo(r, { wasCanceled: !0, cancelingReason: e });
      const t = this.taskSelfResolvers.get(r);
      t == null || t(void 0, new Bm.TaskCanceledError(e)), this.taskSelfResolvers.delete(r), this.taskStepInfos.delete(r), yield this.cancelLogic(r, e);
    });
  }
  addStepInfo(r, e) {
    const t = this.taskStepInfos.get(r) || {}, a = Object.assign(Object.assign({}, t), e);
    this.taskStepInfos.set(r, a);
  }
  getStepInfo(r) {
    return this.taskStepInfos.get(r);
  }
}
Za.Step = Qm;
var eo = {};
Object.defineProperty(eo, "__esModule", { value: !0 });
eo.Addon = void 0;
class Um {
  constructor() {
    this.events = {};
  }
}
eo.Addon = Um;
var to = {}, Zr, qm = new Uint8Array(16);
function Mu() {
  if (!Zr && (Zr = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !Zr))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Zr(qm);
}
const jm = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function no(n) {
  return typeof n == "string" && jm.test(n);
}
var Fe = [];
for (var Oo = 0; Oo < 256; ++Oo)
  Fe.push((Oo + 256).toString(16).substr(1));
function ro(n) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, e = (Fe[n[r + 0]] + Fe[n[r + 1]] + Fe[n[r + 2]] + Fe[n[r + 3]] + "-" + Fe[n[r + 4]] + Fe[n[r + 5]] + "-" + Fe[n[r + 6]] + Fe[n[r + 7]] + "-" + Fe[n[r + 8]] + Fe[n[r + 9]] + "-" + Fe[n[r + 10]] + Fe[n[r + 11]] + Fe[n[r + 12]] + Fe[n[r + 13]] + Fe[n[r + 14]] + Fe[n[r + 15]]).toLowerCase();
  if (!no(e))
    throw TypeError("Stringified UUID is invalid");
  return e;
}
var ic, No, Ro = 0, Fo = 0;
function zm(n, r, e) {
  var t = r && e || 0, a = r || new Array(16);
  n = n || {};
  var o = n.node || ic, i = n.clockseq !== void 0 ? n.clockseq : No;
  if (o == null || i == null) {
    var s = n.random || (n.rng || Mu)();
    o == null && (o = ic = [s[0] | 1, s[1], s[2], s[3], s[4], s[5]]), i == null && (i = No = (s[6] << 8 | s[7]) & 16383);
  }
  var l = n.msecs !== void 0 ? n.msecs : Date.now(), c = n.nsecs !== void 0 ? n.nsecs : Fo + 1, u = l - Ro + (c - Fo) / 1e4;
  if (u < 0 && n.clockseq === void 0 && (i = i + 1 & 16383), (u < 0 || l > Ro) && n.nsecs === void 0 && (c = 0), c >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  Ro = l, Fo = c, No = i, l += 122192928e5;
  var d = ((l & 268435455) * 1e4 + c) % 4294967296;
  a[t++] = d >>> 24 & 255, a[t++] = d >>> 16 & 255, a[t++] = d >>> 8 & 255, a[t++] = d & 255;
  var f = l / 4294967296 * 1e4 & 268435455;
  a[t++] = f >>> 8 & 255, a[t++] = f & 255, a[t++] = f >>> 24 & 15 | 16, a[t++] = f >>> 16 & 255, a[t++] = i >>> 8 | 128, a[t++] = i & 255;
  for (var p = 0; p < 6; ++p)
    a[t + p] = o[p];
  return r || ro(a);
}
function Pu(n) {
  if (!no(n))
    throw TypeError("Invalid UUID");
  var r, e = new Uint8Array(16);
  return e[0] = (r = parseInt(n.slice(0, 8), 16)) >>> 24, e[1] = r >>> 16 & 255, e[2] = r >>> 8 & 255, e[3] = r & 255, e[4] = (r = parseInt(n.slice(9, 13), 16)) >>> 8, e[5] = r & 255, e[6] = (r = parseInt(n.slice(14, 18), 16)) >>> 8, e[7] = r & 255, e[8] = (r = parseInt(n.slice(19, 23), 16)) >>> 8, e[9] = r & 255, e[10] = (r = parseInt(n.slice(24, 36), 16)) / 1099511627776 & 255, e[11] = r / 4294967296 & 255, e[12] = r >>> 24 & 255, e[13] = r >>> 16 & 255, e[14] = r >>> 8 & 255, e[15] = r & 255, e;
}
function Vm(n) {
  n = unescape(encodeURIComponent(n));
  for (var r = [], e = 0; e < n.length; ++e)
    r.push(n.charCodeAt(e));
  return r;
}
var Gm = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", Km = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function Au(n, r, e) {
  function t(a, o, i, s) {
    if (typeof a == "string" && (a = Vm(a)), typeof o == "string" && (o = Pu(o)), o.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var l = new Uint8Array(16 + a.length);
    if (l.set(o), l.set(a, o.length), l = e(l), l[6] = l[6] & 15 | r, l[8] = l[8] & 63 | 128, i) {
      s = s || 0;
      for (var c = 0; c < 16; ++c)
        i[s + c] = l[c];
      return i;
    }
    return ro(l);
  }
  try {
    t.name = n;
  } catch (a) {
  }
  return t.DNS = Gm, t.URL = Km, t;
}
function Xm(n) {
  if (typeof n == "string") {
    var r = unescape(encodeURIComponent(n));
    n = new Uint8Array(r.length);
    for (var e = 0; e < r.length; ++e)
      n[e] = r.charCodeAt(e);
  }
  return Jm(Zm(eg(n), n.length * 8));
}
function Jm(n) {
  for (var r = [], e = n.length * 32, t = "0123456789abcdef", a = 0; a < e; a += 8) {
    var o = n[a >> 5] >>> a % 32 & 255, i = parseInt(t.charAt(o >>> 4 & 15) + t.charAt(o & 15), 16);
    r.push(i);
  }
  return r;
}
function Ou(n) {
  return (n + 64 >>> 9 << 4) + 14 + 1;
}
function Zm(n, r) {
  n[r >> 5] |= 128 << r % 32, n[Ou(r) - 1] = r;
  for (var e = 1732584193, t = -271733879, a = -1732584194, o = 271733878, i = 0; i < n.length; i += 16) {
    var s = e, l = t, c = a, u = o;
    e = $e(e, t, a, o, n[i], 7, -680876936), o = $e(o, e, t, a, n[i + 1], 12, -389564586), a = $e(a, o, e, t, n[i + 2], 17, 606105819), t = $e(t, a, o, e, n[i + 3], 22, -1044525330), e = $e(e, t, a, o, n[i + 4], 7, -176418897), o = $e(o, e, t, a, n[i + 5], 12, 1200080426), a = $e(a, o, e, t, n[i + 6], 17, -1473231341), t = $e(t, a, o, e, n[i + 7], 22, -45705983), e = $e(e, t, a, o, n[i + 8], 7, 1770035416), o = $e(o, e, t, a, n[i + 9], 12, -1958414417), a = $e(a, o, e, t, n[i + 10], 17, -42063), t = $e(t, a, o, e, n[i + 11], 22, -1990404162), e = $e(e, t, a, o, n[i + 12], 7, 1804603682), o = $e(o, e, t, a, n[i + 13], 12, -40341101), a = $e(a, o, e, t, n[i + 14], 17, -1502002290), t = $e(t, a, o, e, n[i + 15], 22, 1236535329), e = Be(e, t, a, o, n[i + 1], 5, -165796510), o = Be(o, e, t, a, n[i + 6], 9, -1069501632), a = Be(a, o, e, t, n[i + 11], 14, 643717713), t = Be(t, a, o, e, n[i], 20, -373897302), e = Be(e, t, a, o, n[i + 5], 5, -701558691), o = Be(o, e, t, a, n[i + 10], 9, 38016083), a = Be(a, o, e, t, n[i + 15], 14, -660478335), t = Be(t, a, o, e, n[i + 4], 20, -405537848), e = Be(e, t, a, o, n[i + 9], 5, 568446438), o = Be(o, e, t, a, n[i + 14], 9, -1019803690), a = Be(a, o, e, t, n[i + 3], 14, -187363961), t = Be(t, a, o, e, n[i + 8], 20, 1163531501), e = Be(e, t, a, o, n[i + 13], 5, -1444681467), o = Be(o, e, t, a, n[i + 2], 9, -51403784), a = Be(a, o, e, t, n[i + 7], 14, 1735328473), t = Be(t, a, o, e, n[i + 12], 20, -1926607734), e = Qe(e, t, a, o, n[i + 5], 4, -378558), o = Qe(o, e, t, a, n[i + 8], 11, -2022574463), a = Qe(a, o, e, t, n[i + 11], 16, 1839030562), t = Qe(t, a, o, e, n[i + 14], 23, -35309556), e = Qe(e, t, a, o, n[i + 1], 4, -1530992060), o = Qe(o, e, t, a, n[i + 4], 11, 1272893353), a = Qe(a, o, e, t, n[i + 7], 16, -155497632), t = Qe(t, a, o, e, n[i + 10], 23, -1094730640), e = Qe(e, t, a, o, n[i + 13], 4, 681279174), o = Qe(o, e, t, a, n[i], 11, -358537222), a = Qe(a, o, e, t, n[i + 3], 16, -722521979), t = Qe(t, a, o, e, n[i + 6], 23, 76029189), e = Qe(e, t, a, o, n[i + 9], 4, -640364487), o = Qe(o, e, t, a, n[i + 12], 11, -421815835), a = Qe(a, o, e, t, n[i + 15], 16, 530742520), t = Qe(t, a, o, e, n[i + 2], 23, -995338651), e = Ue(e, t, a, o, n[i], 6, -198630844), o = Ue(o, e, t, a, n[i + 7], 10, 1126891415), a = Ue(a, o, e, t, n[i + 14], 15, -1416354905), t = Ue(t, a, o, e, n[i + 5], 21, -57434055), e = Ue(e, t, a, o, n[i + 12], 6, 1700485571), o = Ue(o, e, t, a, n[i + 3], 10, -1894986606), a = Ue(a, o, e, t, n[i + 10], 15, -1051523), t = Ue(t, a, o, e, n[i + 1], 21, -2054922799), e = Ue(e, t, a, o, n[i + 8], 6, 1873313359), o = Ue(o, e, t, a, n[i + 15], 10, -30611744), a = Ue(a, o, e, t, n[i + 6], 15, -1560198380), t = Ue(t, a, o, e, n[i + 13], 21, 1309151649), e = Ue(e, t, a, o, n[i + 4], 6, -145523070), o = Ue(o, e, t, a, n[i + 11], 10, -1120210379), a = Ue(a, o, e, t, n[i + 2], 15, 718787259), t = Ue(t, a, o, e, n[i + 9], 21, -343485551), e = an(e, s), t = an(t, l), a = an(a, c), o = an(o, u);
  }
  return [e, t, a, o];
}
function eg(n) {
  if (n.length === 0)
    return [];
  for (var r = n.length * 8, e = new Uint32Array(Ou(r)), t = 0; t < r; t += 8)
    e[t >> 5] |= (n[t / 8] & 255) << t % 32;
  return e;
}
function an(n, r) {
  var e = (n & 65535) + (r & 65535), t = (n >> 16) + (r >> 16) + (e >> 16);
  return t << 16 | e & 65535;
}
function tg(n, r) {
  return n << r | n >>> 32 - r;
}
function ao(n, r, e, t, a, o) {
  return an(tg(an(an(r, n), an(t, o)), a), e);
}
function $e(n, r, e, t, a, o, i) {
  return ao(r & e | ~r & t, n, r, a, o, i);
}
function Be(n, r, e, t, a, o, i) {
  return ao(r & t | e & ~t, n, r, a, o, i);
}
function Qe(n, r, e, t, a, o, i) {
  return ao(r ^ e ^ t, n, r, a, o, i);
}
function Ue(n, r, e, t, a, o, i) {
  return ao(e ^ (r | ~t), n, r, a, o, i);
}
var ng = Au("v3", 48, Xm);
const rg = ng;
function ag(n, r, e) {
  n = n || {};
  var t = n.random || (n.rng || Mu)();
  if (t[6] = t[6] & 15 | 64, t[8] = t[8] & 63 | 128, r) {
    e = e || 0;
    for (var a = 0; a < 16; ++a)
      r[e + a] = t[a];
    return r;
  }
  return ro(t);
}
function og(n, r, e, t) {
  switch (n) {
    case 0:
      return r & e ^ ~r & t;
    case 1:
      return r ^ e ^ t;
    case 2:
      return r & e ^ r & t ^ e & t;
    case 3:
      return r ^ e ^ t;
  }
}
function Io(n, r) {
  return n << r | n >>> 32 - r;
}
function ig(n) {
  var r = [1518500249, 1859775393, 2400959708, 3395469782], e = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof n == "string") {
    var t = unescape(encodeURIComponent(n));
    n = [];
    for (var a = 0; a < t.length; ++a)
      n.push(t.charCodeAt(a));
  } else
    Array.isArray(n) || (n = Array.prototype.slice.call(n));
  n.push(128);
  for (var o = n.length / 4 + 2, i = Math.ceil(o / 16), s = new Array(i), l = 0; l < i; ++l) {
    for (var c = new Uint32Array(16), u = 0; u < 16; ++u)
      c[u] = n[l * 64 + u * 4] << 24 | n[l * 64 + u * 4 + 1] << 16 | n[l * 64 + u * 4 + 2] << 8 | n[l * 64 + u * 4 + 3];
    s[l] = c;
  }
  s[i - 1][14] = (n.length - 1) * 8 / Math.pow(2, 32), s[i - 1][14] = Math.floor(s[i - 1][14]), s[i - 1][15] = (n.length - 1) * 8 & 4294967295;
  for (var d = 0; d < i; ++d) {
    for (var f = new Uint32Array(80), p = 0; p < 16; ++p)
      f[p] = s[d][p];
    for (var h = 16; h < 80; ++h)
      f[h] = Io(f[h - 3] ^ f[h - 8] ^ f[h - 14] ^ f[h - 16], 1);
    for (var m = e[0], g = e[1], b = e[2], v = e[3], D = e[4], k = 0; k < 80; ++k) {
      var x = Math.floor(k / 20), R = Io(m, 5) + og(x, g, b, v) + D + r[x] + f[k] >>> 0;
      D = v, v = b, b = Io(g, 30) >>> 0, g = m, m = R;
    }
    e[0] = e[0] + m >>> 0, e[1] = e[1] + g >>> 0, e[2] = e[2] + b >>> 0, e[3] = e[3] + v >>> 0, e[4] = e[4] + D >>> 0;
  }
  return [e[0] >> 24 & 255, e[0] >> 16 & 255, e[0] >> 8 & 255, e[0] & 255, e[1] >> 24 & 255, e[1] >> 16 & 255, e[1] >> 8 & 255, e[1] & 255, e[2] >> 24 & 255, e[2] >> 16 & 255, e[2] >> 8 & 255, e[2] & 255, e[3] >> 24 & 255, e[3] >> 16 & 255, e[3] >> 8 & 255, e[3] & 255, e[4] >> 24 & 255, e[4] >> 16 & 255, e[4] >> 8 & 255, e[4] & 255];
}
var sg = Au("v5", 80, ig);
const cg = sg, lg = "00000000-0000-0000-0000-000000000000";
function ug(n) {
  if (!no(n))
    throw TypeError("Invalid UUID");
  return parseInt(n.substr(14, 1), 16);
}
const dg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NIL: lg,
  parse: Pu,
  stringify: ro,
  v1: zm,
  v3: rg,
  v4: ag,
  v5: cg,
  validate: no,
  version: ug
}, Symbol.toStringTag, { value: "Module" })), fg = /* @__PURE__ */ jp(dg);
Object.defineProperty(to, "__esModule", { value: !0 });
to.TaskPassport = void 0;
const pg = fg;
class hg {
  constructor() {
    this.taskId = (0, pg.v4)();
  }
}
to.TaskPassport = hg;
(function(n) {
  var r = Le && Le.__createBinding || (Object.create ? function(t, a, o, i) {
    i === void 0 && (i = o);
    var s = Object.getOwnPropertyDescriptor(a, o);
    (!s || ("get" in s ? !a.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
      return a[o];
    } }), Object.defineProperty(t, i, s);
  } : function(t, a, o, i) {
    i === void 0 && (i = o), t[i] = a[o];
  }), e = Le && Le.__exportStar || function(t, a) {
    for (var o in t)
      o !== "default" && !Object.prototype.hasOwnProperty.call(a, o) && r(a, t, o);
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), e(Ja, n), e(Za, n), e(Wi, n), e(eo, n), e(to, n), e(Wr, n);
})(Eu);
(function(n) {
  var r = Le && Le.__createBinding || (Object.create ? function(t, a, o, i) {
    i === void 0 && (i = o);
    var s = Object.getOwnPropertyDescriptor(a, o);
    (!s || ("get" in s ? !a.__esModule : s.writable || s.configurable)) && (s = { enumerable: !0, get: function() {
      return a[o];
    } }), Object.defineProperty(t, i, s);
  } : function(t, a, o, i) {
    i === void 0 && (i = o), t[i] = a[o];
  }), e = Le && Le.__exportStar || function(t, a) {
    for (var o in t)
      o !== "default" && !Object.prototype.hasOwnProperty.call(a, o) && r(a, t, o);
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), e(Eu, n);
})(rt);
const Nu = (n) => {
  if (n !== void 0)
    return `${n}`;
}, Ru = (n) => {
  if (n !== void 0)
    return new Date(n).toISOString();
}, Hi = () => !1;
function sc(n, r) {
  const e = r.filter;
  return "or" in e ? (t) => e.or.map((a) => n(Object.assign(Object.assign({}, r), { filter: a }))).reduce((a, o) => a || o(t), !1) : "and" in e ? (t) => e.and.map((a) => n(Object.assign(Object.assign({}, r), { filter: a }))).reduce((a, o) => a && o(t), !0) : n(r);
}
function mg(n) {
  const { datatype: r } = n, e = n.filter, t = r === "datetime" ? Ru : Nu;
  return (a) => {
    const o = e.members.map(t), i = t(a);
    return o.includes(i);
  };
}
function gg(n) {
  const { datatype: r } = n, e = n.filter, t = r === "datetime" ? Ru : Nu;
  return (a) => {
    var o, i;
    const s = ((i = (o = e.exclude) === null || o === void 0 ? void 0 : o.members) === null || i === void 0 ? void 0 : i.map(t)) || [], l = t(a);
    return !s.includes(l);
  };
}
function yg(n) {
  const r = n.filter, e = Ni(r);
  return e === qe.STARTS_WITH ? (t) => new RegExp(`^${r.startsWith}`, "i").test(t) : e === qe.ENDS_WITH ? (t) => new RegExp(`${r.endsWith}$`, "i").test(t) : e === qe.CONTAINS ? (t) => new RegExp(r.contains, "i").test(t) : e === qe.EQUALS ? (t) => t.localeCompare(r.equals, void 0, {
    sensitivity: "base"
  }) === 0 : e === qe.DOESNT_START_WITH ? (t) => !new RegExp(`^${r.doesntStartWith}`, "i").test(t) : e === qe.DOESNT_END_WITH ? (t) => !new RegExp(`${r.doesntEndWith}$`, "i").test(t) : e === qe.DOESNT_CONTAIN ? (t) => !new RegExp(r.doesntContain, "i").test(t) : e === qe.DOESNT_EQUAL ? (t) => t.localeCompare(r.doesntEqual, void 0, {
    sensitivity: "base"
  }) !== 0 : Hi;
}
function bg(n) {
  const r = n.filter, e = Ni(r);
  return e === qe.EQUALS ? (t) => Number(r.equals) === Number(t) : e === qe.DOESNT_EQUAL ? (t) => Number(r.doesntEqual) !== Number(t) : e === qe.LESS_THAN ? (t) => Number(t) < Number(r.toNotEqual) : e === qe.GREATER_THAN ? (t) => Number(t) > Number(r.fromNotEqual) : e === qe.BETWEEN ? (t) => Number(r.to) >= Number(t) && Number(t) >= Number(r.from) : e === qe.GREATER_THAN_OR_EQUAL ? (t) => Number(t) >= Number(r.from) : e === qe.LESS_THAN_OR_EQUAL ? (t) => Number(r.to) >= Number(t) : Hi;
}
function vg(n) {
  const r = n, { datatype: e } = r, t = r.filter;
  return zp(t) ? mg(r) : Vp(t) && Ni(t) === qe.IS_NOT ? gg(r) : e === "text" ? sc(yg, r) : e === "numeric" ? sc(bg, r) : Hi;
}
var Fu = { exports: {} };
/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */
(function(n) {
  (function(r, e) {
    n.exports ? n.exports = e() : r.numeral = e();
  })(Le, function() {
    var r, e, t = "2.0.6", a = {}, o = {}, i = {
      currentLocale: "en",
      zeroFormat: null,
      nullFormat: null,
      defaultFormat: "0,0",
      scalePercentBy100: !0
    }, s = {
      currentLocale: i.currentLocale,
      zeroFormat: i.zeroFormat,
      nullFormat: i.nullFormat,
      defaultFormat: i.defaultFormat,
      scalePercentBy100: i.scalePercentBy100
    };
    function l(c, u) {
      this._input = c, this._value = u;
    }
    return r = function(c) {
      var u, d, f, p;
      if (r.isNumeral(c))
        u = c.value();
      else if (c === 0 || typeof c == "undefined")
        u = 0;
      else if (c === null || e.isNaN(c))
        u = null;
      else if (typeof c == "string")
        if (s.zeroFormat && c === s.zeroFormat)
          u = 0;
        else if (s.nullFormat && c === s.nullFormat || !c.replace(/[^0-9]+/g, "").length)
          u = null;
        else {
          for (d in a)
            if (p = typeof a[d].regexps.unformat == "function" ? a[d].regexps.unformat() : a[d].regexps.unformat, p && c.match(p)) {
              f = a[d].unformat;
              break;
            }
          f = f || r._.stringToNumber, u = f(c);
        }
      else
        u = Number(c) || null;
      return new l(c, u);
    }, r.version = t, r.isNumeral = function(c) {
      return c instanceof l;
    }, r._ = e = {
      // formats numbers separators, decimals places, signs, abbreviations
      numberToFormat: function(c, u, d) {
        var f = o[r.options.currentLocale], p = !1, h = !1, m = 0, g = "", b = 1e12, v = 1e9, D = 1e6, k = 1e3, x = "", R = !1, I, L, A, W, O, U, $;
        if (c = c || 0, L = Math.abs(c), r._.includes(u, "(") ? (p = !0, u = u.replace(/[\(|\)]/g, "")) : (r._.includes(u, "+") || r._.includes(u, "-")) && (O = r._.includes(u, "+") ? u.indexOf("+") : c < 0 ? u.indexOf("-") : -1, u = u.replace(/[\+|\-]/g, "")), r._.includes(u, "a") && (I = u.match(/a(k|m|b|t)?/), I = I ? I[1] : !1, r._.includes(u, " a") && (g = " "), u = u.replace(new RegExp(g + "a[kmbt]?"), ""), L >= b && !I || I === "t" ? (g += f.abbreviations.trillion, c = c / b) : L < b && L >= v && !I || I === "b" ? (g += f.abbreviations.billion, c = c / v) : L < v && L >= D && !I || I === "m" ? (g += f.abbreviations.million, c = c / D) : (L < D && L >= k && !I || I === "k") && (g += f.abbreviations.thousand, c = c / k)), r._.includes(u, "[.]") && (h = !0, u = u.replace("[.]", ".")), A = c.toString().split(".")[0], W = u.split(".")[1], U = u.indexOf(","), m = (u.split(".")[0].split(",")[0].match(/0/g) || []).length, W ? (r._.includes(W, "[") ? (W = W.replace("]", ""), W = W.split("["), x = r._.toFixed(c, W[0].length + W[1].length, d, W[1].length)) : x = r._.toFixed(c, W.length, d), A = x.split(".")[0], r._.includes(x, ".") ? x = f.delimiters.decimal + x.split(".")[1] : x = "", h && Number(x.slice(1)) === 0 && (x = "")) : A = r._.toFixed(c, 0, d), g && !I && Number(A) >= 1e3 && g !== f.abbreviations.trillion)
          switch (A = String(Number(A) / 1e3), g) {
            case f.abbreviations.thousand:
              g = f.abbreviations.million;
              break;
            case f.abbreviations.million:
              g = f.abbreviations.billion;
              break;
            case f.abbreviations.billion:
              g = f.abbreviations.trillion;
              break;
          }
        if (r._.includes(A, "-") && (A = A.slice(1), R = !0), A.length < m)
          for (var N = m - A.length; N > 0; N--)
            A = "0" + A;
        return U > -1 && (A = A.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + f.delimiters.thousands)), u.indexOf(".") === 0 && (A = ""), $ = A + x + (g || ""), p ? $ = (p && R ? "(" : "") + $ + (p && R ? ")" : "") : O >= 0 ? $ = O === 0 ? (R ? "-" : "+") + $ : $ + (R ? "-" : "+") : R && ($ = "-" + $), $;
      },
      // unformats numbers separators, decimals places, signs, abbreviations
      stringToNumber: function(c) {
        var u = o[s.currentLocale], d = c, f = {
          thousand: 3,
          million: 6,
          billion: 9,
          trillion: 12
        }, p, h, m;
        if (s.zeroFormat && c === s.zeroFormat)
          h = 0;
        else if (s.nullFormat && c === s.nullFormat || !c.replace(/[^0-9]+/g, "").length)
          h = null;
        else {
          h = 1, u.delimiters.decimal !== "." && (c = c.replace(/\./g, "").replace(u.delimiters.decimal, "."));
          for (p in f)
            if (m = new RegExp("[^a-zA-Z]" + u.abbreviations[p] + "(?:\\)|(\\" + u.currency.symbol + ")?(?:\\))?)?$"), d.match(m)) {
              h *= Math.pow(10, f[p]);
              break;
            }
          h *= (c.split("-").length + Math.min(c.split("(").length - 1, c.split(")").length - 1)) % 2 ? 1 : -1, c = c.replace(/[^0-9\.]+/g, ""), h *= Number(c);
        }
        return h;
      },
      isNaN: function(c) {
        return typeof c == "number" && isNaN(c);
      },
      includes: function(c, u) {
        return c.indexOf(u) !== -1;
      },
      insert: function(c, u, d) {
        return c.slice(0, d) + u + c.slice(d);
      },
      reduce: function(c, u) {
        if (this === null)
          throw new TypeError("Array.prototype.reduce called on null or undefined");
        if (typeof u != "function")
          throw new TypeError(u + " is not a function");
        var d = Object(c), f = d.length >>> 0, p = 0, h;
        if (arguments.length === 3)
          h = arguments[2];
        else {
          for (; p < f && !(p in d); )
            p++;
          if (p >= f)
            throw new TypeError("Reduce of empty array with no initial value");
          h = d[p++];
        }
        for (; p < f; p++)
          p in d && (h = u(h, d[p], p, d));
        return h;
      },
      /**
       * Computes the multiplier necessary to make x >= 1,
       * effectively eliminating miscalculations caused by
       * finite precision.
       */
      multiplier: function(c) {
        var u = c.toString().split(".");
        return u.length < 2 ? 1 : Math.pow(10, u[1].length);
      },
      /**
       * Given a variable number of arguments, returns the maximum
       * multiplier that must be used to normalize an operation involving
       * all of them.
       */
      correctionFactor: function() {
        var c = Array.prototype.slice.call(arguments);
        return c.reduce(function(u, d) {
          var f = e.multiplier(d);
          return u > f ? u : f;
        }, 1);
      },
      /**
       * Implementation of toFixed() that treats floats more like decimals
       *
       * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
       * problems for accounting- and finance-related software.
       */
      toFixed: function(c, u, d, f) {
        var p = c.toString().split("."), h = u - (f || 0), m, g, b, v;
        return p.length === 2 ? m = Math.min(Math.max(p[1].length, h), u) : m = h, b = Math.pow(10, m), v = (d(c + "e+" + m) / b).toFixed(m), f > u - m && (g = new RegExp("\\.?0{1," + (f - (u - m)) + "}$"), v = v.replace(g, "")), v;
      }
    }, r.options = s, r.formats = a, r.locales = o, r.locale = function(c) {
      return c && (s.currentLocale = c.toLowerCase()), s.currentLocale;
    }, r.localeData = function(c) {
      if (!c)
        return o[s.currentLocale];
      if (c = c.toLowerCase(), !o[c])
        throw new Error("Unknown locale : " + c);
      return o[c];
    }, r.reset = function() {
      for (var c in i)
        s[c] = i[c];
    }, r.zeroFormat = function(c) {
      s.zeroFormat = typeof c == "string" ? c : null;
    }, r.nullFormat = function(c) {
      s.nullFormat = typeof c == "string" ? c : null;
    }, r.defaultFormat = function(c) {
      s.defaultFormat = typeof c == "string" ? c : "0.0";
    }, r.register = function(c, u, d) {
      if (u = u.toLowerCase(), this[c + "s"][u])
        throw new TypeError(u + " " + c + " already registered.");
      return this[c + "s"][u] = d, d;
    }, r.validate = function(c, u) {
      var d, f, p, h, m, g, b, v;
      if (typeof c != "string" && (c += "", console.warn && console.warn("Numeral.js: Value is not string. It has been co-erced to: ", c)), c = c.trim(), c.match(/^\d+$/))
        return !0;
      if (c === "")
        return !1;
      try {
        b = r.localeData(u);
      } catch (D) {
        b = r.localeData(r.locale());
      }
      return p = b.currency.symbol, m = b.abbreviations, d = b.delimiters.decimal, b.delimiters.thousands === "." ? f = "\\." : f = b.delimiters.thousands, v = c.match(/^[^\d]+/), v !== null && (c = c.substr(1), v[0] !== p) || (v = c.match(/[^\d]+$/), v !== null && (c = c.slice(0, -1), v[0] !== m.thousand && v[0] !== m.million && v[0] !== m.billion && v[0] !== m.trillion)) ? !1 : (g = new RegExp(f + "{2}"), c.match(/[^\d.,]/g) ? !1 : (h = c.split(d), h.length > 2 ? !1 : h.length < 2 ? !!h[0].match(/^\d+.*\d$/) && !h[0].match(g) : h[0].length === 1 ? !!h[0].match(/^\d+$/) && !h[0].match(g) && !!h[1].match(/^\d+$/) : !!h[0].match(/^\d+.*\d$/) && !h[0].match(g) && !!h[1].match(/^\d+$/)));
    }, r.fn = l.prototype = {
      clone: function() {
        return r(this);
      },
      format: function(c, u) {
        var d = this._value, f = c || s.defaultFormat, p, h, m;
        if (u = u || Math.round, d === 0 && s.zeroFormat !== null)
          h = s.zeroFormat;
        else if (d === null && s.nullFormat !== null)
          h = s.nullFormat;
        else {
          for (p in a)
            if (f.match(a[p].regexps.format)) {
              m = a[p].format;
              break;
            }
          m = m || r._.numberToFormat, h = m(d, f, u);
        }
        return h;
      },
      value: function() {
        return this._value;
      },
      input: function() {
        return this._input;
      },
      set: function(c) {
        return this._value = Number(c), this;
      },
      add: function(c) {
        var u = e.correctionFactor.call(null, this._value, c);
        function d(f, p, h, m) {
          return f + Math.round(u * p);
        }
        return this._value = e.reduce([this._value, c], d, 0) / u, this;
      },
      subtract: function(c) {
        var u = e.correctionFactor.call(null, this._value, c);
        function d(f, p, h, m) {
          return f - Math.round(u * p);
        }
        return this._value = e.reduce([c], d, Math.round(this._value * u)) / u, this;
      },
      multiply: function(c) {
        function u(d, f, p, h) {
          var m = e.correctionFactor(d, f);
          return Math.round(d * m) * Math.round(f * m) / Math.round(m * m);
        }
        return this._value = e.reduce([this._value, c], u, 1), this;
      },
      divide: function(c) {
        function u(d, f, p, h) {
          var m = e.correctionFactor(d, f);
          return Math.round(d * m) / Math.round(f * m);
        }
        return this._value = e.reduce([this._value, c], u), this;
      },
      difference: function(c) {
        return Math.abs(r(this._value).subtract(c).value());
      }
    }, r.register("locale", "en", {
      delimiters: {
        thousands: ",",
        decimal: "."
      },
      abbreviations: {
        thousand: "k",
        million: "m",
        billion: "b",
        trillion: "t"
      },
      ordinal: function(c) {
        var u = c % 10;
        return ~~(c % 100 / 10) === 1 ? "th" : u === 1 ? "st" : u === 2 ? "nd" : u === 3 ? "rd" : "th";
      },
      currency: {
        symbol: "$"
      }
    }), function() {
      r.register("format", "bps", {
        regexps: {
          format: /(BPS)/,
          unformat: /(BPS)/
        },
        format: function(c, u, d) {
          var f = r._.includes(u, " BPS") ? " " : "", p;
          return c = c * 1e4, u = u.replace(/\s?BPS/, ""), p = r._.numberToFormat(c, u, d), r._.includes(p, ")") ? (p = p.split(""), p.splice(-1, 0, f + "BPS"), p = p.join("")) : p = p + f + "BPS", p;
        },
        unformat: function(c) {
          return +(r._.stringToNumber(c) * 1e-4).toFixed(15);
        }
      });
    }(), function() {
      var c = {
        base: 1e3,
        suffixes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
      }, u = {
        base: 1024,
        suffixes: ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
      }, d = c.suffixes.concat(u.suffixes.filter(function(p) {
        return c.suffixes.indexOf(p) < 0;
      })), f = d.join("|");
      f = "(" + f.replace("B", "B(?!PS)") + ")", r.register("format", "bytes", {
        regexps: {
          format: /([0\s]i?b)/,
          unformat: new RegExp(f)
        },
        format: function(p, h, m) {
          var g, b = r._.includes(h, "ib") ? u : c, v = r._.includes(h, " b") || r._.includes(h, " ib") ? " " : "", D, k, x;
          for (h = h.replace(/\s?i?b/, ""), D = 0; D <= b.suffixes.length; D++)
            if (k = Math.pow(b.base, D), x = Math.pow(b.base, D + 1), p === null || p === 0 || p >= k && p < x) {
              v += b.suffixes[D], k > 0 && (p = p / k);
              break;
            }
          return g = r._.numberToFormat(p, h, m), g + v;
        },
        unformat: function(p) {
          var h = r._.stringToNumber(p), m, g;
          if (h) {
            for (m = c.suffixes.length - 1; m >= 0; m--) {
              if (r._.includes(p, c.suffixes[m])) {
                g = Math.pow(c.base, m);
                break;
              }
              if (r._.includes(p, u.suffixes[m])) {
                g = Math.pow(u.base, m);
                break;
              }
            }
            h *= g || 1;
          }
          return h;
        }
      });
    }(), function() {
      r.register("format", "currency", {
        regexps: {
          format: /(\$)/
        },
        format: function(c, u, d) {
          var f = r.locales[r.options.currentLocale], p = {
            before: u.match(/^([\+|\-|\(|\s|\$]*)/)[0],
            after: u.match(/([\+|\-|\)|\s|\$]*)$/)[0]
          }, h, m, g;
          for (u = u.replace(/\s?\$\s?/, ""), h = r._.numberToFormat(c, u, d), c >= 0 ? (p.before = p.before.replace(/[\-\(]/, ""), p.after = p.after.replace(/[\-\)]/, "")) : c < 0 && !r._.includes(p.before, "-") && !r._.includes(p.before, "(") && (p.before = "-" + p.before), g = 0; g < p.before.length; g++)
            switch (m = p.before[g], m) {
              case "$":
                h = r._.insert(h, f.currency.symbol, g);
                break;
              case " ":
                h = r._.insert(h, " ", g + f.currency.symbol.length - 1);
                break;
            }
          for (g = p.after.length - 1; g >= 0; g--)
            switch (m = p.after[g], m) {
              case "$":
                h = g === p.after.length - 1 ? h + f.currency.symbol : r._.insert(h, f.currency.symbol, -(p.after.length - (1 + g)));
                break;
              case " ":
                h = g === p.after.length - 1 ? h + " " : r._.insert(h, " ", -(p.after.length - (1 + g) + f.currency.symbol.length - 1));
                break;
            }
          return h;
        }
      });
    }(), function() {
      r.register("format", "exponential", {
        regexps: {
          format: /(e\+|e-)/,
          unformat: /(e\+|e-)/
        },
        format: function(c, u, d) {
          var f, p = typeof c == "number" && !r._.isNaN(c) ? c.toExponential() : "0e+0", h = p.split("e");
          return u = u.replace(/e[\+|\-]{1}0/, ""), f = r._.numberToFormat(Number(h[0]), u, d), f + "e" + h[1];
        },
        unformat: function(c) {
          var u = r._.includes(c, "e+") ? c.split("e+") : c.split("e-"), d = Number(u[0]), f = Number(u[1]);
          f = r._.includes(c, "e-") ? f *= -1 : f;
          function p(h, m, g, b) {
            var v = r._.correctionFactor(h, m), D = h * v * (m * v) / (v * v);
            return D;
          }
          return r._.reduce([d, Math.pow(10, f)], p, 1);
        }
      });
    }(), function() {
      r.register("format", "ordinal", {
        regexps: {
          format: /(o)/
        },
        format: function(c, u, d) {
          var f = r.locales[r.options.currentLocale], p, h = r._.includes(u, " o") ? " " : "";
          return u = u.replace(/\s?o/, ""), h += f.ordinal(c), p = r._.numberToFormat(c, u, d), p + h;
        }
      });
    }(), function() {
      r.register("format", "percentage", {
        regexps: {
          format: /(%)/,
          unformat: /(%)/
        },
        format: function(c, u, d) {
          var f = r._.includes(u, " %") ? " " : "", p;
          return r.options.scalePercentBy100 && (c = c * 100), u = u.replace(/\s?\%/, ""), p = r._.numberToFormat(c, u, d), r._.includes(p, ")") ? (p = p.split(""), p.splice(-1, 0, f + "%"), p = p.join("")) : p = p + f + "%", p;
        },
        unformat: function(c) {
          var u = r._.stringToNumber(c);
          return r.options.scalePercentBy100 ? u * 0.01 : u;
        }
      });
    }(), function() {
      r.register("format", "time", {
        regexps: {
          format: /(:)/,
          unformat: /(:)/
        },
        format: function(c, u, d) {
          var f = Math.floor(c / 60 / 60), p = Math.floor((c - f * 60 * 60) / 60), h = Math.round(c - f * 60 * 60 - p * 60);
          return f + ":" + (p < 10 ? "0" + p : p) + ":" + (h < 10 ? "0" + h : h);
        },
        unformat: function(c) {
          var u = c.split(":"), d = 0;
          return u.length === 3 ? (d = d + Number(u[0]) * 60 * 60, d = d + Number(u[1]) * 60, d = d + Number(u[2])) : u.length === 2 && (d = d + Number(u[0]) * 60, d = d + Number(u[1])), Number(d);
        }
      });
    }(), r;
  });
})(Fu);
var wg = Fu.exports;
const _g = /* @__PURE__ */ Ri(wg), Dg = (n, r) => {
  const e = Cg(n);
  return kg(e, r);
};
function kg(n, r) {
  return {
    columns: r == null ? void 0 : r.map((e) => ({
      name: e.name,
      type: Gp(e.type)
    })),
    rows: xg(n)
  };
}
function xg(n) {
  var r;
  let e = !1;
  const t = (r = n[0]) === null || r === void 0 ? void 0 : r.map((a, o) => {
    const i = n.some((s) => "selected" in s[o]);
    return i && (e = !0), i;
  });
  return n.map((a) => {
    const o = e ? t.some((i, s) => i && !a[s].selected) : void 0;
    return a.map((i) => o !== void 0 ? {
      data: i.data,
      text: i.text,
      blur: o
    } : { data: i.data, text: i.text });
  });
}
function Cg({ values: n = [], metadata: r = [] }) {
  var e, t, a, o;
  n[0] && !Array.isArray(n[0]) && (n = [n]);
  for (let i = 0; i < n.length; i++) {
    const s = n[i];
    for (let l = 0; l < s.length; l++)
      r[l].format && (!((t = (e = r[l]) === null || e === void 0 ? void 0 : e.format) === null || t === void 0) && t.number) && (s[l].text = _g(s[l].data).format((o = (a = r[l]) === null || a === void 0 ? void 0 : a.format) === null || o === void 0 ? void 0 : o.number));
  }
  return n;
}
class je extends au {
  constructor(r, e) {
    super(Su, {
      key: r,
      interpolationOptions: e
    }, Ym.t);
  }
  get status() {
    return this.interpolationOptions.status;
  }
}
var bn = function(n, r, e, t) {
  function a(o) {
    return o instanceof e ? o : new e(function(i) {
      i(o);
    });
  }
  return new (e || (e = Promise))(function(o, i) {
    function s(u) {
      try {
        c(t.next(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      try {
        c(t.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function c(u) {
      u.done ? o(u.value) : a(u.value).then(s, l);
    }
    c((t = t.apply(n, r || [])).next());
  });
};
class Tg extends rt.AbstractTaskManager {
  constructor(r, e) {
    super(), this.sentRequestsAbortersMap = /* @__PURE__ */ new Map(), this.executeQuerySending = super.createFlow([
      new rt.Step("PREPARE_JAQL_PAYLOAD", this.prepareJaqlPayload.bind(this), () => bn(this, void 0, void 0, function* () {
      })),
      new rt.Step("SEND_JAQL_QUERY", this.sendJaqlQuery.bind(this), this.cancelDataRetrievalQuery.bind(this))
    ]), this.executeDownloadCsvSending = super.createFlow([
      new rt.Step("PREPARE_JAQL_PAYLOAD", this.prepareJaqlPayload.bind(this), () => bn(this, void 0, void 0, function* () {
      })),
      new rt.Step("SEND_DOWNLOAD_CSV_QUERY", this.sendCsvQuery.bind(this), this.cancelDataRetrievalQuery.bind(this))
    ]), this.executePivotQuerySending = super.createFlow([
      new rt.Step("PREPARE_JAQL_PAYLOAD", this.preparePivotJaqlPayload.bind(this), () => bn(this, void 0, void 0, function* () {
      })),
      new rt.Step("SEND_JAQL_QUERY", this.sendPivotJaqlQuery.bind(this), this.cancelPivotJaqlQuery.bind(this))
    ]), this.queryApi = r, this.pivotClient = e;
  }
  prepareJaqlPayload(r) {
    return bn(this, void 0, void 0, function* () {
      const { queryDescription: e, executionConfig: t } = r.passport, a = Lf(e, t.shouldSkipHighlightsWithoutAttributes), o = r.passport.executionConfig.onBeforeQuery;
      return o ? o(a) : a;
    });
  }
  sendJaqlQuery(r, e) {
    return bn(this, void 0, void 0, function* () {
      const { queryDescription: t, taskId: a } = r.passport, { responsePromise: o, abortHttpRequest: i } = this.queryApi.sendJaqlRequest(r.passport.queryDescription.dataSource, e);
      this.sentRequestsAbortersMap.set(a, i);
      const s = yield o.finally(() => {
        this.sentRequestsAbortersMap.delete(a);
      });
      Sg(s);
      const l = [...t.attributes, ...t.measures], c = (s.headers || []).slice(l.length).map((u) => ({ name: u, type: "number" }));
      return Dg(s, [...l, ...c]);
    });
  }
  sendCsvQuery(r, e) {
    return bn(this, void 0, void 0, function* () {
      const { taskId: t } = r.passport, { responsePromise: a, abortHttpRequest: o } = this.queryApi.sendDownloadCsvRequest(r.passport.queryDescription.dataSource, e);
      return this.sentRequestsAbortersMap.set(t, o), a.finally(() => {
        this.sentRequestsAbortersMap.delete(t);
      });
    });
  }
  cancelDataRetrievalQuery(r) {
    const e = r.passport.taskId, t = this.sentRequestsAbortersMap.get(e);
    return t && (t(), this.sentRequestsAbortersMap.delete(e)), this.queryApi.sendCancelJaqlQueryRequest(e, r.passport.queryDescription.dataSource);
  }
  /**
   * Prepares the JAQL payload for the pivot query
   *
   * @param task
   * @returns JAQL payload
   */
  preparePivotJaqlPayload(r) {
    return bn(this, void 0, void 0, function* () {
      const { pivotQueryDescription: e, executionConfig: t } = r.passport, a = Yf(e, t.shouldSkipHighlightsWithoutAttributes), o = r.passport.executionConfig.onBeforeQuery;
      return o ? o(a) : a;
    });
  }
  /**
   * Executes the pivot query and returns the result
   *
   * @param task
   * @param jaqlPayload
   */
  sendPivotJaqlQuery(r, e) {
    var t;
    const { pivotQueryDescription: a } = r.passport;
    return this.pivotClient.queryData(e, !0, (t = a.count) !== null && t !== void 0 ? t : Fg, !1);
  }
  cancelPivotJaqlQuery(r) {
    const e = r.passport.taskId, t = this.sentRequestsAbortersMap.get(e);
    return t && (t(), this.sentRequestsAbortersMap.delete(e)), this.queryApi.sendCancelJaqlQueryRequest(e, r.passport.pivotQueryDescription.dataSource);
  }
}
function Sg(n) {
  var r;
  if (!n)
    throw new je("errors.noJaqlResponse");
  if (n.error)
    throw new Error(`${n.details} ${(r = n.database) !== null && r !== void 0 ? r : ""} ${n.extraDetails ? JSON.stringify(n.extraDetails) : ""}`);
}
class cc extends rt.TaskPassport {
  constructor(r, e, t) {
    super(), this.queryDescription = e, this.type = r, this.executionConfig = t;
  }
}
class Eg extends rt.TaskPassport {
  constructor(r, e, t) {
    super(), this.pivotQueryDescription = e, this.type = r, this.executionConfig = t;
  }
}
var Mg = function(n, r, e, t) {
  function a(o) {
    return o instanceof e ? o : new e(function(i) {
      i(o);
    });
  }
  return new (e || (e = Promise))(function(o, i) {
    function s(u) {
      try {
        c(t.next(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      try {
        c(t.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function c(u) {
      u.done ? o(u.value) : a(u.value).then(s, l);
    }
    c((t = t.apply(n, r || [])).next());
  });
};
const Er = "api/datasources", Pg = "api/v2/datamodels";
class Ag {
  constructor(r) {
    this.httpClient = r;
  }
  getDataSourceFields(r, e = 9999, t = 0) {
    const a = Ln(r), o = `${Er}/${encodeURI(a)}/fields/search`;
    return this.httpClient.post(o, { offset: t, count: e }).catch(() => {
      throw new je("errors.dataSourceNotFound", {
        dataSource: typeof r == "string" ? r : r.title
      });
    });
  }
  /**
   * Returns a list of data sources.
   * This method works with user of viewer role or above.
   */
  getDataSourceList() {
    const r = `${Er}/?sharedWith=r,w`;
    return this.httpClient.get(r);
  }
  /**
   * Returns the schema of a data source by its name.
   */
  getDataSourceSchema(r) {
    const e = `${Pg}/schema?title=${encodeURIComponent(r)}`;
    return this.httpClient.get(e);
  }
  sendJaqlRequest(r, e) {
    const t = Iu(r), a = new AbortController();
    return {
      responsePromise: this.httpClient.post(t, e, void 0, a.signal).then((o) => Array.isArray(o) ? {
        values: [],
        metadata: []
      } : o),
      abortHttpRequest: (o) => a.abort(o)
    };
  }
  sendDownloadCsvRequest(r, e) {
    const t = Rg(r), a = new AbortController(), o = new URLSearchParams();
    return o.append("data", encodeURIComponent(JSON.stringify(e))), {
      responsePromise: this.httpClient.post(t, o, { headers: { "Content-Type": "application/x-www-form-urlencoded" } }, a.signal, { nonJSONBody: !0, returnBlob: !0 }),
      abortHttpRequest: (i) => a.abort(i)
    };
  }
  /**
   * Sends a request to cancel a JAQL query.
   *
   * @param guid - The guid of the query to cancel.
   * @param dataSource - The datasource of where query sent.
   */
  sendCancelJaqlQueryRequest(r, e) {
    return this.sendCancelMultipleJaqlQueriesRequest([r], e);
  }
  /**
   * Sends a request to cancel multiple JAQL queries.
   *
   * @param guids - The guids of the queries to cancel.
   * @param dataSource - The datasource of where queries sent.
   */
  sendCancelMultipleJaqlQueriesRequest(r, e) {
    return Mg(this, void 0, void 0, function* () {
      const t = {
        queries: r.join(";")
      }, a = Og(e);
      try {
        yield this.httpClient.post(a, t);
      } catch (o) {
        if (o.status === "404") {
          const i = Ng(e);
          yield this.httpClient.post(i, t);
        } else
          throw o;
      }
    });
  }
}
function Og(n) {
  const r = encodeURIComponent(Ln(n));
  return `${Er}/localhost/${r}/cancel_queries`;
}
function Ng(n) {
  const r = encodeURIComponent(Ln(n));
  return `${Er}/live/${r}/cancel_queries`;
}
function Iu(n) {
  const r = encodeURIComponent(Ln(n));
  return `${Er}/${r}/jaql`;
}
function Rg(n) {
  return `${Iu(n)}/csv`;
}
var lc = function(n, r, e, t) {
  function a(o) {
    return o instanceof e ? o : new e(function(i) {
      i(o);
    });
  }
  return new (e || (e = Promise))(function(o, i) {
    function s(u) {
      try {
        c(t.next(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      try {
        c(t.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function c(u) {
      u.done ? o(u.value) : a(u.value).then(s, l);
    }
    c((t = t.apply(n, r || [])).next());
  });
};
const Fg = 2e4, Lo = "Unspecified reason";
class Ig {
  constructor(r, e = new Pl(r.url, r.auth), t) {
    Yg(r), this.queryApi = new Ag(r), this.taskManager = new Tg(this.queryApi, e), this.shouldSkipHighlightsWithoutAttributes = t != null ? t : !1;
  }
  /**
   * Executes query
   *
   * @param queryDescription - all options that describe query
   * @param config - query execution configuration
   * @returns promise that resolves to query result data and cancel function that can be used to cancel sent query
   * @throws Error if query description is invalid
   */
  executeQuery(r, e) {
    const t = new cc("SEND_JAQL_QUERY", r, Object.assign(Object.assign({}, e || {}), { shouldSkipHighlightsWithoutAttributes: this.shouldSkipHighlightsWithoutAttributes || !1 }));
    return {
      resultPromise: new Promise((a, o) => {
        uc(r), this.taskManager.executeQuerySending(t).then((i) => {
          i.status === rt.ExecutionResultStatus.SUCCESS ? a(i.result) : o(i.error);
        });
      }),
      cancel: (a) => this.taskManager.cancel(t.taskId, a || Lo)
    };
  }
  executeCsvQuery(r, e) {
    const t = new cc("SEND_DOWNLOAD_CSV_QUERY", r, Object.assign(Object.assign({}, e || {}), { shouldSkipHighlightsWithoutAttributes: this.shouldSkipHighlightsWithoutAttributes || !1 }));
    return {
      resultPromise: new Promise((a, o) => {
        uc(r), this.taskManager.executeDownloadCsvSending(t).then((i) => {
          i.status === rt.ExecutionResultStatus.SUCCESS ? a(i.result) : o(i.error);
        });
      }),
      cancel: (a) => this.taskManager.cancel(t.taskId, a || Lo)
    };
  }
  /**
   * Executes pivot query
   *
   * @param pivotQueryDescription - all options that describe the pivot query
   * @param config - query execution configuration
   * @returns promise that resolves to pivot query result data and cancel function that can be used to cancel sent query
   * @throws Error if query description is invalid
   */
  executePivotQuery(r, e) {
    const t = new Eg("SEND_JAQL_QUERY", r, Object.assign(Object.assign({}, e || {}), { shouldSkipHighlightsWithoutAttributes: this.shouldSkipHighlightsWithoutAttributes || !1 }));
    return {
      resultPromise: new Promise((a, o) => {
        Lg(r), this.taskManager.executePivotQuerySending(t).then((i) => {
          i.status === rt.ExecutionResultStatus.SUCCESS ? a(i.result) : o(i.error);
        });
      }),
      cancel: (a) => this.taskManager.cancel(t.taskId, a || Lo)
    };
  }
  getDataSourceFields(r, e = 9999, t = 0) {
    return lc(this, void 0, void 0, function* () {
      return (yield this.queryApi.getDataSourceFields(r, e, t)) || [];
    });
  }
  /**
   * Returns the schema of a data source by its name.
   */
  getDataSourceSchema(r) {
    return this.queryApi.getDataSourceSchema(r);
  }
  /**
   * Returns a list of data sources
   */
  getDataSourceList() {
    return lc(this, void 0, void 0, function* () {
      return (yield this.queryApi.getDataSourceList()) || [];
    });
  }
}
function uc(n) {
  const { attributes: r, measures: e, filters: t, highlights: a, count: o, offset: i } = n;
  if (o && o < 0)
    throw new je("errors.invalidCountNegative", { count: o.toString() });
  if (i && i < 0)
    throw new je("errors.invalidOffset", { offset: i.toString() });
  if (r.length + e.length === 0)
    throw new je("errors.noDimensionsOrMeasures");
  r.forEach((s) => {
    if (!s.skipValidation && !Dn.isAttribute(s)) {
      const { name: l } = s;
      throw new je("errors.invalidAttribute", { attributeName: l });
    }
  }), e.forEach((s) => {
    if (!s.skipValidation && !Dn.isMeasure(s))
      throw new je("errors.invalidMeasure", { measureName: s.name });
  }), t.forEach((s) => {
    if (!s.skipValidation && !Dn.isFilter(s))
      throw new je("errors.invalidFilter", { filterName: s.name });
  }), a.forEach((s) => {
    if (!s.skipValidation && !Dn.isFilter(s))
      throw new je("errors.invalidHighlight", { highlightName: s.name });
  });
}
function Lg(n) {
  const { rowsAttributes: r, columnsAttributes: e, measures: t, filters: a, highlights: o, count: i, offset: s } = n;
  if (i && i < 0)
    throw new je("errors.invalidCountNegative", { count: i.toString() });
  if (s && s < 0)
    throw new je("errors.invalidOffset", { offset: s.toString() });
  if (r.length + e.length + t.length === 0)
    throw new je("errors.noDimensionsOrMeasures");
  a.forEach((l) => {
    if (!l.skipValidation && !Dn.isFilter(l))
      throw new je("errors.invalidFilter", { filterName: l.name });
  }), o.forEach((l) => {
    if (!l.skipValidation && !Dn.isFilter(l))
      throw new je("errors.invalidHighlight", { highlightName: l.name });
  });
}
function Yg(n) {
  if (!n)
    throw new je("errors.missingHttpClient");
  if (!n.post)
    throw new je("errors.missingPostMethod");
}
const Wg = 2e4, Hg = { enabled: !0, delay: 500 }, $g = {
  locale: Wf(),
  dateConfig: Hf,
  loadingIndicatorConfig: Hg,
  translationConfig: {
    language: "en",
    customTranslations: []
  },
  language: "en",
  queryCacheConfig: {
    enabled: !1
  },
  queryLimit: Wg,
  accessibilityConfig: {
    enabled: !1
  },
  errorBoundaryConfig: {
    alwaysShowErrorText: !1
  },
  trackingConfig: {
    enabled: !0
  }
};
function Bg(n, r, e) {
  return Ee(this, null, function* () {
    const t = yield Ug(r, e);
    return ka.withOptions(
      { mergeArrays: !1 },
      $g,
      t,
      n
    );
  });
}
function Qg(n) {
  const r = {};
  return n.forEach((e) => {
    r[e.key] = e;
  }), r;
}
function Ug(n, r = !1) {
  return Ee(this, null, function* () {
    const e = yield n.get("api/globals");
    if (!e)
      throw new ne("errors.serverSettingsNotLoaded");
    const t = r ? { colors: $f().palette.variantColors } : yield Bf(Qf(e.designSettings), n);
    return {
      serverThemeSettings: Uf(e.designSettings, t, n.url),
      serverLanguage: e.language,
      serverVersion: e.version,
      serverFeatures: Qg(e.features),
      user: {
        tenant: {
          name: e.user.tenant.name
        }
      }
    };
  });
}
const qg = "system";
function jg(n, r) {
  return r === qg ? n : n.replace(`/${r}`, "");
}
function zg() {
  window.addEventListener("unhandledrejection", (n) => {
    n.reason instanceof Error ? console.error(n.reason.message) : console.error(n.reason);
  });
}
const Vg = (l) => Ee(void 0, [l], function* ({
  defaultDataSource: n,
  url: r,
  token: e,
  wat: t,
  ssoEnabled: a,
  appConfig: o,
  enableSilentPreAuth: i,
  useFusionAuth: s
}) {
  if (r === void 0)
    throw new ne("errors.sisenseContextNoAuthentication");
  const c = Am({
    url: r,
    token: e,
    wat: t,
    ssoEnabled: a,
    enableSilentPreAuth: i,
    useFusionAuth: s
  });
  if (!c)
    throw new ne("errors.sisenseContextNoAuthentication");
  zg();
  const u = new Nm(
    r,
    c,
    "sdk-ui-1.22.0"
  ), d = yield u.login(), f = Cu(c) || !d, p = yield Bg(o || {}, u, f), h = new Pl(jg(r, p.user.tenant.name), c), m = new Ig(u, h);
  return {
    httpClient: u,
    pivotClient: h,
    queryClient: m,
    settings: p,
    // todo: make it optional (incorrect previous implementation)
    defaultDataSource: n,
    queryCache: {
      clear: Al
    }
  };
}), Lu = /* @__PURE__ */ j.createContext(void 0);
process.env.NODE_ENV !== "production" && (Lu.displayName = "FormControlContext");
function Gg() {
  return j.useContext(Lu);
}
function Kg(n) {
  return Ol("PrivateSwitchBase", n);
}
Nl("PrivateSwitchBase", ["root", "checked", "disabled", "input", "edgeStart", "edgeEnd"]);
const Xg = ["autoFocus", "checked", "checkedIcon", "className", "defaultChecked", "disabled", "disableFocusRipple", "edge", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"], Jg = (n) => {
  const {
    classes: r,
    checked: e,
    disabled: t,
    edge: a
  } = n, o = {
    root: ["root", e && "checked", t && "disabled", a && `edge${xn(a)}`],
    input: ["input"]
  };
  return Il(o, Kg, r);
}, Zg = sr(qf)(({
  ownerState: n
}) => cn({
  padding: 9,
  borderRadius: "50%"
}, n.edge === "start" && {
  marginLeft: n.size === "small" ? -3 : -12
}, n.edge === "end" && {
  marginRight: n.size === "small" ? -3 : -12
})), ey = sr("input", {
  shouldForwardProp: jf
})({
  cursor: "inherit",
  position: "absolute",
  opacity: 0,
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
}), Yu = /* @__PURE__ */ j.forwardRef(function(r, e) {
  const {
    autoFocus: t,
    checked: a,
    checkedIcon: o,
    className: i,
    defaultChecked: s,
    disabled: l,
    disableFocusRipple: c = !1,
    edge: u = !1,
    icon: d,
    id: f,
    inputProps: p,
    inputRef: h,
    name: m,
    onBlur: g,
    onChange: b,
    onFocus: v,
    readOnly: D,
    required: k = !1,
    tabIndex: x,
    type: R,
    value: I
  } = r, L = Rl(r, Xg), [A, W] = zf({
    controlled: a,
    default: !!s,
    name: "SwitchBase",
    state: "checked"
  }), O = Gg(), U = (F) => {
    v && v(F), O && O.onFocus && O.onFocus(F);
  }, $ = (F) => {
    g && g(F), O && O.onBlur && O.onBlur(F);
  }, N = (F) => {
    if (F.nativeEvent.defaultPrevented)
      return;
    const K = F.target.checked;
    W(K), b && b(F, K);
  };
  let T = l;
  O && typeof T == "undefined" && (T = O.disabled);
  const M = R === "checkbox" || R === "radio", C = cn({}, r, {
    checked: A,
    disabled: T,
    disableFocusRipple: c,
    edge: u
  }), S = Jg(C);
  return /* @__PURE__ */ J(Zg, cn({
    component: "span",
    className: Te(S.root, i),
    centerRipple: !0,
    focusRipple: !c,
    disabled: T,
    tabIndex: null,
    role: void 0,
    onFocus: U,
    onBlur: $,
    ownerState: C,
    ref: e
  }, L, {
    children: [/* @__PURE__ */ y(ey, cn({
      autoFocus: t,
      checked: a,
      defaultChecked: s,
      className: S.input,
      disabled: T,
      id: M ? f : void 0,
      name: m,
      onChange: N,
      readOnly: D,
      ref: h,
      required: k,
      ownerState: C,
      tabIndex: x,
      type: R
    }, R === "checkbox" && I === void 0 ? {} : {
      value: I
    }, p)), A ? o : d]
  }));
});
process.env.NODE_ENV !== "production" && (Yu.propTypes = {
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: V.bool,
  /**
   * If `true`, the component is checked.
   */
  checked: V.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: V.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: V.object,
  /**
   * @ignore
   */
  className: V.string,
  /**
   * @ignore
   */
  defaultChecked: V.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: V.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: V.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: V.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: V.node.isRequired,
  /**
   * The id of the `input` element.
   */
  id: V.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: V.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Fl,
  /*
   * @ignore
   */
  name: V.string,
  /**
   * @ignore
   */
  onBlur: V.func,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: V.func,
  /**
   * @ignore
   */
  onFocus: V.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: V.bool,
  /**
   * If `true`, the `input` element is required.
   */
  required: V.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: V.object,
  /**
   * @ignore
   */
  tabIndex: V.oneOfType([V.number, V.string]),
  /**
   * The input component prop `type`.
   */
  type: V.string.isRequired,
  /**
   * The value of the component.
   */
  value: V.any
});
function dc(n) {
  return n.substring(2).toLowerCase();
}
function ty(n, r) {
  return r.documentElement.clientWidth < n.clientX || r.documentElement.clientHeight < n.clientY;
}
function Sa(n) {
  const {
    children: r,
    disableReactTree: e = !1,
    mouseEvent: t = "onClick",
    onClickAway: a,
    touchEvent: o = "onTouchEnd"
  } = n, i = j.useRef(!1), s = j.useRef(null), l = j.useRef(!1), c = j.useRef(!1);
  j.useEffect(() => (setTimeout(() => {
    l.current = !0;
  }, 0), () => {
    l.current = !1;
  }), []);
  const u = Vf(
    // @ts-expect-error TODO upstream fix
    r.ref,
    s
  ), d = Gf((h) => {
    const m = c.current;
    c.current = !1;
    const g = xo(s.current);
    if (!l.current || !s.current || "clientX" in h && ty(h, g))
      return;
    if (i.current) {
      i.current = !1;
      return;
    }
    let b;
    h.composedPath ? b = h.composedPath().indexOf(s.current) > -1 : b = !g.documentElement.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      h.target
    ) || s.current.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      h.target
    ), !b && (e || !m) && a(h);
  }), f = (h) => (m) => {
    c.current = !0;
    const g = r.props[h];
    g && g(m);
  }, p = {
    ref: u
  };
  return o !== !1 && (p[o] = f(o)), j.useEffect(() => {
    if (o !== !1) {
      const h = dc(o), m = xo(s.current), g = () => {
        i.current = !0;
      };
      return m.addEventListener(h, d), m.addEventListener("touchmove", g), () => {
        m.removeEventListener(h, d), m.removeEventListener("touchmove", g);
      };
    }
  }, [d, o]), t !== !1 && (p[t] = f(t)), j.useEffect(() => {
    if (t !== !1) {
      const h = dc(t), m = xo(s.current);
      return m.addEventListener(h, d), () => {
        m.removeEventListener(h, d);
      };
    }
  }, [d, t]), /* @__PURE__ */ y(j.Fragment, {
    children: /* @__PURE__ */ j.cloneElement(r, p)
  });
}
process.env.NODE_ENV !== "production" && (Sa.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The wrapped element.
   */
  children: Kf.isRequired,
  /**
   * If `true`, the React tree is ignored and only the DOM tree is considered.
   * This prop changes how portaled elements are handled.
   * @default false
   */
  disableReactTree: V.bool,
  /**
   * The mouse event to listen to. You can disable the listener by providing `false`.
   * @default 'onClick'
   */
  mouseEvent: V.oneOf(["onClick", "onMouseDown", "onMouseUp", "onPointerDown", "onPointerUp", !1]),
  /**
   * Callback fired when a "click away" event is detected.
   */
  onClickAway: V.func.isRequired,
  /**
   * The touch event to listen to. You can disable the listener by providing `false`.
   * @default 'onTouchEnd'
   */
  touchEvent: V.oneOf(["onTouchEnd", "onTouchStart", !1])
});
process.env.NODE_ENV !== "production" && (Sa.propTypes = Xf(Sa.propTypes));
function ny(n) {
  return Ol("MuiSwitch", n);
}
const Ge = Nl("MuiSwitch", ["root", "edgeStart", "edgeEnd", "switchBase", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium", "checked", "disabled", "input", "thumb", "track"]), ry = ["className", "color", "edge", "size", "sx"], ay = (n) => {
  const {
    classes: r,
    edge: e,
    size: t,
    color: a,
    checked: o,
    disabled: i
  } = n, s = {
    root: ["root", e && `edge${xn(e)}`, `size${xn(t)}`],
    switchBase: ["switchBase", `color${xn(a)}`, o && "checked", i && "disabled"],
    thumb: ["thumb"],
    track: ["track"],
    input: ["input"]
  }, l = Il(s, ny, r);
  return cn({}, r, l);
}, oy = sr("span", {
  name: "MuiSwitch",
  slot: "Root",
  overridesResolver: (n, r) => {
    const {
      ownerState: e
    } = n;
    return [r.root, e.edge && r[`edge${xn(e.edge)}`], r[`size${xn(e.size)}`]];
  }
})({
  display: "inline-flex",
  width: 34 + 12 * 2,
  height: 14 + 12 * 2,
  overflow: "hidden",
  padding: 12,
  boxSizing: "border-box",
  position: "relative",
  flexShrink: 0,
  zIndex: 0,
  // Reset the stacking context.
  verticalAlign: "middle",
  // For correct alignment with the text.
  "@media print": {
    colorAdjust: "exact"
  },
  variants: [{
    props: {
      edge: "start"
    },
    style: {
      marginLeft: -8
    }
  }, {
    props: {
      edge: "end"
    },
    style: {
      marginRight: -8
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      width: 40,
      height: 24,
      padding: 7,
      [`& .${Ge.thumb}`]: {
        width: 16,
        height: 16
      },
      [`& .${Ge.switchBase}`]: {
        padding: 4,
        [`&.${Ge.checked}`]: {
          transform: "translateX(16px)"
        }
      }
    }
  }]
}), iy = sr(Yu, {
  name: "MuiSwitch",
  slot: "SwitchBase",
  overridesResolver: (n, r) => {
    const {
      ownerState: e
    } = n;
    return [r.switchBase, {
      [`& .${Ge.input}`]: r.input
    }, e.color !== "default" && r[`color${xn(e.color)}`]];
  }
})(({
  theme: n
}) => ({
  position: "absolute",
  top: 0,
  left: 0,
  zIndex: 1,
  // Render above the focus ripple.
  color: n.vars ? n.vars.palette.Switch.defaultColor : `${n.palette.mode === "light" ? n.palette.common.white : n.palette.grey[300]}`,
  transition: n.transitions.create(["left", "transform"], {
    duration: n.transitions.duration.shortest
  }),
  [`&.${Ge.checked}`]: {
    transform: "translateX(20px)"
  },
  [`&.${Ge.disabled}`]: {
    color: n.vars ? n.vars.palette.Switch.defaultDisabledColor : `${n.palette.mode === "light" ? n.palette.grey[100] : n.palette.grey[600]}`
  },
  [`&.${Ge.checked} + .${Ge.track}`]: {
    opacity: 0.5
  },
  [`&.${Ge.disabled} + .${Ge.track}`]: {
    opacity: n.vars ? n.vars.opacity.switchTrackDisabled : `${n.palette.mode === "light" ? 0.12 : 0.2}`
  },
  [`& .${Ge.input}`]: {
    left: "-100%",
    width: "300%"
  }
}), ({
  theme: n
}) => ({
  "&:hover": {
    backgroundColor: n.vars ? `rgba(${n.vars.palette.action.activeChannel} / ${n.vars.palette.action.hoverOpacity})` : $s(n.palette.action.active, n.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  variants: [...Object.entries(n.palette).filter(([, r]) => r.main && r.light).map(([r]) => ({
    props: {
      color: r
    },
    style: {
      [`&.${Ge.checked}`]: {
        color: (n.vars || n).palette[r].main,
        "&:hover": {
          backgroundColor: n.vars ? `rgba(${n.vars.palette[r].mainChannel} / ${n.vars.palette.action.hoverOpacity})` : $s(n.palette[r].main, n.palette.action.hoverOpacity),
          "@media (hover: none)": {
            backgroundColor: "transparent"
          }
        },
        [`&.${Ge.disabled}`]: {
          color: n.vars ? n.vars.palette.Switch[`${r}DisabledColor`] : `${n.palette.mode === "light" ? Jf(n.palette[r].main, 0.62) : Zf(n.palette[r].main, 0.55)}`
        }
      },
      [`&.${Ge.checked} + .${Ge.track}`]: {
        backgroundColor: (n.vars || n).palette[r].main
      }
    }
  }))]
})), sy = sr("span", {
  name: "MuiSwitch",
  slot: "Track",
  overridesResolver: (n, r) => r.track
})(({
  theme: n
}) => ({
  height: "100%",
  width: "100%",
  borderRadius: 14 / 2,
  zIndex: -1,
  transition: n.transitions.create(["opacity", "background-color"], {
    duration: n.transitions.duration.shortest
  }),
  backgroundColor: n.vars ? n.vars.palette.common.onBackground : `${n.palette.mode === "light" ? n.palette.common.black : n.palette.common.white}`,
  opacity: n.vars ? n.vars.opacity.switchTrack : `${n.palette.mode === "light" ? 0.38 : 0.3}`
})), cy = sr("span", {
  name: "MuiSwitch",
  slot: "Thumb",
  overridesResolver: (n, r) => r.thumb
})(({
  theme: n
}) => ({
  boxShadow: (n.vars || n).shadows[1],
  backgroundColor: "currentColor",
  width: 20,
  height: 20,
  borderRadius: "50%"
})), Wu = /* @__PURE__ */ j.forwardRef(function(r, e) {
  const t = ep({
    props: r,
    name: "MuiSwitch"
  }), {
    className: a,
    color: o = "primary",
    edge: i = !1,
    size: s = "medium",
    sx: l
  } = t, c = Rl(t, ry), u = cn({}, t, {
    color: o,
    edge: i,
    size: s
  }), d = ay(u), f = /* @__PURE__ */ y(cy, {
    className: d.thumb,
    ownerState: u
  });
  return /* @__PURE__ */ J(oy, {
    className: Te(d.root, a),
    sx: l,
    ownerState: u,
    children: [/* @__PURE__ */ y(iy, cn({
      type: "checkbox",
      icon: f,
      checkedIcon: f,
      ref: e,
      ownerState: u
    }, c, {
      classes: cn({}, d, {
        root: d.switchBase
      })
    })), /* @__PURE__ */ y(sy, {
      className: d.track,
      ownerState: u
    })]
  });
});
process.env.NODE_ENV !== "production" && (Wu.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: V.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: V.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: V.object,
  /**
   * @ignore
   */
  className: V.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: V.oneOfType([V.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), V.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: V.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: V.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: V.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: V.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: V.node,
  /**
   * The id of the `input` element.
   */
  id: V.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: V.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Fl,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: V.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: V.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense switch styling.
   * @default 'medium'
   */
  size: V.oneOfType([V.oneOf(["medium", "small"]), V.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: V.oneOfType([V.arrayOf(V.oneOfType([V.func, V.object, V.bool])), V.func, V.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: V.any
});
const Cn = (n, r) => `${r}px solid ${n}`, ly = (n) => ({
  columns: [
    {
      widthPercentage: 100,
      rows: n.map((r) => ({
        cells: [{ widthPercentage: 100, widgetId: r.id }]
      }))
    }
  ]
});
function Hu(n) {
  return tp(n) ? { direction: n } : n;
}
function fc(n, r) {
  return {
    valuesIndex: n.field - (r.rows || []).length - (r.columns || []).length,
    columnsMembersPath: Object.values(n.measurePath || {})
  };
}
function uy({ type: n, settings: r, sortDetails: e }, t) {
  return n === "simple" ? e.field >= (t.rows || []).length ? [
    {
      rowIndex: 0,
      sort: {
        direction: So(r[0].direction),
        by: fc(e, t)
      }
    }
  ] : [
    {
      rowIndex: e.field,
      sort: {
        direction: So(r[0].direction)
      }
    }
  ] : r.reduce((a, o, i) => {
    var d;
    const s = (d = t.rows) == null ? void 0 : d[i], l = (s == null ? void 0 : s.sortType) && Hu(s == null ? void 0 : s.sortType), c = {
      direction: So(o.direction),
      by: fc(e, t)
    };
    return !o.selected && Ir(l == null ? void 0 : l.by, c.by) && a.push({
      rowIndex: i,
      sort: null
    }), o.selected && a.push({
      rowIndex: i,
      sort: c
    }), a;
  }, []);
}
function dy(n) {
  const { jaql: r, pivotBuilder: e, isForceReload: t } = n, [a, o] = me({
    isLoading: !1,
    isNoResults: !1
  }), i = _t(r);
  ge(() => {
    r && (i || t) && e.updateJaql(r);
  }, [t, i, r, e]);
  const s = le(() => {
    o({ isLoading: !0, isNoResults: !1 });
  }, []), l = le((c) => {
    o({
      isLoading: !1,
      isNoResults: !c.cellsMetadata
    });
  }, []);
  return ge(() => {
    const c = [
      { event: np, handler: s },
      { event: rp, handler: l }
    ];
    return c.forEach(({ event: u, handler: d }) => {
      e.on(u, d);
    }), () => {
      c.forEach(({ event: u, handler: d }) => {
        e.off(u, d);
      });
    };
  }, [e, s, l]), a;
}
function fy(n) {
  const { pivotClient: r, pivotBuilder: e, shouldBeRecreated: t } = n, [a, o] = me(
    () => r.prepareDataService()
  );
  return ge(() => {
    if (t) {
      const i = r.prepareDataService();
      o(i), e.updateDataService(i);
    }
  }, [r, e, t]), a;
}
const py = ({
  dataOptions: n
}) => {
  const [r, e] = me(
    Ll(n)
  );
  return {
    dataOptionsInternal: r,
    updateSort(t) {
      var a;
      e(E(w({}, r), {
        rows: (a = r.rows) == null ? void 0 : a.map((o, i) => {
          const s = t.rows.find(({ rowIndex: l }) => l === i);
          return s ? s.sort === null ? Gs(o, { sortType: void 0 }) : Gs(o, { sortType: s.sort }) : o;
        })
      }));
    }
  };
}, hy = (n) => (r, e, t, a) => {
  var l;
  const o = op(n, (l = a == null ? void 0 : a.field) == null ? void 0 : l.index), i = ap(o), s = r.value === null || typeof r.value == "undefined";
  r.content = s ? "" : ou(i, r.value);
}, my = () => (n, r, e) => {
  var c, u;
  const t = n.userType === Bs.CORNER, a = n.userType === Bs.SUB_TOTAL;
  if (!r || t || a)
    return;
  const o = e.metadata.find(({ panel: d, jaql: f }) => {
    var b;
    const p = ["rows", "columns"].includes(d), h = f.dim === r.jaql.dim, m = r.jaql.datatype === f.datatype && r.jaql.level === f.level, g = (b = f.in) == null ? void 0 : b.selected;
    return p && h && m && g;
  }), i = (u = (c = o == null ? void 0 : o.jaql) == null ? void 0 : c.in) == null ? void 0 : u.selected;
  if (!i)
    return;
  vg(i.jaql)(n.value) && (n.state = {
    isSelected: !0
  });
}, gy = ({
  dataService: n,
  dataOptions: r
}) => {
  const { app: e } = Ye(), t = le(Ks([hy(r)]), [
    r
  ]), a = le(
    (i, s) => Yl(i, s, e == null ? void 0 : e.settings.locale, e == null ? void 0 : e.settings.dateConfig),
    [e]
  ), o = le(
    Ks([
      ip(r, a),
      my()
    ]),
    [r]
  );
  ge(() => (n.on(Qs, t), n.on(Us, o), () => {
    n.off(Qs, t), n.off(Us, o);
  }), [n, t]);
};
function An(n, r) {
  return n === void 0 && r === void 0 ? !1 : [n, r].some((e) => e === void 0) || n.length !== r.length ? !0 : n.length === 0 && r.length === 0 ? !1 : n.some(
    (e, t) => !sp(
      e,
      r[t],
      (a, o) => {
        const i = pc(a) ? E(w({}, a.toJSON()), {
          name: void 0
        }) : a, s = pc(o) ? E(w({}, o.toJSON()), {
          name: void 0
        }) : o;
        return Ir(i, s);
      }
    )
  );
}
function pc(n) {
  return "toJSON" in n && typeof n.toJSON == "function";
}
function yy(n, r, e, t) {
  if (e === void 0 && t === void 0)
    return !1;
  if ([e, t].some((o) => o === void 0))
    return !0;
  function a(o, i) {
    const s = o, l = o, c = i, u = i;
    return o === void 0 && i === void 0 ? !0 : [o, i].some((d) => d === void 0) || s.operator !== c.operator ? !1 : l.instanceid && u.instanceid ? !An(
      n == null ? void 0 : n.filter((d) => d.guid === l.instanceid),
      r == null ? void 0 : r.filter((d) => d.guid === u.instanceid)
    ) : a(s.left, c.left) && a(s.right, c.right) || a(s.left, c.right) && a(s.right, c.left);
  }
  return !a(e, t);
}
function hc(n, r) {
  return Dt(n, r);
}
const qC = mt("useExecutePivotQuery")(
  $u
);
function $u(n) {
  const r = vy(n), e = hn(n, r), [t, a] = Ht(hc, {
    isLoading: !0,
    isError: !1,
    isSuccess: !1,
    status: "loading",
    error: void 0,
    data: void 0
  }), { isInitialized: o, app: i } = Ye();
  return ge(() => {
    if (o || a({
      type: "error",
      error: new ne("errors.executeQueryNoSisenseContext")
    }), e(i)) {
      a({ type: "loading" });
      const {
        dataSource: s,
        rows: l,
        columns: c,
        values: u,
        grandTotals: d,
        filters: f,
        highlights: p,
        count: h,
        offset: m,
        onBeforeQuery: g
      } = n, { filters: b, relations: v } = Mn(f);
      Wl(
        {
          dataSource: s,
          rows: l,
          columns: c,
          values: u,
          grandTotals: d,
          filters: b,
          filterRelations: v,
          highlights: p,
          count: h,
          offset: m
        },
        i,
        { onBeforeQuery: g }
      ).then((D) => {
        a({ type: "success", data: D });
      }).catch((D) => {
        a({ type: "error", error: D });
      });
    }
  }, [i, o, n, e]), t.data && r ? hc(t, { type: "loading" }) : t;
}
const by = [
  "dataSource",
  "rows",
  "columns",
  "values",
  "grandTotals",
  "count",
  "offset",
  "onBeforeQuery"
];
function vy(n) {
  return _t(n, by, (r, e) => {
    const { filters: t } = Mn(e.filters), { filters: a } = Mn(r.filters);
    return An(t, a) || An(e.highlights, r.highlights);
  });
}
const mc = (n) => w({
  attribute: iu(n),
  includeSubTotals: n.includeSubTotals || !1
}, n.sortType && {
  sort: Hu(n.sortType)
}), wy = (n) => ({
  measure: su(n),
  totalsCalculation: n.totalsCalculation,
  dataBars: n.dataBars || !1
}), Bu = (n) => {
  const {
    rows: r = [],
    columns: e = [],
    values: t = [],
    grandTotals: a
  } = n, o = r.flatMap(mc), i = e.flatMap(mc), s = t.flatMap(wy);
  return { rows: o, columns: i, values: s, grandTotals: a };
}, _y = ({
  dataSet: n,
  dataOptionsInternal: r,
  filters: e,
  highlights: t
}) => {
  const [a, o] = me(), { rows: i, columns: s, values: l, grandTotals: c } = Bu(r), u = le(
    (p) => {
      o((h) => Ir(h, p) ? h : p);
    },
    [o]
  ), d = {
    dataSource: n,
    rows: i,
    columns: s,
    values: l,
    grandTotals: c,
    filters: e,
    highlights: t,
    onBeforeQuery: u
  }, { error: f } = $u(d);
  return { jaql: a, error: f };
}, Dy = "#cbced7", ky = "#ffff9c";
function xy(n, r) {
  var a, o, i, s, l, c, u, d, f, p, h;
  let e, t;
  if ((a = r == null ? void 0 : r.chart) != null && a.backgroundColor) {
    const m = Kp(Xp((o = r == null ? void 0 : r.chart) == null ? void 0 : o.backgroundColor)) < 0.5 ? 0.07 : -0.07;
    e = kt((i = r == null ? void 0 : r.chart) == null ? void 0 : i.backgroundColor, m), t = kt(
      (s = r == null ? void 0 : r.chart) == null ? void 0 : s.backgroundColor,
      m * 1.5
    );
  }
  return {
    fontFamily: (l = r == null ? void 0 : r.typography) == null ? void 0 : l.fontFamily,
    textColor: (c = r == null ? void 0 : r.chart) == null ? void 0 : c.textColor,
    backgroundColor: (u = r == null ? void 0 : r.chart) == null ? void 0 : u.backgroundColor,
    borderColor: Dy,
    fillColor: e,
    additionalFillColor: t,
    fillOptions: {
      alternatingRows: n == null ? void 0 : n.alternatingRowsColor,
      alternatingColumns: n == null ? void 0 : n.alternatingColumnsColor,
      columnsHeaders: n == null ? void 0 : n.headersColor,
      rowMembers: n == null ? void 0 : n.membersColor,
      totals: n == null ? void 0 : n.totalsColor
    },
    rowHeight: n == null ? void 0 : n.rowHeight,
    isAutoHeight: (d = n == null ? void 0 : n.isAutoHeight) != null ? d : !1,
    navigationPrimaryColor: (f = r == null ? void 0 : r.typography) == null ? void 0 : f.primaryTextColor,
    navigationSecondaryColor: (p = r == null ? void 0 : r.typography) == null ? void 0 : p.secondaryTextColor,
    selectionColor: (h = n == null ? void 0 : n.highlightColor) != null ? h : ky
  };
}
const Cy = 25;
function Ty({
  nodeRef: n,
  pivotBuilder: r,
  dataOptions: e,
  styleOptions: t,
  themeSettings: a,
  size: o
}) {
  const i = le(
    (u, d) => {
      const p = [
        ...e.rows ? e.rows : [],
        ...e.columns ? e.columns : [],
        ...e.values ? e.values : []
      ].map((m) => m == null ? void 0 : m.width);
      if (d) {
        const [m, g] = d, b = u[m];
        b && typeof b.jaqlIndex != "undefined" && (p[b.jaqlIndex] = g);
      }
      const h = [];
      return u.forEach((m, g) => {
        typeof m.jaqlIndex != "undefined" && typeof p[m.jaqlIndex] != "undefined" && h.push([
          g,
          p[m.jaqlIndex]
        ]);
      }), h;
    },
    [e]
  ), s = pe(
    () => xy(t, a),
    [t, a]
  ), { rowsPerPage: l = Cy } = t, c = pe(() => o ? w({
    width: o.width,
    height: o.height,
    isPaginated: !0,
    itemsPerPage: l,
    isSelectedMode: !0,
    onUpdatePredefinedColumnWidth: i
  }, s) : null, [o, l, i, s]);
  ge(() => {
    n.current && c && (!!n.current.children.length ? r.updateProps(c) : r.render(n.current, c));
  }, [n, r, c]);
}
const Sy = se({
  componentName: "PivotTable"
})((n) => {
  const { dataSet: r, dataOptions: e, filters: t, highlights: a, refreshCounter: o = 0 } = n, i = pe(
    () => {
      var A;
      return (A = n.styleOptions) != null ? A : {};
    },
    [n.styleOptions]
  ), s = it(null), [l, c] = me(null), { app: u } = Ye(), { themeSettings: d } = ve(), f = u == null ? void 0 : u.pivotClient;
  if (!f)
    throw new ne("errors.noPivotClient");
  const { dataOptionsInternal: p, updateSort: h } = py({ dataOptions: e }), { error: m, jaql: g } = _y({
    dataSet: r,
    dataOptionsInternal: p,
    filters: t,
    highlights: a
  });
  if (m)
    throw m;
  const b = pe(() => f.preparePivotBuilder(), [f]), v = _t(g), D = o > 0 && _t(o), k = fy({
    pivotClient: f,
    pivotBuilder: b,
    shouldBeRecreated: v || D
  });
  gy({ dataService: k, dataOptions: e });
  const { isLoading: x, isNoResults: R } = dy({
    jaql: g,
    pivotBuilder: b,
    isForceReload: D
  });
  Ty({ nodeRef: s, pivotBuilder: b, dataOptions: e, styleOptions: i, themeSettings: d, size: l });
  const I = le(
    (A) => {
      const W = uy(A, p);
      h({
        rows: W
      });
    },
    [p, h]
  );
  ge(() => (b.on(qs, I), () => {
    b.off(qs, I);
  }), [b, I]);
  const L = le(
    (A) => {
      (A.width !== (l == null ? void 0 : l.width) || A.height !== (l == null ? void 0 : l.height)) && c(A);
    },
    [l, c]
  );
  return /* @__PURE__ */ y(
    Ei,
    {
      defaultSize: cp,
      size: {
        width: i == null ? void 0 : i.width,
        height: i == null ? void 0 : i.height
      },
      useContentSize: { height: i == null ? void 0 : i.isAutoHeight },
      onSizeChange: L,
      children: /* @__PURE__ */ y(Hl, { themeSettings: d, isVisible: x, children: /* @__PURE__ */ J(Zt, { children: [
        R && /* @__PURE__ */ y(lp, { iconType: "table" }),
        /* @__PURE__ */ y("div", { ref: s, "aria-label": "pivot-table-root" })
      ] }) })
    }
  );
}), Qu = se({
  componentName: "PivotTableWidget"
})((n) => {
  var d;
  const [r, e] = me(0), { app: t } = Ye(), { styleOptions: a, dataSource: o = t == null ? void 0 : t.defaultDataSource, dataOptions: i } = n, s = $l("pivot", {
    hasHeader: !((d = a == null ? void 0 : a.header) != null && d.hidden)
  }), f = n.styleOptions || {}, { width: l, height: c } = f, u = Re(f, ["width", "height"]);
  return i ? /* @__PURE__ */ y(
    Ei,
    {
      defaultSize: s,
      size: {
        width: l,
        height: c
      },
      useContentSize: { height: a == null ? void 0 : a.isAutoHeight },
      children: /* @__PURE__ */ y(
        Bl,
        E(w({}, n), {
          dataSetName: o && Ln(o),
          onRefresh: () => e(r + 1),
          children: /* @__PURE__ */ y(
            Sy,
            {
              dataSet: n.dataSource,
              dataOptions: n.dataOptions,
              styleOptions: u,
              filters: n.filters,
              highlights: n.highlights,
              refreshCounter: r
            }
          )
        })
      )
    }
  ) : null;
});
function Ey(o, i) {
  return Ee(this, arguments, function* (n, r, e = {}, t, a) {
    var h;
    const { includeWidgets: s, includeFilters: l } = e, c = new ja(n), u = ["oid", "title", "datasource", "style"];
    s && u.push("layout"), l && u.push("filters");
    const d = [
      c.getDashboard(r, { fields: u }),
      s ? c.getDashboardWidgets(r) : void 0
    ], [f, p] = yield Promise.all(d);
    if (!f)
      throw new ne("errors.dashboardWithOidNotFound", { dashboardOid: r });
    if (p && (f.widgets = p), (h = f.style) != null && h.paletteId && !f.style.palette) {
      const m = yield c.getPalettes(), g = m == null ? void 0 : m.find(({ _id: b }) => {
        var v;
        return b === ((v = f.style) == null ? void 0 : v.paletteId);
      });
      g && (f.style.palette = {
        name: g.name,
        colors: g.colors
      });
    }
    return Vi(f, t, a);
  });
}
function My(e) {
  return Ee(this, arguments, function* (n, r = {}) {
    const { includeWidgets: t, searchByTitle: a } = r, o = new ja(n), i = [];
    let s = ["oid", "title", "datasource"];
    t && (s = [], i.push("widgets"));
    const l = yield o.getDashboards({ fields: s, expand: i, searchByTitle: a });
    return (l == null ? void 0 : l.map((c) => Vi(c))) || [];
  });
}
const Py = mt("useGetDashboardModel")(
  Ay
);
function Ay(n) {
  const r = _t(n, ["dashboardOid"]), e = hn(n, r), [t, a] = Ht(Dt, {
    isLoading: !0,
    isError: !1,
    isSuccess: !1,
    status: "loading",
    error: void 0,
    data: void 0
  }), { isInitialized: o, app: i } = Ye(), { themeSettings: s } = ve();
  return ge(() => {
    if (o || a({
      type: "error",
      error: new ne("errors.sisenseContextNotFound")
    }), e(i)) {
      a({ type: "loading" });
      const { dashboardOid: l, includeWidgets: c, includeFilters: u } = n;
      Ey(
        i.httpClient,
        l,
        {
          includeWidgets: c,
          includeFilters: u
        },
        s,
        i.settings
      ).then((d) => {
        a({ type: "success", data: d });
      }).catch((d) => {
        a({ type: "error", error: d });
      });
    }
  }, [i, o, n, e, s]), t.data && r ? gc(Dt(t, { type: "loading" })) : gc(t);
}
function gc(n) {
  const t = n, { data: r } = t, e = Re(t, ["data"]);
  return E(w({}, e), {
    dashboard: r
  });
}
const jC = mt("useGetDashboardModels")(
  Oy
);
function Oy(n = {}) {
  const r = _t(n, ["includeWidgets"]), e = hn(n, r), [t, a] = Ht(Dt, {
    isLoading: !0,
    isError: !1,
    isSuccess: !1,
    status: "loading",
    error: void 0,
    data: void 0
  }), { isInitialized: o, app: i } = Ye();
  return ge(() => {
    o || a({
      type: "error",
      error: new ne("errors.sisenseContextNotFound")
    }), e(i) && (a({ type: "loading" }), My(i.httpClient, n).then((s) => {
      a({ type: "success", data: s });
    }).catch((s) => {
      a({ type: "error", error: s });
    }));
  }, [i, o, n, e]), t.data && r ? yc(Dt(t, { type: "loading" })) : yc(t);
}
function yc(n) {
  const t = n, { data: r } = t, e = Re(t, ["data"]);
  return E(w({}, e), {
    dashboards: r
  });
}
const $i = (a) => Ee(void 0, [a], function* ({
  widgetOid: n,
  dashboardOid: r,
  includeDashboard: e,
  api: t
}) {
  const [o, i] = yield Promise.all([
    t.getWidget(n, r),
    e ? t.getDashboard(r) : void 0
  ]);
  return { widget: o, dashboard: i };
}), Ny = ({
  widgetOid: n,
  dashboardOid: r,
  includeDashboard: e
}) => {
  const [t, a] = me(), o = Ql(), [i, s] = me();
  return ge(() => {
    $i({ widgetOid: n, dashboardOid: r, includeDashboard: e, api: o }).then(({ widget: l, dashboard: c }) => {
      if (!l)
        throw new ne("errors.widgetEmptyResponse", { widgetOid: n });
      s({
        widget: l,
        dashboard: c
      });
    }).catch((l) => {
      a(l);
    });
  }, [n, r, o, e]), E(w({}, i), {
    error: t
  });
};
function Ry(n, r, e, t, a) {
  return Ee(this, null, function* () {
    const o = new ja(n), { widget: i } = yield $i({
      widgetOid: e,
      dashboardOid: r,
      api: o
    });
    if (!i)
      throw new ne("errors.widgetWithOidNotFound", { widgetOid: e });
    return Hr(i, t, a);
  });
}
const zC = mt("useGetWidgetModel")(Fy);
function Fy(n) {
  const r = _t(n, ["dashboardOid", "widgetOid"]), e = hn(n, r), { themeSettings: t } = ve(), [a, o] = Ht(Dt, {
    isLoading: !0,
    isError: !1,
    isSuccess: !1,
    status: "loading",
    error: void 0,
    data: void 0
  }), { isInitialized: i, app: s } = Ye();
  return ge(() => {
    if (i || o({
      type: "error",
      error: new ne("errors.sisenseContextNotFound")
    }), e(s)) {
      o({ type: "loading" });
      const { dashboardOid: l, widgetOid: c } = n;
      Ry(s.httpClient, l, c, t, s.settings).then((u) => {
        o({ type: "success", data: u });
      }).catch((u) => {
        o({ type: "error", error: u });
      });
    }
  }, [s, i, n, e, t]), a.data && r ? bc(Dt(a, { type: "loading" })) : bc(a);
}
function bc(n) {
  const t = n, { data: r } = t, e = Re(t, ["data"]);
  return E(w({}, e), {
    widget: r
  });
}
function Yn(n, r) {
  const e = cu(n);
  return w(w({}, r), e && { subtype: e });
}
function jt(n) {
  const { min: r, max: e } = n || {};
  return E(w({}, n), {
    min: typeof r == "number" ? r : null,
    max: typeof e == "number" ? e : null
  });
}
function Iy(n, r, e) {
  var b, v, D, k, x, R, I, L, A, W;
  const t = {
    xAxis: jt(r.xAxis),
    yAxis: jt(r.yAxis),
    y2Axis: jt(r.y2Axis)
  }, o = ["chart/line", "chart/area"].includes(n) ? "x-axis" : "categories", i = xt(e, o), s = xt(e, "values"), l = i.length === 2;
  l && (t.xAxis = E(w({}, t.xAxis), {
    title: (b = t.xAxis) == null ? void 0 : b.x2Title,
    x2Title: (v = t.xAxis) == null ? void 0 : v.title
  }));
  const c = !!((D = t.xAxis) != null && D.title && "text" in t.xAxis.title), u = i[i.length - 1];
  !c && u && (t.xAxis = E(w({}, t.xAxis), {
    title: E(w({}, (k = t.xAxis) == null ? void 0 : k.title), {
      text: u.jaql.title
    })
  }));
  const d = !!((x = t.xAxis) != null && x.x2Title && "text" in t.xAxis.x2Title), f = i[0];
  !d && l && (t.xAxis = E(w({}, t.xAxis), {
    x2Title: E(w({}, (R = t.xAxis) == null ? void 0 : R.x2Title), {
      text: f.jaql.title
    })
  }));
  const p = !!((I = t.yAxis) != null && I.title && "text" in t.yAxis.title), h = s.filter((O) => !O.y2);
  !p && h.length === 1 && (t.yAxis = E(w({}, t.yAxis), {
    title: E(w({}, (L = t.yAxis) == null ? void 0 : L.title), {
      text: h[0].jaql.title
    })
  }));
  const m = !!((A = t.y2Axis) != null && A.title && "text" in t.y2Axis.title), g = s.filter((O) => O.y2);
  return !m && g.length === 1 && (t.y2Axis = E(w({}, t.y2Axis), {
    title: E(w({}, (W = t.y2Axis) == null ? void 0 : W.title), {
      text: g[0].jaql.title
    })
  })), t;
}
function Ly(n, r) {
  var o, i;
  const e = {
    xAxis: jt(n.categories),
    yAxis: jt(n.axis)
  }, t = xt(r, "categories")[0];
  return !!!((o = e.xAxis) != null && o.title && "text" in e.xAxis.title) && t && (e.xAxis = E(w({}, e.xAxis), {
    title: E(w({}, (i = e.xAxis) == null ? void 0 : i.title), {
      text: t.jaql.title
    })
  })), e.yAxis = E(w({}, e.yAxis), {
    title: {
      enabled: !1
    }
  }), e;
}
function Yy(n, r) {
  var s, l, c, u;
  const e = {
    xAxis: jt(n.xAxis),
    yAxis: jt(n.yAxis)
  }, t = xt(r, "x-axis")[0], a = xt(r, "y-axis")[0];
  return !!!((s = e.xAxis) != null && s.title && "text" in e.xAxis.title) && t && (e.xAxis = E(w({}, e.xAxis), {
    title: E(w({}, (l = e.xAxis) == null ? void 0 : l.title), {
      text: t.jaql.title
    })
  })), !!!((c = e.yAxis) != null && c.title && "text" in e.yAxis.title) && a && (e.yAxis = E(w({}, e.yAxis), {
    title: E(w({}, (u = e.yAxis) == null ? void 0 : u.title), {
      text: a.jaql.title
    })
  })), e;
}
function Wy(n, r) {
  var s, l, c, u;
  const e = {
    xAxis: jt(n.xAxis),
    yAxis: jt(n.yAxis)
  }, t = xt(r, "category")[0], a = xt(r, "value")[0];
  return !!!((s = e.xAxis) != null && s.title && "text" in e.xAxis.title) && t && (e.xAxis = E(w({}, e.xAxis), {
    title: E(w({}, (l = e.xAxis) == null ? void 0 : l.title), {
      text: t.jaql.title
    })
  })), !!!((c = e.yAxis) != null && c.title && "text" in e.yAxis.title) && a && (e.yAxis = E(w({}, e.yAxis), {
    title: E(w({}, (u = e.yAxis) == null ? void 0 : u.title), {
      text: a.jaql.title
    })
  })), e;
}
function Hy(n, r, e, t) {
  return E(w(w({}, Yn(r, e)), Iy(n, e, t)), {
    lineWidth: e.lineWidth,
    markers: e.markers
  });
}
function $y(n, r, e) {
  return w(w({}, Yn(n, r)), Ly(r, e));
}
function By(n, r, e) {
  var t, a, o;
  return E(w(w({}, Yn(n, r)), Yy(r, e)), {
    markerSize: {
      scatterDefaultSize: (t = r.markerSize) == null ? void 0 : t.defaultSize,
      scatterBubbleMinSize: (a = r.markerSize) == null ? void 0 : a.min,
      scatterBubbleMaxSize: (o = r.markerSize) == null ? void 0 : o.max
    }
  });
}
function Qy(n) {
  return {
    header: {
      color: {
        enabled: n["colors/headers"]
      }
    },
    rows: {
      alternatingColor: {
        enabled: n["colors/rows"]
      }
    },
    columns: {
      alternatingColor: {
        enabled: n["colors/columns"]
      }
    }
  };
}
function Uy(n, r) {
  return E(w({}, Yn(n, r)), {
    funnelSize: r.size,
    funnelType: r.type,
    funnelDirection: r.direction,
    labels: r.labels,
    legend: r.legend
  });
}
const qy = (n, r) => {
  const e = cu(n);
  return e === "indicator/gauge" ? {
    subtype: e,
    skin: +r.skin
  } : r.subtype === "bar" ? {
    subtype: e,
    numericSubtype: "numericBar"
  } : {
    subtype: e,
    numericSubtype: "numericSimple",
    skin: r.skin
  };
};
function jy(n, r, e) {
  var i, s, l, c, u, d, f, p;
  const t = qy(n, r), a = (i = xt(e, "value")[0]) == null ? void 0 : i.jaql.title, o = (s = xt(e, "secondary")[0]) == null ? void 0 : s.jaql.title;
  return E(w({}, t), {
    indicatorComponents: {
      title: {
        shouldBeShown: ((c = (l = r.components) == null ? void 0 : l.title) == null ? void 0 : c.enabled) || !1,
        text: a
      },
      secondaryTitle: {
        text: o || ""
      },
      ticks: {
        shouldBeShown: ((d = (u = r.components) == null ? void 0 : u.ticks) == null ? void 0 : d.enabled) || !1
      },
      labels: {
        shouldBeShown: ((p = (f = r.components) == null ? void 0 : f.labels) == null ? void 0 : p.enabled) || !1
      }
    }
  });
}
function zy(n) {
  var r, e, t, a;
  return {
    labels: {
      category: [
        { enabled: (r = n["title/1"]) != null ? r : !0 },
        { enabled: (e = n["title/2"]) != null ? e : !0 },
        { enabled: (t = n["title/3"]) != null ? t : !0 }
      ]
    },
    tooltip: {
      mode: (a = n["tooltip/value"]) == null || a ? "value" : "contribution"
    }
  };
}
function Vy(n) {
  var r;
  return {
    legend: {
      enabled: n["legend/enabled"],
      position: n["legend/position"]
    },
    tooltip: {
      mode: (r = n["tooltip/value"]) == null || r ? "value" : "contribution"
    }
  };
}
function Gy(n, r, e) {
  return w(w({}, Yn(n, r)), Wy(r, e));
}
function Ky(n, r) {
  return E(w({}, Yn(n, r)), {
    markers: {
      fill: r.markers.fill,
      size: {
        defaultSize: r.markers.size.defaultSize,
        minSize: r.markers.size.min,
        maxSize: r.markers.size.max
      }
    }
  });
}
function Xy(n) {
  let r;
  switch (n) {
    case "areamap/world":
      r = "world";
      break;
    case "areamap/usa":
      r = "usa";
      break;
    default:
      throw new ne("errors.unsupportedWidgetType", { widgetSubtype: n });
  }
  return {
    mapType: r
  };
}
function Jy(n) {
  var r, e, t, a, o;
  return {
    rowsPerPage: parseInt(`${n.pageSize}`),
    isAutoHeight: n.automaticHeight,
    rowHeight: n.rowHeight,
    alternatingRowsColor: (r = n.colors) == null ? void 0 : r.rows,
    alternatingColumnsColor: (e = n.colors) == null ? void 0 : e.columns,
    headersColor: (t = n.colors) == null ? void 0 : t.headers,
    membersColor: (a = n.colors) == null ? void 0 : a.members,
    totalsColor: (o = n.colors) == null ? void 0 : o.totals
  };
}
function Zy(n, r) {
  var o, i, s;
  const {
    subtype: e,
    style: t,
    metadata: { panels: a }
  } = r;
  switch (n) {
    case "chart/line":
    case "chart/area":
    case "chart/bar":
    case "chart/column": {
      const l = Hy(
        n,
        e,
        t,
        a
      );
      if (l.navigator) {
        const c = (o = r.options) == null ? void 0 : o.previousScrollerLocation;
        l.navigator.scrollerLocation = Xs(c) ? c : void 0;
      }
      return l;
    }
    case "chart/polar":
      return $y(e, t, a);
    case "chart/scatter":
      return By(e, t, a);
    case "chart/funnel":
      return Uy(e, t);
    case "treemap":
      return zy(t);
    case "sunburst":
      return Vy(t);
    case "chart/pie":
      return Yn(e, t);
    case "tablewidget":
    case "tablewidgetagg":
      return Qy(t);
    case "pivot":
    case "pivot2":
      return Jy(t);
    case "indicator":
      return jy(
        e,
        t,
        a
      );
    case "chart/boxplot": {
      const l = Gy(
        e,
        t,
        a
      );
      return l.navigator && (l.navigator.scrollerLocation = Xs(
        (i = r.options) == null ? void 0 : i.previousScrollerLocation
      ) ? (s = r.options) == null ? void 0 : s.previousScrollerLocation : void 0), l;
    }
    case "map/scatter":
      return Ky(e, t);
    case "map/area":
      return Xy(e);
    case "richtexteditor":
      return t.content;
    default:
      throw new ne("errors.unsupportedWidgetType", { widgetType: n });
  }
}
function eb(n, r, e) {
  if (!r || !e)
    return n;
  const t = {
    backgroundColor: r.widgetBackgroundColor,
    spaceAround: Jr[r.widgetSpacing],
    cornerRadius: Jr[r.widgetCornerRadius],
    shadow: Jr[r.widgetShadow],
    border: r.widgetBorderEnabled,
    borderColor: r.widgetBorderColor,
    header: {
      titleTextColor: r.widgetTitleColor,
      titleAlignment: Jr[r.widgetTitleAlignment],
      dividerLine: r.widgetTitleDividerEnabled,
      dividerLineColor: r.widgetTitleDividerColor,
      backgroundColor: r.widgetTitleBackgroundColor
    }
  };
  return w(w({}, n), t);
}
function tb(n, r) {
  return n && n.length ? up(n, Jp(r)) : [];
}
function nb(n, r) {
  const e = n.findIndex((t) => t === r);
  return e === -1 ? [] : n.slice(e);
}
const Uu = (n) => n != null && n.parent ? [...Uu(n.parent), Mi(n).column] : [], qu = (n) => {
  var r, e, t;
  if (n != null && n.parent && n.through && "filter" in n.through.jaql) {
    const a = Mi(n).column, { jaql: o, format: { mask: i } = {} } = n.parent, s = "level" in o && o.level && i && i[o.level], l = (t = (e = (r = n.through.jaql.filter) == null ? void 0 : r.members) == null ? void 0 : e.map(
      s ? (c) => ({
        categoryValue: c,
        categoryDisplayValue: Yl(Zp(c), s)
      }) : (c) => ({ categoryValue: c })
    )) != null ? t : [];
    return [...qu(n.parent), { nextDimension: a, points: l }];
  }
  return [];
};
function rb(n) {
  switch (n) {
    case "chart/line":
    case "chart/area":
      return ["x-axis"];
    case "chart/boxplot":
      return ["category"];
    case "chart/scatter":
      return ["x-axis", "y-axis", "point", "Break By / Color"];
    default:
      return ["categories"];
  }
}
const ab = (n, r) => {
  const e = rb(n).map((a) => xt(r, a)).flat().filter((a) => {
    const o = "agg" in a.jaql && a.jaql.agg, i = "formula" in a.jaql && a.jaql.formula;
    return !o && !i;
  });
  return e.length === 1 ? e[0] : void 0;
}, ju = "calendar", zu = "calendar - weeks", ob = [
  Ie.Years,
  Ie.Quarters,
  Ie.Months,
  Ie.Days
], ib = [Ie.Years, Ie.Weeks, Ie.Days], sb = [
  Ie.Years,
  Ie.Quarters,
  Ie.Months,
  Ie.Weeks,
  Ie.Days
], cb = (n) => n.length === 2 ? sb : n[0] === ju ? ob : n[0] === zu ? ib : [], lb = (n, r) => {
  const [e = [], t] = Ul(
    n,
    (o) => [ju, zu].includes(o)
  ), a = nb(
    cb(e),
    r.granularity
  );
  return a.length ? [{ title: "Calendar Hierarchy", levels: a.map(
    (s) => new ri(
      `${s} in ${r.name}`,
      r.expression,
      s,
      ri.getDefaultFormatForGranularity(s)
    )
  ) }, ...t] : t;
}, ub = (n) => {
  const r = n && Mi(n), e = (n == null ? void 0 : n.hierarchies) || [];
  return r && eh(r.column.type) ? (r.column.name = (n == null ? void 0 : n.jaql).column, lb(
    e,
    r.column
  )) : e;
}, db = (n, r, e = [], t) => {
  const a = ab(n, r), o = a && th(a), i = qu(a), s = ub(o);
  return {
    drilldownPaths: [...tb(
      [
        ...a ? Uu(a) : []
      ],
      ({ expression: c }) => c
    ), ...s],
    drilldownSelections: i
  };
};
function Bi(n) {
  const i = n.filter, { filter: r } = i, e = Re(i, ["filter"]), t = r && "turnedOff" in r && r.turnedOff;
  let a, o;
  return t ? o = r : a = r, e.members && e.members.length === 0 && (e.all = !0), {
    filter: e,
    backgroundFilter: a,
    turnOffMembersFilter: o
  };
}
function fb(n) {
  const { filter: r, backgroundFilter: e, turnOffMembersFilter: t } = Bi(
    n.jaql
  ), a = [
    E(w({}, n), {
      jaql: E(w({}, n.jaql), {
        filter: w(w({}, r), t && {
          filter: t
        })
      })
    })
  ];
  return e && a.push(E(w({}, n), {
    jaql: E(w({}, n.jaql), {
      filter: e
    }),
    // "background" filters always enabled
    disabled: !1
  })), a;
}
function pb(n) {
  const r = n.find((t) => t.name === "filters"), e = [];
  return r == null || r.items.forEach((t) => {
    e.push(...fb(t).filter(({ disabled: a }) => !a));
  }), e;
}
function Vu(n) {
  return pb(n).map(
    (r) => Sr(r.jaql, r.instanceid)
  );
}
function Gu(n) {
  if (Wt(n.widgetType))
    throw new zi("toExecuteQueryParams");
  let r, e, t, a;
  if (Va(n.widgetType)) {
    const { attributes: o, measures: i } = ql(
      dp(n.dataOptions)
    );
    r = o, e = i, t = gp * yp + 1, a = !0;
  } else {
    const { attributes: o, measures: i } = fp(
      n.dataOptions,
      n.chartType
    );
    r = o, e = i;
  }
  return {
    dataSource: n.dataSource,
    dimensions: r,
    measures: e,
    filters: n.filters,
    highlights: n.highlights,
    count: t,
    ungroup: a
  };
}
function Ku(n) {
  if (!Wt(n.widgetType))
    throw new ne("errors.widgetModel.onlyPivotWidgetSupported", {
      methodName: "toExecutePivotQueryParams"
    });
  const { rows: r, columns: e, values: t, grandTotals: a } = Bu(
    Ll(n.dataOptions)
  );
  return {
    dataSource: n.dataSource,
    rows: r,
    columns: e,
    values: t,
    grandTotals: a,
    filters: n.filters,
    highlights: n.highlights
  };
}
function Xu(n) {
  if (Wt(n.widgetType))
    throw new zi("toChartProps");
  if (Lr(n.widgetType))
    throw new od("toChartProps");
  return Va(n.widgetType) ? w({
    chartType: n.chartType
  }, Qi(n)) : {
    chartType: n.chartType,
    dataOptions: n.dataOptions,
    styleOptions: n.styleOptions,
    dataSet: n.dataSource,
    filters: n.filters,
    highlights: n.highlights
  };
}
function Qi(n) {
  if (!Va(n.widgetType))
    throw new ne("errors.widgetModel.onlyTableWidgetSupported", {
      methodName: "toTableProps"
    });
  return {
    dataOptions: n.dataOptions,
    styleOptions: n.styleOptions,
    dataSet: n.dataSource,
    filters: n.filters
  };
}
function Ju(n) {
  if (!Wt(n.widgetType))
    throw new ne("errors.widgetModel.onlyPivotWidgetSupported", {
      methodName: "toPivotTableProps"
    });
  return {
    dataOptions: n.dataOptions,
    styleOptions: n.styleOptions,
    dataSet: n.dataSource,
    filters: n.filters,
    highlights: n.highlights
  };
}
function Ui(n) {
  if (Wt(n.widgetType))
    throw new zi("toChartWidgetProps");
  if (Lr(n.widgetType))
    throw new od("toChartWidgetProps");
  return {
    chartType: n.chartType,
    dataOptions: n.dataOptions,
    styleOptions: n.styleOptions,
    dataSource: n.dataSource,
    filters: n.filters,
    highlights: n.highlights,
    title: n.title,
    description: n.description || "",
    drilldownOptions: n.drilldownOptions
  };
}
function Zu(n) {
  if (!Va(n.widgetType))
    throw new ne("errors.widgetModel.onlyTableWidgetSupported", {
      methodName: "toTableWidgetProps"
    });
  return {
    dataOptions: n.dataOptions,
    styleOptions: n.styleOptions,
    dataSource: n.dataSource,
    filters: n.filters,
    title: n.title,
    description: n.description || ""
  };
}
function qi(n) {
  if (!Wt(n.widgetType))
    throw new ne("errors.widgetModel.onlyPivotWidgetSupported", {
      methodName: "toPivotTableWidgetProps"
    });
  return {
    dataOptions: n.dataOptions,
    styleOptions: n.styleOptions,
    dataSource: n.dataSource,
    filters: n.filters,
    highlights: n.highlights,
    title: n.title,
    description: n.description || ""
  };
}
function ji(n) {
  if (!Lr(n.widgetType))
    throw new ne("errors.widgetModel.onlyTextWidgetSupported", {
      methodName: "toTextWidgetProps"
    });
  return { styleOptions: n.styleOptions };
}
function ed(n) {
  if (!lu(n.widgetType))
    throw new ne("errors.widgetModel.onlyPluginWidgetSupported", {
      methodName: "toPluginWidgetProps"
    });
  return {
    pluginType: n.pluginType,
    dataOptions: n.dataOptions,
    styleOptions: n.styleOptions,
    dataSource: n.dataSource,
    filters: n.filters,
    highlights: n.highlights,
    title: n.title,
    description: n.description || ""
  };
}
function td(n) {
  const { widgetType: r } = n;
  return Wt(r) ? w({ widgetType: "pivot" }, qi(n)) : Lr(r) ? w({ widgetType: "text" }, ji(n)) : lu(r) ? w({ widgetType: "plugin" }, ed(n)) : w({ widgetType: "chart" }, Ui(n));
}
function nd(n) {
  const { oid: r } = n;
  return E(w({}, td(n)), { id: r });
}
const Ut = () => {
  throw new ne("errors.methodNotImplemented");
}, rd = {
  oid: "",
  title: "",
  dataSource: "",
  description: "",
  widgetType: "plugin",
  pluginType: "",
  dataOptions: {},
  styleOptions: {},
  drilldownOptions: {},
  filters: [],
  highlights: [],
  chartType: void 0,
  getExecuteQueryParams: Ut,
  getExecutePivotQueryParams: Ut,
  getChartProps: Ut,
  getTableProps: Ut,
  getPivotTableProps: Ut,
  getPivotTableWidgetProps: Ut,
  getChartWidgetProps: Ut,
  getTableWidgetProps: Ut,
  getTextWidgetProps: Ut
};
function ad(n) {
  return E(w({}, n), {
    getExecuteQueryParams: () => Gu(n),
    getExecutePivotQueryParams: () => Ku(n),
    getChartProps: () => Xu(n),
    getTableProps: () => Qi(n),
    getPivotTableProps: () => Ju(n),
    getChartWidgetProps: () => Ui(n),
    getTableWidgetProps: () => Zu(n),
    getPivotTableWidgetProps: () => qi(n),
    getTextWidgetProps: () => ji(n)
  });
}
function Hr(n, r, e) {
  var f, p, h, m;
  let t, a, o, i;
  const s = pp(n.metadata.panels, n.datasource);
  if (t = n.type, !nh(t))
    a = t, t = "plugin", o = hp(s, (f = r == null ? void 0 : r.palette.variantColors) != null ? f : []), i = n.style;
  else {
    o = mp(
      t,
      s,
      n.style,
      r == null ? void 0 : r.palette.variantColors
    ), i = Zy(t, n);
    const g = (m = (h = (p = e == null ? void 0 : e.serverFeatures) == null ? void 0 : p.widgetDesignStyle) == null ? void 0 : h.active) != null ? m : !0;
    i = eb(
      i,
      n.style.widgetDesign,
      g
    );
  }
  const l = db(t, s), c = Vu(s), u = sh(t) ? ch(t) : void 0, d = E(w({}, rd), {
    oid: n.oid,
    title: n.title,
    dataSource: Fi(n.datasource),
    description: n.desc || "",
    widgetType: t,
    chartType: u,
    pluginType: a || "",
    dataOptions: o || {},
    styleOptions: i || {},
    drilldownOptions: l,
    filters: c
  });
  return ad(d);
}
function hb(n) {
  const r = rh(n.chartType), e = E(w(w({}, rd), n), {
    filters: n.filters || [],
    // typecast because of FilterRelation tmp incompatibility
    widgetType: r
  });
  return ad(e);
}
function mb(n, r) {
  const e = n.chartType;
  let t = n.widgetType, a = {}, o = n.styleOptions.subtype || "";
  if (!e)
    throw new Error("Chart type is required");
  const i = [];
  if (ah(e)) {
    const l = ["chart/line", "chart/area"].includes(n.widgetType) ? "x-axis" : "categories", c = n.dataOptions.category.map(
      (p) => jn(Eo(p))
    ), u = {
      name: l,
      items: c
    };
    i.push(u);
    const d = n.dataOptions.value.map(
      (p) => jn(Mo(p))
    );
    i.push({
      name: "values",
      items: d
    });
    const f = n.dataOptions.breakBy.map(
      (p) => jn(Eo(p))
    );
    i.push({
      name: "break by",
      items: f
    });
  } else if (oh(e)) {
    const { attributes: l, measures: c } = ql(
      n.dataOptions
    ), u = [
      ...l.map((d) => jn(Eo(d))),
      ...c.map((d) => jn(Mo(d)))
    ];
    i.push({
      name: "columns",
      items: u
    }), i.push({
      name: "filters",
      items: []
    }), t = "tablewidget";
  } else if (ih(e))
    ["value", "min", "max", "secondary"].forEach((l) => {
      const c = (n.dataOptions[l] || []).map((u) => jn(Mo(u)));
      i.push({ name: l, items: c });
    }), i.push({
      name: "filters",
      items: []
    }), o = n.styleOptions.subtype, a = void 0;
  else
    throw new Error("Unsupported chart type");
  return {
    oid: n.oid || "",
    title: n.title,
    desc: n.description,
    datasource: r,
    type: t,
    metadata: {
      panels: i
    },
    style: a,
    subtype: o
  };
}
class zi extends ne {
  constructor(r) {
    super("errors.widgetModel.pivotWidgetNotSupported", { methodName: r });
  }
}
class od extends ne {
  constructor(r) {
    super("errors.widgetModel.textWidgetNotSupported", { methodName: r });
  }
}
const VC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fromChartWidgetProps: hb,
  fromWidgetDto: Hr,
  toChartProps: Xu,
  toChartWidgetProps: Ui,
  toCommonWidgetProps: td,
  toExecutePivotQueryParams: Ku,
  toExecuteQueryParams: Gu,
  toPivotTableProps: Ju,
  toPivotTableWidgetProps: qi,
  toPluginWidgetProps: ed,
  toTableProps: Qi,
  toTableWidgetProps: Zu,
  toTextWidgetProps: ji,
  toWidgetDto: mb,
  toWidgetProps: nd
}, Symbol.toStringTag, { value: "Module" })), gb = (n) => "levels" in n && n.isCascading === !0;
var Jn = /* @__PURE__ */ ((n) => (n.HIGHLIGHT = "highlight", n.FILTER = "filter", n))(Jn || {});
const yb = (n) => ({
  columns: n.columns.map((r) => ({
    widthPercentage: r.width,
    rows: (r.cells || []).map((e) => {
      const t = e.subcells.reduce((a, o) => a + o.width, 0);
      return {
        cells: e.subcells.map((a) => ({
          // If the total width of the subcells is less than 100, we increase width percentage to make the subcells fill the column
          widthPercentage: t < 100 ? a.width / (t / 100) : a.width,
          height: a.elements[0].height,
          widgetId: a.elements[0].widgetid
        }))
      };
    })
  }))
}), bb = (n) => {
  var e, t;
  const r = Sr(n.jaql, n.instanceid);
  return r.disabled = (e = n.disabled) != null ? e : !1, r.locked = (t = n.locked) != null ? t : !1, r;
}, vb = (n) => {
  var t, a;
  const r = n.levels.map(
    (o) => Sr(o, n.instanceid)
  ), e = new Ii(r, n.instanceid);
  return e.disabled = (t = n.disabled) != null ? t : !1, e.locked = (a = n.locked) != null ? a : !1, e;
};
function wb(n) {
  return n.map(
    (r) => gb(r) ? vb(r) : bb(r)
  );
}
function _b(n = []) {
  const r = {};
  return n.forEach((e) => {
    var t, a, o, i;
    r[e.oid] = {
      filtersOptions: {
        applyMode: ((t = e.options) == null ? void 0 : t.dashboardFiltersMode) === "filter" ? Jn.FILTER : Jn.HIGHLIGHT,
        shouldAffectFilters: (a = e.options) == null ? void 0 : a.selector,
        ignoreFilters: {
          all: (o = e.metadata.ignore) == null ? void 0 : o.all,
          ids: (i = e.metadata.ignore) == null ? void 0 : i.ids
        },
        forceApplyBackgroundFilters: !0
      }
    };
  }), r;
}
function id(n) {
  const {
    title: r,
    dataSource: e,
    widgets: t,
    layoutOptions: a,
    filters: o,
    widgetsOptions: i,
    styleOptions: s
  } = n;
  return {
    title: r,
    defaultDataSource: e,
    widgets: t.map(nd),
    layoutOptions: a,
    config: {},
    filters: o,
    widgetsOptions: i,
    styleOptions: s
  };
}
function Vi(n, r, e) {
  const {
    oid: t,
    title: a,
    datasource: o,
    widgets: i,
    layout: s,
    filters: l,
    style: c
  } = n, u = {
    title: o.title,
    type: o.live ? "live" : "elasticube"
  }, d = w({}, c != null && c.palette ? { palette: { variantColors: c == null ? void 0 : c.palette.colors } } : null), f = r && w(w({}, r), d.palette ? { palette: d.palette } : null), p = (i == null ? void 0 : i.map(
    (v) => Hr(v, f, e)
  )) || [], h = s ? yb(s) : { columns: [] }, m = wb(l || []), g = _b(i);
  return {
    oid: t,
    title: a,
    dataSource: u,
    styleOptions: d,
    widgets: p,
    layoutOptions: { widgetsPanel: h },
    filters: m,
    widgetsOptions: g
  };
}
const GC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fromDashboardDto: Vi,
  toDashboardProps: id
}, Symbol.toStringTag, { value: "Module" }));
function Db(n) {
  const { disabled: r } = n, e = Object.assign(Object.create(n), { disabled: !1 }).jaql(!0);
  return {
    jaql: E(w({}, e), {
      table: lh(n.attribute),
      column: uh(n.attribute)
    }),
    disabled: r,
    instanceid: n.id,
    isCascading: !1
  };
}
var sd = /* @__PURE__ */ ((n) => (n.DASHBOARD_INIT = "DASHBOARD.INIT", n))(sd || {}), cd = /* @__PURE__ */ ((n) => (n.FILTERS_UPDATE = "FILTERS.UPDATE", n))(cd || {});
function vc(n, r) {
  switch (r.type) {
    case "DASHBOARD.INIT":
      return w(w({}, n), r.payload);
    case "FILTERS.UPDATE":
      return E(w({}, n), {
        filters: r.payload
      });
    default:
      return n;
  }
}
function kb(n, r) {
  return (e, t) => (e !== null && t.type !== "DASHBOARD.INIT" && xb(e, t, n).catch((a) => {
    console.error("Failed to persist dashboard model changes with error:", a);
  }), r(e, t));
}
function xb(n, r, e) {
  return r.type === "FILTERS.UPDATE" ? e.patchDashboard(n.oid, {
    filters: r.payload.map(Db)
  }) : Promise.resolve(null);
}
function Cb(n) {
  return n.type === Df.FILTERS_UPDATE ? {
    type: cd.FILTERS_UPDATE,
    payload: n.payload
  } : null;
}
function Tb(n, r) {
  return n === "wat" ? (r && console.warn(
    'WAT authentication does not support persistence. The changes will not be saved.Disable "persist" flag to avoid this warning.'
  ), !1) : !0;
}
const Sb = mt("useDashboardModel")(Eb);
function Eb({
  dashboardOid: n,
  includeWidgets: r,
  includeFilters: e,
  persist: t = !0
}) {
  const a = Ql(), { app: o } = Ye(), i = pe(
    () => !!(o != null && o.httpClient.auth) && Tb(o.httpClient.auth.type, t),
    [o == null ? void 0 : o.httpClient.auth, t]
  ), s = t && i, l = pe(
    () => s ? kb(a, vc) : vc,
    [s, a]
  ), [c, u] = Ht(l, null), {
    dashboard: d,
    isLoading: f,
    isError: p
  } = Py({
    dashboardOid: n,
    includeWidgets: r,
    includeFilters: e
  });
  return ge(() => {
    d && u({
      type: sd.DASHBOARD_INIT,
      payload: d
    });
  }, [d]), {
    dashboard: c,
    isLoading: f,
    isError: p,
    dispatchChanges: u
  };
}
/*! @license DOMPurify 3.1.6 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.1.6/LICENSE */
const {
  entries: ld,
  setPrototypeOf: wc,
  isFrozen: Mb,
  getPrototypeOf: Pb,
  getOwnPropertyDescriptor: Ab
} = Object;
let {
  freeze: Je,
  seal: ht,
  create: ud
} = Object, {
  apply: ai,
  construct: oi
} = typeof Reflect != "undefined" && Reflect;
Je || (Je = function(r) {
  return r;
});
ht || (ht = function(r) {
  return r;
});
ai || (ai = function(r, e, t) {
  return r.apply(e, t);
});
oi || (oi = function(r, e) {
  return new r(...e);
});
const ea = st(Array.prototype.forEach), _c = st(Array.prototype.pop), pr = st(Array.prototype.push), da = st(String.prototype.toLowerCase), Yo = st(String.prototype.toString), Dc = st(String.prototype.match), hr = st(String.prototype.replace), Ob = st(String.prototype.indexOf), Nb = st(String.prototype.trim), wt = st(Object.prototype.hasOwnProperty), Ve = st(RegExp.prototype.test), mr = Rb(TypeError);
function st(n) {
  return function(r) {
    for (var e = arguments.length, t = new Array(e > 1 ? e - 1 : 0), a = 1; a < e; a++)
      t[a - 1] = arguments[a];
    return ai(n, r, t);
  };
}
function Rb(n) {
  return function() {
    for (var r = arguments.length, e = new Array(r), t = 0; t < r; t++)
      e[t] = arguments[t];
    return oi(n, e);
  };
}
function re(n, r) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : da;
  wc && wc(n, null);
  let t = r.length;
  for (; t--; ) {
    let a = r[t];
    if (typeof a == "string") {
      const o = e(a);
      o !== a && (Mb(r) || (r[t] = o), a = o);
    }
    n[a] = !0;
  }
  return n;
}
function Fb(n) {
  for (let r = 0; r < n.length; r++)
    wt(n, r) || (n[r] = null);
  return n;
}
function vn(n) {
  const r = ud(null);
  for (const [e, t] of ld(n))
    wt(n, e) && (Array.isArray(t) ? r[e] = Fb(t) : t && typeof t == "object" && t.constructor === Object ? r[e] = vn(t) : r[e] = t);
  return r;
}
function gr(n, r) {
  for (; n !== null; ) {
    const t = Ab(n, r);
    if (t) {
      if (t.get)
        return st(t.get);
      if (typeof t.value == "function")
        return st(t.value);
    }
    n = Pb(n);
  }
  function e() {
    return null;
  }
  return e;
}
const kc = Je(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Wo = Je(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Ho = Je(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), Ib = Je(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), $o = Je(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), Lb = Je(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), xc = Je(["#text"]), Cc = Je(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), Bo = Je(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), Tc = Je(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), ta = Je(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), Yb = ht(/\{\{[\w\W]*|[\w\W]*\}\}/gm), Wb = ht(/<%[\w\W]*|[\w\W]*%>/gm), Hb = ht(/\${[\w\W]*}/gm), $b = ht(/^data-[\-\w.\u00B7-\uFFFF]/), Bb = ht(/^aria-[\-\w]+$/), dd = ht(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), Qb = ht(/^(?:\w+script|data):/i), Ub = ht(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), fd = ht(/^html$/i), qb = ht(/^[a-z][.\w]*(-[.\w]+)+$/i);
var Sc = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  MUSTACHE_EXPR: Yb,
  ERB_EXPR: Wb,
  TMPLIT_EXPR: Hb,
  DATA_ATTR: $b,
  ARIA_ATTR: Bb,
  IS_ALLOWED_URI: dd,
  IS_SCRIPT_OR_DATA: Qb,
  ATTR_WHITESPACE: Ub,
  DOCTYPE_NAME: fd,
  CUSTOM_ELEMENT: qb
});
const yr = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12
  // Deprecated
}, jb = function() {
  return typeof window == "undefined" ? null : window;
}, zb = function(r, e) {
  if (typeof r != "object" || typeof r.createPolicy != "function")
    return null;
  let t = null;
  const a = "data-tt-policy-suffix";
  e && e.hasAttribute(a) && (t = e.getAttribute(a));
  const o = "dompurify" + (t ? "#" + t : "");
  try {
    return r.createPolicy(o, {
      createHTML(i) {
        return i;
      },
      createScriptURL(i) {
        return i;
      }
    });
  } catch (i) {
    return console.warn("TrustedTypes policy " + o + " could not be created."), null;
  }
};
function pd() {
  let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : jb();
  const r = (z) => pd(z);
  if (r.version = "3.1.6", r.removed = [], !n || !n.document || n.document.nodeType !== yr.document)
    return r.isSupported = !1, r;
  let {
    document: e
  } = n;
  const t = e, a = t.currentScript, {
    DocumentFragment: o,
    HTMLTemplateElement: i,
    Node: s,
    Element: l,
    NodeFilter: c,
    NamedNodeMap: u = n.NamedNodeMap || n.MozNamedAttrMap,
    HTMLFormElement: d,
    DOMParser: f,
    trustedTypes: p
  } = n, h = l.prototype, m = gr(h, "cloneNode"), g = gr(h, "remove"), b = gr(h, "nextSibling"), v = gr(h, "childNodes"), D = gr(h, "parentNode");
  if (typeof i == "function") {
    const z = e.createElement("template");
    z.content && z.content.ownerDocument && (e = z.content.ownerDocument);
  }
  let k, x = "";
  const {
    implementation: R,
    createNodeIterator: I,
    createDocumentFragment: L,
    getElementsByTagName: A
  } = e, {
    importNode: W
  } = t;
  let O = {};
  r.isSupported = typeof ld == "function" && typeof D == "function" && R && R.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: U,
    ERB_EXPR: $,
    TMPLIT_EXPR: N,
    DATA_ATTR: T,
    ARIA_ATTR: M,
    IS_SCRIPT_OR_DATA: C,
    ATTR_WHITESPACE: S,
    CUSTOM_ELEMENT: F
  } = Sc;
  let {
    IS_ALLOWED_URI: K
  } = Sc, X = null;
  const he = re({}, [...kc, ...Wo, ...Ho, ...$o, ...xc]);
  let ee = null;
  const Se = re({}, [...Cc, ...Bo, ...Tc, ...ta]);
  let ae = Object.seal(ud(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), ut = null, gt = null, tn = !0, yt = !0, Oe = !1, bt = !0, dt = !1, nn = !0, yn = !1, go = !1, yo = !1, $n = !1, jr = !1, zr = !1, bs = !0, vs = !1;
  const Tf = "user-content-";
  let bo = !0, ur = !1, Bn = {}, Qn = null;
  const ws = re({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let _s = null;
  const Ds = re({}, ["audio", "video", "img", "source", "image", "track"]);
  let vo = null;
  const ks = re({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Vr = "http://www.w3.org/1998/Math/MathML", Gr = "http://www.w3.org/2000/svg", $t = "http://www.w3.org/1999/xhtml";
  let Un = $t, wo = !1, _o = null;
  const Sf = re({}, [Vr, Gr, $t], Yo);
  let dr = null;
  const Ef = ["application/xhtml+xml", "text/html"], Mf = "text/html";
  let Pe = null, qn = null;
  const Pf = e.createElement("form"), xs = function(_) {
    return _ instanceof RegExp || _ instanceof Function;
  }, Do = function() {
    let _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(qn && qn === _)) {
      if ((!_ || typeof _ != "object") && (_ = {}), _ = vn(_), dr = // eslint-disable-next-line unicorn/prefer-includes
      Ef.indexOf(_.PARSER_MEDIA_TYPE) === -1 ? Mf : _.PARSER_MEDIA_TYPE, Pe = dr === "application/xhtml+xml" ? Yo : da, X = wt(_, "ALLOWED_TAGS") ? re({}, _.ALLOWED_TAGS, Pe) : he, ee = wt(_, "ALLOWED_ATTR") ? re({}, _.ALLOWED_ATTR, Pe) : Se, _o = wt(_, "ALLOWED_NAMESPACES") ? re({}, _.ALLOWED_NAMESPACES, Yo) : Sf, vo = wt(_, "ADD_URI_SAFE_ATTR") ? re(
        vn(ks),
        // eslint-disable-line indent
        _.ADD_URI_SAFE_ATTR,
        // eslint-disable-line indent
        Pe
        // eslint-disable-line indent
      ) : ks, _s = wt(_, "ADD_DATA_URI_TAGS") ? re(
        vn(Ds),
        // eslint-disable-line indent
        _.ADD_DATA_URI_TAGS,
        // eslint-disable-line indent
        Pe
        // eslint-disable-line indent
      ) : Ds, Qn = wt(_, "FORBID_CONTENTS") ? re({}, _.FORBID_CONTENTS, Pe) : ws, ut = wt(_, "FORBID_TAGS") ? re({}, _.FORBID_TAGS, Pe) : {}, gt = wt(_, "FORBID_ATTR") ? re({}, _.FORBID_ATTR, Pe) : {}, Bn = wt(_, "USE_PROFILES") ? _.USE_PROFILES : !1, tn = _.ALLOW_ARIA_ATTR !== !1, yt = _.ALLOW_DATA_ATTR !== !1, Oe = _.ALLOW_UNKNOWN_PROTOCOLS || !1, bt = _.ALLOW_SELF_CLOSE_IN_ATTR !== !1, dt = _.SAFE_FOR_TEMPLATES || !1, nn = _.SAFE_FOR_XML !== !1, yn = _.WHOLE_DOCUMENT || !1, $n = _.RETURN_DOM || !1, jr = _.RETURN_DOM_FRAGMENT || !1, zr = _.RETURN_TRUSTED_TYPE || !1, yo = _.FORCE_BODY || !1, bs = _.SANITIZE_DOM !== !1, vs = _.SANITIZE_NAMED_PROPS || !1, bo = _.KEEP_CONTENT !== !1, ur = _.IN_PLACE || !1, K = _.ALLOWED_URI_REGEXP || dd, Un = _.NAMESPACE || $t, ae = _.CUSTOM_ELEMENT_HANDLING || {}, _.CUSTOM_ELEMENT_HANDLING && xs(_.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (ae.tagNameCheck = _.CUSTOM_ELEMENT_HANDLING.tagNameCheck), _.CUSTOM_ELEMENT_HANDLING && xs(_.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (ae.attributeNameCheck = _.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), _.CUSTOM_ELEMENT_HANDLING && typeof _.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (ae.allowCustomizedBuiltInElements = _.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), dt && (yt = !1), jr && ($n = !0), Bn && (X = re({}, xc), ee = [], Bn.html === !0 && (re(X, kc), re(ee, Cc)), Bn.svg === !0 && (re(X, Wo), re(ee, Bo), re(ee, ta)), Bn.svgFilters === !0 && (re(X, Ho), re(ee, Bo), re(ee, ta)), Bn.mathMl === !0 && (re(X, $o), re(ee, Tc), re(ee, ta))), _.ADD_TAGS && (X === he && (X = vn(X)), re(X, _.ADD_TAGS, Pe)), _.ADD_ATTR && (ee === Se && (ee = vn(ee)), re(ee, _.ADD_ATTR, Pe)), _.ADD_URI_SAFE_ATTR && re(vo, _.ADD_URI_SAFE_ATTR, Pe), _.FORBID_CONTENTS && (Qn === ws && (Qn = vn(Qn)), re(Qn, _.FORBID_CONTENTS, Pe)), bo && (X["#text"] = !0), yn && re(X, ["html", "head", "body"]), X.table && (re(X, ["tbody"]), delete ut.tbody), _.TRUSTED_TYPES_POLICY) {
        if (typeof _.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw mr('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof _.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw mr('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        k = _.TRUSTED_TYPES_POLICY, x = k.createHTML("");
      } else
        k === void 0 && (k = zb(p, a)), k !== null && typeof x == "string" && (x = k.createHTML(""));
      Je && Je(_), qn = _;
    }
  }, Cs = re({}, ["mi", "mo", "mn", "ms", "mtext"]), Ts = re({}, ["foreignobject", "annotation-xml"]), Af = re({}, ["title", "style", "font", "a", "script"]), Ss = re({}, [...Wo, ...Ho, ...Ib]), Es = re({}, [...$o, ...Lb]), Of = function(_) {
    let Y = D(_);
    (!Y || !Y.tagName) && (Y = {
      namespaceURI: Un,
      tagName: "template"
    });
    const q = da(_.tagName), ye = da(Y.tagName);
    return _o[_.namespaceURI] ? _.namespaceURI === Gr ? Y.namespaceURI === $t ? q === "svg" : Y.namespaceURI === Vr ? q === "svg" && (ye === "annotation-xml" || Cs[ye]) : !!Ss[q] : _.namespaceURI === Vr ? Y.namespaceURI === $t ? q === "math" : Y.namespaceURI === Gr ? q === "math" && Ts[ye] : !!Es[q] : _.namespaceURI === $t ? Y.namespaceURI === Gr && !Ts[ye] || Y.namespaceURI === Vr && !Cs[ye] ? !1 : !Es[q] && (Af[q] || !Ss[q]) : !!(dr === "application/xhtml+xml" && _o[_.namespaceURI]) : !1;
  }, St = function(_) {
    pr(r.removed, {
      element: _
    });
    try {
      D(_).removeChild(_);
    } catch (Y) {
      g(_);
    }
  }, Kr = function(_, Y) {
    try {
      pr(r.removed, {
        attribute: Y.getAttributeNode(_),
        from: Y
      });
    } catch (q) {
      pr(r.removed, {
        attribute: null,
        from: Y
      });
    }
    if (Y.removeAttribute(_), _ === "is" && !ee[_])
      if ($n || jr)
        try {
          St(Y);
        } catch (q) {
        }
      else
        try {
          Y.setAttribute(_, "");
        } catch (q) {
        }
  }, Ms = function(_) {
    let Y = null, q = null;
    if (yo)
      _ = "<remove></remove>" + _;
    else {
      const Ne = Dc(_, /^[\r\n\t ]+/);
      q = Ne && Ne[0];
    }
    dr === "application/xhtml+xml" && Un === $t && (_ = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + _ + "</body></html>");
    const ye = k ? k.createHTML(_) : _;
    if (Un === $t)
      try {
        Y = new f().parseFromString(ye, dr);
      } catch (Ne) {
      }
    if (!Y || !Y.documentElement) {
      Y = R.createDocument(Un, "template", null);
      try {
        Y.documentElement.innerHTML = wo ? x : ye;
      } catch (Ne) {
      }
    }
    const He = Y.body || Y.documentElement;
    return _ && q && He.insertBefore(e.createTextNode(q), He.childNodes[0] || null), Un === $t ? A.call(Y, yn ? "html" : "body")[0] : yn ? Y.documentElement : He;
  }, Ps = function(_) {
    return I.call(
      _.ownerDocument || _,
      _,
      // eslint-disable-next-line no-bitwise
      c.SHOW_ELEMENT | c.SHOW_COMMENT | c.SHOW_TEXT | c.SHOW_PROCESSING_INSTRUCTION | c.SHOW_CDATA_SECTION,
      null
    );
  }, As = function(_) {
    return _ instanceof d && (typeof _.nodeName != "string" || typeof _.textContent != "string" || typeof _.removeChild != "function" || !(_.attributes instanceof u) || typeof _.removeAttribute != "function" || typeof _.setAttribute != "function" || typeof _.namespaceURI != "string" || typeof _.insertBefore != "function" || typeof _.hasChildNodes != "function");
  }, Os = function(_) {
    return typeof s == "function" && _ instanceof s;
  }, Bt = function(_, Y, q) {
    O[_] && ea(O[_], (ye) => {
      ye.call(r, Y, q, qn);
    });
  }, Ns = function(_) {
    let Y = null;
    if (Bt("beforeSanitizeElements", _, null), As(_))
      return St(_), !0;
    const q = Pe(_.nodeName);
    if (Bt("uponSanitizeElement", _, {
      tagName: q,
      allowedTags: X
    }), _.hasChildNodes() && !Os(_.firstElementChild) && Ve(/<[/\w]/g, _.innerHTML) && Ve(/<[/\w]/g, _.textContent) || _.nodeType === yr.progressingInstruction || nn && _.nodeType === yr.comment && Ve(/<[/\w]/g, _.data))
      return St(_), !0;
    if (!X[q] || ut[q]) {
      if (!ut[q] && Fs(q) && (ae.tagNameCheck instanceof RegExp && Ve(ae.tagNameCheck, q) || ae.tagNameCheck instanceof Function && ae.tagNameCheck(q)))
        return !1;
      if (bo && !Qn[q]) {
        const ye = D(_) || _.parentNode, He = v(_) || _.childNodes;
        if (He && ye) {
          const Ne = He.length;
          for (let tt = Ne - 1; tt >= 0; --tt) {
            const Et = m(He[tt], !0);
            Et.__removalCount = (_.__removalCount || 0) + 1, ye.insertBefore(Et, b(_));
          }
        }
      }
      return St(_), !0;
    }
    return _ instanceof l && !Of(_) || (q === "noscript" || q === "noembed" || q === "noframes") && Ve(/<\/no(script|embed|frames)/i, _.innerHTML) ? (St(_), !0) : (dt && _.nodeType === yr.text && (Y = _.textContent, ea([U, $, N], (ye) => {
      Y = hr(Y, ye, " ");
    }), _.textContent !== Y && (pr(r.removed, {
      element: _.cloneNode()
    }), _.textContent = Y)), Bt("afterSanitizeElements", _, null), !1);
  }, Rs = function(_, Y, q) {
    if (bs && (Y === "id" || Y === "name") && (q in e || q in Pf))
      return !1;
    if (!(yt && !gt[Y] && Ve(T, Y))) {
      if (!(tn && Ve(M, Y))) {
        if (!ee[Y] || gt[Y]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(Fs(_) && (ae.tagNameCheck instanceof RegExp && Ve(ae.tagNameCheck, _) || ae.tagNameCheck instanceof Function && ae.tagNameCheck(_)) && (ae.attributeNameCheck instanceof RegExp && Ve(ae.attributeNameCheck, Y) || ae.attributeNameCheck instanceof Function && ae.attributeNameCheck(Y)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            Y === "is" && ae.allowCustomizedBuiltInElements && (ae.tagNameCheck instanceof RegExp && Ve(ae.tagNameCheck, q) || ae.tagNameCheck instanceof Function && ae.tagNameCheck(q)))
          )
            return !1;
        } else if (!vo[Y]) {
          if (!Ve(K, hr(q, S, ""))) {
            if (!((Y === "src" || Y === "xlink:href" || Y === "href") && _ !== "script" && Ob(q, "data:") === 0 && _s[_])) {
              if (!(Oe && !Ve(C, hr(q, S, "")))) {
                if (q)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, Fs = function(_) {
    return _ !== "annotation-xml" && Dc(_, F);
  }, Is = function(_) {
    Bt("beforeSanitizeAttributes", _, null);
    const {
      attributes: Y
    } = _;
    if (!Y)
      return;
    const q = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: ee
    };
    let ye = Y.length;
    for (; ye--; ) {
      const He = Y[ye], {
        name: Ne,
        namespaceURI: tt,
        value: Et
      } = He, fr = Pe(Ne);
      let ze = Ne === "value" ? Et : Nb(Et);
      if (q.attrName = fr, q.attrValue = ze, q.keepAttr = !0, q.forceKeepAttr = void 0, Bt("uponSanitizeAttribute", _, q), ze = q.attrValue, nn && Ve(/((--!?|])>)|<\/(style|title)/i, ze)) {
        Kr(Ne, _);
        continue;
      }
      if (q.forceKeepAttr || (Kr(Ne, _), !q.keepAttr))
        continue;
      if (!bt && Ve(/\/>/i, ze)) {
        Kr(Ne, _);
        continue;
      }
      dt && ea([U, $, N], (Ys) => {
        ze = hr(ze, Ys, " ");
      });
      const Ls = Pe(_.nodeName);
      if (Rs(Ls, fr, ze)) {
        if (vs && (fr === "id" || fr === "name") && (Kr(Ne, _), ze = Tf + ze), k && typeof p == "object" && typeof p.getAttributeType == "function" && !tt)
          switch (p.getAttributeType(Ls, fr)) {
            case "TrustedHTML": {
              ze = k.createHTML(ze);
              break;
            }
            case "TrustedScriptURL": {
              ze = k.createScriptURL(ze);
              break;
            }
          }
        try {
          tt ? _.setAttributeNS(tt, Ne, ze) : _.setAttribute(Ne, ze), As(_) ? St(_) : _c(r.removed);
        } catch (Ys) {
        }
      }
    }
    Bt("afterSanitizeAttributes", _, null);
  }, Nf = function z(_) {
    let Y = null;
    const q = Ps(_);
    for (Bt("beforeSanitizeShadowDOM", _, null); Y = q.nextNode(); )
      Bt("uponSanitizeShadowNode", Y, null), !Ns(Y) && (Y.content instanceof o && z(Y.content), Is(Y));
    Bt("afterSanitizeShadowDOM", _, null);
  };
  return r.sanitize = function(z) {
    let _ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Y = null, q = null, ye = null, He = null;
    if (wo = !z, wo && (z = "<!-->"), typeof z != "string" && !Os(z))
      if (typeof z.toString == "function") {
        if (z = z.toString(), typeof z != "string")
          throw mr("dirty is not a string, aborting");
      } else
        throw mr("toString is not a function");
    if (!r.isSupported)
      return z;
    if (go || Do(_), r.removed = [], typeof z == "string" && (ur = !1), ur) {
      if (z.nodeName) {
        const Et = Pe(z.nodeName);
        if (!X[Et] || ut[Et])
          throw mr("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (z instanceof s)
      Y = Ms("<!---->"), q = Y.ownerDocument.importNode(z, !0), q.nodeType === yr.element && q.nodeName === "BODY" || q.nodeName === "HTML" ? Y = q : Y.appendChild(q);
    else {
      if (!$n && !dt && !yn && // eslint-disable-next-line unicorn/prefer-includes
      z.indexOf("<") === -1)
        return k && zr ? k.createHTML(z) : z;
      if (Y = Ms(z), !Y)
        return $n ? null : zr ? x : "";
    }
    Y && yo && St(Y.firstChild);
    const Ne = Ps(ur ? z : Y);
    for (; ye = Ne.nextNode(); )
      Ns(ye) || (ye.content instanceof o && Nf(ye.content), Is(ye));
    if (ur)
      return z;
    if ($n) {
      if (jr)
        for (He = L.call(Y.ownerDocument); Y.firstChild; )
          He.appendChild(Y.firstChild);
      else
        He = Y;
      return (ee.shadowroot || ee.shadowrootmode) && (He = W.call(t, He, !0)), He;
    }
    let tt = yn ? Y.outerHTML : Y.innerHTML;
    return yn && X["!doctype"] && Y.ownerDocument && Y.ownerDocument.doctype && Y.ownerDocument.doctype.name && Ve(fd, Y.ownerDocument.doctype.name) && (tt = "<!DOCTYPE " + Y.ownerDocument.doctype.name + `>
` + tt), dt && ea([U, $, N], (Et) => {
      tt = hr(tt, Et, " ");
    }), k && zr ? k.createHTML(tt) : tt;
  }, r.setConfig = function() {
    let z = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Do(z), go = !0;
  }, r.clearConfig = function() {
    qn = null, go = !1;
  }, r.isValidAttribute = function(z, _, Y) {
    qn || Do({});
    const q = Pe(z), ye = Pe(_);
    return Rs(q, ye, Y);
  }, r.addHook = function(z, _) {
    typeof _ == "function" && (O[z] = O[z] || [], pr(O[z], _));
  }, r.removeHook = function(z) {
    if (O[z])
      return _c(O[z]);
  }, r.removeHooks = function(z) {
    O[z] && (O[z] = []);
  }, r.removeAllHooks = function() {
    O = {};
  }, r;
}
var Vb = pd();
function na(n) {
  return n !== null && typeof n == "object" && typeof n.styleOptions == "object" && typeof n.styleOptions.html == "string" && typeof n.styleOptions.bgColor == "string" && typeof n.styleOptions.vAlign == "string";
}
const Gb = {
  "valign-top": "flex-start",
  "valign-middle": "center",
  "valign-bottom": "flex-end"
}, Kb = Z.div`
  background-color: ${(n) => n.styleOptions.bgColor};
  display: flex;
  align-items: ${(n) => Gb[n.styleOptions.vAlign]};
  text-align: center;
  height: 100%;
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
`, Xb = Z.div`
  width: 100%;
`, hd = se({
  componentName: "TextWidget"
})((n) => {
  const r = Vb.sanitize(n.styleOptions.html);
  return /* @__PURE__ */ y(Kb, { styleOptions: n.styleOptions, children: /* @__PURE__ */ y(Xb, { dangerouslySetInnerHTML: { __html: r } }) });
}), Jb = /* @__PURE__ */ new Map(), Gi = am({
  plugins: Jb,
  registerPlugin: () => {
  },
  getPlugin: () => {
  }
}), Zb = ({ children: n }) => {
  const r = it(/* @__PURE__ */ new Map()), e = le((o, i) => {
    r.current.has(o) || r.current.set(o, i);
  }, []), t = le((o) => r.current.get(o), []), a = pe(() => r.current, []);
  return /* @__PURE__ */ y(Gi.Provider, { value: { registerPlugin: e, getPlugin: t, plugins: a }, children: n });
}, ev = () => om(Gi), tv = (n) => {
  var s;
  const { t: r } = We(), { plugins: e } = ev(), { app: t } = Ye(), a = e.get(n.pluginType);
  if (!a)
    return /* @__PURE__ */ y(
      bp,
      {
        error: r("plugins.registerPrompt", { pluginType: n.pluginType })
      }
    );
  const o = (s = n.dataSource) != null ? s : t == null ? void 0 : t.defaultDataSource, i = {
    dataSource: o,
    dataOptions: n.dataOptions,
    styleOptions: n.styleOptions,
    filters: n.filters,
    highlights: n.highlights
  };
  return /* @__PURE__ */ y(Ei, { defaultSize: $l("line", { hasHeader: !0 }), children: /* @__PURE__ */ y(
    Bl,
    {
      title: n.title,
      description: n.description,
      dataSetName: o && Ln(o),
      children: a(i)
    }
  ) });
}, nv = (n) => /* @__PURE__ */ J(Pi, { onBeforeMenuOpen: n.onBeforeMenuOpen, children: [
  dh(n) && /* @__PURE__ */ y(tv, w({}, n)),
  fh(n) && /* @__PURE__ */ y(Qu, w({}, n)),
  uu(n) && /* @__PURE__ */ y(hd, w({}, n)),
  ph(n) && /* @__PURE__ */ y(jl, E(w({}, n), { highlightSelectionDisabled: !0 }))
] }), rv = (n) => /* @__PURE__ */ y(nv, w({}, n), n.id), Ec = Z.div`
  display: grid;
  grid-template-columns: ${({ widths: n }) => n.map((r) => `${r}%`).join(" ")};
`, av = Z.div`
  &:not(:first-of-type) {
    border-left: ${({ dividerWidth: n, dividerColor: r }) => Cn(r, n)};
  }
`, ov = Z.div`
  border-bottom: ${({ dividerWidth: n, dividerColor: r }) => Cn(r, n)};
  &:not(:first-of-type) {
    border-left: ${({ dividerWidth: n, dividerColor: r }) => Cn(r, n)};
  }
  height: ${({ height: n }) => `calc(${n} + 32px)`};
`, iv = ({ layout: n, widgets: r }) => {
  const { themeSettings: e } = ve(), t = pe(() => n != null ? n : ly(r), [n, r]);
  return /* @__PURE__ */ y(Ec, { widths: t.columns.map((a) => a.widthPercentage), children: t.columns.map((a, o) => {
    var i;
    return /* @__PURE__ */ y(
      av,
      {
        dividerWidth: e.dashboard.dividerLineWidth,
        dividerColor: e.dashboard.dividerLineColor,
        children: (i = a.rows) == null ? void 0 : i.map((s, l) => /* @__PURE__ */ y(
          Ec,
          {
            widths: s.cells.map((c) => c.widthPercentage),
            children: s.cells.map((c) => {
              const u = r.find((d) => d.id === c.widgetId);
              return /* @__PURE__ */ y(
                ov,
                {
                  height: c.height || 0,
                  dividerWidth: e.dashboard.dividerLineWidth,
                  dividerColor: e.dashboard.dividerLineColor,
                  children: u && /* @__PURE__ */ y(rv, w({}, u))
                },
                `${c.widgetId},${c.widthPercentage}`
              );
            })
          },
          `${o},${l}`
        ))
      },
      o
    );
  }) });
}, fa = "#d5d5d5", pa = 1, md = 48, sv = Z.div`
  height: ${md}px;
  font-family: ${({ font: n }) => n};
  background-color: ${({ background: n }) => n};
  color: ${({ color: n }) => n};
  border-bottom: ${Cn(fa, pa)};
  padding: 10px 20px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
`, cv = Z.div`
  font-size: 13px;
  font-weight: 700;
`, lv = ({ title: n }) => {
  const { themeSettings: r } = ve();
  return /* @__PURE__ */ y(
    sv,
    {
      font: r.typography.fontFamily,
      color: r.typography.primaryTextColor,
      background: r.general.backgroundColor,
      children: /* @__PURE__ */ y(cv, { children: n })
    }
  );
};
function ii(n, r) {
  return Dt(n, r);
}
const uv = [
  "dataSource",
  "dimensions",
  "measures",
  "count",
  "offset",
  "onBeforeQuery"
];
function gd(n) {
  return _t(n, uv, (r, e) => {
    const { filters: t, relations: a } = Mn(
      e.filters
    ), { filters: o, relations: i } = Mn(
      r.filters
    );
    return An(t, o) || yy(t, o, a, i) || An(e.highlights, r.highlights);
  });
}
const dv = mt("useExecuteQuery")(Ki);
function Ki(n) {
  var m;
  const r = gd(n), e = hn(n, r), [t, a] = me(!1), [o, i] = me(), { isInitialized: s, app: l } = Ye(), c = (m = l == null ? void 0 : l.settings.queryCacheConfig) == null ? void 0 : m.enabled, u = c ? wp : Ai, [d, f] = Ht(ii, {
    isLoading: !0,
    isError: !1,
    isSuccess: !1,
    status: "loading",
    error: void 0,
    data: void 0
  }), p = le(() => {
    c && o && (Al(o), i(void 0)), d.isLoading || a(!0);
  }, [c, o, d.isLoading]), h = le(
    (g, b) => {
      const {
        dataSource: v,
        dimensions: D,
        measures: k,
        filters: x,
        highlights: R,
        count: I = g.settings.queryLimit,
        offset: L,
        ungroup: A,
        onBeforeQuery: W
      } = b;
      f({ type: "loading" });
      const { filters: O, relations: U } = Mn(x), $ = [
        {
          dataSource: v,
          dimensions: D,
          measures: k,
          filters: O,
          filterRelations: U,
          highlights: R,
          count: I,
          offset: L,
          ungroup: A
        },
        g,
        { onBeforeQuery: W }
      ];
      if (c) {
        const N = vp(...$);
        o !== N && i(N);
      }
      u(...$).then((N) => {
        f({ type: "success", data: N });
      }).catch((N) => {
        f({ type: "error", error: N });
      });
    },
    [u, c, o]
  );
  return ge(() => {
    s || f({
      type: "error",
      error: new ne("errors.executeQueryNoSisenseContext")
    }), t && a(!1), e(l, t) && h(l, n);
  }, [l, u, s, n, h, e, t]), d.data && r ? E(w({}, ii(d, { type: "loading" })), { refetch: p }) : E(w({}, d), { refetch: p });
}
const yd = im((n, r) => /* @__PURE__ */ y(
  "button",
  E(w({}, n), {
    ref: r,
    className: "csdk-rounded disabled:csdk-cursor-not-allowed csdk-leading-[18px] csdk-text-[13px] csdk-py-[5px] csdk-px-[8px] csdk-text-text-content disabled:csdk-opacity-30 " + (n.className || ""),
    children: n.children
  })
)), fv = (n) => {
  const i = n, { tooltipTitle: r, disableTooltip: e, children: t, disabled: a } = i, o = Re(i, ["tooltipTitle", "disableTooltip", "children", "disabled"]);
  return /* @__PURE__ */ y(_p, { title: r, disableHoverListener: e, children: /* @__PURE__ */ y("span", { children: /* @__PURE__ */ y(
    yd,
    E(w({
      disabled: a,
      style: a ? E(w({}, o.style || {}), { pointerEvents: "none" }) : o.style
    }, o), {
      children: t
    })
  ) }) });
}, bd = (n) => {
  const l = n, { wrapperClassName: r, label: e, isLabelInactive: t, indeterminate: a } = l, o = Re(l, ["wrapperClassName", "label", "isLabelInactive", "indeterminate"]), i = ["csdk-border-l", "csdk-pl-3"], s = it(null);
  return ge(() => {
    s.current && (s.current.indeterminate = a != null ? a : !1);
  }, [s, a]), t && i.push("csdk-opacity-50"), /* @__PURE__ */ J(
    "label",
    {
      className: js(
        "csdk-my-[2px] csdk-flex csdk-items-center csdk-leading-4 csdk-text-[13px]",
        r,
        {
          "csdk-cursor-pointer": !n.disabled
        }
      ),
      children: [
        /* @__PURE__ */ y(
          "input",
          E(w({}, o), {
            ref: s,
            type: "checkbox",
            className: js(
              "csdk-accent-UI-default csdk-h-checkbox csdk-w-checkbox csdk-m-checkbox",
              {
                "csdk-cursor-pointer": !n.disabled
              }
            )
          })
        ),
        e && /* @__PURE__ */ y("span", { className: i.join(" "), children: e })
      ]
    }
  );
}, pv = Z.input`
  box-sizing: border-box;
  height: 100%;
  border-width: 1px;
  border-style: solid;
  background-color: transparent;
  font-size: 13px;
  color: inherit;
  padding: 0 8px;
  border-radius: 0;
  transition: border-color 250ms;
  border-color: #e6e6e6;
  width: 100%;
  height: 24px;
  box-sizing: border-box;

  &:disabled {
    cursor: not-allowed;
  }

  &:invalid {
    border-color: #fb7570;
  }

  &::placeholder {
    color: inherit;
    opacity: 0.75;
  }

  &:focus {
    outline: none;
    border-color: inherit;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`, hv = Z.div`
  border: 1px solid #e6e6e6;
  border-left: none;
  display: flex;
  flex-direction: column;
  width: 14px;
  height: 24px;
  box-sizing: border-box;
`, Mc = Z.button`
  height: 12px;
  width: 14px;
  position: relative;
  overflow: hidden;
  padding: 0;
  margin: 0;
  border: none;
  background-color: transparent;
  cursor: pointer;

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin-left: -0.5px;
  }
`, Mr = (n) => {
  var g;
  const m = n, {
    callback: r,
    className: e,
    type: t = "text",
    value: a,
    disabled: o,
    containerStyle: i,
    labelStyle: s,
    inputStyle: l
  } = m, c = Re(m, [
    "callback",
    "className",
    "type",
    "value",
    "disabled",
    "containerStyle",
    "labelStyle",
    "inputStyle"
  ]), [u, d] = me((g = a == null ? void 0 : a.toString()) != null ? g : ""), f = Xt(), { themeSettings: p } = ve(), h = le(
    (b, v) => {
      const D = v === "increment" ? parseFloat(b) + 1 : parseFloat(b) - 1;
      hh(D) && (r(D.toString()), d(D.toString()));
    },
    [r, d]
  );
  return /* @__PURE__ */ J("div", { className: "csdk-flex csdk-items-center csdk-gap-x-2", style: i, children: [
    n.label && /* @__PURE__ */ y("label", { style: s, className: "csdk-min-w-fit", htmlFor: n.id, children: n.label }),
    /* @__PURE__ */ J("div", { className: "csdk-h-full csdk-w-[100%] csdk-flex csdk-justify-end", children: [
      /* @__PURE__ */ y(
        pv,
        E(w({}, c), {
          type: t,
          style: l,
          ref: f,
          className: ["csdk-border-UI-default", e].join(" "),
          value: u,
          onChange: (b) => {
            r(b.target.value), d(b.target.value);
          },
          disabled: o
        })
      ),
      t === "number" && /* @__PURE__ */ J(hv, { children: [
        /* @__PURE__ */ y(Mc, { onClick: () => h(u, "increment"), children: /* @__PURE__ */ y("svg", { className: "csdk-mt-[2px]", width: 24, height: 24, viewBox: "0 0 24 24", children: /* @__PURE__ */ y(
          "path",
          {
            fill: p.typography.primaryTextColor,
            d: "M12 10.16l-3.174 2.719a.5.5 0 0 1-.65-.76l3.5-2.998a.5.5 0 0 1 .65 0l3.5 2.998a.5.5 0 1 1-.65.76L12 10.159z"
          }
        ) }) }),
        /* @__PURE__ */ y(Mc, { onClick: () => h(u, "decrement"), children: /* @__PURE__ */ y("svg", { className: "csdk-mt-[-2px]", width: 24, height: 24, viewBox: "0 0 24 24", children: /* @__PURE__ */ y(
          "path",
          {
            fill: p.typography.primaryTextColor,
            d: "M12 13.84l3.174-2.719a.5.5 0 0 1 .65.76l-3.5 2.998a.5.5 0 0 1-.65 0l-3.5-2.998a.5.5 0 1 1 .65-.76L12 13.841z"
          }
        ) }) })
      ] })
    ] })
  ] });
}, mv = (n) => /* @__PURE__ */ y(
  "svg",
  E(w({
    width: "22",
    height: "22",
    viewBox: "0 0 22 22",
    fill: "#b4b4b4",
    xmlns: "http://www.w3.org/2000/svg"
  }, n), {
    children: /* @__PURE__ */ J("g", { transform: "translate(5.000000,5.000000) scale(.70, 0.6)", children: [
      /* @__PURE__ */ y("path", { d: "m3,9v11h14V9M4,9V6c0-3.3 2.7-6 6-6c3.3,0 6,2.7 6,6v3H14V6c0-2.2-1.8-4-4-4-2.2,0-4,1.8-4,4v3" }),
      /* @__PURE__ */ y("rect", { y: "10", x: "4", width: "12", height: "9", fill: "#dcdcdc" })
    ] })
  })
), gv = (n) => {
  const r = n.width || "24", e = n.height || "24";
  return /* @__PURE__ */ y(
    "svg",
    {
      viewBox: `0 0 ${r} ${e}`,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: n.className,
      width: r,
      height: e,
      children: /* @__PURE__ */ y(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9 5V3.5C9 3.22386 9.22386 3 9.5 3C9.77614 3 10 3.22386 10 3.5V5H13V3.5C13 3.22386 13.2239 3 13.5 3C13.7761 3 14 3.22386 14 3.5V5H17C18.1046 5 19 5.89543 19 7V8V9V17C19 18.1046 18.1046 19 17 19H6C4.89543 19 4 18.1046 4 17V9V8V7C4 5.89543 4.89543 5 6 5H9ZM10 6H13V6.5C13 6.77614 13.2239 7 13.5 7C13.7761 7 14 6.77614 14 6.5V6H17C17.5523 6 18 6.44772 18 7V8H5V7C5 6.44772 5.44772 6 6 6H9V6.5C9 6.77614 9.22386 7 9.5 7C9.77614 7 10 6.77614 10 6.5V6ZM5 17V9H18V17C18 17.5523 17.5523 18 17 18H6C5.44772 18 5 17.5523 5 17ZM14.5 12H8.5C8.22386 12 8 11.7761 8 11.5C8 11.2239 8.22386 11 8.5 11H14.5C14.7761 11 15 11.2239 15 11.5C15 11.7761 14.7761 12 14.5 12ZM8.5 14H14.5C14.7761 14 15 13.7761 15 13.5C15 13.2239 14.7761 13 14.5 13H8.5C8.22386 13 8 13.2239 8 13.5C8 13.7761 8.22386 14 8.5 14ZM14.5 16H8.5C8.22386 16 8 15.7761 8 15.5C8 15.2239 8.22386 15 8.5 15H14.5C14.7761 15 15 15.2239 15 15.5C15 15.7761 14.7761 16 14.5 16Z",
          fill: n.iconColor || "#5B6372"
        }
      )
    }
  );
}, yv = (n) => {
  var r;
  return /* @__PURE__ */ y("svg", E(w({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, n), { children: /* @__PURE__ */ y(
    "path",
    {
      fill: (r = n.fill) != null ? r : "#000",
      fillRule: "nonzero",
      d: "M7.589 10L7 10.777 11.99 15 17 10.777 16.413 10l-4.422 3.727z"
    }
  ) }));
}, bv = (n) => /* @__PURE__ */ J("label", { children: [
  /* @__PURE__ */ y(
    "input",
    E(w({}, n), {
      className: "csdk-accent-UI-default csdk-text-UI-default  csdk-w-radio csdk-h-radio csdk-m-radio " + n.className,
      type: "radio"
    })
  ),
  n.label
] }), vv = Z("div")({
  "::-webkit-scrollbar": {
    width: "8px",
    height: "8px"
  },
  "::-webkit-scrollbar-track": {
    backgroundColor: "transparent"
  },
  "::-webkit-scrollbar-thumb": {
    backgroundColor: "#c2c2c2",
    borderRadius: "4px",
    border: "1px solid transparent",
    backgroundClip: "content-box",
    minHeight: "20px",
    minWidth: "20px"
  },
  "::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "#7d7d7d",
    border: "none"
  }
}), wv = (o) => {
  var i = o, {
    items: n,
    currentSelection: r,
    title: e,
    className: t
  } = i, a = Re(i, [
    "items",
    "currentSelection",
    "title",
    "className"
  ]);
  return /* @__PURE__ */ J(vv, { className: t, children: [
    /* @__PURE__ */ y("div", { className: "csdk-ml-1.5", children: e }),
    n.map((s, l) => /* @__PURE__ */ y(bv, w({ value: s, label: s, checked: s === r }, a), l))
  ] });
}, _v = Z(Wu)(({ theme: n }) => {
  var r;
  return {
    height: "23px",
    width: "33px",
    "& .MuiSwitch-switchBase": {
      transform: "translateX(1px)",
      top: "2px",
      transition: "all .3s ease",
      "&.Mui-checked": {
        color: "#fff",
        transform: "translateX(13px)",
        "& + .MuiSwitch-track": {
          opacity: 1,
          backgroundColor: (r = n.general.brandColor) != null ? r : "#FFC805"
        },
        "&:hover": {
          background: "transparent"
        }
      },
      "&:hover": {
        background: "transparent"
      }
    },
    "&:hover": {
      "& .MuiSwitch-thumb": {
        transform: "scale(1.2)"
      }
    },
    "& .MuiSwitch-thumb": {
      backgroundColor: "#fff",
      width: 11,
      height: 11,
      border: "1px solid #c4c8cd",
      boxShadow: "none",
      transition: "all .3s ease",
      boxSizing: "border-box"
    },
    "& .MuiSwitch-track": {
      opacity: 1,
      height: "9px",
      width: "19px",
      backgroundColor: "#6e737d",
      borderRadius: 9
    }
  };
}), vd = () => {
  const { themeSettings: n } = ve(), { backgroundColor: r } = n.general, e = kt(r, du);
  return /* @__PURE__ */ y("div", { className: "csdk-flex csdk-justify-center", "data-testid": "triangle-indicator", children: /* @__PURE__ */ y(
    "div",
    {
      style: { borderTopColor: e },
      className: "csdk-border-l-[70px] csdk-border-l-[transparent] csdk-border-r-[70px] csdk-border-r-[transparent] csdk-border-t-[13px]"
    }
  ) });
}, ha = (n) => n === "white", Pc = "rgb(240, 240, 240)", Dv = "rgba(0, 0, 0, 0.26)", kv = Z.button`
  cursor: pointer;
  background-color: ${({ theme: n, variant: r, disabled: e }) => e ? Pc : ha(r) ? n.general.backgroundColor : "#f4f4f8"};
  border: ${({ variant: n }) => ha(n) ? "1px solid rgb(110 115 125 / var(--tw-border-opacity))" : "none"};
  color: ${({ theme: n, isActive: r, disabled: e }) => e ? Dv : r ? n.general.primaryButtonTextColor : n.typography.primaryTextColor};
  border-radius: 0.375rem;
  &:hover {
    background-color: ${({ theme: n, variant: r, disabled: e }) => e ? Pc : kt(ha(r) ? n.general.backgroundColor : "#f4f4f8")};
    transition: 0.2s;
  }
  transition: color 250ms;
`, xv = Z.label`
  color: ${({ theme: n, variant: r }) => ha(r) ? n.typography.primaryTextColor : n.general.primaryButtonTextColor};
`, si = (n) => {
  const { variant: r = "grey", label: e, isActive: t, theme: a } = n;
  return /* @__PURE__ */ J(
    "div",
    {
      className: "csdk-relative csdk-flex csdk-mr-[5px] csdk-cursor-pointer",
      "aria-label": "DateRangeField",
      children: [
        e && /* @__PURE__ */ y(
          xv,
          {
            htmlFor: n.id,
            className: "csdk-my-[5px] csdk-mr-[7px] csdk-text-[13px] csdk-leading-[18px]",
            theme: a,
            variant: r,
            children: e
          }
        ),
        /* @__PURE__ */ y("div", { className: "csdk-relative csdk-h-6", children: /* @__PURE__ */ J(
          kv,
          E(w({}, n), {
            variant: r,
            "aria-label": "DateRangeFieldButton",
            className: "csdk-text-left csdk-w-[152px] csdk-bg-[#f4f4f8] csdk-text-[13px] csdk-outline-0 csdk-border csdk-border-transparent csdk-p-input csdk-h-6 csdk-rounded-[4px] " + "disabled:csdk-placeholder:csdk-opacity-30 disabled:csdk-cursor-not-allowed " + "focus:csdk-border-solid focus:csdk-border-input focus:csdk-border-UI-default " + "hover:csdk-border-guiding csdk-text-text-active " + "csdk-pl-2.5 csdk-pr-10 csdk-overflow-hidden " + (n.className || ""),
            children: [
              n.value,
              /* @__PURE__ */ y(
                "div",
                {
                  "aria-label": "DateRangeFieldIcon",
                  className: "csdk-absolute csdk-right-[4px] csdk-top-1/2 csdk-transform -csdk-translate-y-1/2",
                  children: /* @__PURE__ */ y(
                    gv,
                    {
                      className: "csdk-flex csdk-text-text-active",
                      "aria-hidden": "true",
                      iconColor: t ? a.general.primaryButtonTextColor : a.typography.primaryTextColor
                    }
                  )
                }
              )
            ]
          })
        ) })
      ]
    }
  );
}, ci = (n) => {
  var c, u;
  const [r, e] = me(!1), { themeSettings: t } = ve(), a = () => {
    e(!r);
  }, o = it(null), i = (c = n.selectedIdx) != null ? c : null, s = {
    fontFamily: t.typography.fontFamily,
    fontWeight: 400,
    textTransform: "none",
    fontSize: "13px",
    color: t.typography.primaryTextColor
  }, l = n.elements.map((d, f) => /* @__PURE__ */ y(
    Dp,
    {
      onClick: () => {
        e(!1);
      },
      sx: E(w({}, s), {
        minHeight: "unset",
        "&:hover": {
          backgroundColor: kt(t.general.backgroundColor)
        }
      }),
      disabled: n.disabled,
      children: d
    },
    f
  ));
  return /* @__PURE__ */ J(Zt, { children: [
    /* @__PURE__ */ y(
      kp,
      {
        ref: o,
        onClick: a,
        className: "csdk-h-full csdk-border-solid csdk-border-input csdk-box-border",
        sx: E(w({}, s), {
          border: "1px solid rgb(110 115 125 / var(--tw-border-opacity))",
          marginLeft: "5px",
          marginRight: "5px",
          borderRadius: "0.375rem",
          verticalAlign: "unset",
          "&:hover": {
            backgroundColor: kt(t.general.backgroundColor)
          }
        }),
        disabled: n.disabled,
        children: ((u = n.icon) != null ? u : i !== null) ? n.elements[i != null ? i : 0] : /* @__PURE__ */ y("div", { children: "Select..." })
      }
    ),
    /* @__PURE__ */ y(
      xp,
      {
        open: r,
        anchorEl: o.current,
        placement: "bottom-start",
        sx: {
          backgroundColor: t.general.backgroundColor,
          border: "1px solid #c4c8cd",
          borderRadius: "4px",
          boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.25)"
        },
        children: /* @__PURE__ */ y(Sa, { onClickAway: () => e(!1), children: /* @__PURE__ */ y(Cp, { autoFocusItem: r, children: l }) })
      }
    )
  ] });
}, zt = (n) => n === "vertical", Cv = Z.div`
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDE0IDc5LjE1Njc5NywgMjAxNC8wOC8yMC0wOTo1MzowMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpkZmY0YWNkMy1lYWYxLTQwNzItYTdlMy1hMjk3YzZjZTFlODUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QTBFNDE0ODgwMjBFMTFFNThCQzJGRjdDRkI3RTQ1RUMiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6ODRDMjI3QTIwMUU4MTFFNThCQzJGRjdDRkI3RTQ1RUMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpkZmY0YWNkMy1lYWYxLTQwNzItYTdlMy1hMjk3YzZjZTFlODUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6ZGZmNGFjZDMtZWFmMS00MDcyLWE3ZTMtYTI5N2M2Y2UxZTg1Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+caeyqgAAAIdJREFUeNpi/P//PwMlgImBQkCxASzIHF0TZ6I0XT6zF7sBUPCOgH4hnC5A8hY/Ds3fiAmDOCD+h0UcFF0xxBiwCYhrsIjXAfF6YmOhA4iXIfGXA3ErKdEIcm4qEj8FKkZSOgAF2A9cgYcvFpDBTyC+TUlKXATEFkSnRCwgj1CqZBzw3AgQYADC5RtdNfxKVwAAAABJRU5ErkJggg==)
    center center no-repeat;
  float: left;
  margin: 4px 0 0 0;
  width: 16px;
  height: 16px;
  display: inline-block;
`, Xi = "1px solid #dadada", Ac = 215, Tv = Z.div`
  width: min-content;
  max-width: 100%;
  align-self: flex-start;
  box-sizing: border-box;

  ${({ shouldShowBorder: n }) => n && zl`
      border: ${Xi};
    `}
`, Sv = Z.header`
  display: flex;
  align-items: center;

  ${({ shouldShowBorder: n }) => n && zl`
      border-bottom: ${Xi};
    `}
`, Ev = Z.footer`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-height: 26px;

  border-top: ${Xi};
`, Mv = {
  header: {
    shouldBeShown: !0,
    hasBorder: !0,
    isCollapsible: !0,
    hasBackgroundFilterIcon: !1
  },
  border: {
    shouldBeShown: !0
  },
  footer: {
    shouldBeShown: !0
  }
}, Pv = Z("div")({
  ".MuiSwitch-root": {
    opacity: 0.55,
    transition: "all .3s ease"
  },
  "&:hover": {
    ".MuiSwitch-root": {
      opacity: 1
    }
  }
}), mn = (n) => {
  var g, b;
  const {
    title: r,
    renderContent: e,
    arrangement: t = "vertical",
    disabled: a,
    onToggleDisabled: o,
    isDependent: i,
    locked: s = !1
  } = n, l = ka.withOptions(
    { mergeArrays: !1 },
    Mv,
    (g = n.design) != null ? g : {}
  ), [c, u] = me(!0), { themeSettings: d } = ve(), { backgroundColor: f } = d.general, { primaryTextColor: p } = d.typography, h = kt(f, 0.1), m = i ? Ac - 2 : Ac;
  return /* @__PURE__ */ y(Pv, { children: /* @__PURE__ */ J(
    Tv,
    {
      shouldShowBorder: (b = l.border) == null ? void 0 : b.shouldBeShown,
      style: {
        minWidth: zt(t) ? m : "auto",
        backgroundColor: a ? h : f
      },
      children: [
        zt(t) && l.header.shouldBeShown && /* @__PURE__ */ J(Zt, { children: [
          i && /* @__PURE__ */ y(vd, {}),
          /* @__PURE__ */ J(Sv, { shouldShowBorder: l.header.hasBorder, style: { color: p }, children: [
            !s && l.header.isCollapsible && /* @__PURE__ */ y(
              yv,
              {
                "aria-label": "arrow-down",
                width: "16",
                height: "16",
                fill: `${p != null ? p : "#5B6372"}`,
                className: `csdk-transition csdk-ml-[4px] csdk-cursor-pointer ${c ? "-csdk-rotate-90" : ""}`,
                onClick: () => u((v) => !v)
              }
            ),
            l.header.hasBackgroundFilterIcon && /* @__PURE__ */ y(Cv, {}),
            s && !i && /* @__PURE__ */ y(mv, {}),
            /* @__PURE__ */ y(
              "span",
              {
                className: "csdk-text-[13px] csdk-mt-[6px] csdk-mb-[4px] csdk-ml-[7px] csdk-leading-[16px]",
                style: { color: p },
                children: r
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ J("main", { style: { color: p, position: "relative" }, children: [
          e(c, a != null ? a : !1),
          s && l.header.shouldBeShown && /* @__PURE__ */ y(
            "div",
            {
              style: {
                position: "absolute",
                top: "4px",
                left: "4px",
                right: "4px",
                bottom: "4px",
                backgroundColor: "white",
                opacity: 0.5
              }
            }
          )
        ] }),
        zt(t) && l.footer.shouldBeShown && /* @__PURE__ */ y(Ev, { children: !s && /* @__PURE__ */ y(
          _v,
          {
            checked: !a,
            size: "small",
            inputProps: { role: "switch", name: "tile-switch" },
            onChange: () => o == null ? void 0 : o(),
            theme: d
          }
        ) })
      ]
    }
  ) });
};
function $r(n, r, e) {
  if (!n && !e)
    throw new ne("errors.synchronizedFilterInvalidProps");
  const t = n || e(), [a, o] = me(t), i = Vl(n);
  ge(() => {
    n && (!i || !Av(i, n)) && o(n);
  }, [n, i]);
  const s = le(
    (l) => {
      o(l), r(l);
    },
    [r]
  );
  return {
    filter: a,
    updateFilter: s
  };
}
function Av(n, r) {
  return n === r || n.name === r.name;
}
const Ov = Z.button`
  font-family: inherit;
  background-color: ${({ backgroundColor: n }) => n};
  color: ${({ textColor: n }) => n};
  border: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  letter-spacing: 0.3px;
  line-height: 18px;
  font-size: 13px;
  padding: 3px 8px;
  border-radius: 4px;
  // minus half of space between pills to fit 2 pills per row
  max-width: calc(50% - 2.5px);
  user-select: none;
  cursor: pointer;
`, wd = ({ name: n, active: r, excludeMembers: e, disabled: t, onClick: a }) => {
  const { themeSettings: o } = ve(), i = r && !t, s = i ? e ? "#fc7570" : o.general.brandColor : "#cbced7", l = i ? e ? "#ffffff" : o.general.primaryButtonTextColor : "#ffffff";
  return /* @__PURE__ */ y(Ov, { backgroundColor: s, textColor: l, onClick: a, children: n });
}, Nv = ({ disabled: n }) => {
  const { t: r } = We();
  return /* @__PURE__ */ y(wd, { name: r("includeAll"), disabled: n, excludeMembers: !1, active: !0 });
}, _d = ({
  members: n,
  selectedMembers: r,
  onToggleSelectedMember: e,
  excludeMembers: t,
  disabled: a
}) => {
  const o = (r.length === 0 || r.length === n.length) && r.every((i) => !i.inactive);
  return /* @__PURE__ */ J("div", { className: "csdk-flex csdk-flex-wrap csdk-p-3 csdk-gap-[5px]", children: [
    o && /* @__PURE__ */ y(Nv, { disabled: a }),
    !o && r.map((i) => /* @__PURE__ */ y(
      wd,
      {
        name: i.title,
        active: !i.inactive,
        onClick: () => e(i.key),
        excludeMembers: t,
        disabled: a
      },
      i.key
    ))
  ] });
}, Rv = Z.input`
  font-size: 13px;
  padding-left: 0.75rem;
  background-color: transparent;
  color: inherit;
  outline: none;
  border: none;
  appearance: none;
  font-family: inherit;

  &:focus {
    outline: none;
  }

  &::-webkit-search-cancel-button,
  &::-webkit-search-decoration {
    -webkit-appearance: none;
    appearance: none;
  }

  &::placeholder {
    color: inherit;
    opacity: 0.75;
  }
`, Fv = 300, Iv = ({ onChange: n, delayMs: r = Fv, disabled: e }) => {
  const t = Tp((a) => n(a), r);
  return /* @__PURE__ */ y(
    Rv,
    {
      placeholder: "Start typing to search...",
      disabled: e,
      onChange: (a) => {
        t(a.target.value);
      },
      type: "search"
    }
  );
}, Lv = ({ label: n, checked: r, onCheck: e, disabled: t, inactive: a }) => /* @__PURE__ */ y(
  bd,
  {
    wrapperClassName: "csdk-border-b hover:csdk-bg-row-hover",
    label: n,
    isLabelInactive: a,
    checked: r,
    readOnly: !0,
    onChange: (o) => e(o.target.checked),
    disabled: t
  }
), Dd = ({
  members: n,
  selectedMembers: r,
  onSelectMember: e,
  checkAllMembers: t,
  uncheckAllMembers: a,
  excludeMembers: o,
  disabled: i
}) => {
  const [s, l] = me(""), c = pe(() => s && s.trim().length > 0 ? n.filter((d) => d.title.toLowerCase().includes(s.toLowerCase())) : n, [n, s]), u = o ? r.length === 0 : r.length === n.length;
  return /* @__PURE__ */ J("div", { className: "csdk-p-3", children: [
    /* @__PURE__ */ J("div", { className: "csdk-flex csdk-mb-[3px]", children: [
      /* @__PURE__ */ y(
        bd,
        {
          "aria-label": "change-all",
          checked: u,
          onChange: (d) => {
            d.target.checked ? t() : a();
          },
          readOnly: !0,
          indeterminate: o && r.length > 0 && r.length < n.length,
          disabled: i
        }
      ),
      /* @__PURE__ */ y(Iv, { onChange: (d) => l(d), disabled: i })
    ] }),
    /* @__PURE__ */ y("div", { className: "csdk-max-h-[150px] csdk-overflow-auto", children: c.map((d) => /* @__PURE__ */ y(
      Lv,
      {
        label: d.title,
        checked: (
          // when excludeMembers is true, checking (ticking) a member means deselecting it.
          // In other words, selected member is unchecked
          r.some((f) => d.key === f.key) === !o
        ),
        onCheck: (f) => (
          // when excludeMembers is true, unchecking (unticking) a member means selecting it
          e(d, o ? !f : f)
        ),
        disabled: i,
        inactive: r.some(
          (f) => d.key === f.key && f.inactive
        )
      },
      d.key
    )) })
  ] });
};
function li(n, r, e) {
  (e !== void 0 && !mh(n[r], e) || e === void 0 && !(r in n)) && gh(n, r, e);
}
function ui(n, r) {
  if (!(r === "constructor" && typeof n[r] == "function") && r != "__proto__")
    return n[r];
}
function Yv(n) {
  return yh(n, fu(n));
}
function Wv(n, r, e, t, a, o, i) {
  var s = ui(n, e), l = ui(r, e), c = i.get(l);
  if (c) {
    li(n, e, c);
    return;
  }
  var u = o ? o(s, l, e + "", n, r, i) : void 0, d = u === void 0;
  if (d) {
    var f = Js(l), p = !f && bh(l), h = !f && !p && vh(l);
    u = l, f || p || h ? Js(s) ? u = s : Sp(s) ? u = wh(s) : p ? (d = !1, u = _h(l, !0)) : h ? (d = !1, u = Dh(l, !0)) : u = [] : Ep(l) || Zs(l) ? (u = s, Zs(s) ? u = Yv(s) : (!pu(s) || kh(s)) && (u = xh(l))) : d = !1;
  }
  d && (i.set(l, u), a(u, l, t, o, i), i.delete(l)), li(n, e, u);
}
function Ji(n, r, e, t, a) {
  n !== r && Ch(r, function(o, i) {
    if (a || (a = new Th()), pu(o))
      Wv(n, r, i, e, Ji, t, a);
    else {
      var s = t ? t(ui(n, i), o, i + "", n, r, a) : void 0;
      s === void 0 && (s = o), li(n, i, s);
    }
  }, fu);
}
function kd(n) {
  return Sh(function(r, e) {
    var t = -1, a = e.length, o = a > 1 ? e[a - 1] : void 0, i = a > 2 ? e[2] : void 0;
    for (o = n.length > 3 && typeof o == "function" ? (a--, o) : void 0, i && Mp(e[0], e[1], i) && (o = a < 3 ? void 0 : o, a = 1), r = Object(r); ++t < a; ) {
      var s = e[t];
      s && n(r, s, t, o);
    }
    return r;
  });
}
var Hv = kd(function(n, r, e) {
  Ji(n, r, e);
});
const xd = se({
  componentName: "MemberFilterTile"
})((n) => {
  const {
    title: r,
    attribute: e,
    filter: t,
    dataSource: a,
    onChange: o,
    parentFilters: i = [],
    tileDesignOptions: s
  } = n, { backgroundFilter: l } = t != null ? t : {}, { filter: c, updateFilter: u } = $r(
    t,
    o,
    () => new hu(e, [])
  ), d = c.excludeMembers, f = pe(() => [e], [e]), p = [...i];
  l && p.push(l);
  const { data: h, error: m } = Ki({
    // prioritize attribute dataSource for the use case of multi-source dashboard
    dataSource: e.dataSource ? Fi(e.dataSource) : a,
    dimensions: f,
    filters: p
  }), g = pe(() => h ? h.rows.map((k) => k[0]) : [], [h]), b = pe(() => {
    const k = Oc(c.members, e.type), x = Oc(c.deactivatedMembers, e.type);
    return g.filter(
      (R) => k.includes(R.data) || x.includes(R.data)
    ).map((R) => {
      var I;
      return {
        key: R.data.toString(),
        title: (I = R.text) != null ? I : R.data.toString(),
        inactive: x.includes(R.data)
      };
    });
  }, [c.deactivatedMembers, c.members, g, e.type]), v = pe(
    () => g.map((k) => {
      var x;
      return {
        key: k.data.toString(),
        title: (x = k.text) != null ? x : k.data.toString()
      };
    }),
    [g]
  ), D = !!l && i.length === 0;
  if (m)
    throw m;
  return h ? /* @__PURE__ */ y(
    mn,
    {
      title: r,
      renderContent: (k, x) => k ? /* @__PURE__ */ y(
        _d,
        {
          members: v,
          selectedMembers: b,
          onToggleSelectedMember: (R) => {
            const I = Uv(
              b,
              R
            );
            u(br(c, I, d));
          },
          excludeMembers: d,
          disabled: x
        }
      ) : /* @__PURE__ */ y(
        Dd,
        {
          members: v,
          selectedMembers: b,
          onSelectMember: (R, I) => {
            const L = I ? Bv(b, R) : Qv(b, R);
            u(
              // if all members are excluded, we should reset the filter to exclude none to match the behavior in Fusion
              L.length === v.length && d ? br(c, [], !1) : br(c, L, d)
            );
          },
          checkAllMembers: () => u(br(c, [], !0)),
          uncheckAllMembers: () => u(br(c, [], !1)),
          excludeMembers: d,
          disabled: x
        }
      ),
      disabled: c.disabled,
      onToggleDisabled: () => {
        const k = za(c);
        u(k);
      },
      isDependent: i && i.length > 0,
      design: Hv(s, {
        header: { hasBackgroundFilterIcon: D }
      }),
      locked: c.locked
    }
  ) : null;
});
function br(n, r, e) {
  const { activeFilterMembers: t, inactiveFilterMembers: a } = $v(r);
  return new hu(
    n.attribute,
    t,
    e,
    n.guid,
    a,
    n.backgroundFilter
  );
}
function $v(n) {
  const r = {
    activeFilterMembers: [],
    inactiveFilterMembers: []
  };
  return n.forEach((e) => {
    e.inactive ? r.inactiveFilterMembers.push(e.key) : r.activeFilterMembers.push(e.key);
  }), r;
}
function Bv(n, r) {
  return n.some((e) => e.key === r.key) ? n : [...n, r];
}
function Qv(n, r) {
  return n.filter(
    (e) => e.key !== r.key
  );
}
function Uv(n, r) {
  return n.map(
    (e) => e.key === r ? E(w({}, e), { inactive: !e.inactive }) : e
  );
}
function Oc(n, r) {
  return n.map((e) => Eh(r) ? Number(e) : e.toString());
}
var Cd = Symbol.for("immer-nothing"), Nc = Symbol.for("immer-draftable"), ct = Symbol.for("immer-state"), qv = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(n) {
    return `The plugin for '${n}' has not been loaded into Immer. To enable the plugin, import and call \`enable${n}()\` when initializing your application.`;
  },
  function(n) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${n}'`;
  },
  "This object has been frozen and should not be mutated",
  function(n) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(n) {
    return `'current' expects a draft, got: ${n}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(n) {
    return `'original' expects a draft, got: ${n}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function nt(n, ...r) {
  if (process.env.NODE_ENV !== "production") {
    const e = qv[n], t = typeof e == "function" ? e.apply(null, r) : e;
    throw new Error(`[Immer] ${t}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${n}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var Zn = Object.getPrototypeOf;
function er(n) {
  return !!n && !!n[ct];
}
function On(n) {
  var r;
  return n ? Td(n) || Array.isArray(n) || !!n[Nc] || !!((r = n.constructor) != null && r[Nc]) || io(n) || so(n) : !1;
}
var jv = Object.prototype.constructor.toString();
function Td(n) {
  if (!n || typeof n != "object")
    return !1;
  const r = Zn(n);
  if (r === null)
    return !0;
  const e = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
  return e === Object ? !0 : typeof e == "function" && Function.toString.call(e) === jv;
}
function Ea(n, r) {
  oo(n) === 0 ? Reflect.ownKeys(n).forEach((e) => {
    r(e, n[e], n);
  }) : n.forEach((e, t) => r(t, e, n));
}
function oo(n) {
  const r = n[ct];
  return r ? r.type_ : Array.isArray(n) ? 1 : io(n) ? 2 : so(n) ? 3 : 0;
}
function di(n, r) {
  return oo(n) === 2 ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function Sd(n, r, e) {
  const t = oo(n);
  t === 2 ? n.set(r, e) : t === 3 ? n.add(e) : n[r] = e;
}
function zv(n, r) {
  return n === r ? n !== 0 || 1 / n === 1 / r : n !== n && r !== r;
}
function io(n) {
  return n instanceof Map;
}
function so(n) {
  return n instanceof Set;
}
function wn(n) {
  return n.copy_ || n.base_;
}
function fi(n, r) {
  if (io(n))
    return new Map(n);
  if (so(n))
    return new Set(n);
  if (Array.isArray(n))
    return Array.prototype.slice.call(n);
  const e = Td(n);
  if (r === !0 || r === "class_only" && !e) {
    const t = Object.getOwnPropertyDescriptors(n);
    delete t[ct];
    let a = Reflect.ownKeys(t);
    for (let o = 0; o < a.length; o++) {
      const i = a[o], s = t[i];
      s.writable === !1 && (s.writable = !0, s.configurable = !0), (s.get || s.set) && (t[i] = {
        configurable: !0,
        writable: !0,
        // could live with !!desc.set as well here...
        enumerable: s.enumerable,
        value: n[i]
      });
    }
    return Object.create(Zn(n), t);
  } else {
    const t = Zn(n);
    if (t !== null && e)
      return w({}, n);
    const a = Object.create(t);
    return Object.assign(a, n);
  }
}
function Zi(n, r = !1) {
  return co(n) || er(n) || !On(n) || (oo(n) > 1 && (n.set = n.add = n.clear = n.delete = Vv), Object.freeze(n), r && Object.entries(n).forEach(([e, t]) => Zi(t, !0))), n;
}
function Vv() {
  nt(2);
}
function co(n) {
  return Object.isFrozen(n);
}
var Gv = {};
function Nn(n) {
  const r = Gv[n];
  return r || nt(0, n), r;
}
var Pr;
function Ed() {
  return Pr;
}
function Kv(n, r) {
  return {
    drafts_: [],
    parent_: n,
    immer_: r,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function Rc(n, r) {
  r && (Nn("Patches"), n.patches_ = [], n.inversePatches_ = [], n.patchListener_ = r);
}
function pi(n) {
  hi(n), n.drafts_.forEach(Xv), n.drafts_ = null;
}
function hi(n) {
  n === Pr && (Pr = n.parent_);
}
function Fc(n) {
  return Pr = Kv(Pr, n);
}
function Xv(n) {
  const r = n[ct];
  r.type_ === 0 || r.type_ === 1 ? r.revoke_() : r.revoked_ = !0;
}
function Ic(n, r) {
  r.unfinalizedDrafts_ = r.drafts_.length;
  const e = r.drafts_[0];
  return n !== void 0 && n !== e ? (e[ct].modified_ && (pi(r), nt(4)), On(n) && (n = Ma(r, n), r.parent_ || Pa(r, n)), r.patches_ && Nn("Patches").generateReplacementPatches_(
    e[ct].base_,
    n,
    r.patches_,
    r.inversePatches_
  )) : n = Ma(r, e, []), pi(r), r.patches_ && r.patchListener_(r.patches_, r.inversePatches_), n !== Cd ? n : void 0;
}
function Ma(n, r, e) {
  if (co(r))
    return r;
  const t = r[ct];
  if (!t)
    return Ea(
      r,
      (a, o) => Lc(n, t, r, a, o, e)
    ), r;
  if (t.scope_ !== n)
    return r;
  if (!t.modified_)
    return Pa(n, t.base_, !0), t.base_;
  if (!t.finalized_) {
    t.finalized_ = !0, t.scope_.unfinalizedDrafts_--;
    const a = t.copy_;
    let o = a, i = !1;
    t.type_ === 3 && (o = new Set(a), a.clear(), i = !0), Ea(
      o,
      (s, l) => Lc(n, t, a, s, l, e, i)
    ), Pa(n, a, !1), e && n.patches_ && Nn("Patches").generatePatches_(
      t,
      e,
      n.patches_,
      n.inversePatches_
    );
  }
  return t.copy_;
}
function Lc(n, r, e, t, a, o, i) {
  if (process.env.NODE_ENV !== "production" && a === e && nt(5), er(a)) {
    const s = o && r && r.type_ !== 3 && // Set objects are atomic since they have no keys.
    !di(r.assigned_, t) ? o.concat(t) : void 0, l = Ma(n, a, s);
    if (Sd(e, t, l), er(l))
      n.canAutoFreeze_ = !1;
    else
      return;
  } else
    i && e.add(a);
  if (On(a) && !co(a)) {
    if (!n.immer_.autoFreeze_ && n.unfinalizedDrafts_ < 1)
      return;
    Ma(n, a), (!r || !r.scope_.parent_) && typeof t != "symbol" && Object.prototype.propertyIsEnumerable.call(e, t) && Pa(n, a);
  }
}
function Pa(n, r, e = !1) {
  !n.parent_ && n.immer_.autoFreeze_ && n.canAutoFreeze_ && Zi(r, e);
}
function Jv(n, r) {
  const e = Array.isArray(n), t = {
    type_: e ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: r ? r.scope_ : Ed(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: r,
    // The base state.
    base_: n,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let a = t, o = es;
  e && (a = [t], o = Ar);
  const { revoke: i, proxy: s } = Proxy.revocable(a, o);
  return t.draft_ = s, t.revoke_ = i, s;
}
var es = {
  get(n, r) {
    if (r === ct)
      return n;
    const e = wn(n);
    if (!di(e, r))
      return Zv(n, e, r);
    const t = e[r];
    return n.finalized_ || !On(t) ? t : t === Qo(n.base_, r) ? (Uo(n), n.copy_[r] = gi(t, n)) : t;
  },
  has(n, r) {
    return r in wn(n);
  },
  ownKeys(n) {
    return Reflect.ownKeys(wn(n));
  },
  set(n, r, e) {
    const t = Md(wn(n), r);
    if (t != null && t.set)
      return t.set.call(n.draft_, e), !0;
    if (!n.modified_) {
      const a = Qo(wn(n), r), o = a == null ? void 0 : a[ct];
      if (o && o.base_ === e)
        return n.copy_[r] = e, n.assigned_[r] = !1, !0;
      if (zv(e, a) && (e !== void 0 || di(n.base_, r)))
        return !0;
      Uo(n), mi(n);
    }
    return n.copy_[r] === e && // special case: handle new props with value 'undefined'
    (e !== void 0 || r in n.copy_) || // special case: NaN
    Number.isNaN(e) && Number.isNaN(n.copy_[r]) || (n.copy_[r] = e, n.assigned_[r] = !0), !0;
  },
  deleteProperty(n, r) {
    return Qo(n.base_, r) !== void 0 || r in n.base_ ? (n.assigned_[r] = !1, Uo(n), mi(n)) : delete n.assigned_[r], n.copy_ && delete n.copy_[r], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(n, r) {
    const e = wn(n), t = Reflect.getOwnPropertyDescriptor(e, r);
    return t && {
      writable: !0,
      configurable: n.type_ !== 1 || r !== "length",
      enumerable: t.enumerable,
      value: e[r]
    };
  },
  defineProperty() {
    nt(11);
  },
  getPrototypeOf(n) {
    return Zn(n.base_);
  },
  setPrototypeOf() {
    nt(12);
  }
}, Ar = {};
Ea(es, (n, r) => {
  Ar[n] = function() {
    return arguments[0] = arguments[0][0], r.apply(this, arguments);
  };
});
Ar.deleteProperty = function(n, r) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(r)) && nt(13), Ar.set.call(this, n, r, void 0);
};
Ar.set = function(n, r, e) {
  return process.env.NODE_ENV !== "production" && r !== "length" && isNaN(parseInt(r)) && nt(14), es.set.call(this, n[0], r, e, n[0]);
};
function Qo(n, r) {
  const e = n[ct];
  return (e ? wn(e) : n)[r];
}
function Zv(n, r, e) {
  var a;
  const t = Md(r, e);
  return t ? "value" in t ? t.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (a = t.get) == null ? void 0 : a.call(n.draft_)
  ) : void 0;
}
function Md(n, r) {
  if (!(r in n))
    return;
  let e = Zn(n);
  for (; e; ) {
    const t = Object.getOwnPropertyDescriptor(e, r);
    if (t)
      return t;
    e = Zn(e);
  }
}
function mi(n) {
  n.modified_ || (n.modified_ = !0, n.parent_ && mi(n.parent_));
}
function Uo(n) {
  n.copy_ || (n.copy_ = fi(
    n.base_,
    n.scope_.immer_.useStrictShallowCopy_
  ));
}
var e0 = class {
  constructor(n) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.produce = (r, e, t) => {
      if (typeof r == "function" && typeof e != "function") {
        const o = e;
        e = r;
        const i = this;
        return function(l = o, ...c) {
          return i.produce(l, (u) => e.call(this, u, ...c));
        };
      }
      typeof e != "function" && nt(6), t !== void 0 && typeof t != "function" && nt(7);
      let a;
      if (On(r)) {
        const o = Fc(this), i = gi(r, void 0);
        let s = !0;
        try {
          a = e(i), s = !1;
        } finally {
          s ? pi(o) : hi(o);
        }
        return Rc(o, t), Ic(a, o);
      } else if (!r || typeof r != "object") {
        if (a = e(r), a === void 0 && (a = r), a === Cd && (a = void 0), this.autoFreeze_ && Zi(a, !0), t) {
          const o = [], i = [];
          Nn("Patches").generateReplacementPatches_(r, a, o, i), t(o, i);
        }
        return a;
      } else
        nt(1, r);
    }, this.produceWithPatches = (r, e) => {
      if (typeof r == "function")
        return (i, ...s) => this.produceWithPatches(i, (l) => r(l, ...s));
      let t, a;
      return [this.produce(r, e, (i, s) => {
        t = i, a = s;
      }), t, a];
    }, typeof (n == null ? void 0 : n.autoFreeze) == "boolean" && this.setAutoFreeze(n.autoFreeze), typeof (n == null ? void 0 : n.useStrictShallowCopy) == "boolean" && this.setUseStrictShallowCopy(n.useStrictShallowCopy);
  }
  createDraft(n) {
    On(n) || nt(8), er(n) && (n = t0(n));
    const r = Fc(this), e = gi(n, void 0);
    return e[ct].isManual_ = !0, hi(r), e;
  }
  finishDraft(n, r) {
    const e = n && n[ct];
    (!e || !e.isManual_) && nt(9);
    const { scope_: t } = e;
    return Rc(t, r), Ic(void 0, t);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(n) {
    this.autoFreeze_ = n;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(n) {
    this.useStrictShallowCopy_ = n;
  }
  applyPatches(n, r) {
    let e;
    for (e = r.length - 1; e >= 0; e--) {
      const a = r[e];
      if (a.path.length === 0 && a.op === "replace") {
        n = a.value;
        break;
      }
    }
    e > -1 && (r = r.slice(e + 1));
    const t = Nn("Patches").applyPatches_;
    return er(n) ? t(n, r) : this.produce(
      n,
      (a) => t(a, r)
    );
  }
};
function gi(n, r) {
  const e = io(n) ? Nn("MapSet").proxyMap_(n, r) : so(n) ? Nn("MapSet").proxySet_(n, r) : Jv(n, r);
  return (r ? r.scope_ : Ed()).drafts_.push(e), e;
}
function t0(n) {
  return er(n) || nt(10, n), Pd(n);
}
function Pd(n) {
  if (!On(n) || co(n))
    return n;
  const r = n[ct];
  let e;
  if (r) {
    if (!r.modified_)
      return r.base_;
    r.finalized_ = !0, e = fi(n, r.scope_.immer_.useStrictShallowCopy_);
  } else
    e = fi(n, !0);
  return Ea(e, (t, a) => {
    Sd(e, t, Pd(a));
  }), r && (r.finalized_ = !1), e;
}
var lt = new e0(), Wn = lt.produce;
lt.produceWithPatches.bind(
  lt
);
lt.setAutoFreeze.bind(lt);
lt.setUseStrictShallowCopy.bind(lt);
lt.applyPatches.bind(lt);
lt.createDraft.bind(lt);
lt.finishDraft.bind(lt);
function n0(n, r) {
  switch (r.type) {
    case "selectMember":
      return r0(n, r.member);
    case "deselectMember":
      return a0(n, r.memberIndex);
    case "selectAllMembers":
      return o0(n);
    case "updateMembers":
      return i0(n, r.members);
    case "clearAllMembers":
      return c0(n);
    case "updatePossibleMembers":
      return s0(n, r.members);
    case "toggleSelectedMember":
      return l0(n, r.memberKey);
  }
}
function r0(n, r) {
  return Wn(n, (e) => {
    e.selectedMembers.push(r);
  });
}
function a0(n, r) {
  return Wn(n, (e) => {
    e.selectedMembers.splice(r, 1);
  });
}
function o0(n) {
  return Wn(n, (r) => {
    r.selectedMembers = r.members;
  });
}
function i0(n, r) {
  return Wn(n, (e) => {
    e.selectedMembers = r;
  });
}
function s0(n, r) {
  return Wn(n, (e) => {
    e.members = r, r.some((t) => !e.selectedMembers.some((a) => t.key === a.key)) ? e.selectedMembers = [] : e.selectedMembers = e.selectedMembers.filter(
      (t) => r.some((a) => a.key === t.key)
    );
  });
}
function c0(n) {
  return Wn(n, (r) => {
    r.selectedMembers = [];
  });
}
function l0(n, r) {
  return Wn(n, (e) => {
    const t = e.selectedMembers.find((a) => a.key === r);
    t && (t.inactive = !t.inactive);
  });
}
const u0 = ({
  initialMembers: n,
  initialSelectedMembers: r,
  onUpdateSelectedMembers: e,
  disabled: t
}) => {
  const [{ members: a, selectedMembers: o }, i] = Ht(n0, {
    selectedMembers: r,
    members: n
  }), s = pe(
    () => o.filter((u) => !u.inactive).map((u) => u.key),
    [o]
  ), l = it(t);
  ge(() => {
    t !== l.current && (l.current = t, e == null || e(t ? [] : s, t));
  }, [t, s, e]);
  const c = it(o);
  return ge(() => {
    Ir(o, c.current) || (c.current = o, e == null || e(s, t));
  }, [o, s, e, t]), {
    members: a,
    selectedMembers: o,
    dispatch: i
  };
}, d0 = (n, r) => {
  const e = {};
  for (const t of n) {
    const a = r(t);
    a in e || (e[a] = t);
  }
  return Object.values(e);
}, f0 = ({
  allMembers: n,
  initialSelectedMembers: r,
  maxAllowedMembers: e
}) => {
  const t = pe(() => n.length > e ? (console.warn(
    `List of members exceeds max allowed size, limiting from ${n.length} to ${e} members`
  ), [
    ...n.slice(0, e - r.length),
    ...r
  ]) : n, [n, e, r]);
  return pe(() => {
    const a = d0(t, (o) => o.key);
    return a.length !== t.length ? (console.warn("Removing detected duplicate member(s)"), a) : t;
  }, [t]);
}, KC = ({
  title: n,
  allMembers: r,
  initialSelectedMembers: e = [],
  onUpdateSelectedMembers: t,
  maxAllowedMembers: a = 2e3,
  isDependent: o,
  shouldUpdateSelectedMembers: i,
  disabled: s
}) => {
  const [l, c] = me(s != null ? s : !1), u = f0({
    allMembers: r,
    initialSelectedMembers: e,
    maxAllowedMembers: a
  }), {
    members: d,
    selectedMembers: f,
    dispatch: p
  } = u0({
    initialMembers: u,
    initialSelectedMembers: e,
    onUpdateSelectedMembers: t,
    disabled: l
  }), h = (g) => {
    const b = f.findIndex((v) => v.key === g.key);
    p(b === -1 ? {
      type: "selectMember",
      member: g
    } : {
      type: "deselectMember",
      memberIndex: b
    });
  }, m = pe(
    () => d.filter(
      (g) => f.some((b) => g.key === b.key) || e.some((b) => g.key === b.key)
    ).map((g) => E(w({}, g), { inactive: !e.some((b) => g.key === b.key) })),
    [e, d, f]
  );
  return ge(() => {
    const g = e.filter(
      (D) => f.some((k) => D.key === k.key && !!D.inactive == !!k.inactive)
    ).length !== e.length, b = f.filter(
      (D) => !e.some((k) => D.key === k.key) && !D.inactive
    ).length !== 0;
    i && (g || b) && (p({
      type: "updateMembers",
      members: m
    }), l && e.length > 0 && c((D) => !D)), Ir(r, d) || p({
      type: "updatePossibleMembers",
      members: r
    });
  }, [
    r,
    l,
    p,
    e,
    d,
    m,
    f,
    n,
    i
  ]), /* @__PURE__ */ y(
    mn,
    {
      title: n,
      renderContent: (g, b) => g ? /* @__PURE__ */ y(
        _d,
        {
          members: r,
          selectedMembers: f,
          onToggleSelectedMember: (v) => {
            p({ type: "toggleSelectedMember", memberKey: v });
          },
          excludeMembers: !1,
          disabled: b
        }
      ) : /* @__PURE__ */ y(
        Dd,
        {
          members: d,
          selectedMembers: f,
          onSelectMember: h,
          checkAllMembers: () => p({ type: "selectAllMembers" }),
          uncheckAllMembers: () => p({ type: "clearAllMembers" }),
          excludeMembers: !1,
          disabled: b
        }
      ),
      disabled: l,
      onToggleDisabled: () => c((g) => !g),
      isDependent: o
    }
  );
};
var Ad = { exports: {} };
(function(n, r) {
  (function(e, t) {
    n.exports = t();
  })(Le, function() {
    var e = 1e3, t = 6e4, a = 36e5, o = "millisecond", i = "second", s = "minute", l = "hour", c = "day", u = "week", d = "month", f = "quarter", p = "year", h = "date", m = "Invalid Date", g = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, b = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, v = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(N) {
      var T = ["th", "st", "nd", "rd"], M = N % 100;
      return "[" + N + (T[(M - 20) % 10] || T[M] || T[0]) + "]";
    } }, D = function(N, T, M) {
      var C = String(N);
      return !C || C.length >= T ? N : "" + Array(T + 1 - C.length).join(M) + N;
    }, k = { s: D, z: function(N) {
      var T = -N.utcOffset(), M = Math.abs(T), C = Math.floor(M / 60), S = M % 60;
      return (T <= 0 ? "+" : "-") + D(C, 2, "0") + ":" + D(S, 2, "0");
    }, m: function N(T, M) {
      if (T.date() < M.date())
        return -N(M, T);
      var C = 12 * (M.year() - T.year()) + (M.month() - T.month()), S = T.clone().add(C, d), F = M - S < 0, K = T.clone().add(C + (F ? -1 : 1), d);
      return +(-(C + (M - S) / (F ? S - K : K - S)) || 0);
    }, a: function(N) {
      return N < 0 ? Math.ceil(N) || 0 : Math.floor(N);
    }, p: function(N) {
      return { M: d, y: p, w: u, d: c, D: h, h: l, m: s, s: i, ms: o, Q: f }[N] || String(N || "").toLowerCase().replace(/s$/, "");
    }, u: function(N) {
      return N === void 0;
    } }, x = "en", R = {};
    R[x] = v;
    var I = "$isDayjsObject", L = function(N) {
      return N instanceof U || !(!N || !N[I]);
    }, A = function N(T, M, C) {
      var S;
      if (!T)
        return x;
      if (typeof T == "string") {
        var F = T.toLowerCase();
        R[F] && (S = F), M && (R[F] = M, S = F);
        var K = T.split("-");
        if (!S && K.length > 1)
          return N(K[0]);
      } else {
        var X = T.name;
        R[X] = T, S = X;
      }
      return !C && S && (x = S), S || !C && x;
    }, W = function(N, T) {
      if (L(N))
        return N.clone();
      var M = typeof T == "object" ? T : {};
      return M.date = N, M.args = arguments, new U(M);
    }, O = k;
    O.l = A, O.i = L, O.w = function(N, T) {
      return W(N, { locale: T.$L, utc: T.$u, x: T.$x, $offset: T.$offset });
    };
    var U = function() {
      function N(M) {
        this.$L = A(M.locale, null, !0), this.parse(M), this.$x = this.$x || M.x || {}, this[I] = !0;
      }
      var T = N.prototype;
      return T.parse = function(M) {
        this.$d = function(C) {
          var S = C.date, F = C.utc;
          if (S === null)
            return /* @__PURE__ */ new Date(NaN);
          if (O.u(S))
            return /* @__PURE__ */ new Date();
          if (S instanceof Date)
            return new Date(S);
          if (typeof S == "string" && !/Z$/i.test(S)) {
            var K = S.match(g);
            if (K) {
              var X = K[2] - 1 || 0, he = (K[7] || "0").substring(0, 3);
              return F ? new Date(Date.UTC(K[1], X, K[3] || 1, K[4] || 0, K[5] || 0, K[6] || 0, he)) : new Date(K[1], X, K[3] || 1, K[4] || 0, K[5] || 0, K[6] || 0, he);
            }
          }
          return new Date(S);
        }(M), this.init();
      }, T.init = function() {
        var M = this.$d;
        this.$y = M.getFullYear(), this.$M = M.getMonth(), this.$D = M.getDate(), this.$W = M.getDay(), this.$H = M.getHours(), this.$m = M.getMinutes(), this.$s = M.getSeconds(), this.$ms = M.getMilliseconds();
      }, T.$utils = function() {
        return O;
      }, T.isValid = function() {
        return this.$d.toString() !== m;
      }, T.isSame = function(M, C) {
        var S = W(M);
        return this.startOf(C) <= S && S <= this.endOf(C);
      }, T.isAfter = function(M, C) {
        return W(M) < this.startOf(C);
      }, T.isBefore = function(M, C) {
        return this.endOf(C) < W(M);
      }, T.$g = function(M, C, S) {
        return O.u(M) ? this[C] : this.set(S, M);
      }, T.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, T.valueOf = function() {
        return this.$d.getTime();
      }, T.startOf = function(M, C) {
        var S = this, F = !!O.u(C) || C, K = O.p(M), X = function(yt, Oe) {
          var bt = O.w(S.$u ? Date.UTC(S.$y, Oe, yt) : new Date(S.$y, Oe, yt), S);
          return F ? bt : bt.endOf(c);
        }, he = function(yt, Oe) {
          return O.w(S.toDate()[yt].apply(S.toDate("s"), (F ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(Oe)), S);
        }, ee = this.$W, Se = this.$M, ae = this.$D, ut = "set" + (this.$u ? "UTC" : "");
        switch (K) {
          case p:
            return F ? X(1, 0) : X(31, 11);
          case d:
            return F ? X(1, Se) : X(0, Se + 1);
          case u:
            var gt = this.$locale().weekStart || 0, tn = (ee < gt ? ee + 7 : ee) - gt;
            return X(F ? ae - tn : ae + (6 - tn), Se);
          case c:
          case h:
            return he(ut + "Hours", 0);
          case l:
            return he(ut + "Minutes", 1);
          case s:
            return he(ut + "Seconds", 2);
          case i:
            return he(ut + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, T.endOf = function(M) {
        return this.startOf(M, !1);
      }, T.$set = function(M, C) {
        var S, F = O.p(M), K = "set" + (this.$u ? "UTC" : ""), X = (S = {}, S[c] = K + "Date", S[h] = K + "Date", S[d] = K + "Month", S[p] = K + "FullYear", S[l] = K + "Hours", S[s] = K + "Minutes", S[i] = K + "Seconds", S[o] = K + "Milliseconds", S)[F], he = F === c ? this.$D + (C - this.$W) : C;
        if (F === d || F === p) {
          var ee = this.clone().set(h, 1);
          ee.$d[X](he), ee.init(), this.$d = ee.set(h, Math.min(this.$D, ee.daysInMonth())).$d;
        } else
          X && this.$d[X](he);
        return this.init(), this;
      }, T.set = function(M, C) {
        return this.clone().$set(M, C);
      }, T.get = function(M) {
        return this[O.p(M)]();
      }, T.add = function(M, C) {
        var S, F = this;
        M = Number(M);
        var K = O.p(C), X = function(Se) {
          var ae = W(F);
          return O.w(ae.date(ae.date() + Math.round(Se * M)), F);
        };
        if (K === d)
          return this.set(d, this.$M + M);
        if (K === p)
          return this.set(p, this.$y + M);
        if (K === c)
          return X(1);
        if (K === u)
          return X(7);
        var he = (S = {}, S[s] = t, S[l] = a, S[i] = e, S)[K] || 1, ee = this.$d.getTime() + M * he;
        return O.w(ee, this);
      }, T.subtract = function(M, C) {
        return this.add(-1 * M, C);
      }, T.format = function(M) {
        var C = this, S = this.$locale();
        if (!this.isValid())
          return S.invalidDate || m;
        var F = M || "YYYY-MM-DDTHH:mm:ssZ", K = O.z(this), X = this.$H, he = this.$m, ee = this.$M, Se = S.weekdays, ae = S.months, ut = S.meridiem, gt = function(Oe, bt, dt, nn) {
          return Oe && (Oe[bt] || Oe(C, F)) || dt[bt].slice(0, nn);
        }, tn = function(Oe) {
          return O.s(X % 12 || 12, Oe, "0");
        }, yt = ut || function(Oe, bt, dt) {
          var nn = Oe < 12 ? "AM" : "PM";
          return dt ? nn.toLowerCase() : nn;
        };
        return F.replace(b, function(Oe, bt) {
          return bt || function(dt) {
            switch (dt) {
              case "YY":
                return String(C.$y).slice(-2);
              case "YYYY":
                return O.s(C.$y, 4, "0");
              case "M":
                return ee + 1;
              case "MM":
                return O.s(ee + 1, 2, "0");
              case "MMM":
                return gt(S.monthsShort, ee, ae, 3);
              case "MMMM":
                return gt(ae, ee);
              case "D":
                return C.$D;
              case "DD":
                return O.s(C.$D, 2, "0");
              case "d":
                return String(C.$W);
              case "dd":
                return gt(S.weekdaysMin, C.$W, Se, 2);
              case "ddd":
                return gt(S.weekdaysShort, C.$W, Se, 3);
              case "dddd":
                return Se[C.$W];
              case "H":
                return String(X);
              case "HH":
                return O.s(X, 2, "0");
              case "h":
                return tn(1);
              case "hh":
                return tn(2);
              case "a":
                return yt(X, he, !0);
              case "A":
                return yt(X, he, !1);
              case "m":
                return String(he);
              case "mm":
                return O.s(he, 2, "0");
              case "s":
                return String(C.$s);
              case "ss":
                return O.s(C.$s, 2, "0");
              case "SSS":
                return O.s(C.$ms, 3, "0");
              case "Z":
                return K;
            }
            return null;
          }(Oe) || K.replace(":", "");
        });
      }, T.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, T.diff = function(M, C, S) {
        var F, K = this, X = O.p(C), he = W(M), ee = (he.utcOffset() - this.utcOffset()) * t, Se = this - he, ae = function() {
          return O.m(K, he);
        };
        switch (X) {
          case p:
            F = ae() / 12;
            break;
          case d:
            F = ae();
            break;
          case f:
            F = ae() / 3;
            break;
          case u:
            F = (Se - ee) / 6048e5;
            break;
          case c:
            F = (Se - ee) / 864e5;
            break;
          case l:
            F = Se / a;
            break;
          case s:
            F = Se / t;
            break;
          case i:
            F = Se / e;
            break;
          default:
            F = Se;
        }
        return S ? F : O.a(F);
      }, T.daysInMonth = function() {
        return this.endOf(d).$D;
      }, T.$locale = function() {
        return R[this.$L];
      }, T.locale = function(M, C) {
        if (!M)
          return this.$L;
        var S = this.clone(), F = A(M, C, !0);
        return F && (S.$L = F), S;
      }, T.clone = function() {
        return O.w(this.$d, this);
      }, T.toDate = function() {
        return new Date(this.valueOf());
      }, T.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, T.toISOString = function() {
        return this.$d.toISOString();
      }, T.toString = function() {
        return this.$d.toUTCString();
      }, N;
    }(), $ = U.prototype;
    return W.prototype = $, [["$ms", o], ["$s", i], ["$m", s], ["$H", l], ["$W", c], ["$M", d], ["$y", p], ["$D", h]].forEach(function(N) {
      $[N[1]] = function(T) {
        return this.$g(T, N[0], N[1]);
      };
    }), W.extend = function(N, T) {
      return N.$i || (N(T, U, W), N.$i = !0), W;
    }, W.locale = A, W.isDayjs = L, W.unix = function(N) {
      return W(1e3 * N);
    }, W.en = R[x], W.Ls = R, W.p = {}, W;
  });
})(Ad);
var p0 = Ad.exports;
const ke = /* @__PURE__ */ Ri(p0);
function h0(n, r) {
  n.prototype = Object.create(r.prototype), n.prototype.constructor = n, yi(n, r);
}
function yi(n, r) {
  return yi = Object.setPrototypeOf || function(t, a) {
    return t.__proto__ = a, t;
  }, yi(n, r);
}
function m0(n, r) {
  if (n == null)
    return {};
  var e = {}, t = Object.keys(n), a, o;
  for (o = 0; o < t.length; o++)
    a = t[o], !(r.indexOf(a) >= 0) && (e[a] = n[a]);
  return e;
}
function Yc(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function g0(n, r, e) {
  return n === r ? !0 : n.correspondingElement ? n.correspondingElement.classList.contains(e) : n.classList.contains(e);
}
function y0(n, r, e) {
  if (n === r)
    return !0;
  for (; n.parentNode || n.host; ) {
    if (n.parentNode && g0(n, r, e))
      return !0;
    n = n.parentNode || n.host;
  }
  return n;
}
function b0(n) {
  return document.documentElement.clientWidth <= n.clientX || document.documentElement.clientHeight <= n.clientY;
}
var v0 = function() {
  if (!(typeof window == "undefined" || typeof window.addEventListener != "function")) {
    var r = !1, e = Object.defineProperty({}, "passive", {
      get: function() {
        r = !0;
      }
    }), t = function() {
    };
    return window.addEventListener("testPassiveEventSupport", t, e), window.removeEventListener("testPassiveEventSupport", t, e), r;
  }
};
function w0(n) {
  return n === void 0 && (n = 0), function() {
    return ++n;
  };
}
var _0 = w0(), bi, ra = {}, qo = {}, D0 = ["touchstart", "touchmove"], k0 = "ignore-react-onclickoutside";
function Wc(n, r) {
  var e = {}, t = D0.indexOf(r) !== -1;
  return t && bi && (e.passive = !n.props.preventDefault), e;
}
function lo(n, r) {
  var e, t, a = n.displayName || n.name || "Component";
  return t = e = /* @__PURE__ */ function(o) {
    h0(i, o);
    function i(l) {
      var c;
      return c = o.call(this, l) || this, c.__outsideClickHandler = function(u) {
        if (typeof c.__clickOutsideHandlerProp == "function") {
          c.__clickOutsideHandlerProp(u);
          return;
        }
        var d = c.getInstance();
        if (typeof d.props.handleClickOutside == "function") {
          d.props.handleClickOutside(u);
          return;
        }
        if (typeof d.handleClickOutside == "function") {
          d.handleClickOutside(u);
          return;
        }
        throw new Error("WrappedComponent: " + a + " lacks a handleClickOutside(event) function for processing outside click events.");
      }, c.__getComponentNode = function() {
        var u = c.getInstance();
        return typeof u.setClickOutsideRef == "function" ? u.setClickOutsideRef() : lm(u);
      }, c.enableOnClickOutside = function() {
        if (!(typeof document == "undefined" || qo[c._uid])) {
          typeof bi == "undefined" && (bi = v0()), qo[c._uid] = !0;
          var u = c.props.eventTypes;
          u.forEach || (u = [u]), ra[c._uid] = function(d) {
            if (c.componentNode !== null && (c.props.preventDefault && d.preventDefault(), c.props.stopPropagation && d.stopPropagation(), !(c.props.excludeScrollbar && b0(d)))) {
              var f = d.composed && d.composedPath && d.composedPath().shift() || d.target;
              y0(f, c.componentNode, c.props.outsideClickIgnoreClass) === document && c.__outsideClickHandler(d);
            }
          }, u.forEach(function(d) {
            document.addEventListener(d, ra[c._uid], Wc(Yc(c), d));
          });
        }
      }, c.disableOnClickOutside = function() {
        delete qo[c._uid];
        var u = ra[c._uid];
        if (u && typeof document != "undefined") {
          var d = c.props.eventTypes;
          d.forEach || (d = [d]), d.forEach(function(f) {
            return document.removeEventListener(f, u, Wc(Yc(c), f));
          }), delete ra[c._uid];
        }
      }, c.getRef = function(u) {
        return c.instanceRef = u;
      }, c._uid = _0(), c;
    }
    var s = i.prototype;
    return s.getInstance = function() {
      if (n.prototype && !n.prototype.isReactComponent)
        return this;
      var c = this.instanceRef;
      return c.getInstance ? c.getInstance() : c;
    }, s.componentDidMount = function() {
      typeof document == "undefined" || !document.createElement || (this.getInstance(), this.componentNode = this.__getComponentNode(), !this.props.disableOnClickOutside && this.enableOnClickOutside());
    }, s.componentDidUpdate = function() {
      this.componentNode = this.__getComponentNode();
    }, s.componentWillUnmount = function() {
      this.disableOnClickOutside();
    }, s.render = function() {
      var c = this.props, u = m0(c, ["excludeScrollbar"]);
      return n.prototype && n.prototype.isReactComponent ? u.ref = this.getRef : u.wrappedRef = this.getRef, u.disableOnClickOutside = this.disableOnClickOutside, u.enableOnClickOutside = this.enableOnClickOutside, _u(n, u);
    }, i;
  }(Me), e.displayName = "OnClickOutside(" + a + ")", e.defaultProps = {
    eventTypes: ["mousedown", "touchstart"],
    excludeScrollbar: !1,
    outsideClickIgnoreClass: k0,
    preventDefault: !1,
    stopPropagation: !1
  }, e.getClass = function() {
    return n.getClass ? n.getClass() : n;
  }, t;
}
function Q(n) {
  const r = Object.prototype.toString.call(n);
  return n instanceof Date || typeof n == "object" && r === "[object Date]" ? new n.constructor(+n) : typeof n == "number" || r === "[object Number]" || typeof n == "string" || r === "[object String]" ? new Date(n) : /* @__PURE__ */ new Date(NaN);
}
function de(n, r) {
  return n instanceof Date ? new n.constructor(r) : new Date(r);
}
function gn(n, r) {
  const e = Q(n);
  return isNaN(r) ? de(n, NaN) : (r && e.setDate(e.getDate() + r), e);
}
function ts(n, r) {
  const e = +Q(n);
  return de(n, e + r);
}
const Od = 6048e5, x0 = 864e5, uo = 6e4, fo = 36e5, C0 = 1e3;
function T0(n, r) {
  return ts(n, r * fo);
}
function vi(n, r) {
  return ts(n, r * uo);
}
function Ct(n, r) {
  const e = Q(n);
  if (isNaN(r))
    return de(n, NaN);
  if (!r)
    return e;
  const t = e.getDate(), a = de(n, e.getTime());
  a.setMonth(e.getMonth() + r + 1, 0);
  const o = a.getDate();
  return t >= o ? a : (e.setFullYear(
    a.getFullYear(),
    a.getMonth(),
    t
  ), e);
}
function ns(n, r) {
  const e = r * 3;
  return Ct(n, e);
}
function S0(n, r) {
  return ts(n, r * 1e3);
}
function Aa(n, r) {
  const e = r * 7;
  return gn(n, e);
}
function Vt(n, r) {
  return Ct(n, r * 12);
}
function Rn(n) {
  const r = Q(n);
  return r.setHours(0, 0, 0, 0), r;
}
function Oa(n) {
  const r = Q(n), e = new Date(
    Date.UTC(
      r.getFullYear(),
      r.getMonth(),
      r.getDate(),
      r.getHours(),
      r.getMinutes(),
      r.getSeconds(),
      r.getMilliseconds()
    )
  );
  return e.setUTCFullYear(r.getFullYear()), +n - +e;
}
function Or(n, r) {
  const e = Rn(n), t = Rn(r), a = +e - Oa(e), o = +t - Oa(t);
  return Math.round((a - o) / x0);
}
function Na(n, r) {
  const e = Q(n), t = Q(r), a = e.getFullYear() - t.getFullYear(), o = e.getMonth() - t.getMonth();
  return a * 12 + o;
}
function Tn(n) {
  const r = Q(n);
  return Math.trunc(r.getMonth() / 3) + 1;
}
function Ra(n, r) {
  const e = Q(n), t = Q(r), a = e.getFullYear() - t.getFullYear(), o = Tn(e) - Tn(t);
  return a * 4 + o;
}
function Fa(n, r) {
  const e = Q(n), t = Q(r);
  return e.getFullYear() - t.getFullYear();
}
function Nd(n) {
  const r = Q(n);
  return r.setHours(23, 59, 59, 999), r;
}
function E0(n) {
  const r = Q(n), e = r.getMonth();
  return r.setFullYear(r.getFullYear(), e + 1, 0), r.setHours(23, 59, 59, 999), r;
}
let M0 = {};
function Hn() {
  return M0;
}
function P0(n, r) {
  var s, l, c, u;
  const e = Hn(), t = (u = (c = e.weekStartsOn) != null ? c : (l = (s = e.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) != null ? u : 0, a = Q(n), o = a.getDay(), i = (o < t ? -7 : 0) + 6 - (o - t);
  return a.setDate(a.getDate() + i), a.setHours(23, 59, 59, 999), a;
}
function Rd(n) {
  const r = Q(n), e = r.getFullYear();
  return r.setFullYear(e + 1, 0, 0), r.setHours(23, 59, 59, 999), r;
}
const A0 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, O0 = (n, r, e) => {
  let t;
  const a = A0[n];
  return typeof a == "string" ? t = a : r === 1 ? t = a.one : t = a.other.replace("{{count}}", r.toString()), e != null && e.addSuffix ? e.comparison && e.comparison > 0 ? "in " + t : t + " ago" : t;
};
function jo(n) {
  return (r = {}) => {
    const e = r.width ? String(r.width) : n.defaultWidth;
    return n.formats[e] || n.formats[n.defaultWidth];
  };
}
const N0 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, R0 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, F0 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, I0 = {
  date: jo({
    formats: N0,
    defaultWidth: "full"
  }),
  time: jo({
    formats: R0,
    defaultWidth: "full"
  }),
  dateTime: jo({
    formats: F0,
    defaultWidth: "full"
  })
}, L0 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Y0 = (n, r, e, t) => L0[n];
function vr(n) {
  return (r, e) => {
    const t = e != null && e.context ? String(e.context) : "standalone";
    let a;
    if (t === "formatting" && n.formattingValues) {
      const i = n.defaultFormattingWidth || n.defaultWidth, s = e != null && e.width ? String(e.width) : i;
      a = n.formattingValues[s] || n.formattingValues[i];
    } else {
      const i = n.defaultWidth, s = e != null && e.width ? String(e.width) : n.defaultWidth;
      a = n.values[s] || n.values[i];
    }
    const o = n.argumentCallback ? n.argumentCallback(r) : r;
    return a[o];
  };
}
const W0 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, H0 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, $0 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, B0 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Q0 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, U0 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, q0 = (n, r) => {
  const e = Number(n), t = e % 100;
  if (t > 20 || t < 10)
    switch (t % 10) {
      case 1:
        return e + "st";
      case 2:
        return e + "nd";
      case 3:
        return e + "rd";
    }
  return e + "th";
}, j0 = {
  ordinalNumber: q0,
  era: vr({
    values: W0,
    defaultWidth: "wide"
  }),
  quarter: vr({
    values: H0,
    defaultWidth: "wide",
    argumentCallback: (n) => n - 1
  }),
  month: vr({
    values: $0,
    defaultWidth: "wide"
  }),
  day: vr({
    values: B0,
    defaultWidth: "wide"
  }),
  dayPeriod: vr({
    values: Q0,
    defaultWidth: "wide",
    formattingValues: U0,
    defaultFormattingWidth: "wide"
  })
};
function wr(n) {
  return (r, e = {}) => {
    const t = e.width, a = t && n.matchPatterns[t] || n.matchPatterns[n.defaultMatchWidth], o = r.match(a);
    if (!o)
      return null;
    const i = o[0], s = t && n.parsePatterns[t] || n.parsePatterns[n.defaultParseWidth], l = Array.isArray(s) ? V0(s, (d) => d.test(i)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      z0(s, (d) => d.test(i))
    );
    let c;
    c = n.valueCallback ? n.valueCallback(l) : l, c = e.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      e.valueCallback(c)
    ) : c;
    const u = r.slice(i.length);
    return { value: c, rest: u };
  };
}
function z0(n, r) {
  for (const e in n)
    if (Object.prototype.hasOwnProperty.call(n, e) && r(n[e]))
      return e;
}
function V0(n, r) {
  for (let e = 0; e < n.length; e++)
    if (r(n[e]))
      return e;
}
function G0(n) {
  return (r, e = {}) => {
    const t = r.match(n.matchPattern);
    if (!t)
      return null;
    const a = t[0], o = r.match(n.parsePattern);
    if (!o)
      return null;
    let i = n.valueCallback ? n.valueCallback(o[0]) : o[0];
    i = e.valueCallback ? e.valueCallback(i) : i;
    const s = r.slice(a.length);
    return { value: i, rest: s };
  };
}
const K0 = /^(\d+)(th|st|nd|rd)?/i, X0 = /\d+/i, J0 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Z0 = {
  any: [/^b/i, /^(a|c)/i]
}, ew = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, tw = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, nw = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, rw = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, aw = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, ow = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, iw = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, sw = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, cw = {
  ordinalNumber: G0({
    matchPattern: K0,
    parsePattern: X0,
    valueCallback: (n) => parseInt(n, 10)
  }),
  era: wr({
    matchPatterns: J0,
    defaultMatchWidth: "wide",
    parsePatterns: Z0,
    defaultParseWidth: "any"
  }),
  quarter: wr({
    matchPatterns: ew,
    defaultMatchWidth: "wide",
    parsePatterns: tw,
    defaultParseWidth: "any",
    valueCallback: (n) => n + 1
  }),
  month: wr({
    matchPatterns: nw,
    defaultMatchWidth: "wide",
    parsePatterns: rw,
    defaultParseWidth: "any"
  }),
  day: wr({
    matchPatterns: aw,
    defaultMatchWidth: "wide",
    parsePatterns: ow,
    defaultParseWidth: "any"
  }),
  dayPeriod: wr({
    matchPatterns: iw,
    defaultMatchWidth: "any",
    parsePatterns: sw,
    defaultParseWidth: "any"
  })
}, Fd = {
  code: "en-US",
  formatDistance: O0,
  formatLong: I0,
  formatRelative: Y0,
  localize: j0,
  match: cw,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function po(n) {
  const r = Q(n), e = de(n, 0);
  return e.setFullYear(r.getFullYear(), 0, 1), e.setHours(0, 0, 0, 0), e;
}
function lw(n) {
  const r = Q(n);
  return Or(r, po(r)) + 1;
}
function Jt(n, r) {
  var s, l, c, u, d, f, p, h;
  const e = Hn(), t = (h = (p = (u = (c = r == null ? void 0 : r.weekStartsOn) != null ? c : (l = (s = r == null ? void 0 : r.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) != null ? u : e.weekStartsOn) != null ? p : (f = (d = e.locale) == null ? void 0 : d.options) == null ? void 0 : f.weekStartsOn) != null ? h : 0, a = Q(n), o = a.getDay(), i = (o < t ? 7 : 0) + o - t;
  return a.setDate(a.getDate() - i), a.setHours(0, 0, 0, 0), a;
}
function tr(n) {
  return Jt(n, { weekStartsOn: 1 });
}
function Id(n) {
  const r = Q(n), e = r.getFullYear(), t = de(n, 0);
  t.setFullYear(e + 1, 0, 4), t.setHours(0, 0, 0, 0);
  const a = tr(t), o = de(n, 0);
  o.setFullYear(e, 0, 4), o.setHours(0, 0, 0, 0);
  const i = tr(o);
  return r.getTime() >= a.getTime() ? e + 1 : r.getTime() >= i.getTime() ? e : e - 1;
}
function uw(n) {
  const r = Id(n), e = de(n, 0);
  return e.setFullYear(r, 0, 4), e.setHours(0, 0, 0, 0), tr(e);
}
function rs(n) {
  const r = Q(n), e = +tr(r) - +uw(r);
  return Math.round(e / Od) + 1;
}
function as(n, r) {
  var u, d, f, p, h, m, g, b;
  const e = Q(n), t = e.getFullYear(), a = Hn(), o = (b = (g = (p = (f = r == null ? void 0 : r.firstWeekContainsDate) != null ? f : (d = (u = r == null ? void 0 : r.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) != null ? p : a.firstWeekContainsDate) != null ? g : (m = (h = a.locale) == null ? void 0 : h.options) == null ? void 0 : m.firstWeekContainsDate) != null ? b : 1, i = de(n, 0);
  i.setFullYear(t + 1, 0, o), i.setHours(0, 0, 0, 0);
  const s = Jt(i, r), l = de(n, 0);
  l.setFullYear(t, 0, o), l.setHours(0, 0, 0, 0);
  const c = Jt(l, r);
  return e.getTime() >= s.getTime() ? t + 1 : e.getTime() >= c.getTime() ? t : t - 1;
}
function dw(n, r) {
  var s, l, c, u, d, f, p, h;
  const e = Hn(), t = (h = (p = (u = (c = r == null ? void 0 : r.firstWeekContainsDate) != null ? c : (l = (s = r == null ? void 0 : r.locale) == null ? void 0 : s.options) == null ? void 0 : l.firstWeekContainsDate) != null ? u : e.firstWeekContainsDate) != null ? p : (f = (d = e.locale) == null ? void 0 : d.options) == null ? void 0 : f.firstWeekContainsDate) != null ? h : 1, a = as(n, r), o = de(n, 0);
  return o.setFullYear(a, 0, t), o.setHours(0, 0, 0, 0), Jt(o, r);
}
function Ld(n, r) {
  const e = Q(n), t = +Jt(e, r) - +dw(e, r);
  return Math.round(t / Od) + 1;
}
function ue(n, r) {
  const e = n < 0 ? "-" : "", t = Math.abs(n).toString().padStart(r, "0");
  return e + t;
}
const rn = {
  // Year
  y(n, r) {
    const e = n.getFullYear(), t = e > 0 ? e : 1 - e;
    return ue(r === "yy" ? t % 100 : t, r.length);
  },
  // Month
  M(n, r) {
    const e = n.getMonth();
    return r === "M" ? String(e + 1) : ue(e + 1, 2);
  },
  // Day of the month
  d(n, r) {
    return ue(n.getDate(), r.length);
  },
  // AM or PM
  a(n, r) {
    const e = n.getHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return e.toUpperCase();
      case "aaa":
        return e;
      case "aaaaa":
        return e[0];
      case "aaaa":
      default:
        return e === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(n, r) {
    return ue(n.getHours() % 12 || 12, r.length);
  },
  // Hour [0-23]
  H(n, r) {
    return ue(n.getHours(), r.length);
  },
  // Minute
  m(n, r) {
    return ue(n.getMinutes(), r.length);
  },
  // Second
  s(n, r) {
    return ue(n.getSeconds(), r.length);
  },
  // Fraction of second
  S(n, r) {
    const e = r.length, t = n.getMilliseconds(), a = Math.trunc(
      t * Math.pow(10, e - 3)
    );
    return ue(a, r.length);
  }
}, zn = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Hc = {
  // Era
  G: function(n, r, e) {
    const t = n.getFullYear() > 0 ? 1 : 0;
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return e.era(t, { width: "abbreviated" });
      case "GGGGG":
        return e.era(t, { width: "narrow" });
      case "GGGG":
      default:
        return e.era(t, { width: "wide" });
    }
  },
  // Year
  y: function(n, r, e) {
    if (r === "yo") {
      const t = n.getFullYear(), a = t > 0 ? t : 1 - t;
      return e.ordinalNumber(a, { unit: "year" });
    }
    return rn.y(n, r);
  },
  // Local week-numbering year
  Y: function(n, r, e, t) {
    const a = as(n, t), o = a > 0 ? a : 1 - a;
    if (r === "YY") {
      const i = o % 100;
      return ue(i, 2);
    }
    return r === "Yo" ? e.ordinalNumber(o, { unit: "year" }) : ue(o, r.length);
  },
  // ISO week-numbering year
  R: function(n, r) {
    const e = Id(n);
    return ue(e, r.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(n, r) {
    const e = n.getFullYear();
    return ue(e, r.length);
  },
  // Quarter
  Q: function(n, r, e) {
    const t = Math.ceil((n.getMonth() + 1) / 3);
    switch (r) {
      case "Q":
        return String(t);
      case "QQ":
        return ue(t, 2);
      case "Qo":
        return e.ordinalNumber(t, { unit: "quarter" });
      case "QQQ":
        return e.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return e.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return e.quarter(t, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(n, r, e) {
    const t = Math.ceil((n.getMonth() + 1) / 3);
    switch (r) {
      case "q":
        return String(t);
      case "qq":
        return ue(t, 2);
      case "qo":
        return e.ordinalNumber(t, { unit: "quarter" });
      case "qqq":
        return e.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return e.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return e.quarter(t, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(n, r, e) {
    const t = n.getMonth();
    switch (r) {
      case "M":
      case "MM":
        return rn.M(n, r);
      case "Mo":
        return e.ordinalNumber(t + 1, { unit: "month" });
      case "MMM":
        return e.month(t, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return e.month(t, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return e.month(t, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(n, r, e) {
    const t = n.getMonth();
    switch (r) {
      case "L":
        return String(t + 1);
      case "LL":
        return ue(t + 1, 2);
      case "Lo":
        return e.ordinalNumber(t + 1, { unit: "month" });
      case "LLL":
        return e.month(t, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return e.month(t, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return e.month(t, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(n, r, e, t) {
    const a = Ld(n, t);
    return r === "wo" ? e.ordinalNumber(a, { unit: "week" }) : ue(a, r.length);
  },
  // ISO week of year
  I: function(n, r, e) {
    const t = rs(n);
    return r === "Io" ? e.ordinalNumber(t, { unit: "week" }) : ue(t, r.length);
  },
  // Day of the month
  d: function(n, r, e) {
    return r === "do" ? e.ordinalNumber(n.getDate(), { unit: "date" }) : rn.d(n, r);
  },
  // Day of year
  D: function(n, r, e) {
    const t = lw(n);
    return r === "Do" ? e.ordinalNumber(t, { unit: "dayOfYear" }) : ue(t, r.length);
  },
  // Day of week
  E: function(n, r, e) {
    const t = n.getDay();
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return e.day(t, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return e.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return e.day(t, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return e.day(t, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(n, r, e, t) {
    const a = n.getDay(), o = (a - t.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "e":
        return String(o);
      case "ee":
        return ue(o, 2);
      case "eo":
        return e.ordinalNumber(o, { unit: "day" });
      case "eee":
        return e.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return e.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return e.day(a, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return e.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(n, r, e, t) {
    const a = n.getDay(), o = (a - t.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "c":
        return String(o);
      case "cc":
        return ue(o, r.length);
      case "co":
        return e.ordinalNumber(o, { unit: "day" });
      case "ccc":
        return e.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return e.day(a, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return e.day(a, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return e.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(n, r, e) {
    const t = n.getDay(), a = t === 0 ? 7 : t;
    switch (r) {
      case "i":
        return String(a);
      case "ii":
        return ue(a, r.length);
      case "io":
        return e.ordinalNumber(a, { unit: "day" });
      case "iii":
        return e.day(t, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return e.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return e.day(t, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return e.day(t, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(n, r, e) {
    const a = n.getHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return e.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return e.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return e.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return e.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(n, r, e) {
    const t = n.getHours();
    let a;
    switch (t === 12 ? a = zn.noon : t === 0 ? a = zn.midnight : a = t / 12 >= 1 ? "pm" : "am", r) {
      case "b":
      case "bb":
        return e.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return e.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return e.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return e.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(n, r, e) {
    const t = n.getHours();
    let a;
    switch (t >= 17 ? a = zn.evening : t >= 12 ? a = zn.afternoon : t >= 4 ? a = zn.morning : a = zn.night, r) {
      case "B":
      case "BB":
      case "BBB":
        return e.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return e.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return e.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(n, r, e) {
    if (r === "ho") {
      let t = n.getHours() % 12;
      return t === 0 && (t = 12), e.ordinalNumber(t, { unit: "hour" });
    }
    return rn.h(n, r);
  },
  // Hour [0-23]
  H: function(n, r, e) {
    return r === "Ho" ? e.ordinalNumber(n.getHours(), { unit: "hour" }) : rn.H(n, r);
  },
  // Hour [0-11]
  K: function(n, r, e) {
    const t = n.getHours() % 12;
    return r === "Ko" ? e.ordinalNumber(t, { unit: "hour" }) : ue(t, r.length);
  },
  // Hour [1-24]
  k: function(n, r, e) {
    let t = n.getHours();
    return t === 0 && (t = 24), r === "ko" ? e.ordinalNumber(t, { unit: "hour" }) : ue(t, r.length);
  },
  // Minute
  m: function(n, r, e) {
    return r === "mo" ? e.ordinalNumber(n.getMinutes(), { unit: "minute" }) : rn.m(n, r);
  },
  // Second
  s: function(n, r, e) {
    return r === "so" ? e.ordinalNumber(n.getSeconds(), { unit: "second" }) : rn.s(n, r);
  },
  // Fraction of second
  S: function(n, r) {
    return rn.S(n, r);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(n, r, e) {
    const t = n.getTimezoneOffset();
    if (t === 0)
      return "Z";
    switch (r) {
      case "X":
        return Bc(t);
      case "XXXX":
      case "XX":
        return _n(t);
      case "XXXXX":
      case "XXX":
      default:
        return _n(t, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(n, r, e) {
    const t = n.getTimezoneOffset();
    switch (r) {
      case "x":
        return Bc(t);
      case "xxxx":
      case "xx":
        return _n(t);
      case "xxxxx":
      case "xxx":
      default:
        return _n(t, ":");
    }
  },
  // Timezone (GMT)
  O: function(n, r, e) {
    const t = n.getTimezoneOffset();
    switch (r) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + $c(t, ":");
      case "OOOO":
      default:
        return "GMT" + _n(t, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(n, r, e) {
    const t = n.getTimezoneOffset();
    switch (r) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + $c(t, ":");
      case "zzzz":
      default:
        return "GMT" + _n(t, ":");
    }
  },
  // Seconds timestamp
  t: function(n, r, e) {
    const t = Math.trunc(n.getTime() / 1e3);
    return ue(t, r.length);
  },
  // Milliseconds timestamp
  T: function(n, r, e) {
    const t = n.getTime();
    return ue(t, r.length);
  }
};
function $c(n, r = "") {
  const e = n > 0 ? "-" : "+", t = Math.abs(n), a = Math.trunc(t / 60), o = t % 60;
  return o === 0 ? e + String(a) : e + String(a) + r + ue(o, 2);
}
function Bc(n, r) {
  return n % 60 === 0 ? (n > 0 ? "-" : "+") + ue(Math.abs(n) / 60, 2) : _n(n, r);
}
function _n(n, r = "") {
  const e = n > 0 ? "-" : "+", t = Math.abs(n), a = ue(Math.trunc(t / 60), 2), o = ue(t % 60, 2);
  return e + a + r + o;
}
const Qc = (n, r) => {
  switch (n) {
    case "P":
      return r.date({ width: "short" });
    case "PP":
      return r.date({ width: "medium" });
    case "PPP":
      return r.date({ width: "long" });
    case "PPPP":
    default:
      return r.date({ width: "full" });
  }
}, Yd = (n, r) => {
  switch (n) {
    case "p":
      return r.time({ width: "short" });
    case "pp":
      return r.time({ width: "medium" });
    case "ppp":
      return r.time({ width: "long" });
    case "pppp":
    default:
      return r.time({ width: "full" });
  }
}, fw = (n, r) => {
  const e = n.match(/(P+)(p+)?/) || [], t = e[1], a = e[2];
  if (!a)
    return Qc(n, r);
  let o;
  switch (t) {
    case "P":
      o = r.dateTime({ width: "short" });
      break;
    case "PP":
      o = r.dateTime({ width: "medium" });
      break;
    case "PPP":
      o = r.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      o = r.dateTime({ width: "full" });
      break;
  }
  return o.replace("{{date}}", Qc(t, r)).replace("{{time}}", Yd(a, r));
}, Ia = {
  p: Yd,
  P: fw
}, pw = /^D+$/, hw = /^Y+$/, mw = ["D", "DD", "YY", "YYYY"];
function Wd(n) {
  return pw.test(n);
}
function Hd(n) {
  return hw.test(n);
}
function wi(n, r, e) {
  const t = gw(n, r, e);
  if (console.warn(t), mw.includes(n))
    throw new RangeError(t);
}
function gw(n, r, e) {
  const t = n[0] === "Y" ? "years" : "days of the month";
  return `Use \`${n.toLowerCase()}\` instead of \`${n}\` (in \`${r}\`) for formatting ${t} to the input \`${e}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
function Gt(n) {
  return n instanceof Date || typeof n == "object" && Object.prototype.toString.call(n) === "[object Date]";
}
function La(n) {
  if (!Gt(n) && typeof n != "number")
    return !1;
  const r = Q(n);
  return !isNaN(Number(r));
}
const yw = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, bw = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, vw = /^'([^]*?)'?$/, ww = /''/g, _w = /[a-zA-Z]/;
function Uc(n, r, e) {
  var u, d, f, p, h, m, g, b, v, D, k, x, R, I, L, A, W, O;
  const t = Hn(), a = (d = (u = e == null ? void 0 : e.locale) != null ? u : t.locale) != null ? d : Fd, o = (D = (v = (m = (h = e == null ? void 0 : e.firstWeekContainsDate) != null ? h : (p = (f = e == null ? void 0 : e.locale) == null ? void 0 : f.options) == null ? void 0 : p.firstWeekContainsDate) != null ? m : t.firstWeekContainsDate) != null ? v : (b = (g = t.locale) == null ? void 0 : g.options) == null ? void 0 : b.firstWeekContainsDate) != null ? D : 1, i = (O = (W = (I = (R = e == null ? void 0 : e.weekStartsOn) != null ? R : (x = (k = e == null ? void 0 : e.locale) == null ? void 0 : k.options) == null ? void 0 : x.weekStartsOn) != null ? I : t.weekStartsOn) != null ? W : (A = (L = t.locale) == null ? void 0 : L.options) == null ? void 0 : A.weekStartsOn) != null ? O : 0, s = Q(n);
  if (!La(s))
    throw new RangeError("Invalid time value");
  let l = r.match(bw).map((U) => {
    const $ = U[0];
    if ($ === "p" || $ === "P") {
      const N = Ia[$];
      return N(U, a.formatLong);
    }
    return U;
  }).join("").match(yw).map((U) => {
    if (U === "''")
      return { isToken: !1, value: "'" };
    const $ = U[0];
    if ($ === "'")
      return { isToken: !1, value: Dw(U) };
    if (Hc[$])
      return { isToken: !0, value: U };
    if ($.match(_w))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + $ + "`"
      );
    return { isToken: !1, value: U };
  });
  a.localize.preprocessor && (l = a.localize.preprocessor(s, l));
  const c = {
    firstWeekContainsDate: o,
    weekStartsOn: i,
    locale: a
  };
  return l.map((U) => {
    if (!U.isToken)
      return U.value;
    const $ = U.value;
    (!(e != null && e.useAdditionalWeekYearTokens) && Hd($) || !(e != null && e.useAdditionalDayOfYearTokens) && Wd($)) && wi($, r, String(n));
    const N = Hc[$[0]];
    return N(s, $, a.localize, c);
  }).join("");
}
function Dw(n) {
  const r = n.match(vw);
  return r ? r[1].replace(ww, "'") : n;
}
function qc(n) {
  return Q(n).getDate();
}
function kw(n) {
  return Q(n).getDay();
}
function Ft(n) {
  return Q(n).getHours();
}
function It(n) {
  return Q(n).getMinutes();
}
function Xe(n) {
  return Q(n).getMonth();
}
function Kt(n) {
  return Q(n).getSeconds();
}
function _i(n) {
  return Q(n).getTime();
}
function te(n) {
  return Q(n).getFullYear();
}
function dn(n, r) {
  const e = Q(n), t = Q(r);
  return e.getTime() > t.getTime();
}
function Fn(n, r) {
  const e = Q(n), t = Q(r);
  return +e < +t;
}
function xw(n, r) {
  const e = Q(n), t = Q(r);
  return +e == +t;
}
function Cw(n, r) {
  const e = Rn(n), t = Rn(r);
  return +e == +t;
}
function Tw(n, r) {
  const e = Q(n), t = Q(r);
  return e.getFullYear() === t.getFullYear() && e.getMonth() === t.getMonth();
}
function Di(n) {
  const r = Q(n), e = r.getMonth(), t = e - e % 3;
  return r.setMonth(t, 1), r.setHours(0, 0, 0, 0), r;
}
function Sw(n, r) {
  const e = Di(n), t = Di(r);
  return +e == +t;
}
function Ew(n, r) {
  const e = Q(n), t = Q(r);
  return e.getFullYear() === t.getFullYear();
}
function Nr(n, r) {
  const e = +Q(n), [t, a] = [
    +Q(r.start),
    +Q(r.end)
  ].sort((o, i) => o - i);
  return e >= t && e <= a;
}
function jc(n) {
  let r;
  return n.forEach(function(e) {
    const t = Q(e);
    (r === void 0 || r < t || isNaN(Number(t))) && (r = t);
  }), r || /* @__PURE__ */ new Date(NaN);
}
function zc(n) {
  let r;
  return n.forEach((e) => {
    const t = Q(e);
    (!r || r > t || isNaN(+t)) && (r = t);
  }), r || /* @__PURE__ */ new Date(NaN);
}
function Mw() {
  return Object.assign({}, Hn());
}
function Pw(n, r) {
  const e = r instanceof Date ? de(r, 0) : new r(0);
  return e.setFullYear(
    n.getFullYear(),
    n.getMonth(),
    n.getDate()
  ), e.setHours(
    n.getHours(),
    n.getMinutes(),
    n.getSeconds(),
    n.getMilliseconds()
  ), e;
}
const Aw = 10;
class $d {
  constructor() {
    B(this, "subPriority", 0);
  }
  validate(r, e) {
    return !0;
  }
}
class Ow extends $d {
  constructor(r, e, t, a, o) {
    super(), this.value = r, this.validateValue = e, this.setValue = t, this.priority = a, o && (this.subPriority = o);
  }
  validate(r, e) {
    return this.validateValue(r, this.value, e);
  }
  set(r, e, t) {
    return this.setValue(r, e, this.value, t);
  }
}
class Nw extends $d {
  constructor() {
    super(...arguments);
    B(this, "priority", Aw);
    B(this, "subPriority", -1);
  }
  set(e, t) {
    return t.timestampIsSet ? e : de(e, Pw(e, Date));
  }
}
class ce {
  run(r, e, t, a) {
    const o = this.parse(r, e, t, a);
    return o ? {
      setter: new Ow(
        o.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: o.rest
    } : null;
  }
  validate(r, e, t) {
    return !0;
  }
}
class Rw extends ce {
  constructor() {
    super(...arguments);
    B(this, "priority", 140);
    B(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(e, t, a) {
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return a.era(e, { width: "abbreviated" }) || a.era(e, { width: "narrow" });
      case "GGGGG":
        return a.era(e, { width: "narrow" });
      case "GGGG":
      default:
        return a.era(e, { width: "wide" }) || a.era(e, { width: "abbreviated" }) || a.era(e, { width: "narrow" });
    }
  }
  set(e, t, a) {
    return t.era = a, e.setFullYear(a, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
const xe = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Ot = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function Ce(n, r) {
  return n && {
    value: r(n.value),
    rest: n.rest
  };
}
function _e(n, r) {
  const e = r.match(n);
  return e ? {
    value: parseInt(e[0], 10),
    rest: r.slice(e[0].length)
  } : null;
}
function Nt(n, r) {
  const e = r.match(n);
  if (!e)
    return null;
  if (e[0] === "Z")
    return {
      value: 0,
      rest: r.slice(1)
    };
  const t = e[1] === "+" ? 1 : -1, a = e[2] ? parseInt(e[2], 10) : 0, o = e[3] ? parseInt(e[3], 10) : 0, i = e[5] ? parseInt(e[5], 10) : 0;
  return {
    value: t * (a * fo + o * uo + i * C0),
    rest: r.slice(e[0].length)
  };
}
function Bd(n) {
  return _e(xe.anyDigitsSigned, n);
}
function De(n, r) {
  switch (n) {
    case 1:
      return _e(xe.singleDigit, r);
    case 2:
      return _e(xe.twoDigits, r);
    case 3:
      return _e(xe.threeDigits, r);
    case 4:
      return _e(xe.fourDigits, r);
    default:
      return _e(new RegExp("^\\d{1," + n + "}"), r);
  }
}
function Ya(n, r) {
  switch (n) {
    case 1:
      return _e(xe.singleDigitSigned, r);
    case 2:
      return _e(xe.twoDigitsSigned, r);
    case 3:
      return _e(xe.threeDigitsSigned, r);
    case 4:
      return _e(xe.fourDigitsSigned, r);
    default:
      return _e(new RegExp("^-?\\d{1," + n + "}"), r);
  }
}
function os(n) {
  switch (n) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function Qd(n, r) {
  const e = r > 0, t = e ? r : 1 - r;
  let a;
  if (t <= 50)
    a = n || 100;
  else {
    const o = t + 50, i = Math.trunc(o / 100) * 100, s = n >= o % 100;
    a = n + i - (s ? 100 : 0);
  }
  return e ? a : 1 - a;
}
function Ud(n) {
  return n % 400 === 0 || n % 4 === 0 && n % 100 !== 0;
}
class Fw extends ce {
  constructor() {
    super(...arguments);
    B(this, "priority", 130);
    B(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(e, t, a) {
    const o = (i) => ({
      year: i,
      isTwoDigitYear: t === "yy"
    });
    switch (t) {
      case "y":
        return Ce(De(4, e), o);
      case "yo":
        return Ce(
          a.ordinalNumber(e, {
            unit: "year"
          }),
          o
        );
      default:
        return Ce(De(t.length, e), o);
    }
  }
  validate(e, t) {
    return t.isTwoDigitYear || t.year > 0;
  }
  set(e, t, a) {
    const o = e.getFullYear();
    if (a.isTwoDigitYear) {
      const s = Qd(
        a.year,
        o
      );
      return e.setFullYear(s, 0, 1), e.setHours(0, 0, 0, 0), e;
    }
    const i = !("era" in t) || t.era === 1 ? a.year : 1 - a.year;
    return e.setFullYear(i, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class Iw extends ce {
  constructor() {
    super(...arguments);
    B(this, "priority", 130);
    B(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(e, t, a) {
    const o = (i) => ({
      year: i,
      isTwoDigitYear: t === "YY"
    });
    switch (t) {
      case "Y":
        return Ce(De(4, e), o);
      case "Yo":
        return Ce(
          a.ordinalNumber(e, {
            unit: "year"
          }),
          o
        );
      default:
        return Ce(De(t.length, e), o);
    }
  }
  validate(e, t) {
    return t.isTwoDigitYear || t.year > 0;
  }
  set(e, t, a, o) {
    const i = as(e, o);
    if (a.isTwoDigitYear) {
      const l = Qd(
        a.year,
        i
      );
      return e.setFullYear(
        l,
        0,
        o.firstWeekContainsDate
      ), e.setHours(0, 0, 0, 0), Jt(e, o);
    }
    const s = !("era" in t) || t.era === 1 ? a.year : 1 - a.year;
    return e.setFullYear(s, 0, o.firstWeekContainsDate), e.setHours(0, 0, 0, 0), Jt(e, o);
  }
}
class Lw extends ce {
  constructor() {
    super(...arguments);
    B(this, "priority", 130);
    B(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t) {
    return Ya(t === "R" ? 4 : t.length, e);
  }
  set(e, t, a) {
    const o = de(e, 0);
    return o.setFullYear(a, 0, 4), o.setHours(0, 0, 0, 0), tr(o);
  }
}
class Yw extends ce {
  constructor() {
    super(...arguments);
    B(this, "priority", 130);
    B(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(e, t) {
    return Ya(t === "u" ? 4 : t.length, e);
  }
  set(e, t, a) {
    return e.setFullYear(a, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class Ww extends ce {
  constructor() {
    super(...arguments);
    B(this, "priority", 120);
    B(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t, a) {
    switch (t) {
      case "Q":
      case "QQ":
        return De(t.length, e);
      case "Qo":
        return a.ordinalNumber(e, { unit: "quarter" });
      case "QQQ":
        return a.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        }) || a.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return a.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return a.quarter(e, {
          width: "wide",
          context: "formatting"
        }) || a.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        }) || a.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 4;
  }
  set(e, t, a) {
    return e.setMonth((a - 1) * 3, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class Hw extends ce {
  constructor() {
    super(...arguments);
    B(this, "priority", 120);
    B(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t, a) {
    switch (t) {
      case "q":
      case "qq":
        return De(t.length, e);
      case "qo":
        return a.ordinalNumber(e, { unit: "quarter" });
      case "qqq":
        return a.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        }) || a.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return a.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return a.quarter(e, {
          width: "wide",
          context: "standalone"
        }) || a.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        }) || a.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 4;
  }
  set(e, t, a) {
    return e.setMonth((a - 1) * 3, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class $w extends ce {
  constructor() {
    super(...arguments);
    B(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    B(this, "priority", 110);
  }
  parse(e, t, a) {
    const o = (i) => i - 1;
    switch (t) {
      case "M":
        return Ce(
          _e(xe.month, e),
          o
        );
      case "MM":
        return Ce(De(2, e), o);
      case "Mo":
        return Ce(
          a.ordinalNumber(e, {
            unit: "month"
          }),
          o
        );
      case "MMM":
        return a.month(e, {
          width: "abbreviated",
          context: "formatting"
        }) || a.month(e, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return a.month(e, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return a.month(e, { width: "wide", context: "formatting" }) || a.month(e, {
          width: "abbreviated",
          context: "formatting"
        }) || a.month(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 11;
  }
  set(e, t, a) {
    return e.setMonth(a, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class Bw extends ce {
  constructor() {
    super(...arguments);
    B(this, "priority", 110);
    B(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t, a) {
    const o = (i) => i - 1;
    switch (t) {
      case "L":
        return Ce(
          _e(xe.month, e),
          o
        );
      case "LL":
        return Ce(De(2, e), o);
      case "Lo":
        return Ce(
          a.ordinalNumber(e, {
            unit: "month"
          }),
          o
        );
      case "LLL":
        return a.month(e, {
          width: "abbreviated",
          context: "standalone"
        }) || a.month(e, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return a.month(e, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return a.month(e, { width: "wide", context: "standalone" }) || a.month(e, {
          width: "abbreviated",
          context: "standalone"
        }) || a.month(e, { width: "narrow", context: "standalone" });
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 11;
  }
  set(e, t, a) {
    return e.setMonth(a, 1), e.setHours(0, 0, 0, 0), e;
  }
}
function Qw(n, r, e) {
  const t = Q(n), a = Ld(t, e) - r;
  return t.setDate(t.getDate() - a * 7), t;
}
class Uw extends ce {
  constructor() {
    super(...arguments);
    B(this, "priority", 100);
    B(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(e, t, a) {
    switch (t) {
      case "w":
        return _e(xe.week, e);
      case "wo":
        return a.ordinalNumber(e, { unit: "week" });
      default:
        return De(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 53;
  }
  set(e, t, a, o) {
    return Jt(Qw(e, a, o), o);
  }
}
function qw(n, r) {
  const e = Q(n), t = rs(e) - r;
  return e.setDate(e.getDate() - t * 7), e;
}
class jw extends ce {
  constructor() {
    super(...arguments);
    B(this, "priority", 100);
    B(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t, a) {
    switch (t) {
      case "I":
        return _e(xe.week, e);
      case "Io":
        return a.ordinalNumber(e, { unit: "week" });
      default:
        return De(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 53;
  }
  set(e, t, a) {
    return tr(qw(e, a));
  }
}
const zw = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Vw = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class Gw extends ce {
  constructor() {
    super(...arguments);
    B(this, "priority", 90);
    B(this, "subPriority", 1);
    B(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t, a) {
    switch (t) {
      case "d":
        return _e(xe.date, e);
      case "do":
        return a.ordinalNumber(e, { unit: "date" });
      default:
        return De(t.length, e);
    }
  }
  validate(e, t) {
    const a = e.getFullYear(), o = Ud(a), i = e.getMonth();
    return o ? t >= 1 && t <= Vw[i] : t >= 1 && t <= zw[i];
  }
  set(e, t, a) {
    return e.setDate(a), e.setHours(0, 0, 0, 0), e;
  }
}
class Kw extends ce {
  constructor() {
    super(...arguments);
    B(this, "priority", 90);
    B(this, "subpriority", 1);
    B(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t, a) {
    switch (t) {
      case "D":
      case "DD":
        return _e(xe.dayOfYear, e);
      case "Do":
        return a.ordinalNumber(e, { unit: "date" });
      default:
        return De(t.length, e);
    }
  }
  validate(e, t) {
    const a = e.getFullYear();
    return Ud(a) ? t >= 1 && t <= 366 : t >= 1 && t <= 365;
  }
  set(e, t, a) {
    return e.setMonth(0, a), e.setHours(0, 0, 0, 0), e;
  }
}
function is(n, r, e) {
  var d, f, p, h, m, g, b, v;
  const t = Hn(), a = (v = (b = (h = (p = e == null ? void 0 : e.weekStartsOn) != null ? p : (f = (d = e == null ? void 0 : e.locale) == null ? void 0 : d.options) == null ? void 0 : f.weekStartsOn) != null ? h : t.weekStartsOn) != null ? b : (g = (m = t.locale) == null ? void 0 : m.options) == null ? void 0 : g.weekStartsOn) != null ? v : 0, o = Q(n), i = o.getDay(), l = (r % 7 + 7) % 7, c = 7 - a, u = r < 0 || r > 6 ? r - (i + c) % 7 : (l + c) % 7 - (i + c) % 7;
  return gn(o, u);
}
class Xw extends ce {
  constructor() {
    super(...arguments);
    B(this, "priority", 90);
    B(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(e, t, a) {
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return a.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || a.day(e, { width: "short", context: "formatting" }) || a.day(e, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return a.day(e, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return a.day(e, { width: "short", context: "formatting" }) || a.day(e, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return a.day(e, { width: "wide", context: "formatting" }) || a.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || a.day(e, { width: "short", context: "formatting" }) || a.day(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 6;
  }
  set(e, t, a, o) {
    return e = is(e, a, o), e.setHours(0, 0, 0, 0), e;
  }
}
class Jw extends ce {
  constructor() {
    super(...arguments);
    B(this, "priority", 90);
    B(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t, a, o) {
    const i = (s) => {
      const l = Math.floor((s - 1) / 7) * 7;
      return (s + o.weekStartsOn + 6) % 7 + l;
    };
    switch (t) {
      case "e":
      case "ee":
        return Ce(De(t.length, e), i);
      case "eo":
        return Ce(
          a.ordinalNumber(e, {
            unit: "day"
          }),
          i
        );
      case "eee":
        return a.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || a.day(e, { width: "short", context: "formatting" }) || a.day(e, { width: "narrow", context: "formatting" });
      case "eeeee":
        return a.day(e, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return a.day(e, { width: "short", context: "formatting" }) || a.day(e, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return a.day(e, { width: "wide", context: "formatting" }) || a.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || a.day(e, { width: "short", context: "formatting" }) || a.day(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 6;
  }
  set(e, t, a, o) {
    return e = is(e, a, o), e.setHours(0, 0, 0, 0), e;
  }
}
class Zw extends ce {
  constructor() {
    super(...arguments);
    B(this, "priority", 90);
    B(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(e, t, a, o) {
    const i = (s) => {
      const l = Math.floor((s - 1) / 7) * 7;
      return (s + o.weekStartsOn + 6) % 7 + l;
    };
    switch (t) {
      case "c":
      case "cc":
        return Ce(De(t.length, e), i);
      case "co":
        return Ce(
          a.ordinalNumber(e, {
            unit: "day"
          }),
          i
        );
      case "ccc":
        return a.day(e, {
          width: "abbreviated",
          context: "standalone"
        }) || a.day(e, { width: "short", context: "standalone" }) || a.day(e, { width: "narrow", context: "standalone" });
      case "ccccc":
        return a.day(e, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return a.day(e, { width: "short", context: "standalone" }) || a.day(e, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return a.day(e, { width: "wide", context: "standalone" }) || a.day(e, {
          width: "abbreviated",
          context: "standalone"
        }) || a.day(e, { width: "short", context: "standalone" }) || a.day(e, { width: "narrow", context: "standalone" });
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 6;
  }
  set(e, t, a, o) {
    return e = is(e, a, o), e.setHours(0, 0, 0, 0), e;
  }
}
function e_(n) {
  let e = Q(n).getDay();
  return e === 0 && (e = 7), e;
}
function t_(n, r) {
  const e = Q(n), t = e_(e), a = r - t;
  return gn(e, a);
}
class n_ extends ce {
  constructor() {
    super(...arguments);
    B(this, "priority", 90);
    B(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, t, a) {
    const o = (i) => i === 0 ? 7 : i;
    switch (t) {
      case "i":
      case "ii":
        return De(t.length, e);
      case "io":
        return a.ordinalNumber(e, { unit: "day" });
      case "iii":
        return Ce(
          a.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(e, {
            width: "short",
            context: "formatting"
          }) || a.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiiii":
        return Ce(
          a.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiiiii":
        return Ce(
          a.day(e, {
            width: "short",
            context: "formatting"
          }) || a.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiii":
      default:
        return Ce(
          a.day(e, {
            width: "wide",
            context: "formatting"
          }) || a.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(e, {
            width: "short",
            context: "formatting"
          }) || a.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 7;
  }
  set(e, t, a) {
    return e = t_(e, a), e.setHours(0, 0, 0, 0), e;
  }
}
class r_ extends ce {
  constructor() {
    super(...arguments);
    B(this, "priority", 80);
    B(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(e, t, a) {
    switch (t) {
      case "a":
      case "aa":
      case "aaa":
        return a.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return a.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return a.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || a.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, t, a) {
    return e.setHours(os(a), 0, 0, 0), e;
  }
}
class a_ extends ce {
  constructor() {
    super(...arguments);
    B(this, "priority", 80);
    B(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(e, t, a) {
    switch (t) {
      case "b":
      case "bb":
      case "bbb":
        return a.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return a.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return a.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || a.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, t, a) {
    return e.setHours(os(a), 0, 0, 0), e;
  }
}
class o_ extends ce {
  constructor() {
    super(...arguments);
    B(this, "priority", 80);
    B(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(e, t, a) {
    switch (t) {
      case "B":
      case "BB":
      case "BBB":
        return a.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return a.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return a.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || a.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, t, a) {
    return e.setHours(os(a), 0, 0, 0), e;
  }
}
class i_ extends ce {
  constructor() {
    super(...arguments);
    B(this, "priority", 70);
    B(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(e, t, a) {
    switch (t) {
      case "h":
        return _e(xe.hour12h, e);
      case "ho":
        return a.ordinalNumber(e, { unit: "hour" });
      default:
        return De(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 12;
  }
  set(e, t, a) {
    const o = e.getHours() >= 12;
    return o && a < 12 ? e.setHours(a + 12, 0, 0, 0) : !o && a === 12 ? e.setHours(0, 0, 0, 0) : e.setHours(a, 0, 0, 0), e;
  }
}
class s_ extends ce {
  constructor() {
    super(...arguments);
    B(this, "priority", 70);
    B(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(e, t, a) {
    switch (t) {
      case "H":
        return _e(xe.hour23h, e);
      case "Ho":
        return a.ordinalNumber(e, { unit: "hour" });
      default:
        return De(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 23;
  }
  set(e, t, a) {
    return e.setHours(a, 0, 0, 0), e;
  }
}
class c_ extends ce {
  constructor() {
    super(...arguments);
    B(this, "priority", 70);
    B(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(e, t, a) {
    switch (t) {
      case "K":
        return _e(xe.hour11h, e);
      case "Ko":
        return a.ordinalNumber(e, { unit: "hour" });
      default:
        return De(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 11;
  }
  set(e, t, a) {
    return e.getHours() >= 12 && a < 12 ? e.setHours(a + 12, 0, 0, 0) : e.setHours(a, 0, 0, 0), e;
  }
}
class l_ extends ce {
  constructor() {
    super(...arguments);
    B(this, "priority", 70);
    B(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(e, t, a) {
    switch (t) {
      case "k":
        return _e(xe.hour24h, e);
      case "ko":
        return a.ordinalNumber(e, { unit: "hour" });
      default:
        return De(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 1 && t <= 24;
  }
  set(e, t, a) {
    const o = a <= 24 ? a % 24 : a;
    return e.setHours(o, 0, 0, 0), e;
  }
}
class u_ extends ce {
  constructor() {
    super(...arguments);
    B(this, "priority", 60);
    B(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(e, t, a) {
    switch (t) {
      case "m":
        return _e(xe.minute, e);
      case "mo":
        return a.ordinalNumber(e, { unit: "minute" });
      default:
        return De(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 59;
  }
  set(e, t, a) {
    return e.setMinutes(a, 0, 0), e;
  }
}
class d_ extends ce {
  constructor() {
    super(...arguments);
    B(this, "priority", 50);
    B(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(e, t, a) {
    switch (t) {
      case "s":
        return _e(xe.second, e);
      case "so":
        return a.ordinalNumber(e, { unit: "second" });
      default:
        return De(t.length, e);
    }
  }
  validate(e, t) {
    return t >= 0 && t <= 59;
  }
  set(e, t, a) {
    return e.setSeconds(a, 0), e;
  }
}
class f_ extends ce {
  constructor() {
    super(...arguments);
    B(this, "priority", 30);
    B(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(e, t) {
    const a = (o) => Math.trunc(o * Math.pow(10, -t.length + 3));
    return Ce(De(t.length, e), a);
  }
  set(e, t, a) {
    return e.setMilliseconds(a), e;
  }
}
class p_ extends ce {
  constructor() {
    super(...arguments);
    B(this, "priority", 10);
    B(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(e, t) {
    switch (t) {
      case "X":
        return Nt(
          Ot.basicOptionalMinutes,
          e
        );
      case "XX":
        return Nt(Ot.basic, e);
      case "XXXX":
        return Nt(
          Ot.basicOptionalSeconds,
          e
        );
      case "XXXXX":
        return Nt(
          Ot.extendedOptionalSeconds,
          e
        );
      case "XXX":
      default:
        return Nt(Ot.extended, e);
    }
  }
  set(e, t, a) {
    return t.timestampIsSet ? e : de(
      e,
      e.getTime() - Oa(e) - a
    );
  }
}
class h_ extends ce {
  constructor() {
    super(...arguments);
    B(this, "priority", 10);
    B(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(e, t) {
    switch (t) {
      case "x":
        return Nt(
          Ot.basicOptionalMinutes,
          e
        );
      case "xx":
        return Nt(Ot.basic, e);
      case "xxxx":
        return Nt(
          Ot.basicOptionalSeconds,
          e
        );
      case "xxxxx":
        return Nt(
          Ot.extendedOptionalSeconds,
          e
        );
      case "xxx":
      default:
        return Nt(Ot.extended, e);
    }
  }
  set(e, t, a) {
    return t.timestampIsSet ? e : de(
      e,
      e.getTime() - Oa(e) - a
    );
  }
}
class m_ extends ce {
  constructor() {
    super(...arguments);
    B(this, "priority", 40);
    B(this, "incompatibleTokens", "*");
  }
  parse(e) {
    return Bd(e);
  }
  set(e, t, a) {
    return [de(e, a * 1e3), { timestampIsSet: !0 }];
  }
}
class g_ extends ce {
  constructor() {
    super(...arguments);
    B(this, "priority", 20);
    B(this, "incompatibleTokens", "*");
  }
  parse(e) {
    return Bd(e);
  }
  set(e, t, a) {
    return [de(e, a), { timestampIsSet: !0 }];
  }
}
const y_ = {
  G: new Rw(),
  y: new Fw(),
  Y: new Iw(),
  R: new Lw(),
  u: new Yw(),
  Q: new Ww(),
  q: new Hw(),
  M: new $w(),
  L: new Bw(),
  w: new Uw(),
  I: new jw(),
  d: new Gw(),
  D: new Kw(),
  E: new Xw(),
  e: new Jw(),
  c: new Zw(),
  i: new n_(),
  a: new r_(),
  b: new a_(),
  B: new o_(),
  h: new i_(),
  H: new s_(),
  K: new c_(),
  k: new l_(),
  m: new u_(),
  s: new d_(),
  S: new f_(),
  X: new p_(),
  x: new h_(),
  t: new m_(),
  T: new g_()
}, b_ = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, v_ = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, w_ = /^'([^]*?)'?$/, __ = /''/g, D_ = /\S/, k_ = /[a-zA-Z]/;
function zo(n, r, e, t) {
  var m, g, b, v, D, k, x, R, I, L, A, W, O, U, $, N, T, M;
  const a = Mw(), o = (g = (m = t == null ? void 0 : t.locale) != null ? m : a.locale) != null ? g : Fd, i = (L = (I = (k = (D = t == null ? void 0 : t.firstWeekContainsDate) != null ? D : (v = (b = t == null ? void 0 : t.locale) == null ? void 0 : b.options) == null ? void 0 : v.firstWeekContainsDate) != null ? k : a.firstWeekContainsDate) != null ? I : (R = (x = a.locale) == null ? void 0 : x.options) == null ? void 0 : R.firstWeekContainsDate) != null ? L : 1, s = (M = (T = (U = (O = t == null ? void 0 : t.weekStartsOn) != null ? O : (W = (A = t == null ? void 0 : t.locale) == null ? void 0 : A.options) == null ? void 0 : W.weekStartsOn) != null ? U : a.weekStartsOn) != null ? T : (N = ($ = a.locale) == null ? void 0 : $.options) == null ? void 0 : N.weekStartsOn) != null ? M : 0;
  if (r === "")
    return n === "" ? Q(e) : de(e, NaN);
  const l = {
    firstWeekContainsDate: i,
    weekStartsOn: s,
    locale: o
  }, c = [new Nw()], u = r.match(v_).map((C) => {
    const S = C[0];
    if (S in Ia) {
      const F = Ia[S];
      return F(C, o.formatLong);
    }
    return C;
  }).join("").match(b_), d = [];
  for (let C of u) {
    !(t != null && t.useAdditionalWeekYearTokens) && Hd(C) && wi(C, r, n), !(t != null && t.useAdditionalDayOfYearTokens) && Wd(C) && wi(C, r, n);
    const S = C[0], F = y_[S];
    if (F) {
      const { incompatibleTokens: K } = F;
      if (Array.isArray(K)) {
        const he = d.find(
          (ee) => K.includes(ee.token) || ee.token === S
        );
        if (he)
          throw new RangeError(
            `The format string mustn't contain \`${he.fullToken}\` and \`${C}\` at the same time`
          );
      } else if (F.incompatibleTokens === "*" && d.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${C}\` and any other token at the same time`
        );
      d.push({ token: S, fullToken: C });
      const X = F.run(
        n,
        C,
        o.match,
        l
      );
      if (!X)
        return de(e, NaN);
      c.push(X.setter), n = X.rest;
    } else {
      if (S.match(k_))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + S + "`"
        );
      if (C === "''" ? C = "'" : S === "'" && (C = x_(C)), n.indexOf(C) === 0)
        n = n.slice(C.length);
      else
        return de(e, NaN);
    }
  }
  if (n.length > 0 && D_.test(n))
    return de(e, NaN);
  const f = c.map((C) => C.priority).sort((C, S) => S - C).filter((C, S, F) => F.indexOf(C) === S).map(
    (C) => c.filter((S) => S.priority === C).sort((S, F) => F.subPriority - S.subPriority)
  ).map((C) => C[0]);
  let p = Q(e);
  if (isNaN(p.getTime()))
    return de(e, NaN);
  const h = {};
  for (const C of f) {
    if (!C.validate(p, l))
      return de(e, NaN);
    const S = C.set(p, h, l);
    Array.isArray(S) ? (p = S[0], Object.assign(h, S[1])) : p = S;
  }
  return de(e, p);
}
function x_(n) {
  return n.match(w_)[1].replace(__, "'");
}
function C_(n, r) {
  const t = M_(n);
  let a;
  if (t.date) {
    const l = P_(t.date, 2);
    a = A_(l.restDateString, l.year);
  }
  if (!a || isNaN(a.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  const o = a.getTime();
  let i = 0, s;
  if (t.time && (i = O_(t.time), isNaN(i)))
    return /* @__PURE__ */ new Date(NaN);
  if (t.timezone) {
    if (s = N_(t.timezone), isNaN(s))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    const l = new Date(o + i), c = /* @__PURE__ */ new Date(0);
    return c.setFullYear(
      l.getUTCFullYear(),
      l.getUTCMonth(),
      l.getUTCDate()
    ), c.setHours(
      l.getUTCHours(),
      l.getUTCMinutes(),
      l.getUTCSeconds(),
      l.getUTCMilliseconds()
    ), c;
  }
  return new Date(o + i + s);
}
const aa = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, T_ = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, S_ = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, E_ = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function M_(n) {
  const r = {}, e = n.split(aa.dateTimeDelimiter);
  let t;
  if (e.length > 2)
    return r;
  if (/:/.test(e[0]) ? t = e[0] : (r.date = e[0], t = e[1], aa.timeZoneDelimiter.test(r.date) && (r.date = n.split(aa.timeZoneDelimiter)[0], t = n.substr(
    r.date.length,
    n.length
  ))), t) {
    const a = aa.timezone.exec(t);
    a ? (r.time = t.replace(a[1], ""), r.timezone = a[1]) : r.time = t;
  }
  return r;
}
function P_(n, r) {
  const e = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + r) + "})|(\\d{2}|[+-]\\d{" + (2 + r) + "})$)"
  ), t = n.match(e);
  if (!t)
    return { year: NaN, restDateString: "" };
  const a = t[1] ? parseInt(t[1]) : null, o = t[2] ? parseInt(t[2]) : null;
  return {
    year: o === null ? a : o * 100,
    restDateString: n.slice((t[1] || t[2]).length)
  };
}
function A_(n, r) {
  if (r === null)
    return /* @__PURE__ */ new Date(NaN);
  const e = n.match(T_);
  if (!e)
    return /* @__PURE__ */ new Date(NaN);
  const t = !!e[4], a = _r(e[1]), o = _r(e[2]) - 1, i = _r(e[3]), s = _r(e[4]), l = _r(e[5]) - 1;
  if (t)
    return Y_(r, s, l) ? R_(r, s, l) : /* @__PURE__ */ new Date(NaN);
  {
    const c = /* @__PURE__ */ new Date(0);
    return !I_(r, o, i) || !L_(r, a) ? /* @__PURE__ */ new Date(NaN) : (c.setUTCFullYear(r, o, Math.max(a, i)), c);
  }
}
function _r(n) {
  return n ? parseInt(n) : 1;
}
function O_(n) {
  const r = n.match(S_);
  if (!r)
    return NaN;
  const e = Vo(r[1]), t = Vo(r[2]), a = Vo(r[3]);
  return W_(e, t, a) ? e * fo + t * uo + a * 1e3 : NaN;
}
function Vo(n) {
  return n && parseFloat(n.replace(",", ".")) || 0;
}
function N_(n) {
  if (n === "Z")
    return 0;
  const r = n.match(E_);
  if (!r)
    return 0;
  const e = r[1] === "+" ? -1 : 1, t = parseInt(r[2]), a = r[3] && parseInt(r[3]) || 0;
  return H_(t, a) ? e * (t * fo + a * uo) : NaN;
}
function R_(n, r, e) {
  const t = /* @__PURE__ */ new Date(0);
  t.setUTCFullYear(n, 0, 4);
  const a = t.getUTCDay() || 7, o = (r - 1) * 7 + e + 1 - a;
  return t.setUTCDate(t.getUTCDate() + o), t;
}
const F_ = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function qd(n) {
  return n % 400 === 0 || n % 4 === 0 && n % 100 !== 0;
}
function I_(n, r, e) {
  return r >= 0 && r <= 11 && e >= 1 && e <= (F_[r] || (qd(n) ? 29 : 28));
}
function L_(n, r) {
  return r >= 1 && r <= (qd(n) ? 366 : 365);
}
function Y_(n, r, e) {
  return r >= 1 && r <= 53 && e >= 0 && e <= 6;
}
function W_(n, r, e) {
  return n === 24 ? r === 0 && e === 0 : e >= 0 && e < 60 && r >= 0 && r < 60 && n >= 0 && n < 25;
}
function H_(n, r) {
  return r >= 0 && r <= 59;
}
function $_(n) {
  const r = Q(n), e = r.getFullYear(), t = r.getMonth(), a = de(n, 0);
  return a.setFullYear(e, t + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
function at(n, r) {
  const e = Q(n), t = e.getFullYear(), a = e.getDate(), o = de(n, 0);
  o.setFullYear(t, r, 15), o.setHours(0, 0, 0, 0);
  const i = $_(o);
  return e.setMonth(r, Math.min(a, i)), e;
}
function B_(n, r) {
  let e = Q(n);
  return isNaN(+e) ? de(n, NaN) : (r.year != null && e.setFullYear(r.year), r.month != null && (e = at(e, r.month)), r.date != null && e.setDate(r.date), r.hours != null && e.setHours(r.hours), r.minutes != null && e.setMinutes(r.minutes), r.seconds != null && e.setSeconds(r.seconds), r.milliseconds != null && e.setMilliseconds(r.milliseconds), e);
}
function ma(n, r) {
  const e = Q(n);
  return e.setHours(r), e;
}
function ga(n, r) {
  const e = Q(n);
  return e.setMinutes(r), e;
}
function Vn(n, r) {
  const e = Q(n), t = Math.trunc(e.getMonth() / 3) + 1, a = r - t;
  return at(e, e.getMonth() + a * 3);
}
function ya(n, r) {
  const e = Q(n);
  return e.setSeconds(r), e;
}
function Pt(n, r) {
  const e = Q(n);
  return isNaN(+e) ? de(n, NaN) : (e.setFullYear(r), e);
}
function jd(n) {
  const r = Q(n);
  return r.setDate(1), r.setHours(0, 0, 0, 0), r;
}
function Q_(n, r) {
  return gn(n, -r);
}
function nr(n, r) {
  return Ct(n, -r);
}
function zd(n, r) {
  return ns(n, -r);
}
function Vc(n, r) {
  return Aa(n, -r);
}
function rr(n, r) {
  return Vt(n, -r);
}
function Vd(n) {
  var r;
  return (n == null || (r = n.ownerDocument) == null ? void 0 : r.defaultView) || window;
}
function kr(n) {
  return n instanceof Element || n instanceof Vd(n).Element;
}
function U_(n) {
  return Vd(n).getComputedStyle(n);
}
const ar = Math.min, Sn = Math.max, Wa = Math.round, oa = Math.floor, fn = (n) => ({
  x: n,
  y: n
}), q_ = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, j_ = {
  start: "end",
  end: "start"
};
function z_(n, r, e) {
  return Sn(n, ar(r, e));
}
function ho(n, r) {
  return typeof n == "function" ? n(r) : n;
}
function or(n) {
  return n.split("-")[0];
}
function Br(n) {
  return n.split("-")[1];
}
function V_(n) {
  return n === "x" ? "y" : "x";
}
function ss(n) {
  return n === "y" ? "height" : "width";
}
function cs(n) {
  return ["top", "bottom"].includes(or(n)) ? "y" : "x";
}
function ls(n) {
  return V_(cs(n));
}
function G_(n, r, e) {
  e === void 0 && (e = !1);
  const t = Br(n), a = ls(n), o = ss(a);
  let i = a === "x" ? t === (e ? "end" : "start") ? "right" : "left" : t === "start" ? "bottom" : "top";
  return r.reference[o] > r.floating[o] && (i = Ha(i)), [i, Ha(i)];
}
function K_(n) {
  const r = Ha(n);
  return [ki(n), r, ki(r)];
}
function ki(n) {
  return n.replace(/start|end/g, (r) => j_[r]);
}
function X_(n, r, e) {
  const t = ["left", "right"], a = ["right", "left"], o = ["top", "bottom"], i = ["bottom", "top"];
  switch (n) {
    case "top":
    case "bottom":
      return e ? r ? a : t : r ? t : a;
    case "left":
    case "right":
      return r ? o : i;
    default:
      return [];
  }
}
function J_(n, r, e, t) {
  const a = Br(n);
  let o = X_(or(n), e === "start", t);
  return a && (o = o.map((i) => i + "-" + a), r && (o = o.concat(o.map(ki)))), o;
}
function Ha(n) {
  return n.replace(/left|right|bottom|top/g, (r) => q_[r]);
}
function Z_(n) {
  return w({
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }, n);
}
function Gd(n) {
  return typeof n != "number" ? Z_(n) : {
    top: n,
    right: n,
    bottom: n,
    left: n
  };
}
function $a(n) {
  const {
    x: r,
    y: e,
    width: t,
    height: a
  } = n;
  return {
    width: t,
    height: a,
    top: e,
    left: r,
    right: r + t,
    bottom: e + a,
    x: r,
    y: e
  };
}
function Gc(n, r, e) {
  let {
    reference: t,
    floating: a
  } = n;
  const o = cs(r), i = ls(r), s = ss(i), l = or(r), c = o === "y", u = t.x + t.width / 2 - a.width / 2, d = t.y + t.height / 2 - a.height / 2, f = t[s] / 2 - a[s] / 2;
  let p;
  switch (l) {
    case "top":
      p = {
        x: u,
        y: t.y - a.height
      };
      break;
    case "bottom":
      p = {
        x: u,
        y: t.y + t.height
      };
      break;
    case "right":
      p = {
        x: t.x + t.width,
        y: d
      };
      break;
    case "left":
      p = {
        x: t.x - a.width,
        y: d
      };
      break;
    default:
      p = {
        x: t.x,
        y: t.y
      };
  }
  switch (Br(r)) {
    case "start":
      p[i] -= f * (e && c ? -1 : 1);
      break;
    case "end":
      p[i] += f * (e && c ? -1 : 1);
      break;
  }
  return p;
}
const eD = (n, r, e) => Ee(void 0, null, function* () {
  const {
    placement: t = "bottom",
    strategy: a = "absolute",
    middleware: o = [],
    platform: i
  } = e, s = o.filter(Boolean), l = yield i.isRTL == null ? void 0 : i.isRTL(r);
  let c = yield i.getElementRects({
    reference: n,
    floating: r,
    strategy: a
  }), {
    x: u,
    y: d
  } = Gc(c, t, l), f = t, p = {}, h = 0;
  for (let m = 0; m < s.length; m++) {
    const {
      name: g,
      fn: b
    } = s[m], {
      x: v,
      y: D,
      data: k,
      reset: x
    } = yield b({
      x: u,
      y: d,
      initialPlacement: t,
      placement: f,
      strategy: a,
      middlewareData: p,
      rects: c,
      platform: i,
      elements: {
        reference: n,
        floating: r
      }
    });
    u = v != null ? v : u, d = D != null ? D : d, p = E(w({}, p), {
      [g]: w(w({}, p[g]), k)
    }), x && h <= 50 && (h++, typeof x == "object" && (x.placement && (f = x.placement), x.rects && (c = x.rects === !0 ? yield i.getElementRects({
      reference: n,
      floating: r,
      strategy: a
    }) : x.rects), {
      x: u,
      y: d
    } = Gc(c, f, l)), m = -1);
  }
  return {
    x: u,
    y: d,
    placement: f,
    strategy: a,
    middlewareData: p
  };
});
function tD(n, r) {
  return Ee(this, null, function* () {
    var e;
    r === void 0 && (r = {});
    const {
      x: t,
      y: a,
      platform: o,
      rects: i,
      elements: s,
      strategy: l
    } = n, {
      boundary: c = "clippingAncestors",
      rootBoundary: u = "viewport",
      elementContext: d = "floating",
      altBoundary: f = !1,
      padding: p = 0
    } = ho(r, n), h = Gd(p), g = s[f ? d === "floating" ? "reference" : "floating" : d], b = $a(yield o.getClippingRect({
      element: (e = yield o.isElement == null ? void 0 : o.isElement(g)) == null || e ? g : g.contextElement || (yield o.getDocumentElement == null ? void 0 : o.getDocumentElement(s.floating)),
      boundary: c,
      rootBoundary: u,
      strategy: l
    })), v = d === "floating" ? {
      x: t,
      y: a,
      width: i.floating.width,
      height: i.floating.height
    } : i.reference, D = yield o.getOffsetParent == null ? void 0 : o.getOffsetParent(s.floating), k = (yield o.isElement == null ? void 0 : o.isElement(D)) ? (yield o.getScale == null ? void 0 : o.getScale(D)) || {
      x: 1,
      y: 1
    } : {
      x: 1,
      y: 1
    }, x = $a(o.convertOffsetParentRelativeRectToViewportRelativeRect ? yield o.convertOffsetParentRelativeRectToViewportRelativeRect({
      elements: s,
      rect: v,
      offsetParent: D,
      strategy: l
    }) : v);
    return {
      top: (b.top - x.top + h.top) / k.y,
      bottom: (x.bottom - b.bottom + h.bottom) / k.y,
      left: (b.left - x.left + h.left) / k.x,
      right: (x.right - b.right + h.right) / k.x
    };
  });
}
const nD = (n) => ({
  name: "arrow",
  options: n,
  fn(e) {
    return Ee(this, null, function* () {
      const {
        x: t,
        y: a,
        placement: o,
        rects: i,
        platform: s,
        elements: l,
        middlewareData: c
      } = e, {
        element: u,
        padding: d = 0
      } = ho(n, e) || {};
      if (u == null)
        return {};
      const f = Gd(d), p = {
        x: t,
        y: a
      }, h = ls(o), m = ss(h), g = yield s.getDimensions(u), b = h === "y", v = b ? "top" : "left", D = b ? "bottom" : "right", k = b ? "clientHeight" : "clientWidth", x = i.reference[m] + i.reference[h] - p[h] - i.floating[m], R = p[h] - i.reference[h], I = yield s.getOffsetParent == null ? void 0 : s.getOffsetParent(u);
      let L = I ? I[k] : 0;
      (!L || !(yield s.isElement == null ? void 0 : s.isElement(I))) && (L = l.floating[k] || i.floating[m]);
      const A = x / 2 - R / 2, W = L / 2 - g[m] / 2 - 1, O = ar(f[v], W), U = ar(f[D], W), $ = O, N = L - g[m] - U, T = L / 2 - g[m] / 2 + A, M = z_($, T, N), C = !c.arrow && Br(o) != null && T !== M && i.reference[m] / 2 - (T < $ ? O : U) - g[m] / 2 < 0, S = C ? T < $ ? T - $ : T - N : 0;
      return {
        [h]: p[h] + S,
        data: w({
          [h]: M,
          centerOffset: T - M - S
        }, C && {
          alignmentOffset: S
        }),
        reset: C
      };
    });
  }
}), rD = function(n) {
  return n === void 0 && (n = {}), {
    name: "flip",
    options: n,
    fn(e) {
      return Ee(this, null, function* () {
        var t, a;
        const {
          placement: o,
          middlewareData: i,
          rects: s,
          initialPlacement: l,
          platform: c,
          elements: u
        } = e, $ = ho(n, e), {
          mainAxis: d = !0,
          crossAxis: f = !0,
          fallbackPlacements: p,
          fallbackStrategy: h = "bestFit",
          fallbackAxisSideDirection: m = "none",
          flipAlignment: g = !0
        } = $, b = Re($, [
          "mainAxis",
          "crossAxis",
          "fallbackPlacements",
          "fallbackStrategy",
          "fallbackAxisSideDirection",
          "flipAlignment"
        ]);
        if ((t = i.arrow) != null && t.alignmentOffset)
          return {};
        const v = or(o), D = or(l) === l, k = yield c.isRTL == null ? void 0 : c.isRTL(u.floating), x = p || (D || !g ? [Ha(l)] : K_(l));
        !p && m !== "none" && x.push(...J_(l, g, m, k));
        const R = [l, ...x], I = yield tD(e, b), L = [];
        let A = ((a = i.flip) == null ? void 0 : a.overflows) || [];
        if (d && L.push(I[v]), f) {
          const N = G_(o, s, k);
          L.push(I[N[0]], I[N[1]]);
        }
        if (A = [...A, {
          placement: o,
          overflows: L
        }], !L.every((N) => N <= 0)) {
          var W, O;
          const N = (((W = i.flip) == null ? void 0 : W.index) || 0) + 1, T = R[N];
          if (T)
            return {
              data: {
                index: N,
                overflows: A
              },
              reset: {
                placement: T
              }
            };
          let M = (O = A.filter((C) => C.overflows[0] <= 0).sort((C, S) => C.overflows[1] - S.overflows[1])[0]) == null ? void 0 : O.placement;
          if (!M)
            switch (h) {
              case "bestFit": {
                var U;
                const C = (U = A.map((S) => [S.placement, S.overflows.filter((F) => F > 0).reduce((F, K) => F + K, 0)]).sort((S, F) => S[1] - F[1])[0]) == null ? void 0 : U[0];
                C && (M = C);
                break;
              }
              case "initialPlacement":
                M = l;
                break;
            }
          if (o !== M)
            return {
              reset: {
                placement: M
              }
            };
        }
        return {};
      });
    }
  };
};
function aD(n, r) {
  return Ee(this, null, function* () {
    const {
      placement: e,
      platform: t,
      elements: a
    } = n, o = yield t.isRTL == null ? void 0 : t.isRTL(a.floating), i = or(e), s = Br(e), l = cs(e) === "y", c = ["left", "top"].includes(i) ? -1 : 1, u = o && l ? -1 : 1, d = ho(r, n);
    let {
      mainAxis: f,
      crossAxis: p,
      alignmentAxis: h
    } = typeof d == "number" ? {
      mainAxis: d,
      crossAxis: 0,
      alignmentAxis: null
    } : w({
      mainAxis: 0,
      crossAxis: 0,
      alignmentAxis: null
    }, d);
    return s && typeof h == "number" && (p = s === "end" ? h * -1 : h), l ? {
      x: p * u,
      y: f * c
    } : {
      x: f * c,
      y: p * u
    };
  });
}
const oD = function(n) {
  return n === void 0 && (n = 0), {
    name: "offset",
    options: n,
    fn(e) {
      return Ee(this, null, function* () {
        var t, a;
        const {
          x: o,
          y: i,
          placement: s,
          middlewareData: l
        } = e, c = yield aD(e, n);
        return s === ((t = l.offset) == null ? void 0 : t.placement) && (a = l.arrow) != null && a.alignmentOffset ? {} : {
          x: o + c.x,
          y: i + c.y,
          data: E(w({}, c), {
            placement: s
          })
        };
      });
    }
  };
};
function cr(n) {
  return Kd(n) ? (n.nodeName || "").toLowerCase() : "#document";
}
function ot(n) {
  var r;
  return (n == null || (r = n.ownerDocument) == null ? void 0 : r.defaultView) || window;
}
function en(n) {
  var r;
  return (r = (Kd(n) ? n.ownerDocument : n.document) || window.document) == null ? void 0 : r.documentElement;
}
function Kd(n) {
  return n instanceof Node || n instanceof ot(n).Node;
}
function Lt(n) {
  return n instanceof Element || n instanceof ot(n).Element;
}
function Yt(n) {
  return n instanceof HTMLElement || n instanceof ot(n).HTMLElement;
}
function Kc(n) {
  return typeof ShadowRoot == "undefined" ? !1 : n instanceof ShadowRoot || n instanceof ot(n).ShadowRoot;
}
function Qr(n) {
  const {
    overflow: r,
    overflowX: e,
    overflowY: t,
    display: a
  } = Tt(n);
  return /auto|scroll|overlay|hidden|clip/.test(r + t + e) && !["inline", "contents"].includes(a);
}
function iD(n) {
  return ["table", "td", "th"].includes(cr(n));
}
function us(n) {
  const r = ds(), e = Tt(n);
  return e.transform !== "none" || e.perspective !== "none" || (e.containerType ? e.containerType !== "normal" : !1) || !r && (e.backdropFilter ? e.backdropFilter !== "none" : !1) || !r && (e.filter ? e.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((t) => (e.willChange || "").includes(t)) || ["paint", "layout", "strict", "content"].some((t) => (e.contain || "").includes(t));
}
function sD(n) {
  let r = pn(n);
  for (; Yt(r) && !ir(r); ) {
    if (us(r))
      return r;
    r = pn(r);
  }
  return null;
}
function ds() {
  return typeof CSS == "undefined" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function ir(n) {
  return ["html", "body", "#document"].includes(cr(n));
}
function Tt(n) {
  return ot(n).getComputedStyle(n);
}
function mo(n) {
  return Lt(n) ? {
    scrollLeft: n.scrollLeft,
    scrollTop: n.scrollTop
  } : {
    scrollLeft: n.pageXOffset,
    scrollTop: n.pageYOffset
  };
}
function pn(n) {
  if (cr(n) === "html")
    return n;
  const r = (
    // Step into the shadow DOM of the parent of a slotted node.
    n.assignedSlot || // DOM Element detected.
    n.parentNode || // ShadowRoot detected.
    Kc(n) && n.host || // Fallback.
    en(n)
  );
  return Kc(r) ? r.host : r;
}
function Xd(n) {
  const r = pn(n);
  return ir(r) ? n.ownerDocument ? n.ownerDocument.body : n.body : Yt(r) && Qr(r) ? r : Xd(r);
}
function Rr(n, r, e) {
  var t;
  r === void 0 && (r = []), e === void 0 && (e = !0);
  const a = Xd(n), o = a === ((t = n.ownerDocument) == null ? void 0 : t.body), i = ot(a);
  return o ? r.concat(i, i.visualViewport || [], Qr(a) ? a : [], i.frameElement && e ? Rr(i.frameElement) : []) : r.concat(a, Rr(a, [], e));
}
function Jd(n) {
  const r = Tt(n);
  let e = parseFloat(r.width) || 0, t = parseFloat(r.height) || 0;
  const a = Yt(n), o = a ? n.offsetWidth : e, i = a ? n.offsetHeight : t, s = Wa(e) !== o || Wa(t) !== i;
  return s && (e = o, t = i), {
    width: e,
    height: t,
    $: s
  };
}
function fs(n) {
  return Lt(n) ? n : n.contextElement;
}
function Kn(n) {
  const r = fs(n);
  if (!Yt(r))
    return fn(1);
  const e = r.getBoundingClientRect(), {
    width: t,
    height: a,
    $: o
  } = Jd(r);
  let i = (o ? Wa(e.width) : e.width) / t, s = (o ? Wa(e.height) : e.height) / a;
  return (!i || !Number.isFinite(i)) && (i = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: i,
    y: s
  };
}
const cD = /* @__PURE__ */ fn(0);
function Zd(n) {
  const r = ot(n);
  return !ds() || !r.visualViewport ? cD : {
    x: r.visualViewport.offsetLeft,
    y: r.visualViewport.offsetTop
  };
}
function lD(n, r, e) {
  return r === void 0 && (r = !1), !e || r && e !== ot(n) ? !1 : r;
}
function In(n, r, e, t) {
  r === void 0 && (r = !1), e === void 0 && (e = !1);
  const a = n.getBoundingClientRect(), o = fs(n);
  let i = fn(1);
  r && (t ? Lt(t) && (i = Kn(t)) : i = Kn(n));
  const s = lD(o, e, t) ? Zd(o) : fn(0);
  let l = (a.left + s.x) / i.x, c = (a.top + s.y) / i.y, u = a.width / i.x, d = a.height / i.y;
  if (o) {
    const f = ot(o), p = t && Lt(t) ? ot(t) : t;
    let h = f, m = h.frameElement;
    for (; m && t && p !== h; ) {
      const g = Kn(m), b = m.getBoundingClientRect(), v = Tt(m), D = b.left + (m.clientLeft + parseFloat(v.paddingLeft)) * g.x, k = b.top + (m.clientTop + parseFloat(v.paddingTop)) * g.y;
      l *= g.x, c *= g.y, u *= g.x, d *= g.y, l += D, c += k, h = ot(m), m = h.frameElement;
    }
  }
  return $a({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
const uD = [":popover-open", ":modal"];
function ps(n) {
  return uD.some((r) => {
    try {
      return n.matches(r);
    } catch (e) {
      return !1;
    }
  });
}
function dD(n) {
  let {
    elements: r,
    rect: e,
    offsetParent: t,
    strategy: a
  } = n;
  const o = a === "fixed", i = en(t), s = r ? ps(r.floating) : !1;
  if (t === i || s && o)
    return e;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = fn(1);
  const u = fn(0), d = Yt(t);
  if ((d || !d && !o) && ((cr(t) !== "body" || Qr(i)) && (l = mo(t)), Yt(t))) {
    const f = In(t);
    c = Kn(t), u.x = f.x + t.clientLeft, u.y = f.y + t.clientTop;
  }
  return {
    width: e.width * c.x,
    height: e.height * c.y,
    x: e.x * c.x - l.scrollLeft * c.x + u.x,
    y: e.y * c.y - l.scrollTop * c.y + u.y
  };
}
function fD(n) {
  return Array.from(n.getClientRects());
}
function ef(n) {
  return In(en(n)).left + mo(n).scrollLeft;
}
function pD(n) {
  const r = en(n), e = mo(n), t = n.ownerDocument.body, a = Sn(r.scrollWidth, r.clientWidth, t.scrollWidth, t.clientWidth), o = Sn(r.scrollHeight, r.clientHeight, t.scrollHeight, t.clientHeight);
  let i = -e.scrollLeft + ef(n);
  const s = -e.scrollTop;
  return Tt(t).direction === "rtl" && (i += Sn(r.clientWidth, t.clientWidth) - a), {
    width: a,
    height: o,
    x: i,
    y: s
  };
}
function hD(n, r) {
  const e = ot(n), t = en(n), a = e.visualViewport;
  let o = t.clientWidth, i = t.clientHeight, s = 0, l = 0;
  if (a) {
    o = a.width, i = a.height;
    const c = ds();
    (!c || c && r === "fixed") && (s = a.offsetLeft, l = a.offsetTop);
  }
  return {
    width: o,
    height: i,
    x: s,
    y: l
  };
}
function mD(n, r) {
  const e = In(n, !0, r === "fixed"), t = e.top + n.clientTop, a = e.left + n.clientLeft, o = Yt(n) ? Kn(n) : fn(1), i = n.clientWidth * o.x, s = n.clientHeight * o.y, l = a * o.x, c = t * o.y;
  return {
    width: i,
    height: s,
    x: l,
    y: c
  };
}
function Xc(n, r, e) {
  let t;
  if (r === "viewport")
    t = hD(n, e);
  else if (r === "document")
    t = pD(en(n));
  else if (Lt(r))
    t = mD(r, e);
  else {
    const a = Zd(n);
    t = E(w({}, r), {
      x: r.x - a.x,
      y: r.y - a.y
    });
  }
  return $a(t);
}
function tf(n, r) {
  const e = pn(n);
  return e === r || !Lt(e) || ir(e) ? !1 : Tt(e).position === "fixed" || tf(e, r);
}
function gD(n, r) {
  const e = r.get(n);
  if (e)
    return e;
  let t = Rr(n, [], !1).filter((s) => Lt(s) && cr(s) !== "body"), a = null;
  const o = Tt(n).position === "fixed";
  let i = o ? pn(n) : n;
  for (; Lt(i) && !ir(i); ) {
    const s = Tt(i), l = us(i);
    !l && s.position === "fixed" && (a = null), (o ? !l && !a : !l && s.position === "static" && !!a && ["absolute", "fixed"].includes(a.position) || Qr(i) && !l && tf(n, i)) ? t = t.filter((u) => u !== i) : a = s, i = pn(i);
  }
  return r.set(n, t), t;
}
function yD(n) {
  let {
    element: r,
    boundary: e,
    rootBoundary: t,
    strategy: a
  } = n;
  const i = [...e === "clippingAncestors" ? ps(r) ? [] : gD(r, this._c) : [].concat(e), t], s = i[0], l = i.reduce((c, u) => {
    const d = Xc(r, u, a);
    return c.top = Sn(d.top, c.top), c.right = ar(d.right, c.right), c.bottom = ar(d.bottom, c.bottom), c.left = Sn(d.left, c.left), c;
  }, Xc(r, s, a));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function bD(n) {
  const {
    width: r,
    height: e
  } = Jd(n);
  return {
    width: r,
    height: e
  };
}
function vD(n, r, e) {
  const t = Yt(r), a = en(r), o = e === "fixed", i = In(n, !0, o, r);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = fn(0);
  if (t || !t && !o)
    if ((cr(r) !== "body" || Qr(a)) && (s = mo(r)), t) {
      const d = In(r, !0, o, r);
      l.x = d.x + r.clientLeft, l.y = d.y + r.clientTop;
    } else
      a && (l.x = ef(a));
  const c = i.left + s.scrollLeft - l.x, u = i.top + s.scrollTop - l.y;
  return {
    x: c,
    y: u,
    width: i.width,
    height: i.height
  };
}
function Go(n) {
  return Tt(n).position === "static";
}
function Jc(n, r) {
  return !Yt(n) || Tt(n).position === "fixed" ? null : r ? r(n) : n.offsetParent;
}
function nf(n, r) {
  const e = ot(n);
  if (ps(n))
    return e;
  if (!Yt(n)) {
    let a = pn(n);
    for (; a && !ir(a); ) {
      if (Lt(a) && !Go(a))
        return a;
      a = pn(a);
    }
    return e;
  }
  let t = Jc(n, r);
  for (; t && iD(t) && Go(t); )
    t = Jc(t, r);
  return t && ir(t) && Go(t) && !us(t) ? e : t || sD(n) || e;
}
const wD = function(n) {
  return Ee(this, null, function* () {
    const r = this.getOffsetParent || nf, e = this.getDimensions, t = yield e(n.floating);
    return {
      reference: vD(n.reference, yield r(n.floating), n.strategy),
      floating: {
        x: 0,
        y: 0,
        width: t.width,
        height: t.height
      }
    };
  });
};
function _D(n) {
  return Tt(n).direction === "rtl";
}
const DD = {
  convertOffsetParentRelativeRectToViewportRelativeRect: dD,
  getDocumentElement: en,
  getClippingRect: yD,
  getOffsetParent: nf,
  getElementRects: wD,
  getClientRects: fD,
  getDimensions: bD,
  getScale: Kn,
  isElement: Lt,
  isRTL: _D
};
function kD(n, r) {
  let e = null, t;
  const a = en(n);
  function o() {
    var s;
    clearTimeout(t), (s = e) == null || s.disconnect(), e = null;
  }
  function i(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), o();
    const {
      left: c,
      top: u,
      width: d,
      height: f
    } = n.getBoundingClientRect();
    if (s || r(), !d || !f)
      return;
    const p = oa(u), h = oa(a.clientWidth - (c + d)), m = oa(a.clientHeight - (u + f)), g = oa(c), v = {
      rootMargin: -p + "px " + -h + "px " + -m + "px " + -g + "px",
      threshold: Sn(0, ar(1, l)) || 1
    };
    let D = !0;
    function k(x) {
      const R = x[0].intersectionRatio;
      if (R !== l) {
        if (!D)
          return i();
        R ? i(!1, R) : t = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      D = !1;
    }
    try {
      e = new IntersectionObserver(k, E(w({}, v), {
        // Handle <iframe>s
        root: a.ownerDocument
      }));
    } catch (x) {
      e = new IntersectionObserver(k, v);
    }
    e.observe(n);
  }
  return i(!0), o;
}
function xD(n, r, e, t) {
  t === void 0 && (t = {});
  const {
    ancestorScroll: a = !0,
    ancestorResize: o = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = t, c = fs(n), u = a || o ? [...c ? Rr(c) : [], ...Rr(r)] : [];
  u.forEach((b) => {
    a && b.addEventListener("scroll", e, {
      passive: !0
    }), o && b.addEventListener("resize", e);
  });
  const d = c && s ? kD(c, e) : null;
  let f = -1, p = null;
  i && (p = new ResizeObserver((b) => {
    let [v] = b;
    v && v.target === c && p && (p.unobserve(r), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var D;
      (D = p) == null || D.observe(r);
    })), e();
  }), c && !l && p.observe(c), p.observe(r));
  let h, m = l ? In(n) : null;
  l && g();
  function g() {
    const b = In(n);
    m && (b.x !== m.x || b.y !== m.y || b.width !== m.width || b.height !== m.height) && e(), m = b, h = requestAnimationFrame(g);
  }
  return e(), () => {
    var b;
    u.forEach((v) => {
      a && v.removeEventListener("scroll", e), o && v.removeEventListener("resize", e);
    }), d == null || d(), (b = p) == null || b.disconnect(), p = null, l && cancelAnimationFrame(h);
  };
}
const CD = oD, TD = rD, Zc = nD, SD = (n, r, e) => {
  const t = /* @__PURE__ */ new Map(), a = w({
    platform: DD
  }, e), o = E(w({}, a.platform), {
    _c: t
  });
  return eD(n, r, E(w({}, a), {
    platform: o
  }));
};
var ba = typeof document != "undefined" ? Du : ge;
function Ba(n, r) {
  if (n === r)
    return !0;
  if (typeof n != typeof r)
    return !1;
  if (typeof n == "function" && n.toString() === r.toString())
    return !0;
  let e, t, a;
  if (n && r && typeof n == "object") {
    if (Array.isArray(n)) {
      if (e = n.length, e !== r.length)
        return !1;
      for (t = e; t-- !== 0; )
        if (!Ba(n[t], r[t]))
          return !1;
      return !0;
    }
    if (a = Object.keys(n), e = a.length, e !== Object.keys(r).length)
      return !1;
    for (t = e; t-- !== 0; )
      if (!{}.hasOwnProperty.call(r, a[t]))
        return !1;
    for (t = e; t-- !== 0; ) {
      const o = a[t];
      if (!(o === "_owner" && n.$$typeof) && !Ba(n[o], r[o]))
        return !1;
    }
    return !0;
  }
  return n !== n && r !== r;
}
function rf(n) {
  return typeof window == "undefined" ? 1 : (n.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function el(n, r) {
  const e = rf(n);
  return Math.round(r * e) / e;
}
function tl(n) {
  const r = j.useRef(n);
  return ba(() => {
    r.current = n;
  }), r;
}
function ED(n) {
  n === void 0 && (n = {});
  const {
    placement: r = "bottom",
    strategy: e = "absolute",
    middleware: t = [],
    platform: a,
    elements: {
      reference: o,
      floating: i
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: c
  } = n, [u, d] = j.useState({
    x: 0,
    y: 0,
    strategy: e,
    placement: r,
    middlewareData: {},
    isPositioned: !1
  }), [f, p] = j.useState(t);
  Ba(f, t) || p(t);
  const [h, m] = j.useState(null), [g, b] = j.useState(null), v = j.useCallback((C) => {
    C !== R.current && (R.current = C, m(C));
  }, []), D = j.useCallback((C) => {
    C !== I.current && (I.current = C, b(C));
  }, []), k = o || h, x = i || g, R = j.useRef(null), I = j.useRef(null), L = j.useRef(u), A = l != null, W = tl(l), O = tl(a), U = j.useCallback(() => {
    if (!R.current || !I.current)
      return;
    const C = {
      placement: r,
      strategy: e,
      middleware: f
    };
    O.current && (C.platform = O.current), SD(R.current, I.current, C).then((S) => {
      const F = E(w({}, S), {
        isPositioned: !0
      });
      $.current && !Ba(L.current, F) && (L.current = F, sm.flushSync(() => {
        d(F);
      }));
    });
  }, [f, r, e, O]);
  ba(() => {
    c === !1 && L.current.isPositioned && (L.current.isPositioned = !1, d((C) => E(w({}, C), {
      isPositioned: !1
    })));
  }, [c]);
  const $ = j.useRef(!1);
  ba(() => ($.current = !0, () => {
    $.current = !1;
  }), []), ba(() => {
    if (k && (R.current = k), x && (I.current = x), k && x) {
      if (W.current)
        return W.current(k, x, U);
      U();
    }
  }, [k, x, U, W, A]);
  const N = j.useMemo(() => ({
    reference: R,
    floating: I,
    setReference: v,
    setFloating: D
  }), [v, D]), T = j.useMemo(() => ({
    reference: k,
    floating: x
  }), [k, x]), M = j.useMemo(() => {
    const C = {
      position: e,
      left: 0,
      top: 0
    };
    if (!T.floating)
      return C;
    const S = el(T.floating, u.x), F = el(T.floating, u.y);
    return s ? w(E(w({}, C), {
      transform: "translate(" + S + "px, " + F + "px)"
    }), rf(T.floating) >= 1.5 && {
      willChange: "transform"
    }) : {
      position: e,
      left: S,
      top: F
    };
  }, [e, s, T.floating, u.x, u.y]);
  return j.useMemo(() => E(w({}, u), {
    update: U,
    refs: N,
    elements: T,
    floatingStyles: M
  }), [u, U, N, T, M]);
}
const MD = (n) => {
  function r(e) {
    return {}.hasOwnProperty.call(e, "current");
  }
  return {
    name: "arrow",
    options: n,
    fn(e) {
      const {
        element: t,
        padding: a
      } = typeof n == "function" ? n(e) : n;
      return t && r(t) ? t.current != null ? Zc({
        element: t.current,
        padding: a
      }).fn(e) : {} : t ? Zc({
        element: t,
        padding: a
      }).fn(e) : {};
    }
  };
}, PD = (n, r) => E(w({}, CD(n)), {
  options: [n, r]
}), AD = (n, r) => E(w({}, TD(n)), {
  options: [n, r]
}), OD = (n, r) => E(w({}, MD(n)), {
  options: [n, r]
}), af = w({}, j), ND = af.useInsertionEffect, RD = ND || ((n) => n());
function FD(n) {
  const r = j.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return RD(() => {
    r.current = n;
  }), j.useCallback(function() {
    for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++)
      t[a] = arguments[a];
    return r.current == null ? void 0 : r.current(...t);
  }, []);
}
var Qa = typeof document != "undefined" ? Du : ge;
function xi() {
  return xi = Object.assign ? Object.assign.bind() : function(n) {
    for (var r = 1; r < arguments.length; r++) {
      var e = arguments[r];
      for (var t in e)
        Object.prototype.hasOwnProperty.call(e, t) && (n[t] = e[t]);
    }
    return n;
  }, xi.apply(this, arguments);
}
let nl = !1, ID = 0;
const rl = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + ID++
);
function LD() {
  const [n, r] = j.useState(() => nl ? rl() : void 0);
  return Qa(() => {
    n == null && r(rl());
  }, []), j.useEffect(() => {
    nl = !0;
  }, []), n;
}
const YD = af.useId, of = YD || LD;
let Fr;
process.env.NODE_ENV !== "production" && (Fr = /* @__PURE__ */ new Set());
function WD() {
  for (var n, r = arguments.length, e = new Array(r), t = 0; t < r; t++)
    e[t] = arguments[t];
  const a = "Floating UI: " + e.join(" ");
  if (!((n = Fr) != null && n.has(a))) {
    var o;
    (o = Fr) == null || o.add(a), console.warn(a);
  }
}
function HD() {
  for (var n, r = arguments.length, e = new Array(r), t = 0; t < r; t++)
    e[t] = arguments[t];
  const a = "Floating UI: " + e.join(" ");
  if (!((n = Fr) != null && n.has(a))) {
    var o;
    (o = Fr) == null || o.add(a), console.error(a);
  }
}
const $D = /* @__PURE__ */ j.forwardRef(function(r, e) {
  const C = r, {
    context: {
      placement: t,
      elements: {
        floating: a
      },
      middlewareData: {
        arrow: o
      }
    },
    width: i = 14,
    height: s = 7,
    tipRadius: l = 0,
    strokeWidth: c = 0,
    staticOffset: u,
    stroke: d,
    d: f,
    style: S = {}
  } = C, F = S, {
    transform: p
  } = F, h = Re(F, [
    "transform"
  ]), m = Re(C, [
    "context",
    "width",
    "height",
    "tipRadius",
    "strokeWidth",
    "staticOffset",
    "stroke",
    "d",
    "style"
  ]);
  process.env.NODE_ENV !== "production" && (e || WD("The `ref` prop is required for `FloatingArrow`."));
  const g = of(), [b, v] = j.useState(!1);
  if (Qa(() => {
    if (!a)
      return;
    U_(a).direction === "rtl" && v(!0);
  }, [a]), !a)
    return null;
  const D = c * 2, k = D / 2, x = i / 2 * (l / -8 + 1), R = s / 2 * l / 4, [I, L] = t.split("-"), A = !!f, W = I === "top" || I === "bottom", O = u && L === "end" ? "bottom" : "top";
  let U = u && L === "end" ? "right" : "left";
  u && b && (U = L === "end" ? "left" : "right");
  const $ = (o == null ? void 0 : o.x) != null ? u || o.x : "", N = (o == null ? void 0 : o.y) != null ? u || o.y : "", T = f || "M0,0" + (" H" + i) + (" L" + (i - x) + "," + (s - R)) + (" Q" + i / 2 + "," + s + " " + x + "," + (s - R)) + " Z", M = {
    top: A ? "rotate(180deg)" : "",
    left: A ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: A ? "" : "rotate(180deg)",
    right: A ? "rotate(-90deg)" : "rotate(90deg)"
  }[I];
  return /* @__PURE__ */ j.createElement("svg", xi({}, m, {
    "aria-hidden": !0,
    ref: e,
    width: A ? i : i + D,
    height: i,
    viewBox: "0 0 " + i + " " + (s > i ? s : i),
    style: w({
      position: "absolute",
      pointerEvents: "none",
      [U]: $,
      [O]: N,
      [I]: W || A ? "100%" : "calc(100% - " + D / 2 + "px)",
      transform: "" + M + (p != null ? p : "")
    }, h)
  }), D > 0 && /* @__PURE__ */ j.createElement("path", {
    clipPath: "url(#" + g + ")",
    fill: "none",
    stroke: d,
    strokeWidth: D + (f ? 0 : 1),
    d: T
  }), /* @__PURE__ */ j.createElement("path", {
    stroke: D && !f ? m.fill : "none",
    d: T
  }), /* @__PURE__ */ j.createElement("clipPath", {
    id: g
  }, /* @__PURE__ */ j.createElement("rect", {
    x: -k,
    y: k * (A ? -1 : 1),
    width: i + D,
    height: i
  })));
});
function BD() {
  const n = /* @__PURE__ */ new Map();
  return {
    emit(r, e) {
      var t;
      (t = n.get(r)) == null || t.forEach((a) => a(e));
    },
    on(r, e) {
      n.set(r, [...n.get(r) || [], e]);
    },
    off(r, e) {
      var t;
      n.set(r, ((t = n.get(r)) == null ? void 0 : t.filter((a) => a !== e)) || []);
    }
  };
}
const QD = /* @__PURE__ */ j.createContext(null), UD = /* @__PURE__ */ j.createContext(null), qD = () => {
  var n;
  return ((n = j.useContext(QD)) == null ? void 0 : n.id) || null;
}, jD = () => j.useContext(UD);
function zD(n) {
  const {
    open: r = !1,
    onOpenChange: e,
    elements: t
  } = n, a = of(), o = j.useRef({}), [i] = j.useState(() => BD()), s = qD() != null;
  if (process.env.NODE_ENV !== "production") {
    const p = t.reference;
    p && !kr(p) && HD("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [l, c] = j.useState(t.reference), u = FD((p, h, m) => {
    o.current.openEvent = p ? h : void 0, i.emit("openchange", {
      open: p,
      event: h,
      reason: m,
      nested: s
    }), e == null || e(p, h, m);
  }), d = j.useMemo(() => ({
    setPositionReference: c
  }), []), f = j.useMemo(() => ({
    reference: l || t.reference || null,
    floating: t.floating || null,
    domReference: t.reference
  }), [l, t.reference, t.floating]);
  return j.useMemo(() => ({
    dataRef: o,
    open: r,
    onOpenChange: u,
    elements: f,
    events: i,
    floatingId: a,
    refs: d
  }), [r, u, f, i, a, d]);
}
function VD(n) {
  n === void 0 && (n = {});
  const {
    nodeId: r
  } = n, e = zD(E(w({}, n), {
    elements: w({
      reference: null,
      floating: null
    }, n.elements)
  })), t = n.rootContext || e, a = t.elements, [o, i] = j.useState(null), [s, l] = j.useState(null), u = (a == null ? void 0 : a.reference) || o, d = j.useRef(null), f = jD();
  Qa(() => {
    u && (d.current = u);
  }, [u]);
  const p = ED(E(w({}, n), {
    elements: w(w({}, a), s && {
      reference: s
    })
  })), h = j.useCallback((D) => {
    const k = kr(D) ? {
      getBoundingClientRect: () => D.getBoundingClientRect(),
      contextElement: D
    } : D;
    l(k), p.refs.setReference(k);
  }, [p.refs]), m = j.useCallback((D) => {
    (kr(D) || D === null) && (d.current = D, i(D)), (kr(p.refs.reference.current) || p.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    D !== null && !kr(D)) && p.refs.setReference(D);
  }, [p.refs]), g = j.useMemo(() => E(w({}, p.refs), {
    setReference: m,
    setPositionReference: h,
    domReference: d
  }), [p.refs, m, h]), b = j.useMemo(() => E(w({}, p.elements), {
    domReference: u
  }), [p.elements, u]), v = j.useMemo(() => E(w(w({}, p), t), {
    refs: g,
    elements: b,
    nodeId: r
  }), [p, g, b, r, t]);
  return Qa(() => {
    t.dataRef.current.floatingContext = v;
    const D = f == null ? void 0 : f.nodesRef.current.find((k) => k.id === r);
    D && (D.context = v);
  }), j.useMemo(() => E(w({}, p), {
    context: v,
    refs: g,
    elements: b
  }), [p, g, b, v]);
}
/*!
  react-datepicker v7.3.0
  https://github.com/Hacker0x01/react-datepicker
  Released under the MIT License.
*/
var Ci = function(r, e) {
  return Ci = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function(t, a) {
    t.__proto__ = a;
  } || function(t, a) {
    for (var o in a)
      Object.prototype.hasOwnProperty.call(a, o) && (t[o] = a[o]);
  }, Ci(r, e);
};
function Ae(n, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
  Ci(n, r);
  function e() {
    this.constructor = n;
  }
  n.prototype = r === null ? Object.create(r) : (e.prototype = r.prototype, new e());
}
var ie = function() {
  return ie = Object.assign || function(e) {
    for (var t, a = 1, o = arguments.length; a < o; a++) {
      t = arguments[a];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, ie.apply(this, arguments);
};
function Rt(n, r, e) {
  if (e || arguments.length === 2)
    for (var t = 0, a = r.length, o; t < a; t++)
      (o || !(t in r)) && (o || (o = Array.prototype.slice.call(r, 0, t)), o[t] = r[t]);
  return n.concat(o || Array.prototype.slice.call(r));
}
var GD = function(n) {
  var r = n.showTimeSelectOnly, e = r === void 0 ? !1 : r, t = n.showTime, a = t === void 0 ? !1 : t, o = n.className, i = n.children, s = e ? "Choose Time" : "Choose Date".concat(a ? " and Time" : "");
  return P.createElement("div", { className: o, role: "dialog", "aria-label": s, "aria-modal": "true" }, i);
}, H;
(function(n) {
  n.ArrowUp = "ArrowUp", n.ArrowDown = "ArrowDown", n.ArrowLeft = "ArrowLeft", n.ArrowRight = "ArrowRight", n.PageUp = "PageUp", n.PageDown = "PageDown", n.Home = "Home", n.End = "End", n.Enter = "Enter", n.Space = " ", n.Tab = "Tab", n.Escape = "Escape", n.Backspace = "Backspace", n.X = "x";
})(H || (H = {}));
function sf() {
  var n = typeof window != "undefined" ? window : globalThis;
  return n;
}
var Ur = 12, KD = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
function fe(n) {
  if (n == null)
    return /* @__PURE__ */ new Date();
  var r = typeof n == "string" ? C_(n) : Q(n);
  return qt(r) ? r : /* @__PURE__ */ new Date();
}
function XD(n, r, e, t, a) {
  var o, i = null, s = En(e) || En(Tr()), l = !0;
  if (Array.isArray(r))
    return r.forEach(function(u) {
      var d = zo(n, u, /* @__PURE__ */ new Date(), {
        locale: s,
        useAdditionalWeekYearTokens: !0,
        useAdditionalDayOfYearTokens: !0
      });
      t && (l = qt(d, a) && n === be(d, u, e)), qt(d, a) && l && (i = d);
    }), i;
  if (i = zo(n, r, /* @__PURE__ */ new Date(), {
    locale: s,
    useAdditionalWeekYearTokens: !0,
    useAdditionalDayOfYearTokens: !0
  }), t)
    l = qt(i) && n === be(i, r, e);
  else if (!qt(i)) {
    var c = ((o = r.match(KD)) !== null && o !== void 0 ? o : []).map(function(u) {
      var d = u[0];
      if (d === "p" || d === "P") {
        var f = Ia[d];
        return s ? f(u, s.formatLong) : d;
      }
      return u;
    }).join("");
    n.length > 0 && (i = zo(n, c.slice(0, n.length), /* @__PURE__ */ new Date(), {
      useAdditionalWeekYearTokens: !0,
      useAdditionalDayOfYearTokens: !0
    })), qt(i) || (i = new Date(n));
  }
  return qt(i) && l ? i : null;
}
function qt(n, r) {
  return La(n) && !Fn(n, r != null ? r : /* @__PURE__ */ new Date("1/1/1800"));
}
function be(n, r, e) {
  if (e === "en")
    return Uc(n, r, {
      useAdditionalWeekYearTokens: !0,
      useAdditionalDayOfYearTokens: !0
    });
  var t = e ? En(e) : void 0;
  return e && !t && console.warn('A locale object was not found for the provided string ["'.concat(e, '"].')), !t && Tr() && En(Tr()) && (t = En(Tr())), Uc(n, r, {
    locale: t,
    useAdditionalWeekYearTokens: !0,
    useAdditionalDayOfYearTokens: !0
  });
}
function ft(n, r) {
  var e = r.dateFormat, t = r.locale, a = Array.isArray(e) && e.length > 0 ? e[0] : e;
  return n && be(n, a, t) || "";
}
function JD(n, r, e) {
  if (!n)
    return "";
  var t = ft(n, e), a = r ? ft(r, e) : "";
  return "".concat(t, " - ").concat(a);
}
function ZD(n, r) {
  if (!(n != null && n.length))
    return "";
  var e = n[0] ? ft(n[0], r) : "";
  if (n.length === 1)
    return e;
  if (n.length === 2 && n[1]) {
    var t = ft(n[1], r);
    return "".concat(e, ", ").concat(t);
  }
  var a = n.length - 1;
  return "".concat(e, " (+").concat(a, ")");
}
function Ko(n, r) {
  var e = r.hour, t = e === void 0 ? 0 : e, a = r.minute, o = a === void 0 ? 0 : a, i = r.second, s = i === void 0 ? 0 : i;
  return ma(ga(ya(n, s), o), t);
}
function ek(n) {
  return rs(n);
}
function tk(n, r) {
  return be(n, "ddd", r);
}
function va(n) {
  return Rn(n);
}
function ln(n, r, e) {
  var t = En(r || Tr());
  return Jt(n, {
    locale: t,
    weekStartsOn: e
  });
}
function un(n) {
  return jd(n);
}
function xr(n) {
  return po(n);
}
function al(n) {
  return Di(n);
}
function ol() {
  return Rn(fe());
}
function il(n) {
  return Nd(n);
}
function nk(n) {
  return P0(n);
}
function At(n, r) {
  return n && r ? Ew(n, r) : !n && !r;
}
function Ke(n, r) {
  return n && r ? Tw(n, r) : !n && !r;
}
function Ua(n, r) {
  return n && r ? Sw(n, r) : !n && !r;
}
function oe(n, r) {
  return n && r ? Cw(n, r) : !n && !r;
}
function kn(n, r) {
  return n && r ? xw(n, r) : !n && !r;
}
function Cr(n, r, e) {
  var t, a = Rn(r), o = Nd(e);
  try {
    t = Nr(n, { start: a, end: o });
  } catch (i) {
    t = !1;
  }
  return t;
}
function Tr() {
  var n = sf();
  return n.__localeId__;
}
function En(n) {
  if (typeof n == "string") {
    var r = sf();
    return r.__localeData__ ? r.__localeData__[n] : void 0;
  } else
    return n;
}
function rk(n, r, e) {
  return r(be(n, "EEEE", e));
}
function ak(n, r) {
  return be(n, "EEEEEE", r);
}
function ok(n, r) {
  return be(n, "EEE", r);
}
function hs(n, r) {
  return be(at(fe(), n), "LLLL", r);
}
function cf(n, r) {
  return be(at(fe(), n), "LLL", r);
}
function ik(n, r) {
  return be(Vn(fe(), n), "QQQ", r);
}
function on(n, r) {
  var e = r === void 0 ? {} : r, t = e.minDate, a = e.maxDate, o = e.excludeDates, i = e.excludeDateIntervals, s = e.includeDates, l = e.includeDateIntervals, c = e.filterDate;
  return qr(n, { minDate: t, maxDate: a }) || o && o.some(function(u) {
    var d;
    return u instanceof Date ? oe(n, u) : oe(n, (d = u.date) !== null && d !== void 0 ? d : /* @__PURE__ */ new Date());
  }) || i && i.some(function(u) {
    var d = u.start, f = u.end;
    return Nr(n, { start: d, end: f });
  }) || s && !s.some(function(u) {
    return oe(n, u);
  }) || l && !l.some(function(u) {
    var d = u.start, f = u.end;
    return Nr(n, { start: d, end: f });
  }) || c && !c(fe(n)) || !1;
}
function ms(n, r) {
  var e = r === void 0 ? {} : r, t = e.excludeDates, a = e.excludeDateIntervals;
  return a && a.length > 0 ? a.some(function(o) {
    var i = o.start, s = o.end;
    return Nr(n, { start: i, end: s });
  }) : t && t.some(function(o) {
    var i;
    return o instanceof Date ? oe(n, o) : oe(n, (i = o.date) !== null && i !== void 0 ? i : /* @__PURE__ */ new Date());
  }) || !1;
}
function lf(n, r) {
  var e = r === void 0 ? {} : r, t = e.minDate, a = e.maxDate, o = e.excludeDates, i = e.includeDates, s = e.filterDate;
  return qr(n, {
    minDate: t ? jd(t) : void 0,
    maxDate: a ? E0(a) : void 0
  }) || (o == null ? void 0 : o.some(function(l) {
    return Ke(n, l instanceof Date ? l : l.date);
  })) || i && !i.some(function(l) {
    return Ke(n, l);
  }) || s && !s(fe(n)) || !1;
}
function ia(n, r, e, t) {
  var a = te(n), o = Xe(n), i = te(r), s = Xe(r), l = te(t);
  return a === i && a === l ? o <= e && e <= s : a < i ? l === a && o <= e || l === i && s >= e || l < i && l > a : !1;
}
function sk(n, r) {
  var e = r === void 0 ? {} : r, t = e.minDate, a = e.maxDate, o = e.excludeDates, i = e.includeDates;
  return qr(n, { minDate: t, maxDate: a }) || o && o.some(function(s) {
    return Ke(s instanceof Date ? s : s.date, n);
  }) || i && !i.some(function(s) {
    return Ke(s, n);
  }) || !1;
}
function Xo(n, r) {
  var e = r === void 0 ? {} : r, t = e.minDate, a = e.maxDate, o = e.excludeDates, i = e.includeDates, s = e.filterDate;
  return qr(n, { minDate: t, maxDate: a }) || (o == null ? void 0 : o.some(function(l) {
    return Ua(n, l instanceof Date ? l : l.date);
  })) || i && !i.some(function(l) {
    return Ua(n, l);
  }) || s && !s(fe(n)) || !1;
}
function sa(n, r, e) {
  if (!r || !e || !La(r) || !La(e))
    return !1;
  var t = te(r), a = te(e);
  return t <= n && a >= n;
}
function Ti(n, r) {
  var e = r === void 0 ? {} : r, t = e.minDate, a = e.maxDate, o = e.excludeDates, i = e.includeDates, s = e.filterDate, l = new Date(n, 0, 1);
  return qr(l, {
    minDate: t ? po(t) : void 0,
    maxDate: a ? Rd(a) : void 0
  }) || (o == null ? void 0 : o.some(function(c) {
    return At(l, c instanceof Date ? c : c.date);
  })) || i && !i.some(function(c) {
    return At(l, c);
  }) || s && !s(fe(l)) || !1;
}
function ca(n, r, e, t) {
  var a = te(n), o = Tn(n), i = te(r), s = Tn(r), l = te(t);
  return a === i && a === l ? o <= e && e <= s : a < i ? l === a && o <= e || l === i && s >= e || l < i && l > a : !1;
}
function qr(n, r) {
  var e, t = r === void 0 ? {} : r, a = t.minDate, o = t.maxDate;
  return (e = a && Or(n, a) < 0 || o && Or(n, o) > 0) !== null && e !== void 0 ? e : !1;
}
function sl(n, r) {
  return r.some(function(e) {
    return Ft(e) === Ft(n) && It(e) === It(n) && Kt(e) === Kt(n);
  });
}
function cl(n, r) {
  var e = r === void 0 ? {} : r, t = e.excludeTimes, a = e.includeTimes, o = e.filterTime;
  return t && sl(n, t) || a && !sl(n, a) || o && !o(n) || !1;
}
function ll(n, r) {
  var e = r.minTime, t = r.maxTime;
  if (!e || !t)
    throw new Error("Both minTime and maxTime props required");
  var a = fe();
  a = ma(a, Ft(n)), a = ga(a, It(n)), a = ya(a, Kt(n));
  var o = fe();
  o = ma(o, Ft(e)), o = ga(o, It(e)), o = ya(o, Kt(e));
  var i = fe();
  i = ma(i, Ft(t)), i = ga(i, It(t)), i = ya(i, Kt(t));
  var s;
  try {
    s = !Nr(a, { start: o, end: i });
  } catch (l) {
    s = !1;
  }
  return s;
}
function ul(n, r) {
  var e = r === void 0 ? {} : r, t = e.minDate, a = e.includeDates, o = nr(n, 1);
  return t && Na(t, o) > 0 || a && a.every(function(i) {
    return Na(i, o) > 0;
  }) || !1;
}
function dl(n, r) {
  var e = r === void 0 ? {} : r, t = e.maxDate, a = e.includeDates, o = Ct(n, 1);
  return t && Na(o, t) > 0 || a && a.every(function(i) {
    return Na(o, i) > 0;
  }) || !1;
}
function ck(n, r) {
  var e = r === void 0 ? {} : r, t = e.minDate, a = e.includeDates, o = po(n), i = zd(o, 1);
  return t && Ra(t, i) > 0 || a && a.every(function(s) {
    return Ra(s, i) > 0;
  }) || !1;
}
function lk(n, r) {
  var e = r === void 0 ? {} : r, t = e.maxDate, a = e.includeDates, o = Rd(n), i = ns(o, 1);
  return t && Ra(i, t) > 0 || a && a.every(function(s) {
    return Ra(i, s) > 0;
  }) || !1;
}
function fl(n, r) {
  var e = r === void 0 ? {} : r, t = e.minDate, a = e.includeDates, o = rr(n, 1);
  return t && Fa(t, o) > 0 || a && a.every(function(i) {
    return Fa(i, o) > 0;
  }) || !1;
}
function uk(n, r) {
  var e = r === void 0 ? {} : r, t = e.minDate, a = e.yearItemNumber, o = a === void 0 ? Ur : a, i = xr(rr(n, o)), s = sn(i, o).endPeriod, l = t && te(t);
  return l && l > s || !1;
}
function pl(n, r) {
  var e = r === void 0 ? {} : r, t = e.maxDate, a = e.includeDates, o = Vt(n, 1);
  return t && Fa(o, t) > 0 || a && a.every(function(i) {
    return Fa(o, i) > 0;
  }) || !1;
}
function dk(n, r) {
  var e = r === void 0 ? {} : r, t = e.maxDate, a = e.yearItemNumber, o = a === void 0 ? Ur : a, i = Vt(n, o), s = sn(i, o).startPeriod, l = t && te(t);
  return l && l < s || !1;
}
function uf(n) {
  var r = n.minDate, e = n.includeDates;
  if (e && r) {
    var t = e.filter(function(a) {
      return Or(a, r) >= 0;
    });
    return zc(t);
  } else
    return e ? zc(e) : r;
}
function df(n) {
  var r = n.maxDate, e = n.includeDates;
  if (e && r) {
    var t = e.filter(function(a) {
      return Or(a, r) <= 0;
    });
    return jc(t);
  } else
    return e ? jc(e) : r;
}
function hl(n, r) {
  var e;
  n === void 0 && (n = []), r === void 0 && (r = "react-datepicker__day--highlighted");
  for (var t = /* @__PURE__ */ new Map(), a = 0, o = n.length; a < o; a++) {
    var i = n[a];
    if (Gt(i)) {
      var s = be(i, "MM.dd.yyyy"), l = t.get(s) || [];
      l.includes(r) || (l.push(r), t.set(s, l));
    } else if (typeof i == "object") {
      var c = Object.keys(i), u = (e = c[0]) !== null && e !== void 0 ? e : "", d = i[u];
      if (typeof u == "string" && Array.isArray(d))
        for (var f = 0, p = d.length; f < p; f++) {
          var h = d[f];
          if (h) {
            var s = be(h, "MM.dd.yyyy"), l = t.get(s) || [];
            l.includes(u) || (l.push(u), t.set(s, l));
          }
        }
    }
  }
  return t;
}
function fk(n, r) {
  return n.length !== r.length ? !1 : n.every(function(e, t) {
    return e === r[t];
  });
}
function pk(n, r) {
  n === void 0 && (n = []), r === void 0 && (r = "react-datepicker__day--holidays");
  var e = /* @__PURE__ */ new Map();
  return n.forEach(function(t) {
    var a = t.date, o = t.holidayName;
    if (Gt(a)) {
      var i = be(a, "MM.dd.yyyy"), s = e.get(i) || {
        className: "",
        holidayNames: []
      };
      if (!("className" in s && s.className === r && fk(s.holidayNames, [o]))) {
        s.className = r;
        var l = s.holidayNames;
        s.holidayNames = l ? Rt(Rt([], l, !0), [o], !1) : [o], e.set(i, s);
      }
    }
  }), e;
}
function hk(n, r, e, t, a) {
  for (var o = a.length, i = [], s = 0; s < o; s++) {
    var l = n, c = a[s];
    c && (l = T0(l, Ft(c)), l = vi(l, It(c)), l = S0(l, Kt(c)));
    var u = vi(n, (e + 1) * t);
    dn(l, r) && Fn(l, u) && c != null && i.push(c);
  }
  return i;
}
function ml(n) {
  return n < 10 ? "0".concat(n) : "".concat(n);
}
function sn(n, r) {
  r === void 0 && (r = Ur);
  var e = Math.ceil(te(n) / r) * r, t = e - (r - 1);
  return { startPeriod: t, endPeriod: e };
}
function mk(n) {
  var r = new Date(n.getFullYear(), n.getMonth(), n.getDate()), e = new Date(n.getFullYear(), n.getMonth(), n.getDate(), 24);
  return Math.round((+e - +r) / 36e5);
}
function gl(n) {
  var r = n.getSeconds(), e = n.getMilliseconds();
  return Q(n.getTime() - r * 1e3 - e);
}
function gk(n, r) {
  return gl(n).getTime() === gl(r).getTime();
}
function yl(n) {
  if (!Gt(n))
    throw new Error("Invalid date");
  var r = new Date(n);
  return r.setHours(0, 0, 0, 0), r;
}
function bl(n, r) {
  if (!Gt(n) || !Gt(r))
    throw new Error("Invalid date received");
  var e = yl(n), t = yl(r);
  return Fn(e, t);
}
function ff(n) {
  return n.key === H.Space;
}
var yk = (
  /** @class */
  function(n) {
    Ae(r, n);
    function r(e) {
      var t = n.call(this, e) || this;
      return t.onTimeChange = function(a) {
        var o, i;
        t.setState({ time: a });
        var s = t.props.date, l = s instanceof Date && !isNaN(+s), c = l ? s : /* @__PURE__ */ new Date();
        if (a != null && a.includes(":")) {
          var u = a.split(":"), d = u[0], f = u[1];
          c.setHours(Number(d)), c.setMinutes(Number(f));
        }
        (i = (o = t.props).onChange) === null || i === void 0 || i.call(o, c);
      }, t.renderTimeInput = function() {
        var a = t.state.time, o = t.props, i = o.date, s = o.timeString, l = o.customTimeInput;
        return l ? ku(l, {
          date: i,
          value: a,
          onChange: t.onTimeChange
        }) : P.createElement("input", { type: "time", className: "react-datepicker-time__input", placeholder: "Time", name: "time-input", required: !0, value: a, onChange: function(c) {
          t.onTimeChange(c.target.value || s);
        } });
      }, t.state = {
        time: t.props.timeString
      }, t;
    }
    return r.getDerivedStateFromProps = function(e, t) {
      return e.timeString !== t.time ? {
        time: e.timeString
      } : null;
    }, r.prototype.render = function() {
      return P.createElement(
        "div",
        { className: "react-datepicker__input-time-container" },
        P.createElement("div", { className: "react-datepicker-time__caption" }, this.props.timeInputLabel),
        P.createElement(
          "div",
          { className: "react-datepicker-time__input-container" },
          P.createElement("div", { className: "react-datepicker-time__input" }, this.renderTimeInput())
        )
      );
    }, r;
  }(Me)
), bk = (
  /** @class */
  function(n) {
    Ae(r, n);
    function r() {
      var e = n !== null && n.apply(this, arguments) || this;
      return e.dayEl = Xt(), e.handleClick = function(t) {
        !e.isDisabled() && e.props.onClick && e.props.onClick(t);
      }, e.handleMouseEnter = function(t) {
        !e.isDisabled() && e.props.onMouseEnter && e.props.onMouseEnter(t);
      }, e.handleOnKeyDown = function(t) {
        var a, o, i = t.key;
        i === H.Space && (t.preventDefault(), t.key = H.Enter), (o = (a = e.props).handleOnKeyDown) === null || o === void 0 || o.call(a, t);
      }, e.isSameDay = function(t) {
        return oe(e.props.day, t);
      }, e.isKeyboardSelected = function() {
        var t;
        if (e.props.disabledKeyboardNavigation)
          return !1;
        var a = e.props.selectsMultiple ? (t = e.props.selectedDates) === null || t === void 0 ? void 0 : t.some(function(i) {
          return e.isSameDayOrWeek(i);
        }) : e.isSameDayOrWeek(e.props.selected), o = e.props.preSelection && e.isDisabled(e.props.preSelection);
        return !a && e.isSameDayOrWeek(e.props.preSelection) && !o;
      }, e.isDisabled = function(t) {
        return t === void 0 && (t = e.props.day), on(t, {
          minDate: e.props.minDate,
          maxDate: e.props.maxDate,
          excludeDates: e.props.excludeDates,
          excludeDateIntervals: e.props.excludeDateIntervals,
          includeDateIntervals: e.props.includeDateIntervals,
          includeDates: e.props.includeDates,
          filterDate: e.props.filterDate
        });
      }, e.isExcluded = function() {
        return ms(e.props.day, {
          excludeDates: e.props.excludeDates,
          excludeDateIntervals: e.props.excludeDateIntervals
        });
      }, e.isStartOfWeek = function() {
        return oe(e.props.day, ln(e.props.day, e.props.locale, e.props.calendarStartDay));
      }, e.isSameWeek = function(t) {
        return e.props.showWeekPicker && oe(t, ln(e.props.day, e.props.locale, e.props.calendarStartDay));
      }, e.isSameDayOrWeek = function(t) {
        return e.isSameDay(t) || e.isSameWeek(t);
      }, e.getHighLightedClass = function() {
        var t = e.props, a = t.day, o = t.highlightDates;
        if (!o)
          return !1;
        var i = be(a, "MM.dd.yyyy");
        return o.get(i);
      }, e.getHolidaysClass = function() {
        var t, a = e.props, o = a.day, i = a.holidays;
        if (!i)
          return [void 0];
        var s = be(o, "MM.dd.yyyy");
        return i.has(s) ? [(t = i.get(s)) === null || t === void 0 ? void 0 : t.className] : [void 0];
      }, e.isInRange = function() {
        var t = e.props, a = t.day, o = t.startDate, i = t.endDate;
        return !o || !i ? !1 : Cr(a, o, i);
      }, e.isInSelectingRange = function() {
        var t, a = e.props, o = a.day, i = a.selectsStart, s = a.selectsEnd, l = a.selectsRange, c = a.selectsDisabledDaysInRange, u = a.startDate, d = a.endDate, f = (t = e.props.selectingDate) !== null && t !== void 0 ? t : e.props.preSelection;
        return !(i || s || l) || !f || !c && e.isDisabled() ? !1 : i && d && (Fn(f, d) || kn(f, d)) ? Cr(o, f, d) : s && u && (dn(f, u) || kn(f, u)) || l && u && !d && (dn(f, u) || kn(f, u)) ? Cr(o, u, f) : !1;
      }, e.isSelectingRangeStart = function() {
        var t;
        if (!e.isInSelectingRange())
          return !1;
        var a = e.props, o = a.day, i = a.startDate, s = a.selectsStart, l = (t = e.props.selectingDate) !== null && t !== void 0 ? t : e.props.preSelection;
        return s ? oe(o, l) : oe(o, i);
      }, e.isSelectingRangeEnd = function() {
        var t;
        if (!e.isInSelectingRange())
          return !1;
        var a = e.props, o = a.day, i = a.endDate, s = a.selectsEnd, l = a.selectsRange, c = (t = e.props.selectingDate) !== null && t !== void 0 ? t : e.props.preSelection;
        return s || l ? oe(o, c) : oe(o, i);
      }, e.isRangeStart = function() {
        var t = e.props, a = t.day, o = t.startDate, i = t.endDate;
        return !o || !i ? !1 : oe(o, a);
      }, e.isRangeEnd = function() {
        var t = e.props, a = t.day, o = t.startDate, i = t.endDate;
        return !o || !i ? !1 : oe(i, a);
      }, e.isWeekend = function() {
        var t = kw(e.props.day);
        return t === 0 || t === 6;
      }, e.isAfterMonth = function() {
        return e.props.month !== void 0 && (e.props.month + 1) % 12 === Xe(e.props.day);
      }, e.isBeforeMonth = function() {
        return e.props.month !== void 0 && (Xe(e.props.day) + 1) % 12 === e.props.month;
      }, e.isCurrentDay = function() {
        return e.isSameDay(fe());
      }, e.isSelected = function() {
        var t;
        return e.props.selectsMultiple ? (t = e.props.selectedDates) === null || t === void 0 ? void 0 : t.some(function(a) {
          return e.isSameDayOrWeek(a);
        }) : e.isSameDayOrWeek(e.props.selected);
      }, e.getClassNames = function(t) {
        var a = e.props.dayClassName ? e.props.dayClassName(t) : void 0;
        return Te("react-datepicker__day", a, "react-datepicker__day--" + tk(e.props.day), {
          "react-datepicker__day--disabled": e.isDisabled(),
          "react-datepicker__day--excluded": e.isExcluded(),
          "react-datepicker__day--selected": e.isSelected(),
          "react-datepicker__day--keyboard-selected": e.isKeyboardSelected(),
          "react-datepicker__day--range-start": e.isRangeStart(),
          "react-datepicker__day--range-end": e.isRangeEnd(),
          "react-datepicker__day--in-range": e.isInRange(),
          "react-datepicker__day--in-selecting-range": e.isInSelectingRange(),
          "react-datepicker__day--selecting-range-start": e.isSelectingRangeStart(),
          "react-datepicker__day--selecting-range-end": e.isSelectingRangeEnd(),
          "react-datepicker__day--today": e.isCurrentDay(),
          "react-datepicker__day--weekend": e.isWeekend(),
          "react-datepicker__day--outside-month": e.isAfterMonth() || e.isBeforeMonth()
        }, e.getHighLightedClass(), e.getHolidaysClass());
      }, e.getAriaLabel = function() {
        var t = e.props, a = t.day, o = t.ariaLabelPrefixWhenEnabled, i = o === void 0 ? "Choose" : o, s = t.ariaLabelPrefixWhenDisabled, l = s === void 0 ? "Not available" : s, c = e.isDisabled() || e.isExcluded() ? l : i;
        return "".concat(c, " ").concat(be(a, "PPPP", e.props.locale));
      }, e.getTitle = function() {
        var t = e.props, a = t.day, o = t.holidays, i = o === void 0 ? /* @__PURE__ */ new Map() : o, s = t.excludeDates, l = be(a, "MM.dd.yyyy"), c = [];
        return i.has(l) && c.push.apply(c, i.get(l).holidayNames), e.isExcluded() && c.push(s == null ? void 0 : s.filter(function(u) {
          return u instanceof Date ? oe(u, a) : oe(u == null ? void 0 : u.date, a);
        }).map(function(u) {
          if (!(u instanceof Date))
            return u == null ? void 0 : u.message;
        })), c.join(", ");
      }, e.getTabIndex = function() {
        var t = e.props.selected, a = e.props.preSelection, o = !(e.props.showWeekPicker && (e.props.showWeekNumber || !e.isStartOfWeek())) && (e.isKeyboardSelected() || e.isSameDay(t) && oe(a, t)) ? 0 : -1;
        return o;
      }, e.handleFocusDay = function() {
        var t;
        e.shouldFocusDay() && ((t = e.dayEl.current) === null || t === void 0 || t.focus({ preventScroll: !0 }));
      }, e.renderDayContents = function() {
        return e.props.monthShowsDuplicateDaysEnd && e.isAfterMonth() || e.props.monthShowsDuplicateDaysStart && e.isBeforeMonth() ? null : e.props.renderDayContents ? e.props.renderDayContents(qc(e.props.day), e.props.day) : qc(e.props.day);
      }, e.render = function() {
        return (
          // TODO: Use <option> instead of the "option" role to ensure accessibility across all devices.
          P.createElement(
            "div",
            { ref: e.dayEl, className: e.getClassNames(e.props.day), onKeyDown: e.handleOnKeyDown, onClick: e.handleClick, onMouseEnter: e.props.usePointerEvent ? void 0 : e.handleMouseEnter, onPointerEnter: e.props.usePointerEvent ? e.handleMouseEnter : void 0, tabIndex: e.getTabIndex(), "aria-label": e.getAriaLabel(), role: "option", title: e.getTitle(), "aria-disabled": e.isDisabled(), "aria-current": e.isCurrentDay() ? "date" : void 0, "aria-selected": e.isSelected() || e.isInRange() },
            e.renderDayContents(),
            e.getTitle() !== "" && P.createElement("span", { className: "overlay" }, e.getTitle())
          )
        );
      }, e;
    }
    return r.prototype.componentDidMount = function() {
      this.handleFocusDay();
    }, r.prototype.componentDidUpdate = function() {
      this.handleFocusDay();
    }, r.prototype.shouldFocusDay = function() {
      var e = !1;
      return this.getTabIndex() === 0 && this.isSameDay(this.props.preSelection) && ((!document.activeElement || document.activeElement === document.body) && (e = !0), this.props.inline && !this.props.shouldFocusDayInline && (e = !1), this.isDayActiveElement() && (e = !0), this.isDuplicateDay() && (e = !1)), e;
    }, r.prototype.isDayActiveElement = function() {
      var e, t, a;
      return ((t = (e = this.props.containerRef) === null || e === void 0 ? void 0 : e.current) === null || t === void 0 ? void 0 : t.contains(document.activeElement)) && ((a = document.activeElement) === null || a === void 0 ? void 0 : a.classList.contains("react-datepicker__day"));
    }, r.prototype.isDuplicateDay = function() {
      return (
        //day is one of the non rendered duplicate days
        this.props.monthShowsDuplicateDaysEnd && this.isAfterMonth() || this.props.monthShowsDuplicateDaysStart && this.isBeforeMonth()
      );
    }, r;
  }(Me)
), vk = (
  /** @class */
  function(n) {
    Ae(r, n);
    function r() {
      var e = n !== null && n.apply(this, arguments) || this;
      return e.weekNumberEl = Xt(), e.handleClick = function(t) {
        e.props.onClick && e.props.onClick(t);
      }, e.handleOnKeyDown = function(t) {
        var a, o, i = t.key;
        i === H.Space && (t.preventDefault(), t.key = H.Enter), (o = (a = e.props).handleOnKeyDown) === null || o === void 0 || o.call(a, t);
      }, e.isKeyboardSelected = function() {
        return !e.props.disabledKeyboardNavigation && !oe(e.props.date, e.props.selected) && oe(e.props.date, e.props.preSelection);
      }, e.getTabIndex = function() {
        return e.props.showWeekPicker && e.props.showWeekNumber && (e.isKeyboardSelected() || oe(e.props.date, e.props.selected) && oe(e.props.preSelection, e.props.selected)) ? 0 : -1;
      }, e.handleFocusWeekNumber = function(t) {
        var a = !1;
        e.getTabIndex() === 0 && !(t != null && t.isInputFocused) && oe(e.props.date, e.props.preSelection) && ((!document.activeElement || document.activeElement === document.body) && (a = !0), e.props.inline && !e.props.shouldFocusDayInline && (a = !1), e.props.containerRef && e.props.containerRef.current && e.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number") && (a = !0)), a && e.weekNumberEl.current && e.weekNumberEl.current.focus({ preventScroll: !0 });
      }, e;
    }
    return Object.defineProperty(r, "defaultProps", {
      get: function() {
        return {
          ariaLabelPrefix: "week "
        };
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.componentDidMount = function() {
      this.handleFocusWeekNumber();
    }, r.prototype.componentDidUpdate = function(e) {
      this.handleFocusWeekNumber(e);
    }, r.prototype.render = function() {
      var e = this.props, t = e.weekNumber, a = e.ariaLabelPrefix, o = a === void 0 ? r.defaultProps.ariaLabelPrefix : a, i = e.onClick, s = {
        "react-datepicker__week-number": !0,
        "react-datepicker__week-number--clickable": !!i,
        "react-datepicker__week-number--selected": !!i && oe(this.props.date, this.props.selected),
        "react-datepicker__week-number--keyboard-selected": this.isKeyboardSelected()
      };
      return P.createElement("div", { ref: this.weekNumberEl, className: Te(s), "aria-label": "".concat(o, " ").concat(this.props.weekNumber), onClick: this.handleClick, onKeyDown: this.handleOnKeyDown, tabIndex: this.getTabIndex() }, t);
    }, r;
  }(Me)
), wk = (
  /** @class */
  function(n) {
    Ae(r, n);
    function r() {
      var e = n !== null && n.apply(this, arguments) || this;
      return e.isDisabled = function(t) {
        return on(t, {
          minDate: e.props.minDate,
          maxDate: e.props.maxDate,
          excludeDates: e.props.excludeDates,
          excludeDateIntervals: e.props.excludeDateIntervals,
          includeDateIntervals: e.props.includeDateIntervals,
          includeDates: e.props.includeDates,
          filterDate: e.props.filterDate
        });
      }, e.handleDayClick = function(t, a) {
        e.props.onDayClick && e.props.onDayClick(t, a);
      }, e.handleDayMouseEnter = function(t) {
        e.props.onDayMouseEnter && e.props.onDayMouseEnter(t);
      }, e.handleWeekClick = function(t, a, o) {
        for (var i, s, l, c = new Date(t), u = 0; u < 7; u++) {
          var d = new Date(t);
          d.setDate(d.getDate() + u);
          var f = !e.isDisabled(d);
          if (f) {
            c = d;
            break;
          }
        }
        typeof e.props.onWeekSelect == "function" && e.props.onWeekSelect(c, a, o), e.props.showWeekPicker && e.handleDayClick(c, o), ((i = e.props.shouldCloseOnSelect) !== null && i !== void 0 ? i : r.defaultProps.shouldCloseOnSelect) && ((l = (s = e.props).setOpen) === null || l === void 0 || l.call(s, !1));
      }, e.formatWeekNumber = function(t) {
        return e.props.formatWeekNumber ? e.props.formatWeekNumber(t) : ek(t);
      }, e.renderDays = function() {
        var t = e.startOfWeek(), a = [], o = e.formatWeekNumber(t);
        if (e.props.showWeekNumber) {
          var i = e.props.onWeekSelect || e.props.showWeekPicker ? e.handleWeekClick.bind(e, t, o) : void 0;
          a.push(P.createElement(vk, ie({ key: "W" }, r.defaultProps, e.props, { weekNumber: o, date: t, onClick: i })));
        }
        return a.concat([0, 1, 2, 3, 4, 5, 6].map(function(s) {
          var l = gn(t, s);
          return P.createElement(bk, ie({}, r.defaultProps, e.props, { ariaLabelPrefixWhenEnabled: e.props.chooseDayAriaLabelPrefix, ariaLabelPrefixWhenDisabled: e.props.disabledDayAriaLabelPrefix, key: l.valueOf(), day: l, onClick: e.handleDayClick.bind(e, l), onMouseEnter: e.handleDayMouseEnter.bind(e, l) }));
        }));
      }, e.startOfWeek = function() {
        return ln(e.props.day, e.props.locale, e.props.calendarStartDay);
      }, e.isKeyboardSelected = function() {
        return !e.props.disabledKeyboardNavigation && !oe(e.startOfWeek(), e.props.selected) && oe(e.startOfWeek(), e.props.preSelection);
      }, e;
    }
    return Object.defineProperty(r, "defaultProps", {
      get: function() {
        return {
          shouldCloseOnSelect: !0
        };
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.render = function() {
      var e = {
        "react-datepicker__week": !0,
        "react-datepicker__week--selected": oe(this.startOfWeek(), this.props.selected),
        "react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
      };
      return P.createElement("div", { className: Te(e) }, this.renderDays());
    }, r;
  }(Me)
), Dr, _k = 6, Xn = {
  TWO_COLUMNS: "two_columns",
  THREE_COLUMNS: "three_columns",
  FOUR_COLUMNS: "four_columns"
}, Jo = (Dr = {}, Dr[Xn.TWO_COLUMNS] = {
  grid: [
    [0, 1],
    [2, 3],
    [4, 5],
    [6, 7],
    [8, 9],
    [10, 11]
  ],
  verticalNavigationOffset: 2
}, Dr[Xn.THREE_COLUMNS] = {
  grid: [
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    [9, 10, 11]
  ],
  verticalNavigationOffset: 3
}, Dr[Xn.FOUR_COLUMNS] = {
  grid: [
    [0, 1, 2, 3],
    [4, 5, 6, 7],
    [8, 9, 10, 11]
  ],
  verticalNavigationOffset: 4
}, Dr), la = 1;
function vl(n, r) {
  return n ? Xn.FOUR_COLUMNS : r ? Xn.TWO_COLUMNS : Xn.THREE_COLUMNS;
}
var Dk = (
  /** @class */
  function(n) {
    Ae(r, n);
    function r() {
      var e = n !== null && n.apply(this, arguments) || this;
      return e.MONTH_REFS = Rt([], Array(12), !0).map(function() {
        return Xt();
      }), e.QUARTER_REFS = Rt([], Array(4), !0).map(function() {
        return Xt();
      }), e.isDisabled = function(t) {
        return on(t, {
          minDate: e.props.minDate,
          maxDate: e.props.maxDate,
          excludeDates: e.props.excludeDates,
          excludeDateIntervals: e.props.excludeDateIntervals,
          includeDateIntervals: e.props.includeDateIntervals,
          includeDates: e.props.includeDates,
          filterDate: e.props.filterDate
        });
      }, e.isExcluded = function(t) {
        return ms(t, {
          excludeDates: e.props.excludeDates,
          excludeDateIntervals: e.props.excludeDateIntervals
        });
      }, e.handleDayClick = function(t, a) {
        var o, i;
        (i = (o = e.props).onDayClick) === null || i === void 0 || i.call(o, t, a, e.props.orderInDisplay);
      }, e.handleDayMouseEnter = function(t) {
        var a, o;
        (o = (a = e.props).onDayMouseEnter) === null || o === void 0 || o.call(a, t);
      }, e.handleMouseLeave = function() {
        var t, a;
        (a = (t = e.props).onMouseLeave) === null || a === void 0 || a.call(t);
      }, e.isRangeStartMonth = function(t) {
        var a = e.props, o = a.day, i = a.startDate, s = a.endDate;
        return !i || !s ? !1 : Ke(at(o, t), i);
      }, e.isRangeStartQuarter = function(t) {
        var a = e.props, o = a.day, i = a.startDate, s = a.endDate;
        return !i || !s ? !1 : Ua(Vn(o, t), i);
      }, e.isRangeEndMonth = function(t) {
        var a = e.props, o = a.day, i = a.startDate, s = a.endDate;
        return !i || !s ? !1 : Ke(at(o, t), s);
      }, e.isRangeEndQuarter = function(t) {
        var a = e.props, o = a.day, i = a.startDate, s = a.endDate;
        return !i || !s ? !1 : Ua(Vn(o, t), s);
      }, e.isInSelectingRangeMonth = function(t) {
        var a, o = e.props, i = o.day, s = o.selectsStart, l = o.selectsEnd, c = o.selectsRange, u = o.startDate, d = o.endDate, f = (a = e.props.selectingDate) !== null && a !== void 0 ? a : e.props.preSelection;
        return !(s || l || c) || !f ? !1 : s && d ? ia(f, d, t, i) : l && u || c && u && !d ? ia(u, f, t, i) : !1;
      }, e.isSelectingMonthRangeStart = function(t) {
        var a;
        if (!e.isInSelectingRangeMonth(t))
          return !1;
        var o = e.props, i = o.day, s = o.startDate, l = o.selectsStart, c = at(i, t), u = (a = e.props.selectingDate) !== null && a !== void 0 ? a : e.props.preSelection;
        return l ? Ke(c, u) : Ke(c, s);
      }, e.isSelectingMonthRangeEnd = function(t) {
        var a;
        if (!e.isInSelectingRangeMonth(t))
          return !1;
        var o = e.props, i = o.day, s = o.endDate, l = o.selectsEnd, c = o.selectsRange, u = at(i, t), d = (a = e.props.selectingDate) !== null && a !== void 0 ? a : e.props.preSelection;
        return l || c ? Ke(u, d) : Ke(u, s);
      }, e.isInSelectingRangeQuarter = function(t) {
        var a, o = e.props, i = o.day, s = o.selectsStart, l = o.selectsEnd, c = o.selectsRange, u = o.startDate, d = o.endDate, f = (a = e.props.selectingDate) !== null && a !== void 0 ? a : e.props.preSelection;
        return !(s || l || c) || !f ? !1 : s && d ? ca(f, d, t, i) : l && u || c && u && !d ? ca(u, f, t, i) : !1;
      }, e.isWeekInMonth = function(t) {
        var a = e.props.day, o = gn(t, 6);
        return Ke(t, a) || Ke(o, a);
      }, e.isCurrentMonth = function(t, a) {
        return te(t) === te(fe()) && a === Xe(fe());
      }, e.isCurrentQuarter = function(t, a) {
        return te(t) === te(fe()) && a === Tn(fe());
      }, e.isSelectedMonth = function(t, a, o) {
        return Xe(o) === a && te(t) === te(o);
      }, e.isSelectMonthInList = function(t, a, o) {
        return o.some(function(i) {
          return e.isSelectedMonth(t, a, i);
        });
      }, e.isSelectedQuarter = function(t, a, o) {
        return Tn(t) === a && te(t) === te(o);
      }, e.renderWeeks = function() {
        for (var t = [], a = e.props.fixedHeight, o = 0, i = !1, s = ln(un(e.props.day), e.props.locale, e.props.calendarStartDay), l = function(h) {
          return e.props.showWeekPicker ? ln(h, e.props.locale, e.props.calendarStartDay) : e.props.preSelection;
        }, c = function(h) {
          return e.props.showWeekPicker ? ln(h, e.props.locale, e.props.calendarStartDay) : e.props.selected;
        }, u = e.props.selected ? c(e.props.selected) : void 0, d = e.props.preSelection ? l(e.props.preSelection) : void 0; t.push(P.createElement(wk, ie({}, e.props, { ariaLabelPrefix: e.props.weekAriaLabelPrefix, key: o, day: s, month: Xe(e.props.day), onDayClick: e.handleDayClick, onDayMouseEnter: e.handleDayMouseEnter, selected: u, preSelection: d, showWeekNumber: e.props.showWeekNumbers }))), !i; ) {
          o++, s = Aa(s, 1);
          var f = a && o >= _k, p = !a && !e.isWeekInMonth(s);
          if (f || p)
            if (e.props.peekNextMonth)
              i = !0;
            else
              break;
        }
        return t;
      }, e.onMonthClick = function(t, a) {
        var o = e.isMonthDisabledForLabelDate(a), i = o.isDisabled, s = o.labelDate;
        i || e.handleDayClick(un(s), t);
      }, e.onMonthMouseEnter = function(t) {
        var a = e.isMonthDisabledForLabelDate(t), o = a.isDisabled, i = a.labelDate;
        o || e.handleDayMouseEnter(un(i));
      }, e.handleMonthNavigation = function(t, a) {
        var o, i, s, l;
        (i = (o = e.props).setPreSelection) === null || i === void 0 || i.call(o, a), (l = (s = e.MONTH_REFS[t]) === null || s === void 0 ? void 0 : s.current) === null || l === void 0 || l.focus();
      }, e.handleKeyboardNavigation = function(t, a, o) {
        var i, s = e.props, l = s.selected, c = s.preSelection, u = s.setPreSelection, d = s.minDate, f = s.maxDate, p = s.showFourColumnMonthYearPicker, h = s.showTwoColumnMonthYearPicker;
        if (c) {
          var m = vl(p, h), g = e.getVerticalOffset(m), b = (i = Jo[m]) === null || i === void 0 ? void 0 : i.grid, v = function(I, L, A) {
            var W, O, U = L, $ = A;
            switch (I) {
              case H.ArrowRight:
                U = Ct(L, la), $ = A === 11 ? 0 : A + la;
                break;
              case H.ArrowLeft:
                U = nr(L, la), $ = A === 0 ? 11 : A - la;
                break;
              case H.ArrowUp:
                U = nr(L, g), $ = !((W = b == null ? void 0 : b[0]) === null || W === void 0) && W.includes(A) ? A + 12 - g : A - g;
                break;
              case H.ArrowDown:
                U = Ct(L, g), $ = !((O = b == null ? void 0 : b[b.length - 1]) === null || O === void 0) && O.includes(A) ? A - 12 + g : A + g;
                break;
            }
            return { newCalculatedDate: U, newCalculatedMonth: $ };
          }, D = function(I, L, A) {
            for (var W = 40, O = I, U = !1, $ = 0, N = v(O, L, A), T = N.newCalculatedDate, M = N.newCalculatedMonth; !U; ) {
              if ($ >= W) {
                T = L, M = A;
                break;
              }
              if (d && T < d) {
                O = H.ArrowRight;
                var C = v(O, T, M);
                T = C.newCalculatedDate, M = C.newCalculatedMonth;
              }
              if (f && T > f) {
                O = H.ArrowLeft;
                var C = v(O, T, M);
                T = C.newCalculatedDate, M = C.newCalculatedMonth;
              }
              if (sk(T, e.props)) {
                var C = v(O, T, M);
                T = C.newCalculatedDate, M = C.newCalculatedMonth;
              } else
                U = !0;
              $++;
            }
            return { newCalculatedDate: T, newCalculatedMonth: M };
          };
          if (a === H.Enter) {
            e.isMonthDisabled(o) || (e.onMonthClick(t, o), u == null || u(l));
            return;
          }
          var k = D(a, c, o), x = k.newCalculatedDate, R = k.newCalculatedMonth;
          switch (a) {
            case H.ArrowRight:
            case H.ArrowLeft:
            case H.ArrowUp:
            case H.ArrowDown:
              e.handleMonthNavigation(R, x);
              break;
          }
        }
      }, e.getVerticalOffset = function(t) {
        var a, o;
        return (o = (a = Jo[t]) === null || a === void 0 ? void 0 : a.verticalNavigationOffset) !== null && o !== void 0 ? o : 0;
      }, e.onMonthKeyDown = function(t, a) {
        var o = e.props, i = o.disabledKeyboardNavigation, s = o.handleOnMonthKeyDown, l = t.key;
        l !== H.Tab && t.preventDefault(), i || e.handleKeyboardNavigation(t, l, a), s && s(t);
      }, e.onQuarterClick = function(t, a) {
        var o = Vn(e.props.day, a);
        Xo(o, e.props) || e.handleDayClick(al(o), t);
      }, e.onQuarterMouseEnter = function(t) {
        var a = Vn(e.props.day, t);
        Xo(a, e.props) || e.handleDayMouseEnter(al(a));
      }, e.handleQuarterNavigation = function(t, a) {
        var o, i, s, l;
        e.isDisabled(a) || e.isExcluded(a) || ((i = (o = e.props).setPreSelection) === null || i === void 0 || i.call(o, a), (l = (s = e.QUARTER_REFS[t - 1]) === null || s === void 0 ? void 0 : s.current) === null || l === void 0 || l.focus());
      }, e.onQuarterKeyDown = function(t, a) {
        var o, i, s = t.key;
        if (!e.props.disabledKeyboardNavigation)
          switch (s) {
            case H.Enter:
              e.onQuarterClick(t, a), (i = (o = e.props).setPreSelection) === null || i === void 0 || i.call(o, e.props.selected);
              break;
            case H.ArrowRight:
              if (!e.props.preSelection)
                break;
              e.handleQuarterNavigation(a === 4 ? 1 : a + 1, ns(e.props.preSelection, 1));
              break;
            case H.ArrowLeft:
              if (!e.props.preSelection)
                break;
              e.handleQuarterNavigation(a === 1 ? 4 : a - 1, zd(e.props.preSelection, 1));
              break;
          }
      }, e.isMonthDisabledForLabelDate = function(t) {
        var a, o = e.props, i = o.day, s = o.minDate, l = o.maxDate, c = o.excludeDates, u = o.includeDates, d = at(i, t);
        return {
          isDisabled: (a = (s || l || c || u) && lf(d, e.props)) !== null && a !== void 0 ? a : !1,
          labelDate: d
        };
      }, e.isMonthDisabled = function(t) {
        var a = e.isMonthDisabledForLabelDate(t).isDisabled;
        return a;
      }, e.getMonthClassNames = function(t) {
        var a = e.props, o = a.day, i = a.startDate, s = a.endDate, l = a.preSelection, c = a.monthClassName, u = c ? c(at(o, t)) : void 0, d = e.getSelection();
        return Te("react-datepicker__month-text", "react-datepicker__month-".concat(t), u, {
          "react-datepicker__month-text--disabled": e.isMonthDisabled(t),
          "react-datepicker__month-text--selected": d ? e.isSelectMonthInList(o, t, d) : void 0,
          "react-datepicker__month-text--keyboard-selected": !e.props.disabledKeyboardNavigation && l && e.isSelectedMonth(o, t, l) && !e.isMonthDisabled(t),
          "react-datepicker__month-text--in-selecting-range": e.isInSelectingRangeMonth(t),
          "react-datepicker__month-text--in-range": i && s ? ia(i, s, t, o) : void 0,
          "react-datepicker__month-text--range-start": e.isRangeStartMonth(t),
          "react-datepicker__month-text--range-end": e.isRangeEndMonth(t),
          "react-datepicker__month-text--selecting-range-start": e.isSelectingMonthRangeStart(t),
          "react-datepicker__month-text--selecting-range-end": e.isSelectingMonthRangeEnd(t),
          "react-datepicker__month-text--today": e.isCurrentMonth(o, t)
        });
      }, e.getTabIndex = function(t) {
        if (e.props.preSelection == null)
          return "-1";
        var a = Xe(e.props.preSelection), o = !e.props.disabledKeyboardNavigation && t === a ? "0" : "-1";
        return o;
      }, e.getQuarterTabIndex = function(t) {
        if (e.props.preSelection == null)
          return "-1";
        var a = Tn(e.props.preSelection), o = !e.props.disabledKeyboardNavigation && t === a ? "0" : "-1";
        return o;
      }, e.getAriaLabel = function(t) {
        var a = e.props, o = a.chooseDayAriaLabelPrefix, i = o === void 0 ? "Choose" : o, s = a.disabledDayAriaLabelPrefix, l = s === void 0 ? "Not available" : s, c = a.day, u = a.locale, d = at(c, t), f = e.isDisabled(d) || e.isExcluded(d) ? l : i;
        return "".concat(f, " ").concat(be(d, "MMMM yyyy", u));
      }, e.getQuarterClassNames = function(t) {
        var a = e.props, o = a.day, i = a.startDate, s = a.endDate, l = a.selected, c = a.minDate, u = a.maxDate, d = a.excludeDates, f = a.includeDates, p = a.filterDate, h = a.preSelection, m = a.disabledKeyboardNavigation, g = (c || u || d || f || p) && Xo(Vn(o, t), e.props);
        return Te("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(t), {
          "react-datepicker__quarter-text--disabled": g,
          "react-datepicker__quarter-text--selected": l ? e.isSelectedQuarter(o, t, l) : void 0,
          "react-datepicker__quarter-text--keyboard-selected": !m && h && e.isSelectedQuarter(o, t, h) && !g,
          "react-datepicker__quarter-text--in-selecting-range": e.isInSelectingRangeQuarter(t),
          "react-datepicker__quarter-text--in-range": i && s ? ca(i, s, t, o) : void 0,
          "react-datepicker__quarter-text--range-start": e.isRangeStartQuarter(t),
          "react-datepicker__quarter-text--range-end": e.isRangeEndQuarter(t)
        });
      }, e.getMonthContent = function(t) {
        var a = e.props, o = a.showFullMonthYearPicker, i = a.renderMonthContent, s = a.locale, l = a.day, c = cf(t, s), u = hs(t, s);
        return i ? i(t, c, u, l) : o ? u : c;
      }, e.getQuarterContent = function(t) {
        var a, o = e.props, i = o.renderQuarterContent, s = o.locale, l = ik(t, s);
        return (a = i == null ? void 0 : i(t, l)) !== null && a !== void 0 ? a : l;
      }, e.renderMonths = function() {
        var t, a = e.props, o = a.showTwoColumnMonthYearPicker, i = a.showFourColumnMonthYearPicker, s = a.day, l = a.selected, c = (t = Jo[vl(i, o)]) === null || t === void 0 ? void 0 : t.grid;
        return c == null ? void 0 : c.map(function(u, d) {
          return P.createElement("div", { className: "react-datepicker__month-wrapper", key: d }, u.map(function(f, p) {
            return P.createElement("div", { ref: e.MONTH_REFS[f], key: p, onClick: function(h) {
              e.onMonthClick(h, f);
            }, onKeyDown: function(h) {
              ff(h) && (h.preventDefault(), h.key = H.Enter), e.onMonthKeyDown(h, f);
            }, onMouseEnter: e.props.usePointerEvent ? void 0 : function() {
              return e.onMonthMouseEnter(f);
            }, onPointerEnter: e.props.usePointerEvent ? function() {
              return e.onMonthMouseEnter(f);
            } : void 0, tabIndex: Number(e.getTabIndex(f)), className: e.getMonthClassNames(f), "aria-disabled": e.isMonthDisabled(f), role: "option", "aria-label": e.getAriaLabel(f), "aria-current": e.isCurrentMonth(s, f) ? "date" : void 0, "aria-selected": l ? e.isSelectedMonth(s, f, l) : void 0 }, e.getMonthContent(f));
          }));
        });
      }, e.renderQuarters = function() {
        var t = e.props, a = t.day, o = t.selected, i = [1, 2, 3, 4];
        return P.createElement("div", { className: "react-datepicker__quarter-wrapper" }, i.map(function(s, l) {
          return P.createElement("div", { key: l, ref: e.QUARTER_REFS[l], role: "option", onClick: function(c) {
            e.onQuarterClick(c, s);
          }, onKeyDown: function(c) {
            e.onQuarterKeyDown(c, s);
          }, onMouseEnter: e.props.usePointerEvent ? void 0 : function() {
            return e.onQuarterMouseEnter(s);
          }, onPointerEnter: e.props.usePointerEvent ? function() {
            return e.onQuarterMouseEnter(s);
          } : void 0, className: e.getQuarterClassNames(s), "aria-selected": o ? e.isSelectedQuarter(a, s, o) : void 0, tabIndex: Number(e.getQuarterTabIndex(s)), "aria-current": e.isCurrentQuarter(a, s) ? "date" : void 0 }, e.getQuarterContent(s));
        }));
      }, e.getClassNames = function() {
        var t = e.props, a = t.selectingDate, o = t.selectsStart, i = t.selectsEnd, s = t.showMonthYearPicker, l = t.showQuarterYearPicker, c = t.showWeekPicker;
        return Te("react-datepicker__month", {
          "react-datepicker__month--selecting-range": a && (o || i)
        }, { "react-datepicker__monthPicker": s }, { "react-datepicker__quarterPicker": l }, { "react-datepicker__weekPicker": c });
      }, e;
    }
    return r.prototype.getSelection = function() {
      var e = this.props, t = e.selected, a = e.selectedDates, o = e.selectsMultiple;
      if (o)
        return a;
      if (t)
        return [t];
    }, r.prototype.render = function() {
      var e = this.props, t = e.showMonthYearPicker, a = e.showQuarterYearPicker, o = e.day, i = e.ariaLabelPrefix, s = i === void 0 ? "Month " : i, l = s ? s.trim() + " " : "";
      return P.createElement("div", { className: this.getClassNames(), onMouseLeave: this.props.usePointerEvent ? void 0 : this.handleMouseLeave, onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : void 0, "aria-label": "".concat(l).concat(be(o, "MMMM, yyyy", this.props.locale)), role: "listbox" }, t ? this.renderMonths() : a ? this.renderQuarters() : this.renderWeeks());
    }, r;
  }(Me)
), kk = (
  /** @class */
  function(n) {
    Ae(r, n);
    function r() {
      var e = n !== null && n.apply(this, arguments) || this;
      return e.isSelectedMonth = function(t) {
        return e.props.month === t;
      }, e.renderOptions = function() {
        return e.props.monthNames.map(function(t, a) {
          return P.createElement(
            "div",
            { className: e.isSelectedMonth(a) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option", key: t, onClick: e.onChange.bind(e, a), "aria-selected": e.isSelectedMonth(a) ? "true" : void 0 },
            e.isSelectedMonth(a) ? P.createElement("span", { className: "react-datepicker__month-option--selected" }, "✓") : "",
            t
          );
        });
      }, e.onChange = function(t) {
        return e.props.onChange(t);
      }, e.handleClickOutside = function() {
        return e.props.onCancel();
      }, e;
    }
    return r.prototype.render = function() {
      return P.createElement("div", { className: "react-datepicker__month-dropdown" }, this.renderOptions());
    }, r;
  }(Me)
), xk = lo(kk), Ck = (
  /** @class */
  function(n) {
    Ae(r, n);
    function r() {
      var e = n !== null && n.apply(this, arguments) || this;
      return e.state = {
        dropdownVisible: !1
      }, e.renderSelectOptions = function(t) {
        return t.map(function(a, o) {
          return P.createElement("option", { key: a, value: o }, a);
        });
      }, e.renderSelectMode = function(t) {
        return P.createElement("select", { value: e.props.month, className: "react-datepicker__month-select", onChange: function(a) {
          return e.onChange(parseInt(a.target.value));
        } }, e.renderSelectOptions(t));
      }, e.renderReadView = function(t, a) {
        return P.createElement(
          "div",
          { key: "read", style: { visibility: t ? "visible" : "hidden" }, className: "react-datepicker__month-read-view", onClick: e.toggleDropdown },
          P.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }),
          P.createElement("span", { className: "react-datepicker__month-read-view--selected-month" }, a[e.props.month])
        );
      }, e.renderDropdown = function(t) {
        return P.createElement(xk, ie({ key: "dropdown" }, e.props, { monthNames: t, onChange: e.onChange, onCancel: e.toggleDropdown }));
      }, e.renderScrollMode = function(t) {
        var a = e.state.dropdownVisible, o = [e.renderReadView(!a, t)];
        return a && o.unshift(e.renderDropdown(t)), o;
      }, e.onChange = function(t) {
        e.toggleDropdown(), t !== e.props.month && e.props.onChange(t);
      }, e.toggleDropdown = function() {
        return e.setState({
          dropdownVisible: !e.state.dropdownVisible
        });
      }, e;
    }
    return r.prototype.render = function() {
      var e = this, t = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function(o) {
        return cf(o, e.props.locale);
      } : function(o) {
        return hs(o, e.props.locale);
      }), a;
      switch (this.props.dropdownMode) {
        case "scroll":
          a = this.renderScrollMode(t);
          break;
        case "select":
          a = this.renderSelectMode(t);
          break;
      }
      return P.createElement("div", { className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode) }, a);
    }, r;
  }(Me)
);
function Tk(n, r) {
  for (var e = [], t = un(n), a = un(r); !dn(t, a); )
    e.push(fe(t)), t = Ct(t, 1);
  return e;
}
var Sk = (
  /** @class */
  function(n) {
    Ae(r, n);
    function r(e) {
      var t = n.call(this, e) || this;
      return t.renderOptions = function() {
        return t.state.monthYearsList.map(function(a) {
          var o = _i(a), i = At(t.props.date, a) && Ke(t.props.date, a);
          return P.createElement(
            "div",
            { className: i ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option", key: o, onClick: t.onChange.bind(t, o), "aria-selected": i ? "true" : void 0 },
            i ? P.createElement("span", { className: "react-datepicker__month-year-option--selected" }, "✓") : "",
            be(a, t.props.dateFormat, t.props.locale)
          );
        });
      }, t.onChange = function(a) {
        return t.props.onChange(a);
      }, t.handleClickOutside = function() {
        t.props.onCancel();
      }, t.state = {
        monthYearsList: Tk(t.props.minDate, t.props.maxDate)
      }, t;
    }
    return r.prototype.render = function() {
      var e = Te({
        "react-datepicker__month-year-dropdown": !0,
        "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
      });
      return P.createElement("div", { className: e }, this.renderOptions());
    }, r;
  }(Me)
), Ek = lo(Sk), Mk = (
  /** @class */
  function(n) {
    Ae(r, n);
    function r() {
      var e = n !== null && n.apply(this, arguments) || this;
      return e.state = {
        dropdownVisible: !1
      }, e.renderSelectOptions = function() {
        for (var t = un(e.props.minDate), a = un(e.props.maxDate), o = []; !dn(t, a); ) {
          var i = _i(t);
          o.push(P.createElement("option", { key: i, value: i }, be(t, e.props.dateFormat, e.props.locale))), t = Ct(t, 1);
        }
        return o;
      }, e.onSelectChange = function(t) {
        e.onChange(parseInt(t.target.value));
      }, e.renderSelectMode = function() {
        return P.createElement("select", { value: _i(un(e.props.date)), className: "react-datepicker__month-year-select", onChange: e.onSelectChange }, e.renderSelectOptions());
      }, e.renderReadView = function(t) {
        var a = be(e.props.date, e.props.dateFormat, e.props.locale);
        return P.createElement(
          "div",
          { key: "read", style: { visibility: t ? "visible" : "hidden" }, className: "react-datepicker__month-year-read-view", onClick: e.toggleDropdown },
          P.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }),
          P.createElement("span", { className: "react-datepicker__month-year-read-view--selected-month-year" }, a)
        );
      }, e.renderDropdown = function() {
        return P.createElement(Ek, ie({ key: "dropdown" }, e.props, { onChange: e.onChange, onCancel: e.toggleDropdown }));
      }, e.renderScrollMode = function() {
        var t = e.state.dropdownVisible, a = [e.renderReadView(!t)];
        return t && a.unshift(e.renderDropdown()), a;
      }, e.onChange = function(t) {
        e.toggleDropdown();
        var a = fe(t);
        At(e.props.date, a) && Ke(e.props.date, a) || e.props.onChange(a);
      }, e.toggleDropdown = function() {
        return e.setState({
          dropdownVisible: !e.state.dropdownVisible
        });
      }, e;
    }
    return r.prototype.render = function() {
      var e;
      switch (this.props.dropdownMode) {
        case "scroll":
          e = this.renderScrollMode();
          break;
        case "select":
          e = this.renderSelectMode();
          break;
      }
      return P.createElement("div", { className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode) }, e);
    }, r;
  }(Me)
), Pk = (
  /** @class */
  function(n) {
    Ae(r, n);
    function r() {
      var e = n !== null && n.apply(this, arguments) || this;
      return e.state = {
        height: null
      }, e.scrollToTheSelectedTime = function() {
        requestAnimationFrame(function() {
          var t, a, o;
          e.list && (e.list.scrollTop = (o = e.centerLi && r.calcCenterPosition(e.props.monthRef ? e.props.monthRef.clientHeight - ((a = (t = e.header) === null || t === void 0 ? void 0 : t.clientHeight) !== null && a !== void 0 ? a : 0) : e.list.clientHeight, e.centerLi)) !== null && o !== void 0 ? o : 0);
        });
      }, e.handleClick = function(t) {
        var a, o;
        (e.props.minTime || e.props.maxTime) && ll(t, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && cl(t, e.props) || (o = (a = e.props).onChange) === null || o === void 0 || o.call(a, t);
      }, e.isSelectedTime = function(t) {
        return e.props.selected && gk(e.props.selected, t);
      }, e.isDisabledTime = function(t) {
        return (e.props.minTime || e.props.maxTime) && ll(t, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && cl(t, e.props);
      }, e.liClasses = function(t) {
        var a, o = [
          "react-datepicker__time-list-item",
          e.props.timeClassName ? e.props.timeClassName(t) : void 0
        ];
        return e.isSelectedTime(t) && o.push("react-datepicker__time-list-item--selected"), e.isDisabledTime(t) && o.push("react-datepicker__time-list-item--disabled"), e.props.injectTimes && (Ft(t) * 3600 + It(t) * 60 + Kt(t)) % (((a = e.props.intervals) !== null && a !== void 0 ? a : r.defaultProps.intervals) * 60) !== 0 && o.push("react-datepicker__time-list-item--injected"), o.join(" ");
      }, e.handleOnKeyDown = function(t, a) {
        var o, i;
        t.key === H.Space && (t.preventDefault(), t.key = H.Enter), (t.key === H.ArrowUp || t.key === H.ArrowLeft) && t.target instanceof HTMLElement && t.target.previousSibling && (t.preventDefault(), t.target.previousSibling instanceof HTMLElement && t.target.previousSibling.focus()), (t.key === H.ArrowDown || t.key === H.ArrowRight) && t.target instanceof HTMLElement && t.target.nextSibling && (t.preventDefault(), t.target.nextSibling instanceof HTMLElement && t.target.nextSibling.focus()), t.key === H.Enter && e.handleClick(a), (i = (o = e.props).handleOnKeyDown) === null || i === void 0 || i.call(o, t);
      }, e.renderTimes = function() {
        for (var t, a = [], o = e.props.format ? e.props.format : "p", i = (t = e.props.intervals) !== null && t !== void 0 ? t : r.defaultProps.intervals, s = e.props.selected || e.props.openToDate || fe(), l = va(s), c = e.props.injectTimes && e.props.injectTimes.sort(function(g, b) {
          return g.getTime() - b.getTime();
        }), u = 60 * mk(s), d = u / i, f = 0; f < d; f++) {
          var p = vi(l, f * i);
          if (a.push(p), c) {
            var h = hk(l, p, f, i, c);
            a = a.concat(h);
          }
        }
        var m = a.reduce(function(g, b) {
          return b.getTime() <= s.getTime() ? b : g;
        }, a[0]);
        return a.map(function(g) {
          return P.createElement("li", { key: g.valueOf(), onClick: e.handleClick.bind(e, g), className: e.liClasses(g), ref: function(b) {
            g === m && (e.centerLi = b);
          }, onKeyDown: function(b) {
            e.handleOnKeyDown(b, g);
          }, tabIndex: g === m ? 0 : -1, role: "option", "aria-selected": e.isSelectedTime(g) ? "true" : void 0, "aria-disabled": e.isDisabledTime(g) ? "true" : void 0 }, be(g, o, e.props.locale));
        });
      }, e;
    }
    return Object.defineProperty(r, "defaultProps", {
      get: function() {
        return {
          intervals: 30,
          todayButton: null,
          timeCaption: "Time"
        };
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.componentDidMount = function() {
      this.scrollToTheSelectedTime(), this.props.monthRef && this.header && this.setState({
        height: this.props.monthRef.clientHeight - this.header.clientHeight
      });
    }, r.prototype.render = function() {
      var e = this, t, a = this.state.height;
      return P.createElement(
        "div",
        { className: "react-datepicker__time-container ".concat(((t = this.props.todayButton) !== null && t !== void 0 ? t : r.defaultProps.todayButton) ? "react-datepicker__time-container--with-today-button" : "") },
        P.createElement(
          "div",
          { className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""), ref: function(o) {
            e.header = o;
          } },
          P.createElement("div", { className: "react-datepicker-time__header" }, this.props.timeCaption)
        ),
        P.createElement(
          "div",
          { className: "react-datepicker__time" },
          P.createElement(
            "div",
            { className: "react-datepicker__time-box" },
            P.createElement("ul", { className: "react-datepicker__time-list", ref: function(o) {
              e.list = o;
            }, style: a ? { height: a } : {}, role: "listbox", "aria-label": this.props.timeCaption }, this.renderTimes())
          )
        )
      );
    }, r.calcCenterPosition = function(e, t) {
      return t.offsetTop - (e / 2 - t.clientHeight / 2);
    }, r;
  }(Me)
), wl = 3, Ak = (
  /** @class */
  function(n) {
    Ae(r, n);
    function r(e) {
      var t = n.call(this, e) || this;
      return t.YEAR_REFS = Rt([], Array(t.props.yearItemNumber), !0).map(function() {
        return Xt();
      }), t.isDisabled = function(a) {
        return on(a, {
          minDate: t.props.minDate,
          maxDate: t.props.maxDate,
          excludeDates: t.props.excludeDates,
          includeDates: t.props.includeDates,
          filterDate: t.props.filterDate
        });
      }, t.isExcluded = function(a) {
        return ms(a, {
          excludeDates: t.props.excludeDates
        });
      }, t.selectingDate = function() {
        var a;
        return (a = t.props.selectingDate) !== null && a !== void 0 ? a : t.props.preSelection;
      }, t.updateFocusOnPaginate = function(a) {
        var o = function() {
          var i, s;
          (s = (i = t.YEAR_REFS[a]) === null || i === void 0 ? void 0 : i.current) === null || s === void 0 || s.focus();
        };
        window.requestAnimationFrame(o);
      }, t.handleYearClick = function(a, o) {
        t.props.onDayClick && t.props.onDayClick(a, o);
      }, t.handleYearNavigation = function(a, o) {
        var i, s, l, c, u = t.props, d = u.date, f = u.yearItemNumber;
        if (!(d === void 0 || f === void 0)) {
          var p = sn(d, f).startPeriod;
          t.isDisabled(o) || t.isExcluded(o) || ((s = (i = t.props).setPreSelection) === null || s === void 0 || s.call(i, o), a - p < 0 ? t.updateFocusOnPaginate(f - (p - a)) : a - p >= f ? t.updateFocusOnPaginate(Math.abs(f - (a - p))) : (c = (l = t.YEAR_REFS[a - p]) === null || l === void 0 ? void 0 : l.current) === null || c === void 0 || c.focus());
        }
      }, t.isSameDay = function(a, o) {
        return oe(a, o);
      }, t.isCurrentYear = function(a) {
        return a === te(fe());
      }, t.isRangeStart = function(a) {
        return t.props.startDate && t.props.endDate && At(Pt(fe(), a), t.props.startDate);
      }, t.isRangeEnd = function(a) {
        return t.props.startDate && t.props.endDate && At(Pt(fe(), a), t.props.endDate);
      }, t.isInRange = function(a) {
        return sa(a, t.props.startDate, t.props.endDate);
      }, t.isInSelectingRange = function(a) {
        var o = t.props, i = o.selectsStart, s = o.selectsEnd, l = o.selectsRange, c = o.startDate, u = o.endDate;
        return !(i || s || l) || !t.selectingDate() ? !1 : i && u ? sa(a, t.selectingDate(), u) : s && c || l && c && !u ? sa(a, c, t.selectingDate()) : !1;
      }, t.isSelectingRangeStart = function(a) {
        var o;
        if (!t.isInSelectingRange(a))
          return !1;
        var i = t.props, s = i.startDate, l = i.selectsStart, c = Pt(fe(), a);
        return l ? At(c, (o = t.selectingDate()) !== null && o !== void 0 ? o : null) : At(c, s != null ? s : null);
      }, t.isSelectingRangeEnd = function(a) {
        var o;
        if (!t.isInSelectingRange(a))
          return !1;
        var i = t.props, s = i.endDate, l = i.selectsEnd, c = i.selectsRange, u = Pt(fe(), a);
        return l || c ? At(u, (o = t.selectingDate()) !== null && o !== void 0 ? o : null) : At(u, s != null ? s : null);
      }, t.isKeyboardSelected = function(a) {
        if (!(t.props.date === void 0 || t.props.selected == null || t.props.preSelection == null)) {
          var o = t.props, i = o.minDate, s = o.maxDate, l = o.excludeDates, c = o.includeDates, u = o.filterDate, d = xr(Pt(t.props.date, a)), f = (i || s || l || c || u) && Ti(a, t.props);
          return !t.props.disabledKeyboardNavigation && !t.props.inline && !oe(d, xr(t.props.selected)) && oe(d, xr(t.props.preSelection)) && !f;
        }
      }, t.onYearClick = function(a, o) {
        var i = t.props.date;
        i !== void 0 && t.handleYearClick(xr(Pt(i, o)), a);
      }, t.onYearKeyDown = function(a, o) {
        var i, s, l = a.key, c = t.props, u = c.date, d = c.yearItemNumber, f = c.handleOnKeyDown;
        if (l !== H.Tab && a.preventDefault(), !t.props.disabledKeyboardNavigation)
          switch (l) {
            case H.Enter:
              if (t.props.selected == null)
                break;
              t.onYearClick(a, o), (s = (i = t.props).setPreSelection) === null || s === void 0 || s.call(i, t.props.selected);
              break;
            case H.ArrowRight:
              if (t.props.preSelection == null)
                break;
              t.handleYearNavigation(o + 1, Vt(t.props.preSelection, 1));
              break;
            case H.ArrowLeft:
              if (t.props.preSelection == null)
                break;
              t.handleYearNavigation(o - 1, rr(t.props.preSelection, 1));
              break;
            case H.ArrowUp: {
              if (u === void 0 || d === void 0 || t.props.preSelection == null)
                break;
              var p = sn(u, d).startPeriod, h = wl, m = o - h;
              if (m < p) {
                var g = d % h;
                o >= p && o < p + g ? h = g : h += g, m = o - h;
              }
              t.handleYearNavigation(m, rr(t.props.preSelection, h));
              break;
            }
            case H.ArrowDown: {
              if (u === void 0 || d === void 0 || t.props.preSelection == null)
                break;
              var b = sn(u, d).endPeriod, h = wl, m = o + h;
              if (m > b) {
                var g = d % h;
                o <= b && o > b - g ? h = g : h += g, m = o + h;
              }
              t.handleYearNavigation(m, Vt(t.props.preSelection, h));
              break;
            }
          }
        f && f(a);
      }, t.getYearClassNames = function(a) {
        var o = t.props, i = o.date, s = o.minDate, l = o.maxDate, c = o.selected, u = o.excludeDates, d = o.includeDates, f = o.filterDate, p = o.yearClassName;
        return Te("react-datepicker__year-text", "react-datepicker__year-".concat(a), i ? p == null ? void 0 : p(Pt(i, a)) : void 0, {
          "react-datepicker__year-text--selected": c ? a === te(c) : void 0,
          "react-datepicker__year-text--disabled": (s || l || u || d || f) && Ti(a, t.props),
          "react-datepicker__year-text--keyboard-selected": t.isKeyboardSelected(a),
          "react-datepicker__year-text--range-start": t.isRangeStart(a),
          "react-datepicker__year-text--range-end": t.isRangeEnd(a),
          "react-datepicker__year-text--in-range": t.isInRange(a),
          "react-datepicker__year-text--in-selecting-range": t.isInSelectingRange(a),
          "react-datepicker__year-text--selecting-range-start": t.isSelectingRangeStart(a),
          "react-datepicker__year-text--selecting-range-end": t.isSelectingRangeEnd(a),
          "react-datepicker__year-text--today": t.isCurrentYear(a)
        });
      }, t.getYearTabIndex = function(a) {
        if (t.props.disabledKeyboardNavigation || t.props.preSelection == null)
          return "-1";
        var o = te(t.props.preSelection);
        return a === o ? "0" : "-1";
      }, t.getYearContainerClassNames = function() {
        var a = t.props, o = a.selectingDate, i = a.selectsStart, s = a.selectsEnd, l = a.selectsRange;
        return Te("react-datepicker__year", {
          "react-datepicker__year--selecting-range": o && (i || s || l)
        });
      }, t.getYearContent = function(a) {
        return t.props.renderYearContent ? t.props.renderYearContent(a) : a;
      }, t;
    }
    return r.prototype.render = function() {
      var e = this, t = [], a = this.props, o = a.date, i = a.yearItemNumber, s = a.onYearMouseEnter, l = a.onYearMouseLeave;
      if (o === void 0)
        return null;
      for (var c = sn(o, i), u = c.startPeriod, d = c.endPeriod, f = function(m) {
        t.push(P.createElement("div", { ref: p.YEAR_REFS[m - u], onClick: function(g) {
          e.onYearClick(g, m);
        }, onKeyDown: function(g) {
          ff(g) && (g.preventDefault(), g.key = H.Enter), e.onYearKeyDown(g, m);
        }, tabIndex: Number(p.getYearTabIndex(m)), className: p.getYearClassNames(m), onMouseEnter: p.props.usePointerEvent ? void 0 : function(g) {
          return s(g, m);
        }, onPointerEnter: p.props.usePointerEvent ? function(g) {
          return s(g, m);
        } : void 0, onMouseLeave: p.props.usePointerEvent ? void 0 : function(g) {
          return l(g, m);
        }, onPointerLeave: p.props.usePointerEvent ? function(g) {
          return l(g, m);
        } : void 0, key: m, "aria-current": p.isCurrentYear(m) ? "date" : void 0 }, p.getYearContent(m)));
      }, p = this, h = u; h <= d; h++)
        f(h);
      return P.createElement(
        "div",
        { className: this.getYearContainerClassNames() },
        P.createElement("div", { className: "react-datepicker__year-wrapper", onMouseLeave: this.props.usePointerEvent ? void 0 : this.props.clearSelectingDate, onPointerLeave: this.props.usePointerEvent ? this.props.clearSelectingDate : void 0 }, t)
      );
    }, r;
  }(Me)
);
function Ok(n, r, e, t) {
  for (var a = [], o = 0; o < 2 * r + 1; o++) {
    var i = n + r - o, s = !0;
    e && (s = te(e) <= i), t && s && (s = te(t) >= i), s && a.push(i);
  }
  return a;
}
var Nk = (
  /** @class */
  function(n) {
    Ae(r, n);
    function r(e) {
      var t = n.call(this, e) || this;
      t.renderOptions = function() {
        var s = t.props.year, l = t.state.yearsList.map(function(d) {
          return P.createElement(
            "div",
            { className: s === d ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option", key: d, onClick: t.onChange.bind(t, d), "aria-selected": s === d ? "true" : void 0 },
            s === d ? P.createElement("span", { className: "react-datepicker__year-option--selected" }, "✓") : "",
            d
          );
        }), c = t.props.minDate ? te(t.props.minDate) : null, u = t.props.maxDate ? te(t.props.maxDate) : null;
        return (!u || !t.state.yearsList.find(function(d) {
          return d === u;
        })) && l.unshift(P.createElement(
          "div",
          { className: "react-datepicker__year-option", key: "upcoming", onClick: t.incrementYears },
          P.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" })
        )), (!c || !t.state.yearsList.find(function(d) {
          return d === c;
        })) && l.push(P.createElement(
          "div",
          { className: "react-datepicker__year-option", key: "previous", onClick: t.decrementYears },
          P.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" })
        )), l;
      }, t.onChange = function(s) {
        t.props.onChange(s);
      }, t.handleClickOutside = function() {
        t.props.onCancel();
      }, t.shiftYears = function(s) {
        var l = t.state.yearsList.map(function(c) {
          return c + s;
        });
        t.setState({
          yearsList: l
        });
      }, t.incrementYears = function() {
        return t.shiftYears(1);
      }, t.decrementYears = function() {
        return t.shiftYears(-1);
      };
      var a = e.yearDropdownItemNumber, o = e.scrollableYearDropdown, i = a || (o ? 10 : 5);
      return t.state = {
        yearsList: Ok(t.props.year, i, t.props.minDate, t.props.maxDate)
      }, t.dropdownRef = Xt(), t;
    }
    return r.prototype.componentDidMount = function() {
      var e = this.dropdownRef.current;
      if (e) {
        var t = e.children ? Array.from(e.children) : null, a = t ? t.find(function(o) {
          return o.ariaSelected;
        }) : null;
        e.scrollTop = a && a instanceof HTMLElement ? a.offsetTop + (a.clientHeight - e.clientHeight) / 2 : (e.scrollHeight - e.clientHeight) / 2;
      }
    }, r.prototype.render = function() {
      var e = Te({
        "react-datepicker__year-dropdown": !0,
        "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
      });
      return P.createElement("div", { className: e, ref: this.dropdownRef }, this.renderOptions());
    }, r;
  }(Me)
), Rk = lo(Nk), Fk = (
  /** @class */
  function(n) {
    Ae(r, n);
    function r() {
      var e = n !== null && n.apply(this, arguments) || this;
      return e.state = {
        dropdownVisible: !1
      }, e.renderSelectOptions = function() {
        for (var t = e.props.minDate ? te(e.props.minDate) : 1900, a = e.props.maxDate ? te(e.props.maxDate) : 2100, o = [], i = t; i <= a; i++)
          o.push(P.createElement("option", { key: i, value: i }, i));
        return o;
      }, e.onSelectChange = function(t) {
        e.onChange(parseInt(t.target.value));
      }, e.renderSelectMode = function() {
        return P.createElement("select", { value: e.props.year, className: "react-datepicker__year-select", onChange: e.onSelectChange }, e.renderSelectOptions());
      }, e.renderReadView = function(t) {
        return P.createElement(
          "div",
          { key: "read", style: { visibility: t ? "visible" : "hidden" }, className: "react-datepicker__year-read-view", onClick: function(a) {
            return e.toggleDropdown(a);
          } },
          P.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }),
          P.createElement("span", { className: "react-datepicker__year-read-view--selected-year" }, e.props.year)
        );
      }, e.renderDropdown = function() {
        return P.createElement(Rk, ie({ key: "dropdown" }, e.props, { onChange: e.onChange, onCancel: e.toggleDropdown }));
      }, e.renderScrollMode = function() {
        var t = e.state.dropdownVisible, a = [e.renderReadView(!t)];
        return t && a.unshift(e.renderDropdown()), a;
      }, e.onChange = function(t) {
        e.toggleDropdown(), t !== e.props.year && e.props.onChange(t);
      }, e.toggleDropdown = function(t) {
        e.setState({
          dropdownVisible: !e.state.dropdownVisible
        }, function() {
          e.props.adjustDateOnChange && e.handleYearChange(e.props.date, t);
        });
      }, e.handleYearChange = function(t, a) {
        e.onSelect(t, a), e.setOpen();
      }, e.onSelect = function(t, a) {
        e.props.onSelect && e.props.onSelect(t, a);
      }, e.setOpen = function() {
        e.props.setOpen && e.props.setOpen(!0);
      }, e;
    }
    return r.prototype.render = function() {
      var e;
      switch (this.props.dropdownMode) {
        case "scroll":
          e = this.renderScrollMode();
          break;
        case "select":
          e = this.renderSelectMode();
          break;
      }
      return P.createElement("div", { className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode) }, e);
    }, r;
  }(Me)
), Ik = [
  "react-datepicker__year-select",
  "react-datepicker__month-select",
  "react-datepicker__month-year-select"
], Lk = function(n) {
  var r = (n.className || "").split(/\s+/);
  return Ik.some(function(e) {
    return r.indexOf(e) >= 0;
  });
}, Yk = (
  /** @class */
  function(n) {
    Ae(r, n);
    function r(e) {
      var t = n.call(this, e) || this;
      return t.monthContainer = void 0, t.handleClickOutside = function(a) {
        t.props.onClickOutside(a);
      }, t.setClickOutsideRef = function() {
        return t.containerRef.current;
      }, t.handleDropdownFocus = function(a) {
        var o, i;
        Lk(a.target) && ((i = (o = t.props).onDropdownFocus) === null || i === void 0 || i.call(o, a));
      }, t.getDateInView = function() {
        var a = t.props, o = a.preSelection, i = a.selected, s = a.openToDate, l = uf(t.props), c = df(t.props), u = fe(), d = s || i || o;
        return d || (l && Fn(u, l) ? l : c && dn(u, c) ? c : u);
      }, t.increaseMonth = function() {
        t.setState(function(a) {
          var o = a.date;
          return {
            date: Ct(o, 1)
          };
        }, function() {
          return t.handleMonthChange(t.state.date);
        });
      }, t.decreaseMonth = function() {
        t.setState(function(a) {
          var o = a.date;
          return {
            date: nr(o, 1)
          };
        }, function() {
          return t.handleMonthChange(t.state.date);
        });
      }, t.handleDayClick = function(a, o, i) {
        t.props.onSelect(a, o, i), t.props.setPreSelection && t.props.setPreSelection(a);
      }, t.handleDayMouseEnter = function(a) {
        t.setState({ selectingDate: a }), t.props.onDayMouseEnter && t.props.onDayMouseEnter(a);
      }, t.handleMonthMouseLeave = function() {
        t.setState({ selectingDate: void 0 }), t.props.onMonthMouseLeave && t.props.onMonthMouseLeave();
      }, t.handleYearMouseEnter = function(a, o) {
        t.setState({ selectingDate: Pt(fe(), o) }), t.props.onYearMouseEnter && t.props.onYearMouseEnter(a, o);
      }, t.handleYearMouseLeave = function(a, o) {
        t.props.onYearMouseLeave && t.props.onYearMouseLeave(a, o);
      }, t.handleYearChange = function(a) {
        t.props.onYearChange && (t.props.onYearChange(a), t.setState({ isRenderAriaLiveMessage: !0 })), t.props.adjustDateOnChange && (t.props.onSelect && t.props.onSelect(a), t.props.setOpen && t.props.setOpen(!0)), t.props.setPreSelection && t.props.setPreSelection(a);
      }, t.handleMonthChange = function(a) {
        t.handleCustomMonthChange(a), t.props.adjustDateOnChange && (t.props.onSelect && t.props.onSelect(a), t.props.setOpen && t.props.setOpen(!0)), t.props.setPreSelection && t.props.setPreSelection(a);
      }, t.handleCustomMonthChange = function(a) {
        t.props.onMonthChange && (t.props.onMonthChange(a), t.setState({ isRenderAriaLiveMessage: !0 }));
      }, t.handleMonthYearChange = function(a) {
        t.handleYearChange(a), t.handleMonthChange(a);
      }, t.changeYear = function(a) {
        t.setState(function(o) {
          var i = o.date;
          return {
            date: Pt(i, Number(a))
          };
        }, function() {
          return t.handleYearChange(t.state.date);
        });
      }, t.changeMonth = function(a) {
        t.setState(function(o) {
          var i = o.date;
          return {
            date: at(i, Number(a))
          };
        }, function() {
          return t.handleMonthChange(t.state.date);
        });
      }, t.changeMonthYear = function(a) {
        t.setState(function(o) {
          var i = o.date;
          return {
            date: Pt(at(i, Xe(a)), te(a))
          };
        }, function() {
          return t.handleMonthYearChange(t.state.date);
        });
      }, t.header = function(a) {
        a === void 0 && (a = t.state.date);
        var o = ln(a, t.props.locale, t.props.calendarStartDay), i = [];
        return t.props.showWeekNumbers && i.push(P.createElement("div", { key: "W", className: "react-datepicker__day-name" }, t.props.weekLabel || "#")), i.concat([0, 1, 2, 3, 4, 5, 6].map(function(s) {
          var l = gn(o, s), c = t.formatWeekday(l, t.props.locale), u = t.props.weekDayClassName ? t.props.weekDayClassName(l) : void 0;
          return P.createElement("div", { key: s, "aria-label": be(l, "EEEE", t.props.locale), className: Te("react-datepicker__day-name", u) }, c);
        }));
      }, t.formatWeekday = function(a, o) {
        return t.props.formatWeekDay ? rk(a, t.props.formatWeekDay, o) : t.props.useWeekdaysShort ? ok(a, o) : ak(a, o);
      }, t.decreaseYear = function() {
        t.setState(function(a) {
          var o, i = a.date;
          return {
            date: rr(i, t.props.showYearPicker ? (o = t.props.yearItemNumber) !== null && o !== void 0 ? o : r.defaultProps.yearItemNumber : 1)
          };
        }, function() {
          return t.handleYearChange(t.state.date);
        });
      }, t.clearSelectingDate = function() {
        t.setState({ selectingDate: void 0 });
      }, t.renderPreviousButton = function() {
        var a;
        if (!t.props.renderCustomHeader) {
          var o;
          switch (!0) {
            case t.props.showMonthYearPicker:
              o = fl(t.state.date, t.props);
              break;
            case t.props.showYearPicker:
              o = uk(t.state.date, t.props);
              break;
            case t.props.showQuarterYearPicker:
              o = ck(t.state.date, t.props);
              break;
            default:
              o = ul(t.state.date, t.props);
              break;
          }
          if (!(!((a = t.props.forceShowMonthNavigation) !== null && a !== void 0 ? a : r.defaultProps.forceShowMonthNavigation) && !t.props.showDisabledMonthNavigation && o || t.props.showTimeSelectOnly)) {
            var i = [
              "react-datepicker__navigation-icon",
              "react-datepicker__navigation-icon--previous"
            ], s = [
              "react-datepicker__navigation",
              "react-datepicker__navigation--previous"
            ], l = t.decreaseMonth;
            (t.props.showMonthYearPicker || t.props.showQuarterYearPicker || t.props.showYearPicker) && (l = t.decreaseYear), o && t.props.showDisabledMonthNavigation && (s.push("react-datepicker__navigation--previous--disabled"), l = void 0);
            var c = t.props.showMonthYearPicker || t.props.showQuarterYearPicker || t.props.showYearPicker, u = t.props, d = u.previousMonthButtonLabel, f = d === void 0 ? r.defaultProps.previousMonthButtonLabel : d, p = u.previousYearButtonLabel, h = p === void 0 ? r.defaultProps.previousYearButtonLabel : p, m = t.props, g = m.previousMonthAriaLabel, b = g === void 0 ? typeof f == "string" ? f : "Previous Month" : g, v = m.previousYearAriaLabel, D = v === void 0 ? typeof h == "string" ? h : "Previous Year" : v;
            return P.createElement(
              "button",
              { type: "button", className: s.join(" "), onClick: l, onKeyDown: t.props.handleOnKeyDown, "aria-label": c ? D : b },
              P.createElement("span", { className: i.join(" ") }, c ? h : f)
            );
          }
        }
      }, t.increaseYear = function() {
        t.setState(function(a) {
          var o, i = a.date;
          return {
            date: Vt(i, t.props.showYearPicker ? (o = t.props.yearItemNumber) !== null && o !== void 0 ? o : r.defaultProps.yearItemNumber : 1)
          };
        }, function() {
          return t.handleYearChange(t.state.date);
        });
      }, t.renderNextButton = function() {
        var a;
        if (!t.props.renderCustomHeader) {
          var o;
          switch (!0) {
            case t.props.showMonthYearPicker:
              o = pl(t.state.date, t.props);
              break;
            case t.props.showYearPicker:
              o = dk(t.state.date, t.props);
              break;
            case t.props.showQuarterYearPicker:
              o = lk(t.state.date, t.props);
              break;
            default:
              o = dl(t.state.date, t.props);
              break;
          }
          if (!(!((a = t.props.forceShowMonthNavigation) !== null && a !== void 0 ? a : r.defaultProps.forceShowMonthNavigation) && !t.props.showDisabledMonthNavigation && o || t.props.showTimeSelectOnly)) {
            var i = [
              "react-datepicker__navigation",
              "react-datepicker__navigation--next"
            ], s = [
              "react-datepicker__navigation-icon",
              "react-datepicker__navigation-icon--next"
            ];
            t.props.showTimeSelect && i.push("react-datepicker__navigation--next--with-time"), t.props.todayButton && i.push("react-datepicker__navigation--next--with-today-button");
            var l = t.increaseMonth;
            (t.props.showMonthYearPicker || t.props.showQuarterYearPicker || t.props.showYearPicker) && (l = t.increaseYear), o && t.props.showDisabledMonthNavigation && (i.push("react-datepicker__navigation--next--disabled"), l = void 0);
            var c = t.props.showMonthYearPicker || t.props.showQuarterYearPicker || t.props.showYearPicker, u = t.props, d = u.nextMonthButtonLabel, f = d === void 0 ? r.defaultProps.nextMonthButtonLabel : d, p = u.nextYearButtonLabel, h = p === void 0 ? r.defaultProps.nextYearButtonLabel : p, m = t.props, g = m.nextMonthAriaLabel, b = g === void 0 ? typeof f == "string" ? f : "Next Month" : g, v = m.nextYearAriaLabel, D = v === void 0 ? typeof h == "string" ? h : "Next Year" : v;
            return P.createElement(
              "button",
              { type: "button", className: i.join(" "), onClick: l, onKeyDown: t.props.handleOnKeyDown, "aria-label": c ? D : b },
              P.createElement("span", { className: s.join(" ") }, c ? h : f)
            );
          }
        }
      }, t.renderCurrentMonth = function(a) {
        a === void 0 && (a = t.state.date);
        var o = ["react-datepicker__current-month"];
        return t.props.showYearDropdown && o.push("react-datepicker__current-month--hasYearDropdown"), t.props.showMonthDropdown && o.push("react-datepicker__current-month--hasMonthDropdown"), t.props.showMonthYearDropdown && o.push("react-datepicker__current-month--hasMonthYearDropdown"), P.createElement("h2", { className: o.join(" ") }, be(a, t.props.dateFormat, t.props.locale));
      }, t.renderYearDropdown = function(a) {
        if (a === void 0 && (a = !1), !(!t.props.showYearDropdown || a))
          return P.createElement(Fk, ie({}, r.defaultProps, t.props, { date: t.state.date, onChange: t.changeYear, year: te(t.state.date) }));
      }, t.renderMonthDropdown = function(a) {
        if (a === void 0 && (a = !1), !(!t.props.showMonthDropdown || a))
          return P.createElement(Ck, ie({}, r.defaultProps, t.props, { month: Xe(t.state.date), onChange: t.changeMonth }));
      }, t.renderMonthYearDropdown = function(a) {
        if (a === void 0 && (a = !1), !(!t.props.showMonthYearDropdown || a))
          return P.createElement(Mk, ie({}, r.defaultProps, t.props, { date: t.state.date, onChange: t.changeMonthYear }));
      }, t.handleTodayButtonClick = function(a) {
        t.props.onSelect(ol(), a), t.props.setPreSelection && t.props.setPreSelection(ol());
      }, t.renderTodayButton = function() {
        if (!(!t.props.todayButton || t.props.showTimeSelectOnly))
          return P.createElement("div", { className: "react-datepicker__today-button", onClick: t.handleTodayButtonClick }, t.props.todayButton);
      }, t.renderDefaultHeader = function(a) {
        var o = a.monthDate, i = a.i;
        return P.createElement(
          "div",
          { className: "react-datepicker__header ".concat(t.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "") },
          t.renderCurrentMonth(o),
          P.createElement(
            "div",
            { className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(t.props.dropdownMode), onFocus: t.handleDropdownFocus },
            t.renderMonthDropdown(i !== 0),
            t.renderMonthYearDropdown(i !== 0),
            t.renderYearDropdown(i !== 0)
          ),
          P.createElement("div", { className: "react-datepicker__day-names" }, t.header(o))
        );
      }, t.renderCustomHeader = function(a) {
        var o, i, s = a.monthDate, l = a.i;
        if (t.props.showTimeSelect && !t.state.monthContainer || t.props.showTimeSelectOnly)
          return null;
        var c = ul(t.state.date, t.props), u = dl(t.state.date, t.props), d = fl(t.state.date, t.props), f = pl(t.state.date, t.props), p = !t.props.showMonthYearPicker && !t.props.showQuarterYearPicker && !t.props.showYearPicker;
        return P.createElement(
          "div",
          { className: "react-datepicker__header react-datepicker__header--custom", onFocus: t.props.onDropdownFocus },
          (i = (o = t.props).renderCustomHeader) === null || i === void 0 ? void 0 : i.call(o, ie(ie({}, t.state), { customHeaderCount: l, monthDate: s, changeMonth: t.changeMonth, changeYear: t.changeYear, decreaseMonth: t.decreaseMonth, increaseMonth: t.increaseMonth, decreaseYear: t.decreaseYear, increaseYear: t.increaseYear, prevMonthButtonDisabled: c, nextMonthButtonDisabled: u, prevYearButtonDisabled: d, nextYearButtonDisabled: f })),
          p && P.createElement("div", { className: "react-datepicker__day-names" }, t.header(s))
        );
      }, t.renderYearHeader = function(a) {
        var o = a.monthDate, i = t.props, s = i.showYearPicker, l = i.yearItemNumber, c = l === void 0 ? r.defaultProps.yearItemNumber : l, u = sn(o, c), d = u.startPeriod, f = u.endPeriod;
        return P.createElement("div", { className: "react-datepicker__header react-datepicker-year-header" }, s ? "".concat(d, " - ").concat(f) : te(o));
      }, t.renderHeader = function(a) {
        var o = a.monthDate, i = a.i, s = i === void 0 ? 0 : i, l = { monthDate: o, i: s };
        switch (!0) {
          case t.props.renderCustomHeader !== void 0:
            return t.renderCustomHeader(l);
          case (t.props.showMonthYearPicker || t.props.showQuarterYearPicker || t.props.showYearPicker):
            return t.renderYearHeader(l);
          default:
            return t.renderDefaultHeader(l);
        }
      }, t.renderMonths = function() {
        var a, o;
        if (!(t.props.showTimeSelectOnly || t.props.showYearPicker)) {
          for (var i = [], s = (a = t.props.monthsShown) !== null && a !== void 0 ? a : r.defaultProps.monthsShown, l = t.props.showPreviousMonths ? s - 1 : 0, c = t.props.showMonthYearPicker || t.props.showQuarterYearPicker ? Vt(t.state.date, l) : nr(t.state.date, l), u = (o = t.props.monthSelectedIn) !== null && o !== void 0 ? o : l, d = 0; d < s; ++d) {
            var f = d - u + l, p = t.props.showMonthYearPicker || t.props.showQuarterYearPicker ? Vt(c, f) : Ct(c, f), h = "month-".concat(d), m = d < s - 1, g = d > 0;
            i.push(P.createElement(
              "div",
              { key: h, ref: function(b) {
                t.monthContainer = b != null ? b : void 0;
              }, className: "react-datepicker__month-container" },
              t.renderHeader({ monthDate: p, i: d }),
              P.createElement(Dk, ie({}, r.defaultProps, t.props, { ariaLabelPrefix: t.props.monthAriaLabelPrefix, day: p, onDayClick: t.handleDayClick, handleOnKeyDown: t.props.handleOnDayKeyDown, handleOnMonthKeyDown: t.props.handleOnKeyDown, onDayMouseEnter: t.handleDayMouseEnter, onMouseLeave: t.handleMonthMouseLeave, orderInDisplay: d, selectingDate: t.state.selectingDate, monthShowsDuplicateDaysEnd: m, monthShowsDuplicateDaysStart: g }))
            ));
          }
          return i;
        }
      }, t.renderYears = function() {
        if (!t.props.showTimeSelectOnly && t.props.showYearPicker)
          return P.createElement(
            "div",
            { className: "react-datepicker__year--container" },
            t.renderHeader({ monthDate: t.state.date }),
            P.createElement(Ak, ie({}, r.defaultProps, t.props, { selectingDate: t.state.selectingDate, date: t.state.date, onDayClick: t.handleDayClick, clearSelectingDate: t.clearSelectingDate, onYearMouseEnter: t.handleYearMouseEnter, onYearMouseLeave: t.handleYearMouseLeave }))
          );
      }, t.renderTimeSection = function() {
        if (t.props.showTimeSelect && (t.state.monthContainer || t.props.showTimeSelectOnly))
          return P.createElement(Pk, ie({}, r.defaultProps, t.props, { onChange: t.props.onTimeChange, format: t.props.timeFormat, intervals: t.props.timeIntervals, monthRef: t.state.monthContainer }));
      }, t.renderInputTimeSection = function() {
        var a = t.props.selected ? new Date(t.props.selected) : void 0, o = a && qt(a) && !!t.props.selected, i = o ? "".concat(ml(a.getHours()), ":").concat(ml(a.getMinutes())) : "";
        if (t.props.showTimeInput)
          return P.createElement(yk, ie({}, r.defaultProps, t.props, { date: a, timeString: i, onChange: t.props.onTimeChange }));
      }, t.renderAriaLiveRegion = function() {
        var a, o = sn(t.state.date, (a = t.props.yearItemNumber) !== null && a !== void 0 ? a : r.defaultProps.yearItemNumber), i = o.startPeriod, s = o.endPeriod, l;
        return t.props.showYearPicker ? l = "".concat(i, " - ").concat(s) : t.props.showMonthYearPicker || t.props.showQuarterYearPicker ? l = te(t.state.date) : l = "".concat(hs(Xe(t.state.date), t.props.locale), " ").concat(te(t.state.date)), P.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, t.state.isRenderAriaLiveMessage && l);
      }, t.renderChildren = function() {
        if (t.props.children)
          return P.createElement("div", { className: "react-datepicker__children-container" }, t.props.children);
      }, t.containerRef = Xt(), t.state = {
        date: t.getDateInView(),
        selectingDate: void 0,
        monthContainer: void 0,
        isRenderAriaLiveMessage: !1
      }, t;
    }
    return Object.defineProperty(r, "defaultProps", {
      get: function() {
        return {
          monthsShown: 1,
          forceShowMonthNavigation: !1,
          timeCaption: "Time",
          previousYearButtonLabel: "Previous Year",
          nextYearButtonLabel: "Next Year",
          previousMonthButtonLabel: "Previous Month",
          nextMonthButtonLabel: "Next Month",
          yearItemNumber: Ur
        };
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.componentDidMount = function() {
      var e = this;
      this.props.showTimeSelect && (this.assignMonthContainer = function() {
        e.setState({ monthContainer: e.monthContainer });
      }());
    }, r.prototype.componentDidUpdate = function(e) {
      var t = this;
      if (this.props.preSelection && (!oe(this.props.preSelection, e.preSelection) || this.props.monthSelectedIn !== e.monthSelectedIn)) {
        var a = !Ke(this.state.date, this.props.preSelection);
        this.setState({
          date: this.props.preSelection
        }, function() {
          return a && t.handleCustomMonthChange(t.state.date);
        });
      } else
        this.props.openToDate && !oe(this.props.openToDate, e.openToDate) && this.setState({
          date: this.props.openToDate
        });
    }, r.prototype.render = function() {
      var e = this.props.container || GD;
      return P.createElement(
        "div",
        { style: { display: "contents" }, ref: this.containerRef },
        P.createElement(
          e,
          { className: Te("react-datepicker", this.props.className, {
            "react-datepicker--time-only": this.props.showTimeSelectOnly
          }), showTime: this.props.showTimeSelect || this.props.showTimeInput, showTimeSelectOnly: this.props.showTimeSelectOnly },
          this.renderAriaLiveRegion(),
          this.renderPreviousButton(),
          this.renderNextButton(),
          this.renderMonths(),
          this.renderYears(),
          this.renderTodayButton(),
          this.renderTimeSection(),
          this.renderInputTimeSection(),
          this.renderChildren()
        )
      );
    }, r;
  }(Me)
), Wk = function(n) {
  var r = n.icon, e = n.className, t = e === void 0 ? "" : e, a = n.onClick, o = "react-datepicker__calendar-icon";
  return typeof r == "string" ? P.createElement("i", { className: "".concat(o, " ").concat(r, " ").concat(t), "aria-hidden": "true", onClick: a }) : P.isValidElement(r) ? P.cloneElement(r, {
    className: "".concat(r.props.className || "", " ").concat(o, " ").concat(t),
    onClick: function(i) {
      typeof r.props.onClick == "function" && r.props.onClick(i), typeof a == "function" && a(i);
    }
  }) : P.createElement(
    "svg",
    { className: "".concat(o, " ").concat(t), xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512", onClick: a },
    P.createElement("path", { d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z" })
  );
}, pf = (
  /** @class */
  function(n) {
    Ae(r, n);
    function r(e) {
      var t = n.call(this, e) || this;
      return t.portalRoot = null, t.el = document.createElement("div"), t;
    }
    return r.prototype.componentDidMount = function() {
      this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
    }, r.prototype.componentWillUnmount = function() {
      this.portalRoot && this.portalRoot.removeChild(this.el);
    }, r.prototype.render = function() {
      return cm.createPortal(this.props.children, this.el);
    }, r;
  }(Me)
), Hk = "[tabindex], a, button, input, select, textarea", $k = function(n) {
  return (n instanceof HTMLAnchorElement || !n.disabled) && n.tabIndex !== -1;
}, hf = (
  /** @class */
  function(n) {
    Ae(r, n);
    function r(e) {
      var t = n.call(this, e) || this;
      return t.getTabChildren = function() {
        var a;
        return Array.prototype.slice.call((a = t.tabLoopRef.current) === null || a === void 0 ? void 0 : a.querySelectorAll(Hk), 1, -1).filter($k);
      }, t.handleFocusStart = function() {
        var a = t.getTabChildren();
        a && a.length > 1 && a[a.length - 1].focus();
      }, t.handleFocusEnd = function() {
        var a = t.getTabChildren();
        a && a.length > 1 && a[0].focus();
      }, t.tabLoopRef = Xt(), t;
    }
    return r.prototype.render = function() {
      var e;
      return ((e = this.props.enableTabLoop) !== null && e !== void 0 ? e : r.defaultProps.enableTabLoop) ? P.createElement(
        "div",
        { className: "react-datepicker__tab-loop", ref: this.tabLoopRef },
        P.createElement("div", { className: "react-datepicker__tab-loop__start", tabIndex: 0, onFocus: this.handleFocusStart }),
        this.props.children,
        P.createElement("div", { className: "react-datepicker__tab-loop__end", tabIndex: 0, onFocus: this.handleFocusEnd })
      ) : this.props.children;
    }, r.defaultProps = {
      enableTabLoop: !0
    }, r;
  }(Me)
);
function Bk(n) {
  var r = function(e) {
    var t, a = typeof e.hidePopper == "boolean" ? e.hidePopper : !0, o = it(null), i = VD(ie({ open: !a, whileElementsMounted: xD, placement: e.popperPlacement, middleware: Rt([
      AD({ padding: 15 }),
      PD(10),
      OD({ element: o })
    ], (t = e.popperModifiers) !== null && t !== void 0 ? t : [], !0) }, e.popperProps)), s = ie(ie({}, e), { hidePopper: a, popperProps: ie(ie({}, i), { arrowRef: o }) });
    return P.createElement(n, ie({}, s));
  };
  return r;
}
var Qk = (
  /** @class */
  function(n) {
    Ae(r, n);
    function r() {
      return n !== null && n.apply(this, arguments) || this;
    }
    return Object.defineProperty(r, "defaultProps", {
      get: function() {
        return {
          hidePopper: !0
        };
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.render = function() {
      var e = this.props, t = e.className, a = e.wrapperClassName, o = e.hidePopper, i = o === void 0 ? r.defaultProps.hidePopper : o, s = e.popperComponent, l = e.targetComponent, c = e.enableTabLoop, u = e.popperOnKeyDown, d = e.portalId, f = e.portalHost, p = e.popperProps, h = e.showArrow, m = void 0;
      if (!i) {
        var g = Te("react-datepicker-popper", t);
        m = P.createElement(
          hf,
          { enableTabLoop: c },
          P.createElement(
            "div",
            { ref: p.refs.setFloating, style: p.floatingStyles, className: g, "data-placement": p.placement, onKeyDown: u },
            s,
            h && P.createElement($D, { ref: p.arrowRef, context: p.context, fill: "currentColor", strokeWidth: 1, height: 8, width: 16, style: { transform: "translateY(-1px)" }, className: "react-datepicker__triangle" })
          )
        );
      }
      this.props.popperContainer && (m = _u(this.props.popperContainer, {}, m)), d && !i && (m = P.createElement(pf, { portalId: d, portalHost: f }, m));
      var b = Te("react-datepicker-wrapper", a);
      return P.createElement(
        P.Fragment,
        null,
        P.createElement("div", { ref: p.refs.setReference, className: b }, l),
        m
      );
    }, r;
  }(Me)
), Uk = Bk(Qk), _l = "react-datepicker-ignore-onclickoutside", qk = lo(Yk);
function jk(n, r) {
  return n && r ? Xe(n) !== Xe(r) || te(n) !== te(r) : n !== r;
}
var Zo = "Date input not valid.", zk = (
  /** @class */
  function(n) {
    Ae(r, n);
    function r(e) {
      var t = n.call(this, e) || this;
      return t.calendar = null, t.input = null, t.getPreSelection = function() {
        return t.props.openToDate ? t.props.openToDate : t.props.selectsEnd && t.props.startDate ? t.props.startDate : t.props.selectsStart && t.props.endDate ? t.props.endDate : fe();
      }, t.modifyHolidays = function() {
        var a;
        return (a = t.props.holidays) === null || a === void 0 ? void 0 : a.reduce(function(o, i) {
          var s = new Date(i.date);
          return qt(s) ? Rt(Rt([], o, !0), [ie(ie({}, i), { date: s })], !1) : o;
        }, []);
      }, t.calcInitialState = function() {
        var a, o = t.getPreSelection(), i = uf(t.props), s = df(t.props), l = i && Fn(o, va(i)) ? i : s && dn(o, il(s)) ? s : o;
        return {
          open: t.props.startOpen || !1,
          preventFocus: !1,
          inputValue: null,
          preSelection: (a = t.props.selectsRange ? t.props.startDate : t.props.selected) !== null && a !== void 0 ? a : l,
          // transforming highlighted days (perhaps nested array)
          // to flat Map for faster access in day.jsx
          highlightDates: hl(t.props.highlightDates),
          focused: !1,
          // used to focus day in inline version after month has changed, but not on
          // initial render
          shouldFocusDayInline: !1,
          isRenderAriaLiveMessage: !1,
          wasHidden: !1
        };
      }, t.resetHiddenStatus = function() {
        t.setState(ie(ie({}, t.state), { wasHidden: !1 }));
      }, t.setHiddenStatus = function() {
        t.setState(ie(ie({}, t.state), { wasHidden: !0 }));
      }, t.setHiddenStateOnVisibilityHidden = function() {
        document.visibilityState === "hidden" && t.setHiddenStatus();
      }, t.clearPreventFocusTimeout = function() {
        t.preventFocusTimeout && clearTimeout(t.preventFocusTimeout);
      }, t.setFocus = function() {
        t.input && t.input.focus && t.input.focus({ preventScroll: !0 });
      }, t.setBlur = function() {
        t.input && t.input.blur && t.input.blur(), t.cancelFocusInput();
      }, t.setOpen = function(a, o) {
        o === void 0 && (o = !1), t.setState({
          open: a,
          preSelection: a && t.state.open ? t.state.preSelection : t.calcInitialState().preSelection,
          lastPreSelectChange: ei
        }, function() {
          a || t.setState(function(i) {
            return {
              focused: o ? i.focused : !1
            };
          }, function() {
            !o && t.setBlur(), t.setState({ inputValue: null });
          });
        });
      }, t.inputOk = function() {
        return Gt(t.state.preSelection);
      }, t.isCalendarOpen = function() {
        return t.props.open === void 0 ? t.state.open && !t.props.disabled && !t.props.readOnly : t.props.open;
      }, t.handleFocus = function(a) {
        var o, i, s = t.state.wasHidden, l = s ? t.state.open : !0;
        s && t.resetHiddenStatus(), !t.state.preventFocus && l && ((i = (o = t.props).onFocus) === null || i === void 0 || i.call(o, a), !t.props.preventOpenOnFocus && !t.props.readOnly && t.setOpen(!0)), t.setState({ focused: !0 });
      }, t.sendFocusBackToInput = function() {
        t.preventFocusTimeout && t.clearPreventFocusTimeout(), t.setState({ preventFocus: !0 }, function() {
          t.preventFocusTimeout = setTimeout(function() {
            t.setFocus(), t.setState({ preventFocus: !1 });
          });
        });
      }, t.cancelFocusInput = function() {
        clearTimeout(t.inputFocusTimeout), t.inputFocusTimeout = void 0;
      }, t.deferFocusInput = function() {
        t.cancelFocusInput(), t.inputFocusTimeout = setTimeout(function() {
          return t.setFocus();
        }, 1);
      }, t.handleDropdownFocus = function() {
        t.cancelFocusInput();
      }, t.handleBlur = function(a) {
        var o, i;
        (!t.state.open || t.props.withPortal || t.props.showTimeInput) && ((i = (o = t.props).onBlur) === null || i === void 0 || i.call(o, a)), t.setState({ focused: !1 });
      }, t.handleCalendarClickOutside = function(a) {
        var o, i;
        t.props.inline || t.setOpen(!1), (i = (o = t.props).onClickOutside) === null || i === void 0 || i.call(o, a), t.props.withPortal && a.preventDefault();
      }, t.handleChange = function() {
        for (var a = [], o = 0; o < arguments.length; o++)
          a[o] = arguments[o];
        var i = a[0];
        if (!(t.props.onChangeRaw && (t.props.onChangeRaw.apply(t, a), !i || typeof i.isDefaultPrevented != "function" || i.isDefaultPrevented()))) {
          t.setState({
            inputValue: (i == null ? void 0 : i.target) instanceof HTMLInputElement ? i.target.value : null,
            lastPreSelectChange: Vk
          });
          var s = t.props, l = s.dateFormat, c = l === void 0 ? r.defaultProps.dateFormat : l, u = s.strictParsing, d = u === void 0 ? r.defaultProps.strictParsing : u, f = XD((i == null ? void 0 : i.target) instanceof HTMLInputElement ? i.target.value : "", c, t.props.locale, d, t.props.minDate);
          t.props.showTimeSelectOnly && t.props.selected && f && !oe(f, t.props.selected) && (f = B_(t.props.selected, {
            hours: Ft(f),
            minutes: It(f),
            seconds: Kt(f)
          })), (f || !((i == null ? void 0 : i.target) instanceof HTMLInputElement) || !(i != null && i.target.value)) && t.setSelected(f, i, !0);
        }
      }, t.handleSelect = function(a, o, i) {
        if (t.props.shouldCloseOnSelect && !t.props.showTimeSelect && t.sendFocusBackToInput(), t.props.onChangeRaw && t.props.onChangeRaw(o), t.setSelected(a, o, !1, i), t.props.showDateSelect && t.setState({ isRenderAriaLiveMessage: !0 }), !t.props.shouldCloseOnSelect || t.props.showTimeSelect)
          t.setPreSelection(a);
        else if (!t.props.inline) {
          t.props.selectsRange || t.setOpen(!1);
          var s = t.props, l = s.startDate, c = s.endDate;
          l && !c && (t.props.swapRange || !bl(a, l)) && t.setOpen(!1);
        }
      }, t.setSelected = function(a, o, i, s) {
        var l, c = a;
        if (t.props.showYearPicker) {
          if (c !== null && Ti(te(c), t.props))
            return;
        } else if (t.props.showMonthYearPicker) {
          if (c !== null && lf(c, t.props))
            return;
        } else if (c !== null && on(c, t.props))
          return;
        var u = t.props, d = u.onChange, f = u.selectsRange, p = u.startDate, h = u.endDate, m = u.selectsMultiple, g = u.selectedDates, b = u.minTime, v = u.swapRange;
        if (!kn(t.props.selected, c) || t.props.allowSameDay || f || m)
          if (c !== null && (t.props.selected && (!i || !t.props.showTimeSelect && !t.props.showTimeSelectOnly && !t.props.showTimeInput) && (c = Ko(c, {
            hour: Ft(t.props.selected),
            minute: It(t.props.selected),
            second: Kt(t.props.selected)
          })), !i && (t.props.showTimeSelect || t.props.showTimeSelectOnly) && b && (c = Ko(c, {
            hour: b.getHours(),
            minute: b.getMinutes(),
            second: b.getSeconds()
          })), t.props.inline || t.setState({
            preSelection: c
          }), t.props.focusSelectedMonth || t.setState({ monthSelectedIn: s })), f) {
            var D = !p && !h, k = p && !h, x = p && h;
            D ? d ? d([c, null], o) : r.defaultProps.onChange : k && (c === null ? d ? d([null, null], o) : r.defaultProps.onChange : bl(c, p) ? v ? d ? d([c, p], o) : r.defaultProps.onChange : d ? d([c, null], o) : r.defaultProps.onChange : d ? d([p, c], o) : r.defaultProps.onChange), x && (d ? d([c, null], o) : r.defaultProps.onChange);
          } else if (m) {
            if (c !== null)
              if (!(g != null && g.length))
                d ? d([c], o) : r.defaultProps.onChange;
              else {
                var R = g.some(function(A) {
                  return oe(A, c);
                });
                if (R) {
                  var I = g.filter(function(A) {
                    return !oe(A, c);
                  });
                  d ? d(I, o) : r.defaultProps.onChange;
                } else
                  d ? d(Rt(Rt([], g, !0), [c], !1), o) : r.defaultProps.onChange;
              }
          } else
            d ? d(c, o) : r.defaultProps.onChange;
        if (!i) {
          var L = (l = t.props.onSelect) !== null && l !== void 0 ? l : r.defaultProps.onSelect;
          L(c, o), t.setState({ inputValue: null });
        }
      }, t.setPreSelection = function(a) {
        var o = Gt(t.props.minDate), i = Gt(t.props.maxDate), s = !0;
        if (a) {
          var l = va(a);
          if (o && i)
            s = Cr(a, t.props.minDate, t.props.maxDate);
          else if (o) {
            var c = va(t.props.minDate);
            s = dn(a, c) || kn(l, c);
          } else if (i) {
            var u = il(t.props.maxDate);
            s = Fn(a, u) || kn(l, u);
          }
        }
        s && t.setState({
          preSelection: a
        });
      }, t.toggleCalendar = function() {
        t.setOpen(!t.state.open);
      }, t.handleTimeChange = function(a) {
        var o;
        if (!(t.props.selectsRange || t.props.selectsMultiple)) {
          var i = t.props.selected ? t.props.selected : t.getPreSelection(), s = t.props.selected ? a : Ko(i, {
            hour: Ft(a),
            minute: It(a)
          });
          t.setState({
            preSelection: s
          });
          var l = (o = t.props.onChange) !== null && o !== void 0 ? o : r.defaultProps.onChange;
          l(s), t.props.shouldCloseOnSelect && !t.props.showTimeInput && (t.sendFocusBackToInput(), t.setOpen(!1)), t.props.showTimeInput && t.setOpen(!0), (t.props.showTimeSelectOnly || t.props.showTimeSelect) && t.setState({ isRenderAriaLiveMessage: !0 }), t.setState({ inputValue: null });
        }
      }, t.onInputClick = function() {
        var a, o;
        !t.props.disabled && !t.props.readOnly && t.setOpen(!0), (o = (a = t.props).onInputClick) === null || o === void 0 || o.call(a);
      }, t.onInputKeyDown = function(a) {
        var o, i, s, l, c;
        (i = (o = t.props).onKeyDown) === null || i === void 0 || i.call(o, a);
        var u = a.key;
        if (!t.state.open && !t.props.inline && !t.props.preventOpenOnFocus) {
          (u === H.ArrowDown || u === H.ArrowUp || u === H.Enter) && t.onInputClick();
          return;
        }
        if (t.state.open) {
          if (u === H.ArrowDown || u === H.ArrowUp) {
            a.preventDefault();
            var d = t.props.showTimeSelectOnly ? ".react-datepicker__time-list-item[tabindex='0']" : t.props.showWeekPicker && t.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : t.props.showFullMonthYearPicker || t.props.showMonthYearPicker ? '.react-datepicker__month-text[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]', f = ((s = t.calendar) === null || s === void 0 ? void 0 : s.componentNode) instanceof Element && t.calendar.componentNode.querySelector(d);
            f instanceof HTMLElement && f.focus({ preventScroll: !0 });
            return;
          }
          var p = fe(t.state.preSelection);
          u === H.Enter ? (a.preventDefault(), t.inputOk() && t.state.lastPreSelectChange === ei ? (t.handleSelect(p, a), !t.props.shouldCloseOnSelect && t.setPreSelection(p)) : t.setOpen(!1)) : u === H.Escape ? (a.preventDefault(), t.sendFocusBackToInput(), t.setOpen(!1)) : u === H.Tab && t.setOpen(!1), t.inputOk() || (c = (l = t.props).onInputError) === null || c === void 0 || c.call(l, { code: 1, msg: Zo });
        }
      }, t.onPortalKeyDown = function(a) {
        var o = a.key;
        o === H.Escape && (a.preventDefault(), t.setState({
          preventFocus: !0
        }, function() {
          t.setOpen(!1), setTimeout(function() {
            t.setFocus(), t.setState({ preventFocus: !1 });
          });
        }));
      }, t.onDayKeyDown = function(a) {
        var o, i, s, l, c = t.props, u = c.minDate, d = c.maxDate, f = c.disabledKeyboardNavigation, p = c.showWeekPicker, h = c.shouldCloseOnSelect, m = c.locale, g = c.calendarStartDay, b = c.adjustDateOnChange, v = c.inline;
        if ((i = (o = t.props).onKeyDown) === null || i === void 0 || i.call(o, a), !f) {
          var D = a.key, k = a.shiftKey, x = fe(t.state.preSelection), R = function($, N) {
            var T = N;
            switch ($) {
              case H.ArrowRight:
                T = p ? Aa(N, 1) : gn(N, 1);
                break;
              case H.ArrowLeft:
                T = p ? Vc(N, 1) : Q_(N, 1);
                break;
              case H.ArrowUp:
                T = Vc(N, 1);
                break;
              case H.ArrowDown:
                T = Aa(N, 1);
                break;
              case H.PageUp:
                T = k ? rr(N, 1) : nr(N, 1);
                break;
              case H.PageDown:
                T = k ? Vt(N, 1) : Ct(N, 1);
                break;
              case H.Home:
                T = ln(N, m, g);
                break;
              case H.End:
                T = nk(N);
                break;
            }
            return T;
          }, I = function($, N) {
            for (var T = 40, M = $, C = !1, S = 0, F = R($, N); !C; ) {
              if (S >= T) {
                F = N;
                break;
              }
              u && F < u && (M = H.ArrowRight, F = on(u, t.props) ? R(M, F) : u), d && F > d && (M = H.ArrowLeft, F = on(d, t.props) ? R(M, F) : d), on(F, t.props) ? ((M === H.PageUp || M === H.Home) && (M = H.ArrowRight), (M === H.PageDown || M === H.End) && (M = H.ArrowLeft), F = R(M, F)) : C = !0, S++;
            }
            return F;
          };
          if (D === H.Enter) {
            a.preventDefault(), t.handleSelect(x, a), !h && t.setPreSelection(x);
            return;
          } else if (D === H.Escape) {
            a.preventDefault(), t.setOpen(!1), t.inputOk() || (l = (s = t.props).onInputError) === null || l === void 0 || l.call(s, { code: 1, msg: Zo });
            return;
          }
          var L = null;
          switch (D) {
            case H.ArrowLeft:
            case H.ArrowRight:
            case H.ArrowUp:
            case H.ArrowDown:
            case H.PageUp:
            case H.PageDown:
            case H.Home:
            case H.End:
              L = I(D, x);
              break;
          }
          if (!L) {
            t.props.onInputError && t.props.onInputError({ code: 1, msg: Zo });
            return;
          }
          if (a.preventDefault(), t.setState({ lastPreSelectChange: ei }), b && t.setSelected(L), t.setPreSelection(L), v) {
            var A = Xe(x), W = Xe(L), O = te(x), U = te(L);
            A !== W || O !== U ? t.setState({ shouldFocusDayInline: !0 }) : t.setState({ shouldFocusDayInline: !1 });
          }
        }
      }, t.onPopperKeyDown = function(a) {
        var o = a.key;
        o === H.Escape && (a.preventDefault(), t.sendFocusBackToInput());
      }, t.onClearClick = function(a) {
        a && a.preventDefault && a.preventDefault(), t.sendFocusBackToInput();
        var o = t.props, i = o.selectsRange, s = o.onChange;
        i ? s ? s([null, null], a) : r.defaultProps.onChange() : s ? s(null, a) : r.defaultProps.onChange(), t.setState({ inputValue: null });
      }, t.clear = function() {
        t.onClearClick();
      }, t.onScroll = function(a) {
        typeof t.props.closeOnScroll == "boolean" && t.props.closeOnScroll ? (a.target === document || a.target === document.documentElement || a.target === document.body) && t.setOpen(!1) : typeof t.props.closeOnScroll == "function" && t.props.closeOnScroll(a) && t.setOpen(!1);
      }, t.renderCalendar = function() {
        var a, o;
        return !t.props.inline && !t.isCalendarOpen() ? null : P.createElement(qk, ie({ ref: function(i) {
          t.calendar = i;
        } }, t.props, t.state, { setOpen: t.setOpen, dateFormat: (a = t.props.dateFormatCalendar) !== null && a !== void 0 ? a : r.defaultProps.dateFormatCalendar, onSelect: t.handleSelect, onClickOutside: t.handleCalendarClickOutside, holidays: pk(t.modifyHolidays()), outsideClickIgnoreClass: _l, onDropdownFocus: t.handleDropdownFocus, onTimeChange: t.handleTimeChange, className: t.props.calendarClassName, container: t.props.calendarContainer, handleOnKeyDown: t.props.onKeyDown, handleOnDayKeyDown: t.onDayKeyDown, setPreSelection: t.setPreSelection, dropdownMode: (o = t.props.dropdownMode) !== null && o !== void 0 ? o : r.defaultProps.dropdownMode }), t.props.children);
      }, t.renderAriaLiveRegion = function() {
        var a = t.props, o = a.dateFormat, i = o === void 0 ? r.defaultProps.dateFormat : o, s = a.locale, l = t.props.showTimeInput || t.props.showTimeSelect, c = l ? "PPPPp" : "PPPP", u;
        return t.props.selectsRange ? u = "Selected start date: ".concat(ft(t.props.startDate, {
          dateFormat: c,
          locale: s
        }), ". ").concat(t.props.endDate ? "End date: " + ft(t.props.endDate, {
          dateFormat: c,
          locale: s
        }) : "") : t.props.showTimeSelectOnly ? u = "Selected time: ".concat(ft(t.props.selected, { dateFormat: i, locale: s })) : t.props.showYearPicker ? u = "Selected year: ".concat(ft(t.props.selected, { dateFormat: "yyyy", locale: s })) : t.props.showMonthYearPicker ? u = "Selected month: ".concat(ft(t.props.selected, { dateFormat: "MMMM yyyy", locale: s })) : t.props.showQuarterYearPicker ? u = "Selected quarter: ".concat(ft(t.props.selected, {
          dateFormat: "yyyy, QQQ",
          locale: s
        })) : u = "Selected date: ".concat(ft(t.props.selected, {
          dateFormat: c,
          locale: s
        })), P.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, u);
      }, t.renderDateInput = function() {
        var a, o, i, s = Te(t.props.className, (a = {}, a[_l] = t.state.open, a)), l = t.props.customInput || P.createElement("input", { type: "text" }), c = t.props.customInputRef || "ref", u = t.props, d = u.dateFormat, f = d === void 0 ? r.defaultProps.dateFormat : d, p = u.locale, h = typeof t.props.value == "string" ? t.props.value : typeof t.state.inputValue == "string" ? t.state.inputValue : t.props.selectsRange ? JD(t.props.startDate, t.props.endDate, {
          dateFormat: f,
          locale: p
        }) : t.props.selectsMultiple ? ZD((i = t.props.selectedDates) !== null && i !== void 0 ? i : [], {
          dateFormat: f,
          locale: p
        }) : ft(t.props.selected, {
          dateFormat: f,
          locale: p
        });
        return ku(l, (o = {}, o[c] = function(m) {
          t.input = m;
        }, o.value = h, o.onBlur = t.handleBlur, o.onChange = t.handleChange, o.onClick = t.onInputClick, o.onFocus = t.handleFocus, o.onKeyDown = t.onInputKeyDown, o.id = t.props.id, o.name = t.props.name, o.form = t.props.form, o.autoFocus = t.props.autoFocus, o.placeholder = t.props.placeholderText, o.disabled = t.props.disabled, o.autoComplete = t.props.autoComplete, o.className = Te(l.props.className, s), o.title = t.props.title, o.readOnly = t.props.readOnly, o.required = t.props.required, o.tabIndex = t.props.tabIndex, o["aria-describedby"] = t.props.ariaDescribedBy, o["aria-invalid"] = t.props.ariaInvalid, o["aria-labelledby"] = t.props.ariaLabelledBy, o["aria-required"] = t.props.ariaRequired, o));
      }, t.renderClearButton = function() {
        var a = t.props, o = a.isClearable, i = a.disabled, s = a.selected, l = a.startDate, c = a.endDate, u = a.clearButtonTitle, d = a.clearButtonClassName, f = d === void 0 ? "" : d, p = a.ariaLabelClose, h = p === void 0 ? "Close" : p, m = a.selectedDates;
        return o && (s != null || l != null || c != null || m != null && m.length) ? P.createElement("button", { type: "button", className: Te("react-datepicker__close-icon", f, { "react-datepicker__close-icon--disabled": i }), disabled: i, "aria-label": h, onClick: t.onClearClick, title: u, tabIndex: -1 }) : null;
      }, t.state = t.calcInitialState(), t.preventFocusTimeout = void 0, t;
    }
    return Object.defineProperty(r, "defaultProps", {
      get: function() {
        return {
          allowSameDay: !1,
          dateFormat: "MM/dd/yyyy",
          dateFormatCalendar: "LLLL yyyy",
          onChange: function() {
          },
          disabled: !1,
          disabledKeyboardNavigation: !1,
          dropdownMode: "scroll",
          onFocus: function() {
          },
          onBlur: function() {
          },
          onKeyDown: function() {
          },
          onInputClick: function() {
          },
          onSelect: function() {
          },
          onClickOutside: function() {
          },
          onMonthChange: function() {
          },
          onCalendarOpen: function() {
          },
          onCalendarClose: function() {
          },
          preventOpenOnFocus: !1,
          onYearChange: function() {
          },
          onInputError: function() {
          },
          monthsShown: 1,
          readOnly: !1,
          withPortal: !1,
          selectsDisabledDaysInRange: !1,
          shouldCloseOnSelect: !0,
          showTimeSelect: !1,
          showTimeInput: !1,
          showPreviousMonths: !1,
          showMonthYearPicker: !1,
          showFullMonthYearPicker: !1,
          showTwoColumnMonthYearPicker: !1,
          showFourColumnMonthYearPicker: !1,
          showYearPicker: !1,
          showQuarterYearPicker: !1,
          showWeekPicker: !1,
          strictParsing: !1,
          swapRange: !1,
          timeIntervals: 30,
          timeCaption: "Time",
          previousMonthAriaLabel: "Previous Month",
          previousMonthButtonLabel: "Previous Month",
          nextMonthAriaLabel: "Next Month",
          nextMonthButtonLabel: "Next Month",
          previousYearAriaLabel: "Previous Year",
          previousYearButtonLabel: "Previous Year",
          nextYearAriaLabel: "Next Year",
          nextYearButtonLabel: "Next Year",
          timeInputLabel: "Time",
          enableTabLoop: !0,
          yearItemNumber: Ur,
          focusSelectedMonth: !1,
          showPopperArrow: !0,
          excludeScrollbar: !0,
          customTimeInput: null,
          calendarStartDay: void 0,
          toggleCalendarOnIconClick: !1,
          usePointerEvent: !1
        };
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.componentDidMount = function() {
      window.addEventListener("scroll", this.onScroll, !0), document.addEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    }, r.prototype.componentDidUpdate = function(e, t) {
      var a, o, i, s;
      e.inline && jk(e.selected, this.props.selected) && this.setPreSelection(this.props.selected), this.state.monthSelectedIn !== void 0 && e.monthsShown !== this.props.monthsShown && this.setState({ monthSelectedIn: 0 }), e.highlightDates !== this.props.highlightDates && this.setState({
        highlightDates: hl(this.props.highlightDates)
      }), !t.focused && !kn(e.selected, this.props.selected) && this.setState({ inputValue: null }), t.open !== this.state.open && (t.open === !1 && this.state.open === !0 && ((o = (a = this.props).onCalendarOpen) === null || o === void 0 || o.call(a)), t.open === !0 && this.state.open === !1 && ((s = (i = this.props).onCalendarClose) === null || s === void 0 || s.call(i)));
    }, r.prototype.componentWillUnmount = function() {
      this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0), document.removeEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    }, r.prototype.renderInputContainer = function() {
      var e = this.props, t = e.showIcon, a = e.icon, o = e.calendarIconClassname, i = e.calendarIconClassName, s = e.toggleCalendarOnIconClick, l = this.state.open;
      return o && console.warn("calendarIconClassname props is deprecated. should use calendarIconClassName props."), P.createElement(
        "div",
        { className: "react-datepicker__input-container".concat(t ? " react-datepicker__view-calendar-icon" : "") },
        t && P.createElement(Wk, ie({ icon: a, className: Te(i, !i && o, l && "react-datepicker-ignore-onclickoutside") }, s ? {
          onClick: this.toggleCalendar
        } : null)),
        this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(),
        this.renderDateInput(),
        this.renderClearButton()
      );
    }, r.prototype.render = function() {
      var e = this.renderCalendar();
      if (this.props.inline)
        return e;
      if (this.props.withPortal) {
        var t = this.state.open ? P.createElement(
          hf,
          { enableTabLoop: this.props.enableTabLoop },
          P.createElement("div", { className: "react-datepicker__portal", tabIndex: -1, onKeyDown: this.onPortalKeyDown }, e)
        ) : null;
        return this.state.open && this.props.portalId && (t = P.createElement(pf, ie({ portalId: this.props.portalId }, this.props), t)), P.createElement(
          "div",
          null,
          this.renderInputContainer(),
          t
        );
      }
      return P.createElement(Uk, ie({}, this.props, { className: this.props.popperClassName, hidePopper: !this.isCalendarOpen(), targetComponent: this.renderInputContainer(), popperComponent: e, popperOnKeyDown: this.onPopperKeyDown, showArrow: this.props.showPopperArrow }));
    }, r;
  }(Me)
), Vk = "input", ei = "navigate";
const Gk = (e) => {
  var t = e, {
    className: n
  } = t, r = Re(t, [
    "className"
  ]);
  return /* @__PURE__ */ y(zk, E(w({}, r), { calendarClassName: n }));
}, Kk = Z(Gk)`
  border: none;
  background-color: ${({ theme: n }) => n.general.backgroundColor};
  display: flex;
  align-items: stretch;
  flex-direction: column;
  padding-bottom: 5px;
  .react-datepicker__header {
    background-color: ${({ theme: n }) => n.general.backgroundColor};
    border-bottom: none;
    padding-bottom: 0;
    & > div > button {
      height: 34px;
      width: 34px;
      &:hover {
        background-color: ${({ theme: n }) => kt(n.general.backgroundColor)};
        transition: 0.1s;
      }
      &:disabled {
        background-color: ${({ theme: n }) => n.general.backgroundColor};
      }
    }
  }
  .react-datepicker__day-name {
    color: ${({ theme: n }) => n.typography.primaryTextColor};
    font-weight: 700;
  }
  .react-datepicker__day {
    width: 32px;
    height: 32px;
    line-height: 32px;
    margin-left: 0;
    margin-right: 0;
    margin-top: 1px;
    margin-bottom: 1px;
    border-radius: 100%;
    background-color: ${({ theme: n }) => n.general.backgroundColor};
    color: ${({ theme: n }) => n.typography.primaryTextColor};
    position: relative;
    z-index: 1;
    &:hover {
      background-color: ${({ theme: n }) => n.general.brandColor};
      color: ${({ theme: n }) => n.typography.primaryTextColor};
      transition: 0.1s;
    }

    // before - background highlight
    &:before {
      content: '';
      position: absolute;
      display: block;
      background-color: ${({ theme: n }) => vt(n.general.brandColor, 0.5)};
      width: 100%;
      height: 100%;
      z-index: -1;
      left: 0%;
      visibility: hidden;
    }

    // rounds ends of the week rows
    &:first-of-type:before {
      border-radius: 100% 0 0 100%;
    }
    &:last-of-type:before {
      border-radius: 0 100% 100% 0;
    }

    // after - "bright circle" highlight
    &:after {
      content: '';
      position: absolute;
      display: block;
      background-color: ${({ theme: n }) => n.general.brandColor};
      width: 100%;
      padding-top: 100%;
      top: 50%;
      transform: translateY(-50%);
      border-radius: 100%;
      z-index: -1;
      visibility: hidden;
    }
  }

  // ----------------- Days in range styling ------------------------------
  .react-datepicker__day--in-range:before {
    visibility: visible;
  }

  .react-datepicker__day--in-range.react-datepicker__day--selecting-range-start {
    &:before {
      border-radius: 100% 0 0 100%;
    }
  }
  .react-datepicker__day--in-range.react-datepicker__day--selecting-range-end {
    &:before {
      border-radius: 0 100% 100% 0;
    }
  }
  .react-datepicker__day--in-range.react-datepicker__day--selecting-range-start.react-datepicker__day--selecting-range-end {
    border-radius: 100%;
  }

  // Days in range that becomes out of selecting range when user is hovering dates in calendar
  .react-datepicker__month--selecting-range .react-datepicker__day--in-range {
    &:not(.react-datepicker__day--in-selecting-range) {
      background-color: ${({ theme: n }) => n.general.backgroundColor};
      color: ${({ theme: n }) => n.typography.secondaryTextColor};
      &:before {
        visibility: visible;
        background-color: ${({ theme: n }) => vt(n.general.brandColor, 0.15)};
      }
    }
  }

  // Selecting days out of existing range
  .react-datepicker__month--selecting-range .react-datepicker__day--in-selecting-range {
    &:not(.react-datepicker__day--in-range) {
      &:before {
        visibility: visible;
        background-color: ${({ theme: n }) => vt(n.general.brandColor, 0.15)};
      }
      &.react-datepicker__day--selecting-range-start:before {
        border-radius: 100% 0 0 100%;
      }
      &.react-datepicker__day--selecting-range-end:before {
        border-radius: 0 100% 100% 0;
      }
      color: ${({ theme: n }) => n.typography.secondaryTextColor};
    }
  }

  // Hide background highlighting if range-start and range-end is the same day (when selecting range)
  .react-datepicker__month--selecting-range
    .react-datepicker__day:not(.react-datepicker__day--in-selecting-range) {
    &.react-datepicker__day--range-start.react-datepicker__day--range-end {
      &:before {
        visibility: hidden;
      }
    }
  }

  // ----------------- Range start and end styling ------------------------------
  .react-datepicker__month--selecting-range .react-datepicker__day--selecting-range-start,
  .react-datepicker__day--range-start,
  .react-datepicker__day--range-end,
  .react-datepicker__month--selecting-range .react-datepicker__day--selecting-range-end {
    &:after {
      visibility: visible;
    }

    &:before {
      visibility: visible;
      background-color: ${({ theme: n }) => vt(n.general.brandColor, 0.5)};
    }

    &.react-datepicker__day--range-start:not(.react-datepicker__day--range-end) {
      &:before {
        border-radius: 100% 0 0 100%;
      }
    }

    &.react-datepicker__day--range-end:not(.react-datepicker__day--range-start) {
      &:before {
        border-radius: 0 100% 100% 0;
      }
    }
  }

  // Hide background highlighting if range-start and range-end is the same day
  .react-datepicker__month:not(.react-datepicker__month--selecting-range)
    .react-datepicker__day--range-start.react-datepicker__day--range-end {
    &:before {
      visibility: hidden;
    }
  }

  // ----------------- Fixing react-datepicker internal bugs with wrong classes applied ------------------------------

  // Fix react-datepicker bug with 'react-datepicker__day--selecting-range-start' class duplicated in each month
  .react-datepicker__month:not(.react-datepicker__month--selecting-range)
    .react-datepicker__day--selecting-range-start:not(.react-datepicker__day--range-start) {
    &:not(:first-of-type):not(:last-of-type) {
      &:before {
        border-radius: 0;
      }
      &.react-datepicker__day--range-end {
        &:before {
          border-radius: 0 100% 100% 0;
        }
      }
    }
    &:first-of-type {
      &:before {
        border-radius: 100% 0 0 100%;
      }
    }
    &:last-of-type {
      &:before {
        border-radius: 0 100% 100% 0;
      }
    }
  }

  // Fix react-datepicker bug with 'react-datepicker__day--selecting-range-end' class duplicated in each month
  .react-datepicker__month:not(.react-datepicker__month--selecting-range)
    .react-datepicker__day--selecting-range-end:not(.react-datepicker__day--range-end) {
    &:not(:first-of-type):not(:last-of-type) {
      &:before {
        border-radius: 0;
      }
      &.react-datepicker__day--range-start {
        &:before {
          border-radius: 100% 0 0 100%;
        }
      }
    }
    &:first-of-type {
      &:before {
        border-radius: 100% 0 0 100%;
      }
    }
    &:last-of-type {
      &:before {
        border-radius: 0 100% 100% 0;
      }
    }
  }

  // ------------------------------------------------------

  // Fix cases when selected the same day for start and end:
  .react-datepicker__month--selecting-range
    .react-datepicker__day--range-start.react-datepicker__day--range-end {
    &.react-datepicker__day--selecting-range-end {
      &:before {
        background-color: ${({ theme: n }) => vt(n.general.brandColor, 0.15)};
        visibility: visible;
      }
    }
    &.react-datepicker__day--selecting-range-start {
      &:before {
        background-color: ${({ theme: n }) => vt(n.general.brandColor, 0.15)};
        visibility: visible;
      }
    }
  }

  .react-datepicker__day--disabled {
    color: ${({ theme: n }) => vt(n.typography.primaryTextColor, 0.5)};
  }

  // Hover on day out of the possible selecting range
  // (trying to select 'start day' after selected 'end day' and vice versa)
  .react-datepicker__month--selecting-range .react-datepicker__day {
    &:not(.react-datepicker__day--in-range),
    &:not(.react-datepicker__day--in-selecting-range) {
      &:hover {
        &:after {
          visibility: visible;
          background-color: ${({ theme: n }) => n.general.brandColor};
        }
      }
    }
  }

  .react-datepicker__day--selected {
    &:after {
      visibility: visible;
    }
  }

  // ---------- Smooth background transition during selection new range ends ---------------

  .react-datepicker__month--selecting-range {
    .react-datepicker__day--selecting-range-start,
    .react-datepicker__day--range-start.react-datepicker__day--in-selecting-range:not(
        .react-datepicker__day--selecting-range-start
      ) {
      &.react-datepicker__day--in-range:not(
          .react-datepicker__day--range-start.react-datepicker__day--selecting-range-start,
          .react-datepicker__day--range-end.react-datepicker__day--selecting-range-end
        ) {
        &:before {
          border-radius: 0;
          background: linear-gradient(
            to right,
            ${({ theme: n }) => vt(n.general.brandColor, 0.15)} 50%,
            ${({ theme: n }) => vt(n.general.brandColor, 0.5)} 50%
          );
        }
      }
    }
  }

  .react-datepicker__month--selecting-range {
    .react-datepicker__day--selecting-range-end,
    .react-datepicker__day--range-end.react-datepicker__day--in-selecting-range:not(
        .react-datepicker__day--selecting-range-end
      ) {
      &.react-datepicker__day--in-range:not(
          .react-datepicker__day--range-start.react-datepicker__day--selecting-range-start,
          .react-datepicker__day--range-end.react-datepicker__day--selecting-range-end
        ) {
        &:before {
          border-radius: 0;
          background: linear-gradient(
            to right,
            ${({ theme: n }) => vt(n.general.brandColor, 0.5)} 50%,
            ${({ theme: n }) => vt(n.general.brandColor, 0.15)} 50%
          );
        }
      }
    }
  }

  // ------------------------------------------------------
`, Dl = (n) => {
  var t;
  const r = n.direction === "left" ? "csdk-scale-x-[-1]" : "", e = n.disabled ? "csdk-opacity-0" : "";
  return /* @__PURE__ */ y(
    "svg",
    E(w({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, n), {
      className: [n.className, r, e].join(" "),
      children: /* @__PURE__ */ y(
        "path",
        {
          fill: (t = n.fill) != null ? t : n.theme.typography.primaryTextColor,
          fillRule: "nonzero",
          d: "M13.34 12.5l-2.72-3.175a.5.5 0 1 1 .76-.65l2.998 3.5a.5.5 0 0 1 0 .65l-2.998 3.5a.5.5 0 1 1-.76-.65l2.72-3.175z"
        }
      )
    })
  );
}, kl = (n) => {
  var t;
  const r = n.direction === "left" ? "csdk-scale-x-[-1]" : "", e = n.disabled ? "csdk-opacity-0" : "";
  return /* @__PURE__ */ y(
    "svg",
    E(w({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, n), {
      className: [n.className, r, e].join(" "),
      children: /* @__PURE__ */ y(
        "path",
        {
          fill: (t = n.fill) != null ? t : n.theme.typography.primaryTextColor,
          fillRule: "nonzero",
          d: "M11.34 12.5L8.62 9.325a.5.5 0 0 1 .76-.65l2.998 3.5a.5.5 0 0 1 0 .65l-2.998 3.5a.5.5 0 1 1-.76-.65l2.72-3.175zm.279-3.175a.5.5 0 0 1 .76-.65l2.998 3.5a.5.5 0 0 1 0 .65l-2.999 3.5a.5.5 0 1 1-.76-.65l2.72-3.175-2.72-3.175z"
        }
      )
    })
  );
}, Xk = Z.span`
  font-size: 13px;
  font-weight: 700;
  color: ${({ theme: n }) => n.typography.primaryTextColor};
  width: 70px;
  text-align: center;
`, ua = Z.button`
  border: none;
  background-color: transparent;
  color: ${({ theme: n, disabled: r }) => r ? "transparent" : n.typography.primaryTextColor};
  margin: 0 5px;
  :hover {
    border-radius: 50%;

    font-weight: 500;
  }
`, Jk = Z.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem 10px;
`, Zk = (n) => {
  const r = ke(n.date).year(), { themeSettings: e } = ve();
  return /* @__PURE__ */ J(Jk, { children: [
    /* @__PURE__ */ y(
      ua,
      {
        onClick: () => {
          n.changeYear(r - 1);
        },
        theme: e,
        disabled: n.prevMonthButtonDisabled,
        children: /* @__PURE__ */ y(
          kl,
          {
            direction: "left",
            disabled: n.prevMonthButtonDisabled,
            className: "csdk-transition",
            theme: e
          }
        )
      }
    ),
    /* @__PURE__ */ y(
      ua,
      {
        theme: e,
        onClick: n.decreaseMonth,
        disabled: n.prevMonthButtonDisabled,
        children: /* @__PURE__ */ y(
          Dl,
          {
            direction: "left",
            disabled: n.prevMonthButtonDisabled,
            className: "csdk-transition",
            theme: e
          }
        )
      }
    ),
    /* @__PURE__ */ y(Xk, { theme: e, children: ke(n.date).format("MMM YYYY") }),
    /* @__PURE__ */ y(
      ua,
      {
        theme: e,
        onClick: n.increaseMonth,
        disabled: n.nextMonthButtonDisabled,
        children: /* @__PURE__ */ y(
          Dl,
          {
            direction: "right",
            disabled: n.nextMonthButtonDisabled,
            className: "csdk-transition",
            theme: e
          }
        )
      }
    ),
    /* @__PURE__ */ y(
      ua,
      {
        theme: e,
        onClick: () => {
          n.changeYear(r + 1);
        },
        disabled: n.nextMonthButtonDisabled,
        children: /* @__PURE__ */ y(
          kl,
          {
            direction: "right",
            disabled: n.nextMonthButtonDisabled,
            className: "csdk-transition",
            theme: e
          }
        )
      }
    )
  ] });
}, xl = Z(yd)`
  background-color: #edeef1;
  color: ${({ theme: n }) => n.general.primaryButtonTextColor};
  &:hover {
    background-color: ${() => kt("#edeef1")};
    transition: 0.2s;
  }
`, ex = Z(
  fv
)`
  background-color: #edeef1;
  color: ${({ theme: n }) => n.general.primaryButtonTextColor};
  &:hover {
    background-color: ${() => kt("#edeef1")};
    transition: 0.2s;
  }
`, tx = Z.div`
  background-color: ${({ theme: n }) => n.general.backgroundColor};
`, nx = (n) => {
  var c, u;
  const { themeSettings: r } = ve(), { t: e } = We(), t = ke(/* @__PURE__ */ new Date()), a = (c = n.limit) == null ? void 0 : c.maxDate, o = (u = n.limit) == null ? void 0 : u.minDate, i = o && t.isBefore(o), s = a && t.isAfter(a), l = i || s;
  return /* @__PURE__ */ J(
    tx,
    {
      className: "csdk-flex csdk-justify-evenly csdk-gap-1 csdk-p-[10px] csdk-pb-[0px]",
      theme: r,
      children: [
        /* @__PURE__ */ y(
          xl,
          {
            onClick: () => {
              var f;
              const d = ke(((f = n.limit) == null ? void 0 : f.minDate) || /* @__PURE__ */ new Date());
              n.onDateSelected(d);
            },
            theme: r,
            style: { visibility: n.enabledButtons.includes("earliest") ? "visible" : "hidden" },
            children: e("dateFilter.earliestDate")
          }
        ),
        /* @__PURE__ */ y(
          ex,
          {
            onClick: () => {
              const d = ke(/* @__PURE__ */ new Date());
              n.onDateSelected(d);
            },
            disabled: l,
            tooltipTitle: e("dateFilter.todayOutOfRange"),
            disableTooltip: !l,
            theme: r,
            style: { visibility: n.enabledButtons.includes("today") ? "visible" : "hidden" },
            children: e("dateFilter.today")
          }
        ),
        /* @__PURE__ */ y(
          xl,
          {
            onClick: () => {
              var f;
              const d = ke(((f = n.limit) == null ? void 0 : f.maxDate) || /* @__PURE__ */ new Date());
              n.onDateSelected(d);
            },
            theme: r,
            style: { visibility: n.enabledButtons.includes("latest") ? "visible" : "hidden" },
            children: e("dateFilter.latestDate")
          }
        )
      ]
    }
  );
};
function rx(n, r, e) {
  const t = r.isBefore(n.from), a = r.isAfter(n.to);
  let o, i;
  return e === "fromSelector" ? a ? (o = r, i = r) : (o = r, i = n.to) : t ? (o = r, i = r) : (o = n.from, i = r), {
    from: o,
    to: i
  };
}
function mf({
  selectedDateRange: n,
  limit: r,
  onDateRangeChanged: e,
  selectorMode: t,
  onSelectorModeChanged: a,
  onDateChanged: o,
  selectedDate: i
}) {
  var h, m;
  const s = (g) => {
    t === "pointSelector" && o ? o(g) : r && e && a && n && (e == null || e(
      rx(
        { from: n.from, to: n.to },
        g,
        t
      )
    ), a(t === "fromSelector" ? "toSelector" : "fromSelector"));
  }, { themeSettings: l } = ve(), c = n == null ? void 0 : n.from.toDate(), u = n == null ? void 0 : n.to.toDate(), d = (h = r == null ? void 0 : r.minDate) == null ? void 0 : h.toDate(), f = (m = r == null ? void 0 : r.maxDate) == null ? void 0 : m.toDate(), p = [d && "earliest", "today", f && "latest"].filter(
    (g) => g !== void 0
  );
  return /* @__PURE__ */ J(
    "div",
    {
      style: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        backgroundColor: l.general.backgroundColor
      },
      "aria-label": "date range filter calendar container",
      children: [
        r && /* @__PURE__ */ y(
          nx,
          {
            enabledButtons: p,
            limit: r,
            onDateSelected: (g) => {
              s(ke(g));
            }
          }
        ),
        /* @__PURE__ */ y(
          Kk,
          {
            theme: l,
            selected: t === "pointSelector" ? i == null ? void 0 : i.toDate() : t === "fromSelector" ? c : u,
            onChange: (g) => {
              g instanceof Date && s(ke(g));
            },
            startDate: c,
            endDate: u,
            minDate: d,
            maxDate: f,
            selectsStart: t === "fromSelector",
            selectsEnd: t === "toSelector",
            renderCustomHeader: (g) => /* @__PURE__ */ y(Zk, w({}, g)),
            inline: !0,
            fixedHeight: !0,
            disabledKeyboardNavigation: !0
          }
        )
      ]
    }
  );
}
const Gn = "YYYY-MM-DD", ax = "date-range";
function ox(n) {
  var b, v, D, k;
  const r = it(null), [e, t] = me(!1), a = () => {
    t(!1);
  }, o = e ? "simple-popover" : void 0, { from: i, to: s } = n.value, l = ke(i || ((b = n.limit) == null ? void 0 : b.minDate)), c = ke(s || ((v = n.limit) == null ? void 0 : v.maxDate)), u = {
    maxDate: ke((D = n.limit) == null ? void 0 : D.maxDate),
    minDate: ke((k = n.limit) == null ? void 0 : k.minDate)
  }, [d, f] = me("fromSelector"), p = (x) => {
    f(x), t(!0);
  }, { themeSettings: h } = ve(), { t: m } = We(), g = n.variant || "grey";
  return /* @__PURE__ */ J("div", { children: [
    n.isDependent && /* @__PURE__ */ y("div", { className: "csdk-h-[20px]", children: /* @__PURE__ */ y(vd, {}) }),
    /* @__PURE__ */ J(
      "div",
      {
        "aria-label": "date range filter",
        className: "csdk-w-fit csdk-flex csdk-flex-wrap",
        ref: r,
        children: [
          /* @__PURE__ */ y(
            si,
            {
              value: l ? l.format(Gn) : m("dateFilter.select"),
              label: m("dateFilter.from"),
              onClick: () => p("fromSelector"),
              isActive: e && d === "fromSelector",
              theme: h,
              variant: g,
              disabled: n.disabled
            }
          ),
          /* @__PURE__ */ y(
            si,
            {
              onClick: () => p("toSelector"),
              value: c ? c.format(Gn) : m("dateFilter.today"),
              label: m("dateFilter.to"),
              isActive: e && d === "toSelector",
              theme: h,
              variant: g,
              disabled: n.disabled
            }
          ),
          /* @__PURE__ */ y(
            Gl,
            {
              id: o,
              open: e,
              anchorEl: r.current,
              onClose: a,
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "center"
              },
              transformOrigin: {
                vertical: "top",
                horizontal: "center"
              },
              children: /* @__PURE__ */ y(
                mf,
                {
                  selectorMode: d,
                  onDateRangeChanged: (x) => {
                    n.onChange({
                      type: ax,
                      filter: {
                        from: x.from.format(Gn),
                        to: x.to.format(Gn)
                      }
                    });
                  },
                  onSelectorModeChanged: (x) => {
                    f(x);
                  },
                  selectedDateRange: { from: l, to: c },
                  limit: u
                }
              )
            }
          )
        ]
      }
    )
  ] });
}
const Cl = (n) => {
  const {
    filter: r,
    attribute: e,
    onChange: t,
    parentFilters: a,
    dateLimits: o,
    isOldDateRangeFilterTile: i,
    disabled: s
  } = n, l = a && (a == null ? void 0 : a.filter((d) => d && d !== null)), c = r.from || (o == null ? void 0 : o.minDate), u = r.to || (o == null ? void 0 : o.maxDate);
  return /* @__PURE__ */ y(
    ox,
    {
      onChange: (d) => {
        const f = Mh(
          e,
          d.filter.from,
          d.filter.to
        );
        t(f);
      },
      value: {
        from: c,
        to: u
      },
      limit: o,
      isDependent: l && l.length > 0,
      variant: i ? "grey" : "white",
      disabled: s
    }
  );
}, ix = ({ filter: n }) => {
  const { t: r } = We(), { from: e, to: t } = n, a = e && t ? "from-to" : e ? "only-from" : "only-to", o = pe(() => {
    switch (a) {
      case "from-to":
        return r("dateFilter.dateRange.fromTo", { from: e, to: t });
      case "only-from":
        return r("dateFilter.dateRange.from", { val: e });
      case "only-to":
        return r("dateFilter.dateRange.to", { val: t });
      default:
        return "";
    }
  }, [a, e, t, r]);
  return /* @__PURE__ */ y("div", { className: "csdk-leading-[26px] csdk-mx-auto csdk-my-2 csdk-px-1 csdk-text-[13px] csdk-whitespace-nowrap csdk-flex csdk-flex-wrap csdk-gap-x-1 csdk-justify-center", children: o });
}, sx = (n, r, e, t) => {
  const [a, o] = me(null), { isInitialized: i, app: s } = Ye(), l = Pp(), c = !cx(n) && i && s;
  return ge(() => {
    if (!c)
      return;
    const u = r.dataSource ? Fi(r.dataSource) : e;
    Ai(
      {
        dataSource: u,
        measures: [Ph(r), Ah(r)],
        filters: t
      },
      s
    ).then((d) => {
      const f = d.rows[0];
      o({
        minDate: f[0].data,
        maxDate: f[1].data
      });
    }).catch((d) => l(d));
  }, [s, r, e, c, t, l]), lx(n, a);
};
function cx(n) {
  return n.minDate !== void 0 && n.maxDate !== void 0;
}
function lx(n, r) {
  var a, o;
  const e = (a = n.minDate) != null ? a : r == null ? void 0 : r.minDate, t = (o = n.maxDate) != null ? o : r == null ? void 0 : r.maxDate;
  return e && t ? { minDate: e, maxDate: t } : null;
}
const gf = se({ componentName: "DateRangeFilterTile" })(
  ({
    filter: n,
    onChange: r,
    title: e,
    earliestDate: t,
    lastDate: a,
    attribute: o,
    dataSource: i,
    parentFilters: s,
    tiled: l = !1,
    tileDesignOptions: c
  }) => {
    const { filter: u, updateFilter: d } = $r(n, r);
    if (!Li(u))
      throw new ne("errors.invalidFilterType");
    const f = sx(
      {
        minDate: t,
        maxDate: a
      },
      o,
      i,
      s
    );
    return l ? /* @__PURE__ */ y(
      mn,
      {
        title: e,
        renderContent: (p) => p || !f ? /* @__PURE__ */ y(ix, { filter: u }) : /* @__PURE__ */ y("div", { className: "csdk-mt-2 csdk-ml-2 csdk-mb-1", children: /* @__PURE__ */ y(
          Cl,
          {
            filter: u,
            dateLimits: f,
            disabled: u.disabled,
            onChange: d,
            title: e,
            attribute: o
          }
        ) }),
        onToggleDisabled: () => {
          const p = za(u);
          d(p);
        },
        disabled: u.disabled,
        design: c,
        locked: u.locked
      }
    ) : f ? /* @__PURE__ */ y(
      Cl,
      {
        filter: u,
        dateLimits: f,
        isOldDateRangeFilterTile: !0,
        onChange: d,
        title: e,
        attribute: o
      }
    ) : null;
  }
);
var yf = { exports: {} };
(function(n, r) {
  (function(e, t) {
    n.exports = t();
  })(Le, function() {
    return function(e, t, a) {
      t.prototype.isToday = function() {
        var o = "YYYY-MM-DD", i = a();
        return this.format(o) === i.format(o);
      };
    };
  });
})(yf);
var ux = yf.exports;
const gs = /* @__PURE__ */ Ri(ux);
ke.extend(gs);
const dx = (n) => {
  var b;
  const { filter: r, arrangement: e = "horizontal", onUpdate: t, disabled: a, limit: o } = n, i = r.operator, s = r.count, l = r.attribute, c = ke(r.anchor), u = {
    maxDate: o ? ke(o.maxDate) : void 0,
    minDate: o ? ke(o == null ? void 0 : o.minDate) : void 0
  }, { t: d } = We(), [f, p] = me(!1), h = it(null), { themeSettings: m } = ve(), g = (v, D, k, x) => {
    if (!(v || D || k || x))
      return;
    const R = v != null ? v : i, I = D != null ? D : s, L = k != null ? k : l.granularity;
    x !== void 0 && (x = ke(x));
    const A = x != null ? x : c, W = new ri(L, l.expression, L);
    let O;
    switch (R) {
      case xa.Last:
        O = Nh(
          W,
          0,
          I,
          A.isToday() ? void 0 : A.toDate()
        );
        break;
      case xa.Next:
        O = Oh(
          W,
          0,
          I,
          A.isToday() ? void 0 : A.toDate()
        );
        break;
      default:
        throw new ne("errors.dateFilterIncorrectOperator", {
          operator: R
        });
    }
    t(O);
  };
  return /* @__PURE__ */ J(
    "div",
    {
      className: `csdk-flex ${zt(e) ? "csdk-flex-col" : "csdk-flex-row"} csdk-mb-px`,
      children: [
        /* @__PURE__ */ J("div", { className: "csdk-flex csdk-justify-between csdk-items-center csdk-h-6 csdk-my-1", children: [
          /* @__PURE__ */ y("div", { className: "csdk-h-6", children: /* @__PURE__ */ y(
            ci,
            {
              selectedIdx: Object.keys(wa).indexOf(i),
              elements: Object.keys(wa).map((v) => /* @__PURE__ */ y(
                "div",
                {
                  onClick: () => {
                    i !== v && g(v, void 0, void 0, void 0);
                  },
                  children: d(wa[v])
                }
              )),
              disabled: a
            }
          ) }),
          /* @__PURE__ */ y(
            Mr,
            {
              className: "csdk-w-[60px]",
              type: "number",
              placeholder: d("dateFilter.count"),
              value: (b = s == null ? void 0 : s.toString()) != null ? b : "",
              callback: (v) => {
                v !== "" && g(void 0, Number(v), void 0, void 0);
              },
              required: !0,
              disabled: a
            }
          ),
          /* @__PURE__ */ y("div", { className: "csdk-h-6", children: /* @__PURE__ */ y(
            ci,
            {
              selectedIdx: Object.keys(_a).indexOf(l.granularity),
              elements: Object.keys(_a).map((v) => /* @__PURE__ */ y(
                "div",
                {
                  onClick: () => {
                    l.granularity !== v && g(void 0, void 0, v, void 0);
                  },
                  children: d(_a[v])
                }
              )),
              disabled: a
            }
          ) })
        ] }),
        /* @__PURE__ */ J(
          "div",
          {
            ref: h,
            className: "csdk-flex csdk-justify-end csdk-items-center csdk-h-6 csdk-my-1",
            children: [
              /* @__PURE__ */ y("div", { className: "csdk-text-[13px] csdk-ml-[5px] csdk-mr-2", children: d("dateFilter.from") }),
              /* @__PURE__ */ y(
                si,
                {
                  onClick: () => p(!0),
                  value: c ? c.format(Gn) : d("dateFilter.today"),
                  isActive: f,
                  theme: m,
                  variant: "white",
                  disabled: a
                }
              ),
              /* @__PURE__ */ y(
                Gl,
                {
                  id: "simple-popover",
                  open: f,
                  anchorEl: h.current,
                  onClose: () => p(!1),
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                  },
                  children: /* @__PURE__ */ y(
                    mf,
                    {
                      selectorMode: "pointSelector",
                      limit: u,
                      onDateChanged: (v) => {
                        v !== c && (g(void 0, void 0, void 0, v), p(!1));
                      },
                      selectedDate: c
                    }
                  )
                }
              )
            ]
          }
        )
      ]
    }
  );
}, wa = {
  [xa.Last]: "dateFilter.last",
  [xa.Next]: "dateFilter.next"
}, _a = {
  [Ie.Days]: "dateFilter.days",
  [Ie.Weeks]: "dateFilter.weeks",
  [Ie.Months]: "dateFilter.months",
  [Ie.Quarters]: "dateFilter.quarters",
  [Ie.Years]: "dateFilter.years"
};
ke.extend(gs);
const fx = (n) => {
  const { filter: r } = n, { t: e } = We(), t = e(wa[r.operator]), a = r.count.toString(), o = e(_a[r.attribute.granularity]), i = r.anchor && !ke(r.anchor).isToday() ? ke(r.anchor).format(Gn) : e("dateFilter.today");
  return /* @__PURE__ */ y("div", { className: "csdk-leading-[26px] csdk-mx-auto csdk-my-2 csdk-px-1 csdk-text-[13px] csdk-whitespace-nowrap csdk-flex csdk-flex-wrap csdk-gap-x-1 csdk-justify-center", children: `${t} ${a} ${o} ${e(
    "dateFilter.from"
  )} ${i}` });
};
ke.extend(gs);
const bf = se({
  componentName: "RelativeDateFilterTile"
})((n) => {
  const {
    title: r,
    filter: e,
    arrangement: t = "horizontal",
    onUpdate: a,
    limit: o,
    tileDesignOptions: i
  } = n, { filter: s, updateFilter: l } = $r(
    e,
    a
  ), c = s.disabled;
  return /* @__PURE__ */ y(
    mn,
    {
      title: r,
      renderContent: (u) => u && zt(t) ? /* @__PURE__ */ y(fx, { filter: s }) : /* @__PURE__ */ y(
        dx,
        {
          filter: s,
          arrangement: t,
          onUpdate: l,
          disabled: c,
          limit: o
        }
      ),
      onToggleDisabled: () => {
        const u = za(s);
        l(u);
      },
      disabled: c,
      arrangement: t,
      design: i,
      locked: s.locked
    }
  );
}), we = {
  // exclude - special case, contains numeric filter as attribute
  NOT_BETWEEN: `${G.exclude}${Mt.From}${Mt.To}`,
  // ranking
  TOP: `${G.ranking}${rc.Top}`,
  BOTTOM: `${G.ranking}${rc.Bottom}`,
  // numeric
  BETWEEN: `${G.numeric}${Mt.From}${Mt.To}`,
  EQUALS_NUMERIC: `${G.numeric}${Mt.Equals}`,
  NOT_EQUALS_NUMERIC: `${G.numeric}${Mt.DoesntEqual}`,
  LESS_THAN: `${G.numeric}${Mt.ToNotEqual}`,
  LESS_THAN_OR_EQUAL: `${G.numeric}${Mt.To}`,
  GREATER_THAN: `${G.numeric}${Mt.FromNotEqual}`,
  GREATER_THAN_OR_EQUAL: `${G.numeric}${Mt.From}`,
  // text
  EQUALS_TEXT: `${G.text}${Qt.Equals}`,
  NOT_EQUALS_TEXT: `${G.text}${Qt.DoesntEqual}`,
  CONTAINS: `${G.text}${Qt.Contains}`,
  NOT_CONTAIN: `${G.text}${Qt.DoesntContain}`,
  STARTS_WITH: `${G.text}${Qt.StartsWith}`,
  NOT_STARTS_WITH: `${G.text}${Qt.DoesntStartWith}`,
  ENDS_WITH: `${G.text}${Qt.EndsWith}`,
  NOT_ENDS_WITH: `${G.text}${Qt.DoesntEndWith}`,
  LIKE: `${G.text}${Qt.Like}`
}, lr = {
  [we.EQUALS_NUMERIC]: {
    fn: ec,
    inputCount: 1,
    symbols: ["="],
    message: "criteriaFilter.equals",
    ranked: !1,
    type: G.numeric
  },
  [we.NOT_EQUALS_NUMERIC]: {
    fn: tc,
    inputCount: 1,
    symbols: ["≠"],
    message: "criteriaFilter.notEquals",
    ranked: !1,
    type: G.numeric
  },
  [we.LESS_THAN]: {
    fn: Rh,
    inputCount: 1,
    symbols: ["<"],
    message: "criteriaFilter.lessThan",
    ranked: !1,
    type: G.numeric
  },
  [we.LESS_THAN_OR_EQUAL]: {
    fn: Fh,
    inputCount: 1,
    symbols: ["≤"],
    message: "criteriaFilter.lessThanOrEqual",
    ranked: !1,
    type: G.numeric
  },
  [we.GREATER_THAN]: {
    fn: Ih,
    inputCount: 1,
    symbols: [">"],
    message: "criteriaFilter.greaterThan",
    ranked: !1,
    type: G.numeric
  },
  [we.GREATER_THAN_OR_EQUAL]: {
    fn: Lh,
    inputCount: 1,
    symbols: ["≥"],
    message: "criteriaFilter.greaterThanOrEqual",
    ranked: !1,
    type: G.numeric
  },
  [we.BETWEEN]: {
    fn: nc,
    inputCount: 2,
    symbols: ["≥", "≤"],
    message: "criteriaFilter.between",
    ranked: !1,
    type: G.numeric
  },
  [we.NOT_BETWEEN]: {
    fn: (n, r, e, t) => Yh(
      nc(n, r, e),
      void 0,
      t
    ),
    inputCount: 2,
    symbols: ["≤", "≥"],
    message: "criteriaFilter.notBetween",
    ranked: !1,
    type: G.exclude
  },
  [we.TOP]: {
    fn: Wh,
    inputCount: 2,
    symbols: ["Top", "by"],
    message: "criteriaFilter.top",
    ranked: !0,
    type: G.ranking
  },
  [we.BOTTOM]: {
    fn: Hh,
    inputCount: 2,
    symbols: ["Last", "by"],
    message: "criteriaFilter.bottom",
    ranked: !0,
    type: G.ranking
  },
  [we.EQUALS_TEXT]: {
    fn: ec,
    inputCount: 1,
    symbols: [],
    message: "criteriaFilter.equals",
    ranked: !1,
    type: G.text
  },
  [we.NOT_EQUALS_TEXT]: {
    fn: tc,
    inputCount: 1,
    symbols: [],
    message: "criteriaFilter.notEquals",
    ranked: !1,
    type: G.text
  },
  [we.CONTAINS]: {
    fn: $h,
    inputCount: 1,
    symbols: [],
    message: "criteriaFilter.contains",
    ranked: !1,
    type: G.text
  },
  [we.NOT_CONTAIN]: {
    fn: Bh,
    inputCount: 1,
    symbols: [],
    message: "criteriaFilter.notContains",
    ranked: !1,
    type: G.text
  },
  [we.STARTS_WITH]: {
    fn: Qh,
    inputCount: 1,
    symbols: [],
    message: "criteriaFilter.startsWith",
    ranked: !1,
    type: G.text
  },
  [we.NOT_STARTS_WITH]: {
    fn: Uh,
    inputCount: 1,
    symbols: [],
    message: "criteriaFilter.notStartsWith",
    ranked: !1,
    type: G.text
  },
  [we.ENDS_WITH]: {
    fn: qh,
    inputCount: 1,
    symbols: [],
    message: "criteriaFilter.endsWith",
    ranked: !1,
    type: G.text
  },
  [we.NOT_ENDS_WITH]: {
    fn: jh,
    inputCount: 1,
    symbols: [],
    message: "criteriaFilter.notEndsWith",
    ranked: !1,
    type: G.text
  },
  [we.LIKE]: {
    fn: zh,
    inputCount: 1,
    symbols: [],
    message: "criteriaFilter.like",
    ranked: !1,
    type: G.text
  }
}, px = (n) => {
  let r = "", e = "";
  switch (n.filterType) {
    case G.exclude:
      r = n.filter.operatorA, e = n.filter.operatorB;
      break;
    case G.ranking:
      r = n.operator;
      break;
    case G.numeric:
      r = n.operatorA, e = n.operatorB;
      break;
    case G.text:
      r = n.operatorA, r = n.operatorA;
      break;
  }
  const t = `${n.filterType}${r != null ? r : ""}${e != null ? e : ""}`, a = Object.keys(we).find(
    (o) => we[o] == t
  );
  if (we[a] === void 0)
    throw new ne("errors.unsupportedFilter", { filter: JSON.stringify(n) });
  return we[a];
}, hx = (n) => {
  const r = [];
  let e, t;
  switch (n.filterType) {
    case G.exclude:
      e = n.filter.valueA, t = n.filter.valueB;
      break;
    case G.ranking:
      e = n.count, t = n.measure;
      break;
    case G.numeric:
      e = n.valueA, t = n.valueB;
      break;
    case G.text:
      e = n.valueA, t = n.valueB;
      break;
  }
  return e !== void 0 && r.push(e), t !== void 0 && r.push(t), r;
}, mx = (n) => n.map((r) => Dn.isMeasure(r) ? r.name : r), gx = (n, r) => r(n, { val: "---" }).replace("---", ""), qa = (n) => {
  switch (n) {
    case G.exclude:
    case G.ranking:
    case G.numeric:
      return "number";
    case G.text:
    default:
      return "text";
  }
}, Si = (n) => !(isNaN(Number(n)) || n === ""), yx = (n) => {
  var c, u;
  const { filterType: r, defaultValues: e = [], onUpdate: t, disabled: a } = n, o = lr[r], { t: i } = We(), s = o.type === G.text ? {
    containerStyle: {
      flexDirection: "column",
      alignItems: "flex-start"
    },
    labelStyle: {
      margin: "0 0 8px 10px"
    }
  } : {}, l = (u = (c = e == null ? void 0 : e[0]) == null ? void 0 : c.toString()) != null ? u : "";
  return /* @__PURE__ */ y(
    Mr,
    w({
      type: qa(o.type),
      label: o.type === G.numeric ? o.symbols[0] : `${gx(o.message, i)}`,
      value: l,
      callback: (d) => {
        t == null || t([
          o.type === G.numeric ? Si(d) ? Number(d) : Number(l) : d
        ]);
      },
      required: o.type === G.numeric,
      disabled: a
    }, s)
  );
}, bx = (n) => {
  var i, s, l;
  const { filterType: r, defaultValues: e = [], onUpdate: t, disabled: a } = n, o = lr[r];
  return /* @__PURE__ */ J(Zt, { children: [
    /* @__PURE__ */ y(
      Mr,
      {
        type: qa(o.type),
        label: o.symbols[0],
        value: (i = e == null ? void 0 : e[0]) != null ? i : "",
        callback: (c) => {
          t == null || t([
            o.type === G.numeric ? Si(c) ? Number(c) : Number(e == null ? void 0 : e[0]) : c,
            e == null ? void 0 : e[1]
          ]);
        },
        required: !0,
        disabled: a
      }
    ),
    /* @__PURE__ */ y(
      Mr,
      {
        type: qa(o.type),
        label: o.symbols[1],
        value: (l = (s = e == null ? void 0 : e[1]) == null ? void 0 : s.toString()) != null ? l : "",
        callback: (c) => {
          t == null || t([
            e == null ? void 0 : e[0],
            o.type === G.numeric ? Si(c) ? Number(c) : Number(e == null ? void 0 : e[1]) : c
          ]);
        },
        required: !0,
        disabled: a
      }
    )
  ] });
}, vx = Z.div`
  padding: 7px;
  border: 1px solid #e6e6e6;
  position: relative;
  margin-top: 15px;
  background-color: ${({ backgroundColor: n }) => n};
  z-index: 1;

  &:before {
    content: '';
    position: absolute;
    width: 15px;
    height: 15px;
    border-top: 1px solid #e6e6e6;
    border-right: 1px solid #e6e6e6;
    border-radius: 0 5px 0 0;
    background-color: ${({ backgroundColor: n }) => n};
    transform: rotate(-45deg);
    top: -9px;
    left: 12px;
    z-index: 2;
  }
`, wx = (n) => {
  var g, b;
  const {
    filterType: r,
    defaultValues: e = [],
    onUpdate: t,
    arrangement: a = "vertical",
    disabled: o,
    measures: i = []
  } = n, s = lr[r], l = e == null ? void 0 : e[1], { t: c } = We(), { themeSettings: u } = ve(), d = () => /* @__PURE__ */ y(
    wv,
    {
      className: "csdk-flex csdk-flex-col csdk-max-h-32 csdk-overflow-auto csdk-border-solid csdk-border-input csdk-p-px csdk-rounded-md",
      items: i.map((v) => v.name),
      onChange: (v) => {
        var D;
        t == null || t([
          Number(e == null ? void 0 : e[0]),
          (D = i.find((k) => k.name === v.target.value)) != null ? D : i[0]
        ]);
      },
      currentSelection: l.name,
      title: c("criteriaFilter.byMeasure"),
      disabled: o
    }
  ), f = i.findIndex((v) => v.name === l.name), p = i.map((v) => /* @__PURE__ */ y(
    "div",
    {
      onClick: () => {
        var D;
        v.name !== l.name && (t == null || t([
          Number(e == null ? void 0 : e[0]),
          (D = i.find((k) => k.name === v.name)) != null ? D : i[0]
        ]));
      },
      children: v.name
    },
    v.name
  )), h = () => /* @__PURE__ */ J("div", { className: "csdk-flex csdk-h-6 csdk-items-center", children: [
    c("criteriaFilter.by"),
    /* @__PURE__ */ y(ci, { elements: p, selectedIdx: f })
  ] }), m = () => /* @__PURE__ */ y(
    vx,
    {
      backgroundColor: u.general.backgroundColor,
      className: zt(a) ? "" : "csdk-self-center",
      children: l.name
    }
  );
  return /* @__PURE__ */ J(Zt, { children: [
    /* @__PURE__ */ J("div", { className: "csdk-flex csdk-items-center", children: [
      /* @__PURE__ */ y("div", { className: "csdk-grow", children: /* @__PURE__ */ y(
        Mr,
        {
          type: qa(s.type),
          label: s.symbols[0],
          value: (b = (g = e == null ? void 0 : e[0]) == null ? void 0 : g.toString()) != null ? b : "",
          callback: (v) => {
            v && (t == null || t([Number(v), e == null ? void 0 : e[1]]));
          },
          required: !0,
          disabled: o,
          containerStyle: {
            justifyContent: "space-between"
          },
          inputStyle: {
            width: 40
          }
        }
      ) }),
      /* @__PURE__ */ J("div", { className: "csdk-ml-[10px]", children: [
        c("criteriaFilter.by"),
        ":"
      ] })
    ] }),
    i && i.length > 0 ? zt(a) ? d() : h() : m()
  ] });
}, _x = ({
  filterType: n,
  arrangement: r = "vertical",
  defaultValues: e = [],
  onUpdate: t,
  disabled: a,
  measures: o
}) => {
  const { themeSettings: i } = ve(), s = lr[n];
  return /* @__PURE__ */ J(
    "div",
    {
      className: `csdk-w-100 csdk-p-[12px] csdk-text-[13px] csdk-flex csdk-gap-x-2 csdk-gap-y-0.5 ${zt(r) ? "csdk-flex-col" : "csdk-flex-row"}`,
      style: { color: `${i.typography.primaryTextColor}!important` },
      children: [
        (s == null ? void 0 : s.inputCount) === 1 && /* @__PURE__ */ y(
          yx,
          {
            filterType: n,
            arrangement: r,
            defaultValues: e,
            onUpdate: t,
            disabled: a
          }
        ),
        (s == null ? void 0 : s.inputCount) === 2 && !s.ranked && /* @__PURE__ */ y(
          bx,
          {
            filterType: n,
            arrangement: r,
            defaultValues: e,
            onUpdate: t,
            disabled: a
          }
        ),
        (s == null ? void 0 : s.inputCount) === 2 && s.ranked && /* @__PURE__ */ y(
          wx,
          {
            filterType: n,
            arrangement: r,
            defaultValues: e,
            onUpdate: t,
            disabled: a,
            measures: o
          }
        )
      ]
    }
  );
}, Dx = ({
  filterType: n,
  values: r = []
}) => {
  var i, s, l;
  const e = lr[n], { t } = We();
  let a = "";
  switch (e.inputCount) {
    case 1:
      a += t(e.message, { val: (i = r[0]) == null ? void 0 : i.toString() });
      break;
    case 2:
      a += t(e.message, { valA: (s = r[0]) == null ? void 0 : s.toString(), valB: (l = r[1]) == null ? void 0 : l.toString() });
      break;
    default:
      for (let c = 0; c < e.inputCount; c++)
        a += `${e.symbols[c]} ${r[c]}`;
  }
  const o = `${t("criteriaFilter.displayModePrefix")} ${a[0].toLowerCase() + a.slice(1)}`;
  return /* @__PURE__ */ y(
    "div",
    {
      className: "csdk-p-[12px] csdk-leading-[26px] csdk-mx-auto csdk-text-[13px] csdk-flex csdk-flex-wrap csdk-gap-x-1",
      children: o
    }
  );
}, vf = se({ componentName: "CriteriaFilterTile" })(
  (n) => {
    const {
      title: r,
      filter: e,
      arrangement: t = "vertical",
      onUpdate: a,
      measures: o,
      tileDesignOptions: i
    } = n, { filter: s, updateFilter: l } = $r(e, a), c = s.disabled, u = px(s), d = lr[u], f = hx(
      s
    ), [p, h] = me(f), m = (b) => {
      h(b);
      const v = g(b, c);
      l(v);
    }, g = le(
      (b, v) => {
        let D = null;
        return d.ranked ? D = d.fn(
          s.attribute,
          b == null ? void 0 : b[1],
          b == null ? void 0 : b[0],
          e.guid
        ) : D = d.fn(s.attribute, ...b, e.guid), D.disabled = v, D;
      },
      [e.guid, s.attribute, d]
    );
    return /* @__PURE__ */ y(
      mn,
      {
        title: r,
        renderContent: (b) => b && zt(t) ? /* @__PURE__ */ y(
          Dx,
          {
            filterType: u,
            values: mx(p)
          }
        ) : /* @__PURE__ */ y(
          _x,
          {
            filterType: u,
            arrangement: t,
            defaultValues: p,
            onUpdate: m,
            disabled: c,
            measures: o
          }
        ),
        arrangement: t,
        disabled: c,
        onToggleDisabled: () => {
          const v = g(p, !c);
          l(v);
        },
        design: i,
        locked: s.locked
      }
    );
  }
), wf = ({ filter: n, design: r }) => {
  var t;
  const { t: e } = We();
  return /* @__PURE__ */ y(
    mn,
    {
      title: (t = n.attribute.name) != null ? t : "",
      renderContent: () => /* @__PURE__ */ y("div", { className: "csdk-p-[12px] csdk-text-[13px]", children: e("unsupportedFilterMessage") }),
      design: r,
      locked: n.locked
    }
  );
}, Tl = {
  header: {
    shouldBeShown: !0,
    isCollapsible: !0,
    hasBorder: !1,
    hasBackgroundFilterIcon: !1
  },
  border: {
    shouldBeShown: !1
  },
  footer: {
    shouldBeShown: !1
  }
}, kx = ({
  filter: n,
  dataSource: r,
  parentFilters: e,
  onChange: t,
  isLast: a
}) => {
  const { themeSettings: o } = ve(), { backgroundColor: i } = o.general, s = kt(i, du), l = n.attribute, c = l.name, u = {
    attribute: l,
    dataSource: r,
    title: c,
    onChange: t,
    onUpdate: t,
    tileDesignOptions: Tl
  }, d = Ca(n) ? /* @__PURE__ */ y(xd, E(w({}, u), { filter: n, parentFilters: e })) : Li(n) ? /* @__PURE__ */ y(gf, E(w({}, u), { filter: n, attribute: l, tiled: !0 })) : mu(n) ? /* @__PURE__ */ y(bf, E(w({}, u), { filter: n, arrangement: "vertical" })) : gu(n) || Ca(n) || yu(n) || bu(n) ? /* @__PURE__ */ y(vf, E(w({}, u), { filter: n })) : vu(n) ? /* @__PURE__ */ y(_f, E(w({}, u), { filter: n })) : /* @__PURE__ */ y(wf, { filter: n, design: Tl });
  return /* @__PURE__ */ y(
    "div",
    {
      style: { borderBottomColor: a ? void 0 : s },
      className: a ? "" : "csdk-border-0 csdk-border-b csdk-border-solid",
      children: d
    }
  );
}, xx = se({ componentName: "CascadingFilterTile" })(
  (n) => {
    const {
      filter: r,
      arrangement: e,
      onChange: t,
      dataSource: a
    } = n, { filter: o, updateFilter: i } = $r(
      r,
      t
    ), s = o.filters, l = (c, u) => {
      const d = o.filters.map((p, h) => h === u ? c : h > u ? Oi(p) : p), f = new Ii(d, o.guid);
      f.disabled = o.disabled, i(f);
    };
    return /* @__PURE__ */ y(
      mn,
      {
        renderContent: () => {
          const c = [];
          return s.map((u, d) => {
            const f = [...c];
            return c.push(u), /* @__PURE__ */ y(
              kx,
              {
                filter: u,
                dataSource: a,
                parentFilters: f,
                onChange: (p) => p ? l(p, d) : null,
                isLast: d === s.length - 1
              },
              d
            );
          });
        },
        arrangement: e,
        disabled: o.disabled,
        onToggleDisabled: () => {
          const c = za(o);
          i(c);
        },
        design: {
          header: {
            shouldBeShown: !1
          }
        },
        locked: o.locked
      }
    );
  }
), _f = se({
  componentName: "CustomFilterTile"
})((n) => {
  const { t: r } = We(), { filter: e, onUpdate: t, tileDesignOptions: a } = n, o = e.jaql().jaql.filter;
  delete o.custom, delete o.isAdvanced, delete o.filterType;
  const i = (s) => {
    const l = Ga(s);
    return l.disabled = !s.disabled, Object.setPrototypeOf(l, s), l;
  };
  return /* @__PURE__ */ y(
    mn,
    {
      title: e.attribute.name,
      renderContent: (s) => s ? /* @__PURE__ */ y("p", { className: "csdk-text-center csdk-text-[13px]", children: r("customFilterTileMessage") }) : /* @__PURE__ */ y("div", { className: "csdk-text-[13px] csdk-m-3", style: { whiteSpace: "pre-wrap" }, children: JSON.stringify(o, null, 4) }),
      disabled: e.disabled,
      onToggleDisabled: () => t(i(e)),
      design: a || { header: { isCollapsible: !1 } },
      locked: e.locked
    }
  );
}), Cx = ({
  filter: n,
  onChange: r,
  defaultDataSource: e
}) => {
  const t = n.attribute, a = t.name, o = w({
    attribute: t,
    title: a,
    onChange: r,
    onUpdate: r
  }, e ? { dataSource: e } : null);
  return vu(n) ? /* @__PURE__ */ y(_f, E(w({}, o), { filter: n })) : Ca(n) ? /* @__PURE__ */ y(xd, E(w({}, o), { filter: n })) : Li(n) ? /* @__PURE__ */ y(
    gf,
    E(w({}, o), {
      filter: n,
      attribute: t,
      tiled: !0
    })
  ) : mu(n) ? /* @__PURE__ */ y(bf, E(w({}, o), { filter: n, arrangement: "vertical" })) : gu(n) || Vh(n) || yu(n) || bu(n) ? /* @__PURE__ */ y(vf, E(w({}, o), { filter: n })) : Yi(n) ? /* @__PURE__ */ y(xx, E(w({}, o), { filter: n, onChange: r })) : /* @__PURE__ */ y(wf, { filter: n, design: { header: { isCollapsible: !1 } } });
}, Tx = Z.div`
  background-color: ${({ theme: n }) => n.filter.panel.backgroundColor};
  border: 1px solid #dadada;
  width: fit-content;
  min-width: 240px;
  max-height: 100%;
  overflow: hidden;
`, Sx = Z.div`
  background-color: transparent;
  max-height: calc(100% - ${md}px);
  overflow-y: auto;
`, Ex = Z.div`
  padding: 0px 12px 12px;
`, Mx = Z.div`
  background-color: transparent;
  color: ${({ theme: n }) => n.filter.panel.titleColor};
  margin: 0 9px;
  height: 48px;
  border-bottom: 1px solid #dadada;
  box-sizing: border-box;
`, Px = Z.div`
  font-size: 13px;
  font-weight: bold;
  display: flex;
  align-items: center;
  height: 100%;
  margin-left: 8px;
`, Ax = se({
  componentName: "FiltersPanel"
})(({ filters: n, onFiltersChange: r, defaultDataSource: e }) => {
  const { t } = We(), { themeSettings: a } = ve(), o = [...n], i = (s, l) => {
    n && (o[`${l}`] = s, r(o.filter((c) => c !== null)));
  };
  return /* @__PURE__ */ J(Tx, { theme: a, children: [
    /* @__PURE__ */ y(Mx, { theme: a, children: /* @__PURE__ */ y(Px, { children: t("filters") }) }),
    /* @__PURE__ */ y(Sx, { children: /* @__PURE__ */ y(Ex, { children: n == null ? void 0 : n.map((s, l) => /* @__PURE__ */ y("div", { className: "csdk-mt-[6px]", children: /* @__PURE__ */ y(
      Cx,
      {
        filter: s,
        onChange: (c) => i(c, l),
        defaultDataSource: e
      },
      s.guid
    ) }, s.guid)) }) })
  ] });
}), Ox = Z.div`
  background-color: #b6b6b6;
  width: 8px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: calc(50% - 20px);
  left: 0;
  opacity: 0.4;
  cursor: pointer;

  ${({ reversed: n }) => n ? "transform: scaleX(-1);" : ""}

  &:before {
    content: '';
    position: absolute;
    left: 8px;
    top: 0;
    border-left-width: 0;
    border-left-style: solid;
    border-left-color: #b6b6b6;
    transition: border-left-width 100ms ease;
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;
  }

  svg {
    margin-left: 1px;
  }

  &:hover {
    opacity: 1;
    &:before {
      border-left-width: 10px;
    }
  }
`, Nx = Z.div`
  position: relative;

  &:hover .arrow-wrapper {
    opacity: 1;
  }
`, Rx = Z.div`
  width: ${({ collapsed: n }) => n ? "8px" : "auto"};
  overflow: hidden;
  height: 100%;
`, Fx = ({
  collapsedOnInit: n,
  children: r
}) => {
  const [e, t] = me(n != null ? n : !1);
  return /* @__PURE__ */ J(Nx, { children: [
    /* @__PURE__ */ y(
      Ox,
      {
        className: "arrow-wrapper",
        reversed: e,
        onClick: () => t(!e),
        children: /* @__PURE__ */ y("svg", { fill: "#fff", height: "8px", width: "8px", viewBox: "0 0 330 330", children: /* @__PURE__ */ y("path", { d: "M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001  c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213  C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606  C255,161.018,253.42,157.202,250.606,154.389z" }) })
      }
    ),
    /* @__PURE__ */ y(Rx, { collapsed: e, children: r })
  ] });
}, Ix = Z.div`
  max-width: 100%;
  background-color: ${({ background: n }) => n};
  color: ${({ color: n }) => n};
  display: flex;
  max-height: 100%;
`, Lx = Z.div`
  background-color: ${({ background: n }) => n};
  flex: 1;
  border-top: ${Cn(fa, pa)};
  border-bottom: ${Cn(fa, pa)};
  border-left: ${Cn(fa, pa)};
  display: flex;
  flex-direction: column;
  max-height: 100%;
`, Yx = Z.div`
  max-height: 100%;
  overflow: auto;
`, Wx = ({
  title: n,
  layoutOptions: r,
  config: e,
  widgets: t,
  filters: a,
  onFiltersChange: o,
  defaultDataSource: i
}) => {
  var u, d;
  const { themeSettings: s } = ve(), l = ((u = e == null ? void 0 : e.toolbar) == null ? void 0 : u.isVisible) !== !1, c = ((d = e == null ? void 0 : e.filtersPanel) == null ? void 0 : d.isVisible) !== !1;
  return /* @__PURE__ */ J(
    Ix,
    {
      background: s.dashboard.backgroundColor,
      color: s.typography.primaryTextColor,
      children: [
        /* @__PURE__ */ J(Lx, { background: s.dashboard.backgroundColor, children: [
          l && /* @__PURE__ */ y(lv, { title: n }),
          /* @__PURE__ */ y(Yx, { children: /* @__PURE__ */ y(iv, { layout: r == null ? void 0 : r.widgetsPanel, widgets: t }) })
        ] }),
        c && /* @__PURE__ */ y(Fx, { children: /* @__PURE__ */ y("div", { className: "csdk-w-[240px] csdk-h-[100%] csdk-flex", children: /* @__PURE__ */ y(
          Ax,
          {
            filters: a,
            onFiltersChange: o,
            defaultDataSource: i
          }
        ) }) })
      ]
    }
  );
}, Hx = ({ styleOptions: n }) => {
  const { themeSettings: r } = ve();
  return { themeSettings: pe(() => {
    const o = n != null ? n : {}, { palette: t } = o, a = Re(o, ["palette"]);
    return E(w({}, t && { palette: t }), {
      dashboard: w(w({}, r.dashboard), a)
    });
  }, [n, r.dashboard]) };
}, $x = mt("useDashboardTheme")(Hx), Bx = Z.button`
  color: ${({ theme: n }) => {
  var r;
  return (r = n.chart) == null ? void 0 : r.textColor;
}};
  background-color: ${({ theme: n }) => {
  var r;
  return (r = n.chart) == null ? void 0 : r.backgroundColor;
}};
  font-size: 13px;
  border: none;
  height: 28px;
  padding: 0 11px 0 9px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background-color: rgba(247, 247, 247, 1);
  }
`, Qx = Z.span`
  color: ${({ theme: n }) => {
  var r;
  return (r = n.chart) == null ? void 0 : r.textColor;
}};
  display: inline-block;
  padding-top: 3px;
  white-space: nowrap;
`, Ux = ({ onClick: n }) => {
  var t;
  const { themeSettings: r } = ve(), { t: e } = We();
  return /* @__PURE__ */ J(Bx, { onClick: n, theme: r, children: [
    /* @__PURE__ */ y("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "24", height: "24", children: /* @__PURE__ */ y(
      "path",
      {
        fill: (t = r.chart) == null ? void 0 : t.textColor,
        d: "M7.187 7l9.774 10.279A1 1 0 0 0 17 17V8a1 1 0 0 0-1-1H7.187zm9.018 10.979L6.206 7.463l.487-.415A1 1 0 0 0 6 8v9a1 1 0 0 0 1 1h9c.07 0 .139-.007.205-.021zM7 6h9a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z"
      }
    ) }),
    /* @__PURE__ */ y(Qx, { theme: r, children: e("commonFilter.clearSelectionButton") })
  ] });
};
function qx(n) {
  const r = {};
  return { flatFilters: n.reduce((t, a) => (Yi(a) ? (r[a.guid] || (r[a.guid] = []), a.filters.forEach((o) => {
    r[a.guid].push(o), t.push(o);
  })) : t.push(a), t), []), cascadingToPureFiltersMap: r };
}
function jx(n, r) {
  const e = r.filter(Yi);
  return Vx(
    n,
    e
  ).map((a) => {
    if (zx(a)) {
      const o = e.find(
        (i) => i.guid === a.groupId
      );
      if (!o)
        throw new ne("errors.cascadingFilterOriginalNotFound");
      return Gx(a, o);
    }
    return a;
  });
}
function zx(n) {
  return "groupId" in n;
}
function Vx(n, r) {
  const e = [];
  return n.forEach((t) => {
    const a = r.find(
      (o) => o.filters.some(
        (i) => ac(i) === ac(t)
      )
    );
    if (a) {
      const o = a.guid, i = e.find((s) => "groupId" in s && s.groupId === o);
      i ? i.filters.push(t) : e.push({
        groupId: o,
        filters: [t],
        previousFilters: a.filters
      });
    } else
      e.push(t);
  }), e;
}
function Gx(n, r) {
  const e = Jx(
    n.filters,
    n.previousFilters
  ), t = Kx(e, r.disabled), a = new Ii(e, r.guid);
  return a.disabled = t, a;
}
function Kx(n, r) {
  return n.some(
    (t) => t.disabled !== r
  ) ? !r : r;
}
function Xx(n, r, e) {
  const { flatFilters: t, cascadingToPureFiltersMap: a } = qx(n);
  return {
    pureFilters: t,
    updateFilters: (i) => {
      const s = jx(i, n);
      r(s);
    },
    pureFiltersIgnoringRules: Zx(
      e,
      a
    )
  };
}
function Jx(n, r) {
  const e = n.reduce(
    (t, a, o) => {
      const i = r.find(
        (s) => Ap(s, a)
      );
      return i && !Op(a, i) ? o : t;
    },
    -1
  );
  return n.map((t, a) => a > e ? Oi(t) : t);
}
function Zx(n, r) {
  var e;
  return {
    all: n.all,
    ids: ((e = n.ids) == null ? void 0 : e.reduce((t, a) => {
      const o = r[a];
      return o ? t.concat(o.map((i) => i.guid)) : t.concat(a);
    }, [])) || []
  };
}
const Sl = {
  applyMode: Jn.HIGHLIGHT,
  shouldAffectFilters: !0,
  ignoreFilters: {
    all: !1,
    ids: []
  },
  forceApplyBackgroundFilters: !0
};
function eC(n, r) {
  return n === "table" ? {
    applyMode: Jn.FILTER,
    shouldAffectFilters: !1,
    ignoreFilters: ka(Sl.ignoreFilters, r.ignoreFilters || {})
  } : ka(Sl, r);
}
function tC(n, r, e, t, a, o, i) {
  const s = {}, l = eC(e, a), { pureFilters: c, updateFilters: u, pureFiltersIgnoringRules: d } = Xx(
    n,
    r,
    l.ignoreFilters || {}
  ), f = c.filter((D) => !D.disabled), p = Np(f, d), h = Rp(e, t), m = l.shouldAffectFilters && h.length, [g, b] = rC(
    p,
    h,
    l.applyMode
  ), v = l.forceApplyBackgroundFilters ? pt(nC(c), g) : g;
  if (s.filters = v, s.highlights = b, s.onDataPointsSelected = (D, k) => {
    const x = [], R = zs(
      e,
      t,
      D
    );
    if (R && x.push(R), m) {
      const I = Co(e, t, D), { filters: L, isSelection: A } = To(
        I,
        c,
        !0
      ), W = o(A ? "commonFilter.selectMenuItem" : "commonFilter.unselectMenuItem"), O = Vs(W, () => {
        u(pt(c, L));
      });
      x.push(O);
    }
    x.length && (i == null || i({
      position: {
        left: k.clientX,
        top: k.clientY
      },
      itemSections: x
    }));
  }, s.onDataPointContextMenu = (D, k) => {
    const x = [], R = zs(
      e,
      t,
      [D]
    );
    if (R && x.push(R), m) {
      const I = Co(e, t, [D]), { filters: L, isSelection: A } = To(
        I,
        c,
        !0
      ), W = o(A ? "commonFilter.selectMenuItem" : "commonFilter.unselectMenuItem"), O = Vs(W, () => {
        u(pt(c, L));
      });
      x.push(O);
    }
    x.length && (i == null || i({
      position: {
        left: k.clientX,
        top: k.clientY
      },
      itemSections: x
    }));
  }, m) {
    s.onDataPointClick = (R) => {
      const I = Co(e, t, [R]), { filters: L } = To(
        I,
        c
      );
      u(pt(c, L));
    };
    const D = f.filter(
      (R) => h == null ? void 0 : h.some(
        (I) => Ca(R) && Kl(R.attribute, I) && !Xl(R) && !R.locked
      )
    ), k = !!D.length, x = () => {
      const R = D.map(Oi);
      u(pt(c, R));
    };
    k && (s.renderToolbar = (R, I) => {
      const L = h.map(({ expression: A }) => A).join(";");
      return /* @__PURE__ */ J("div", { style: { display: "flex" }, children: [
        /* @__PURE__ */ y(Ux, { onClick: x }),
        I
      ] }, L);
    });
  }
  return s;
}
function nC(n) {
  return n.map((r) => r.backgroundFilter).filter((r) => !!r);
}
function rC(n, r, e) {
  if (e === Jn.HIGHLIGHT) {
    const [t, a] = Ul(
      n,
      (i) => r.every((s) => !Kl(s, i.attribute))
    ), o = a.filter(
      (i) => !Xl(i)
    );
    return [t, o];
  }
  return [n, []];
}
const aC = ({
  initialFilters: n,
  openMenu: r,
  onBeforeMenuOpen: e,
  onFiltersChange: t
} = {}) => {
  const { t: a } = We(), [o, i] = Jl(
    pe(() => n != null ? n : [], [n]),
    {
      onLocalStateChange: t
    }
  ), s = le(
    (c) => {
      i(pt(o, [c]));
    },
    [i, o]
  ), l = le(
    (c, u = {}) => {
      var g, b;
      if (uu(c))
        return c;
      const d = Zh(c), f = Ga(c), h = "drilldownOptions" in c && ((b = (g = c.drilldownOptions) == null ? void 0 : g.drilldownSelections) == null ? void 0 : b.length) ? Fp(
        c.chartType,
        c.dataOptions,
        Ip(c.drilldownOptions.drilldownSelections).nextDimension
      ) : c.dataOptions, m = tC(
        o,
        i,
        d,
        h,
        u,
        a,
        r
      );
      return f.highlights = pt(m.highlights, f.highlights), f.filters = pt(
        m.filters,
        f.filters
      ), f.onBeforeMenuOpen = e, m.onDataPointClick && Gh(f, m.onDataPointClick), m.onDataPointsSelected && Kh(f, m.onDataPointsSelected), m.onDataPointContextMenu && Xh(f, m.onDataPointContextMenu), m.renderToolbar && Jh(f, m.renderToolbar), f;
    },
    [i, o, r, e, a]
  );
  return {
    filters: o,
    setFilters: i,
    addFilter: s,
    connectToWidgetProps: l
  };
};
var oC = kd(function(n, r, e, t) {
  Ji(n, r, e, t);
});
const iC = (n, r) => oC(Ga(n), r, (e, t) => {
  if (Array.isArray(t))
    return t;
});
function sC(n) {
  const { target: r, onChange: e } = n, t = Array.isArray(r), a = pe(
    () => t ? r : [r],
    [t, r]
  ), o = le(
    (i, s) => {
      a[s] && "onChange" in a[s] && a[s].onChange(i), e(i, t ? s : void 0);
    },
    [a, t, e]
  );
  return pe(() => {
    const i = a.map((s, l) => E(w({}, s), {
      onChange: (c) => o(c, l)
    }));
    return t ? i : i[0];
  }, [t, a, o]);
}
const cC = ({ isTargetMenu: n, combineMenus: r }) => {
  const e = it(null), t = it(null), a = Zl(), o = le(() => {
    if (e.current) {
      const l = t.current ? r(e.current, t.current) : e.current;
      a.openMenu(l);
    }
  }, [a, r]), i = le(
    (l) => {
      e.current = l, o();
    },
    [o]
  ), s = le(
    (l) => n(l) ? (t.current = l, o(), null) : l,
    [n, o]
  );
  return {
    openMenu: i,
    onBeforeMenuOpen: s
  };
};
function lC(n, r) {
  const e = r.itemSections.filter(
    ({ id: t }) => t !== eu.DRILLDOWN_CHART_POINTS_SELECTION
  );
  return E(w({}, n), {
    itemSections: [
      ...n.itemSections,
      ...e
    ]
  });
}
function uC(n) {
  return n.itemSections.some(({ id: r }) => r === eu.DRILLDOWN_CHART_POINTS_SELECTION);
}
function dC(n, { onFiltersChange: r } = {}) {
  const { filters: e, widgets: t, widgetsOptions: a } = n, [o, i] = Jl(t), { openMenu: s, onBeforeMenuOpen: l } = cC({
    isTargetMenu: uC,
    combineMenus: lC
  }), {
    filters: c,
    setFilters: u,
    connectToWidgetProps: d
  } = aC({ initialFilters: e, openMenu: s, onBeforeMenuOpen: l, onFiltersChange: r }), f = sC({
    target: o,
    onChange: le(
      (h, m) => {
        i((g) => {
          const b = Ga(g);
          return b[m] = iC(g[m], h), b;
        });
      },
      [i]
    )
  }), p = pe(() => f.map(
    (h) => {
      var m;
      return d(h, (m = a == null ? void 0 : a[h.id]) == null ? void 0 : m.filtersOptions);
    }
  ), [f, a, d]);
  return {
    dashboard: E(w({}, n), {
      filters: c,
      widgets: p
    }),
    setFilters: u
  };
}
const fC = mt("useComposedDashboard")(
  dC
);
var Df = /* @__PURE__ */ ((n) => (n.FILTERS_UPDATE = "FILTERS.UPDATE", n))(Df || {});
const pC = se({
  componentName: "Dashboard"
})(
  ({
    title: n = "",
    layoutOptions: r,
    config: e,
    widgets: t,
    filters: a,
    defaultDataSource: o,
    widgetsOptions: i,
    styleOptions: s,
    onChange: l
  }) => {
    const { themeSettings: c } = $x({ styleOptions: s }), {
      dashboard: { filters: u = [], widgets: d },
      setFilters: f
    } = fC(
      {
        filters: a,
        widgets: t,
        widgetsOptions: i
      },
      {
        onFiltersChange: le(
          (p) => {
            l == null || l({ type: "FILTERS.UPDATE", payload: p });
          },
          [l]
        )
      }
    );
    return /* @__PURE__ */ y(Da, { theme: c, children: /* @__PURE__ */ y(
      Wx,
      {
        title: n,
        layoutOptions: r,
        config: e,
        widgets: d,
        defaultDataSource: o,
        filters: u,
        onFiltersChange: f
      }
    ) });
  }
), XC = se({
  componentName: "DashboardById"
})(({ dashboardOid: n, persist: r = !1 }) => {
  const { themeSettings: e } = ve(), { dashboard: t, isLoading: a, isError: o, dispatchChanges: i } = Sb({
    dashboardOid: n,
    includeWidgets: !0,
    includeFilters: !0,
    persist: r
  }), s = le(
    (l) => {
      const c = Cb(l);
      c && i(c);
    },
    [i]
  );
  if (o)
    throw new ne("errors.dashboardLoadFailed");
  return /* @__PURE__ */ y(Hl, { themeSettings: e, isVisible: a, children: t && /* @__PURE__ */ y(
    pC,
    E(w({}, id(t)), {
      onChange: s
    })
  ) });
});
function JC(n, r) {
  const { filters: e, highlights: t } = ys(
    n,
    r
  ), a = Vu(r.metadata.panels);
  return {
    filters: pt(e, a),
    highlights: t
  };
}
function ys(n, r) {
  const e = r.metadata.ignore, { filters: t, highlights: a } = gC(
    hC(n.filters || [], e),
    mC(n.filters || []),
    r
  );
  return {
    filters: t.map((o) => Sr(o.jaql, o.instanceid)),
    highlights: a.map((o) => Sr(o.jaql))
  };
}
function kf(n) {
  const r = [];
  for (const e of n)
    if (e.isCascading) {
      const t = e, { disabled: a } = t, o = t.levels.map(
        (i) => ({ jaql: i, disabled: a })
      );
      r.push(...o);
    } else
      r.push(e);
  return r;
}
function hC(n, r) {
  return kf(n).filter(({ instanceid: e = "", disabled: t }) => !(r != null && r.all) && !t && !(r != null && r.ids.includes(e))).map(({ jaql: e, instanceid: t }) => {
    const { filter: a, turnOffMembersFilter: o } = Bi(e);
    return {
      instanceid: t,
      jaql: E(w({}, e), {
        filter: w(w({}, a), o && { filter: o })
      })
    };
  });
}
function mC(n) {
  const r = [];
  return kf(n).forEach(({ jaql: e }) => {
    const { backgroundFilter: t } = Bi(e);
    t && r.push({
      jaql: w(E(w({}, e), {
        filter: t
      }), e.datatype === "datetime" && {
        level: t.level
      })
    });
  }), r;
}
function gC(n, r, e) {
  var i;
  const t = ((i = e.options) == null ? void 0 : i.dashboardFiltersMode) === em.SELECT;
  let a = [];
  const o = [];
  return n.forEach((s) => {
    t && yC(s, e) ? o.push(s) : a.push(s);
  }), a = [...a, ...r], { filters: a, highlights: o };
}
function yC(n, r) {
  return bC(r).includes(n.jaql.dim) && !n.jaql.filter.all;
}
function bC(n) {
  const r = vC(n.type), e = [];
  for (const t of r) {
    const o = xt(n.metadata.panels, t).map((i) => i.jaql.dim);
    e.push(...o);
  }
  return e;
}
function vC(n) {
  switch (n) {
    case "chart/line":
    case "chart/area":
      return ["x-axis"];
    case "chart/bar":
    case "chart/column":
    case "chart/polar":
    case "chart/pie":
    case "treemap":
      return ["categories"];
    case "chart/scatter":
      return ["x-axis", "y-axis", "point"];
    case "chart/boxplot":
      return ["category"];
    case "map/scatter":
      return ["geo"];
    case "pivot2":
      return ["rows", "columns"];
    default:
      return [];
  }
}
function wC(n) {
  const { widgetType: r } = n;
  let e;
  return Wt(r) ? e = n.getPivotTableWidgetProps() : Lr(r) ? e = n.getTextWidgetProps() : e = n.getChartWidgetProps(), {
    props: e,
    widgetType: r
  };
}
const ZC = se({
  componentName: "DashboardWidget",
  customContextErrorMessageKey: "errors.dashboardWidgetNoSisenseContext"
})((n) => {
  var g;
  const m = n, { widgetOid: r, dashboardOid: e, includeDashboardFilters: t } = m, a = Re(m, ["widgetOid", "dashboardOid", "includeDashboardFilters"]), { themeSettings: o } = ve(), { app: i } = Ye(), {
    widget: s,
    dashboard: l,
    error: c
  } = Ny({
    widgetOid: r,
    dashboardOid: e,
    includeDashboard: t
  });
  if (c)
    throw c;
  const { widgetType: u, props: d } = pe(() => {
    if (!s)
      return { widgetType: null, props: null };
    const b = Hr(
      s,
      o,
      i == null ? void 0 : i.settings
    ), v = wC(b);
    if (na(v.props))
      return { widgetType: "richtexteditor", props: v.props };
    if (t) {
      const { filters: D, highlights: k } = ys(l, s);
      v.props.filters = pt(
        D,
        v.props.filters
      ), v.props.highlights = k;
    }
    return v;
  }, [s, l, o, t, i == null ? void 0 : i.settings]);
  if (!d)
    return null;
  const f = na(d) ? [] : Ta(
    d == null ? void 0 : d.filters,
    a.filters,
    a.filtersMergeStrategy
  ), p = na(d) ? [] : Ta(
    d == null ? void 0 : d.highlights,
    a.highlights,
    a.filtersMergeStrategy
  ), h = tm(
    f,
    p,
    wu(
      (g = l == null ? void 0 : l.filterRelations) != null && g.length ? l == null ? void 0 : l.filterRelations[0].filterRelations : void 0
    )
  );
  return na(d) ? /* @__PURE__ */ y(hd, w({}, d)) : Wt(u) ? /* @__PURE__ */ y(
    Qu,
    E(w(w({}, d), a), {
      filters: h,
      highlights: p,
      styleOptions: w(w({}, d.styleOptions), n.styleOptions)
    })
  ) : /* @__PURE__ */ y(
    jl,
    E(w(w({}, d), a), {
      filters: h,
      highlights: p,
      drilldownOptions: w(w({}, d.drilldownOptions), n.drilldownOptions),
      styleOptions: w(w({}, d.styleOptions), n.styleOptions)
    })
  );
}), eT = se({
  componentName: "ExecuteQuery"
})(
  ({
    dataSource: n,
    dimensions: r,
    measures: e,
    filters: t,
    highlights: a,
    count: o,
    offset: i,
    ungroup: s,
    children: l,
    onDataChanged: c,
    onBeforeQuery: u
  }) => {
    const d = Ki({
      dataSource: n,
      dimensions: r,
      measures: e,
      filters: t,
      highlights: a,
      count: o,
      offset: i,
      ungroup: s,
      onBeforeQuery: u
    }), f = d.data, p = Vl(f);
    return f && p !== f && (c == null || c(f)), /* @__PURE__ */ y(Zt, { children: d && (l == null ? void 0 : l(d)) });
  }
);
function El(n, r) {
  return Dt(n, r);
}
const tT = mt("useExecuteCsvQuery")(_C);
function _C(n) {
  const r = gd(n), e = hn(n, r), [t, a] = Ht(El, {
    isLoading: !0,
    isError: !1,
    isSuccess: !1,
    status: "loading",
    error: void 0,
    data: void 0
  }), { isInitialized: o, app: i } = Ye();
  return ge(() => {
    if (o || a({
      type: "error",
      error: new ne("errors.executeQueryNoSisenseContext")
    }), e(i)) {
      a({ type: "loading" });
      const {
        dataSource: s,
        dimensions: l,
        measures: c,
        filters: u,
        highlights: d,
        count: f,
        offset: p,
        config: h,
        onBeforeQuery: m
      } = n, { filters: g, relations: b } = Mn(u);
      Lp(
        {
          dataSource: s,
          dimensions: l,
          measures: c,
          filters: g,
          filterRelations: b,
          highlights: d,
          count: f,
          offset: p
        },
        i,
        { onBeforeQuery: m }
      ).then((v) => h != null && h.asDataStream ? (a({ type: "success", data: v }), null) : v.text()).then((v) => v && a({ type: "success", data: v })).catch((v) => {
        a({ type: "error", error: v });
      });
    }
  }, [i, o, n, e]), t.data && r ? El(t, { type: "loading" }) : t;
}
const nT = mt("useExecuteQueryByWidgetId")(
  xf
);
function xf(n) {
  const r = kC(n), e = hn(n, r), { isInitialized: t, app: a } = Ye(), o = it(void 0), i = it(void 0), [s, l] = Ht(ii, {
    isLoading: !0,
    isError: !1,
    isSuccess: !1,
    status: "loading",
    error: void 0,
    data: void 0
  });
  return ge(() => {
    if (t || l({
      type: "error",
      error: new ne("errors.executeQueryNoSisenseContext")
    }), e(a)) {
      const {
        widgetOid: c,
        dashboardOid: u,
        filters: d,
        highlights: f,
        filtersMergeStrategy: p,
        count: h,
        offset: m,
        includeDashboardFilters: g,
        onBeforeQuery: b
      } = n;
      l({ type: "loading" }), xC({
        widgetOid: c,
        dashboardOid: u,
        filters: d,
        highlights: f,
        filtersMergeStrategy: p,
        app: a,
        count: h,
        offset: m,
        includeDashboardFilters: g,
        onBeforeQuery: b
      }).then(({ data: v, query: D, pivotQuery: k }) => {
        o.current = D, i.current = k, l({ type: "success", data: v });
      }).catch((v) => {
        l({ type: "error", error: v });
      });
    }
  }, [n, a, t, e]), E(w({}, s), {
    query: o.current,
    pivotQuery: i.current
  });
}
const DC = [
  "widgetOid",
  "dashboardOid",
  "count",
  "offset",
  "filtersMergeStrategy",
  "includeDashboardFilters",
  "onBeforeQuery"
];
function kC(n) {
  return _t(n, DC, (r, e) => {
    const t = An(e.filters, r.filters), a = An(e.highlights, r.highlights);
    return t || a;
  });
}
function xC(u) {
  return Ee(this, arguments, function* ({
    widgetOid: n,
    dashboardOid: r,
    filters: e,
    highlights: t,
    filtersMergeStrategy: a,
    count: o,
    offset: i,
    includeDashboardFilters: s,
    app: l,
    onBeforeQuery: c
  }) {
    const d = new ja(l.httpClient), { widget: f, dashboard: p } = yield $i({
      widgetOid: n,
      dashboardOid: r,
      includeDashboard: s,
      api: d
    });
    if (!f)
      throw new ne("errors.widgetWithOidNotFound", { widgetOid: n });
    const h = Hr(f), m = (g, b) => {
      var A;
      const { dataSource: v, filters: D, highlights: k } = g;
      let x = D, R = k;
      if (s && p) {
        const { filters: W, highlights: O } = ys(p, f);
        x = pt(W, D), R = pt(O, k);
      }
      x = Ta(
        x,
        e,
        a
      ), R = Ta(R, t, a);
      const I = (A = p == null ? void 0 : p.filterRelations) != null && A.length ? wu(p.filterRelations[0].filterRelations) : void 0, L = {
        dataSource: v,
        filters: x,
        filterRelations: I,
        highlights: R,
        count: o,
        offset: i
      };
      if (b) {
        const { rows: W, columns: O, values: U, grandTotals: $ } = g;
        return E(w({}, L), {
          rows: W,
          columns: O,
          values: U,
          grandTotals: $
        });
      } else {
        const { dimensions: W, measures: O } = g;
        return E(w({}, L), {
          dimensions: W,
          measures: O
        });
      }
    };
    if (Wt(h.widgetType)) {
      const g = h.getExecutePivotQueryParams(), b = m(g, !0);
      return {
        // return flat table structure only
        data: (yield Wl(b, l, { onBeforeQuery: c })).table,
        query: void 0,
        // return pivotQuery instead of query
        pivotQuery: b
      };
    } else {
      const g = h.getExecuteQueryParams(), b = m(g, !1);
      return {
        data: yield Ai(b, l, { onBeforeQuery: c }),
        query: b,
        pivotQuery: void 0
      };
    }
  });
}
const rT = se({
  componentName: "ExecuteQueryByWidgetId"
})(
  ({
    widgetOid: n,
    dashboardOid: r,
    children: e,
    onDataChanged: t,
    filters: a,
    highlights: o,
    count: i,
    offset: s,
    filtersMergeStrategy: l,
    onBeforeQuery: c,
    includeDashboardFilters: u
  }) => {
    const d = xf({
      widgetOid: n,
      dashboardOid: r,
      filters: a,
      highlights: o,
      count: i,
      offset: s,
      filtersMergeStrategy: l,
      onBeforeQuery: c,
      includeDashboardFilters: u
    }), { data: f, query: p } = d, [h, m] = me(f);
    return h !== f && (m(f), f && p && (t == null || t(f, p))), /* @__PURE__ */ y(Zt, { children: d && (e == null ? void 0 : e(d)) });
  }
);
function aT() {
  const n = Ye().app;
  return n == null ? void 0 : n.queryCache;
}
const CC = new Yp({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: !1,
      refetchOnMount: !1
    }
  }
}), TC = ({ children: n }) => /* @__PURE__ */ y(Wp, { client: CC, children: n }), Cf = ({
  customTranslations: n = [],
  children: r
}) => {
  const { i18n: e } = We();
  return ge(() => {
    for (const { language: t, resources: a, packageName: o = "sdkUi" } of n)
      e.addResourceBundle(t, o, a);
  }, [e, n]), /* @__PURE__ */ y(Zt, { children: r });
}, oT = ({
  defaultDataSource: n,
  url: r,
  token: e,
  wat: t,
  ssoEnabled: a,
  children: o,
  appConfig: i,
  showRuntimeErrors: s = !0,
  enableSilentPreAuth: l = !1,
  useFusionAuth: c = !1,
  onError: u
}) => {
  var b, v, D;
  const d = {
    // if tracking is configured in appConfig, use it
    // if none is set, default to true
    enabled: (v = (b = i == null ? void 0 : i.trackingConfig) == null ? void 0 : b.enabled) != null ? v : !0,
    onTrackingEvent: (D = i == null ? void 0 : i.trackingConfig) == null ? void 0 : D.onTrackingEvent,
    packageName: "sdk-ui"
  }, [f, p] = me(), [h, m] = me();
  ge(() => {
    let k = !1;
    if (gm(e, t)) {
      console.debug("Waiting for the auth token to be set");
      return;
    }
    return Vg({
      defaultDataSource: n,
      url: r,
      token: e,
      wat: t,
      ssoEnabled: a,
      appConfig: i,
      enableSilentPreAuth: l,
      useFusionAuth: c
    }).then((x) => {
      k || p(x);
    }).catch((x) => {
      u == null || u(x), console.error(x), m(x);
    }), () => {
      k = !0;
    };
  }, [
    n,
    r,
    e,
    t,
    a,
    i,
    l,
    c,
    u
  ]);
  const g = (f == null ? void 0 : f.settings.translationConfig.language) || (f == null ? void 0 : f.settings.language) || (f == null ? void 0 : f.settings.serverLanguage);
  return /* @__PURE__ */ y(ti, { userLanguage: g, children: /* @__PURE__ */ y(
    Cf,
    {
      customTranslations: f == null ? void 0 : f.settings.translationConfig.customTranslations,
      children: /* @__PURE__ */ y(ni, { showErrorBox: s, error: h, children: /* @__PURE__ */ y(tu.Provider, { value: { isInitialized: !0, app: f, tracking: d }, children: /* @__PURE__ */ y(Da, { skipTracking: !0, theme: f == null ? void 0 : f.settings.serverThemeSettings, children: /* @__PURE__ */ y(TC, { children: /* @__PURE__ */ y(Zb, { children: /* @__PURE__ */ y(Pi, { children: o }) }) }) }) }) })
    }
  ) });
}, iT = se({
  componentName: "DrilldownWidget",
  trackingConfig: { transparent: !0 },
  shouldSkipSisenseContextWaiting: !0,
  shouldHaveOwnMenuRoot: !0
})((n) => {
  var C;
  const { t: r } = We(), {
    drilldownDimensions: e = [],
    drilldownPaths: t = [],
    initialDimension: a,
    drilldownSelections: o,
    config: i,
    onChange: s,
    children: l
  } = n, { openMenu: c } = Zl(), [u, d] = me([]), [f, p] = me(null), h = _t(f), m = i == null ? void 0 : i.contextMenuComponent, g = (C = i == null ? void 0 : i.breadcrumbsComponent) != null ? C : Qp, b = le(
    (S) => s == null ? void 0 : s({ drilldownSelections: S }),
    [s]
  ), v = pe(
    () => [...t, ...e],
    [t, e]
  ), {
    selectDrilldown: D,
    sliceDrilldownSelections: k,
    clearDrilldownSelections: x,
    availableDrilldownPaths: R,
    drilldownFilters: I,
    drilldownFiltersDisplayValues: L,
    drilldownDimension: A
  } = Hp({
    drilldownPaths: v,
    initialDimension: a,
    drilldownSelections: o,
    onDrilldownSelectionsChange: b
  }), W = pe(() => A && /* @__PURE__ */ y(
    g,
    {
      filtersDisplayValues: L,
      currentDimension: A,
      clearDrilldownSelections: x,
      sliceDrilldownSelections: k
    }
  ), [
    g,
    x,
    A,
    L,
    k
  ]), O = le((S) => {
    p(S);
  }, []), U = le(() => {
    d([]), p(null);
  }, [d]), $ = le(
    (S, F) => {
      D(u, S, F);
    },
    [D, u]
  ), N = le(
    (S) => {
      d(S);
    },
    [d]
  ), T = pe(() => [
    $p(u, A),
    Bp(
      R,
      A,
      $,
      r
    )
  ], [
    A,
    R,
    u,
    $,
    r
  ]);
  ge(() => {
    f && h && !m && c({ position: f, itemSections: T });
  }, [
    f,
    h,
    T,
    c,
    m
  ]);
  const M = pe(() => l({
    drilldownFilters: I,
    drilldownDimension: A,
    onDataPointsSelected: N,
    onContextMenu: O,
    breadcrumbsComponent: i != null && i.isBreadcrumbsDetached ? W : void 0
  }), [
    l,
    I,
    A,
    N,
    O,
    i,
    W
  ]);
  return /* @__PURE__ */ J("div", { style: { display: "flex", flexDirection: "column", height: "100%" }, children: [
    m && /* @__PURE__ */ y(
      m,
      {
        position: f,
        itemSections: T,
        closeContextMenu: U
      }
    ),
    A && !(i != null && i.isBreadcrumbsDetached) && W,
    /* @__PURE__ */ y(
      "div",
      {
        style: {
          flexGrow: 1,
          // prevents 'auto' behavior of using content size as minimal for element
          minWidth: 0,
          minHeight: 0
        },
        children: M
      }
    )
  ] });
}), sT = se({
  componentName: "LineChart",
  shouldSkipSisenseContextWaiting: et
})((n) => /* @__PURE__ */ y(Ze, E(w({}, n), { chartType: "line" }))), cT = se({
  componentName: "ColumnChart",
  shouldSkipSisenseContextWaiting: et
})((n) => /* @__PURE__ */ y(Ze, E(w({}, n), { chartType: "column" }))), lT = se({
  componentName: "AreaChart",
  shouldSkipSisenseContextWaiting: et
})((n) => /* @__PURE__ */ y(Ze, E(w({}, n), { chartType: "area" }))), uT = se({
  componentName: "PieChart",
  shouldSkipSisenseContextWaiting: et
})((n) => /* @__PURE__ */ y(Ze, E(w({}, n), { chartType: "pie" }))), dT = se({
  componentName: "BarChart",
  shouldSkipSisenseContextWaiting: et
})((n) => /* @__PURE__ */ y(Ze, E(w({}, n), { chartType: "bar" }))), fT = se({
  componentName: "FunnelChart",
  shouldSkipSisenseContextWaiting: et
})((n) => /* @__PURE__ */ y(Ze, E(w({}, n), { chartType: "funnel" }))), pT = se({
  componentName: "PolarChart",
  shouldSkipSisenseContextWaiting: et
})((n) => /* @__PURE__ */ y(Ze, E(w({}, n), { chartType: "polar" }))), hT = se({
  componentName: "ScatterChart",
  shouldSkipSisenseContextWaiting: et
})((n) => /* @__PURE__ */ y(Ze, E(w({}, n), { chartType: "scatter" }))), mT = se({
  componentName: "IndicatorChart",
  shouldSkipSisenseContextWaiting: et
})((n) => /* @__PURE__ */ y(Ze, E(w({}, n), { chartType: "indicator" }))), gT = se({
  componentName: "TreemapChart",
  shouldSkipSisenseContextWaiting: et
})((n) => /* @__PURE__ */ y(Ze, E(w({}, n), { chartType: "treemap" }))), yT = se({
  componentName: "SunburstChart",
  shouldSkipSisenseContextWaiting: et
})((n) => /* @__PURE__ */ y(Ze, E(w({}, n), { chartType: "sunburst" }))), bT = se({
  componentName: "BoxplotChart",
  shouldSkipSisenseContextWaiting: et
})((n) => /* @__PURE__ */ y(Ze, E(w({}, n), { chartType: "boxplot" }))), vT = se({
  componentName: "ScattermapChart",
  shouldSkipSisenseContextWaiting: et
})((n) => /* @__PURE__ */ y(Ze, E(w({}, n), { chartType: "scattermap" }))), wT = se({
  componentName: "AreamapChart",
  shouldSkipSisenseContextWaiting: et
})((n) => /* @__PURE__ */ y(Ze, E(w({}, n), { chartType: "areamap" }))), _T = se({
  componentName: "AreaRangeChart",
  shouldSkipSisenseContextWaiting: et
})((n) => /* @__PURE__ */ y(Ze, E(w({}, n), { chartType: "arearange" }))), DT = ({ context: n, error: r, children: e }) => {
  var a, o, i, s, l;
  if (!n)
    return /* @__PURE__ */ y(ni, { showErrorBox: !1, error: r, children: /* @__PURE__ */ y(ti, { children: /* @__PURE__ */ y(Da, { children: e }) }) });
  const t = ((a = n == null ? void 0 : n.app) == null ? void 0 : a.settings.translationConfig.language) || ((o = n == null ? void 0 : n.app) == null ? void 0 : o.settings.language) || ((i = n == null ? void 0 : n.app) == null ? void 0 : i.settings.serverLanguage);
  return /* @__PURE__ */ y(ti, { userLanguage: t, children: /* @__PURE__ */ y(
    Cf,
    {
      customTranslations: (s = n.app) == null ? void 0 : s.settings.translationConfig.customTranslations,
      children: /* @__PURE__ */ y(ni, { showErrorBox: n == null ? void 0 : n.showRuntimeErrors, error: r, children: n && /* @__PURE__ */ y(tu.Provider, { value: n, children: /* @__PURE__ */ y(Da, { skipTracking: !0, theme: (l = n.app) == null ? void 0 : l.settings.serverThemeSettings, children: /* @__PURE__ */ y(Pi, { children: e }) }) }) })
    }
  ) });
}, kT = se({
  componentName: "CustomThemeProvider",
  trackingConfig: {
    skip: (n) => {
      var r;
      return !!((r = n.context) != null && r.skipTracking);
    },
    transparent: !0
  },
  shouldSkipSisenseContextWaiting: !0
})((n) => {
  const {
    context: { themeSettings: r },
    error: e,
    children: t
  } = n;
  if (e)
    throw e;
  return /* @__PURE__ */ y(Zt, { children: r && /* @__PURE__ */ y(Up.Provider, { value: { themeSettings: r }, children: t }) });
}), xT = ({ context: n, children: r }) => {
  const { pluginMap: e, registerPlugin: t, getPlugin: a } = n;
  return /* @__PURE__ */ y(Gi.Provider, { value: { registerPlugin: t, getPlugin: a, plugins: e }, children: r });
};
function SC(n) {
  const r = [], e = [];
  return Object.keys(n).forEach((t) => {
    n[t].length && n[t].forEach((a) => {
      nm(a) ? e.push(su(a)) : r.push(iu(a));
    });
  }), {
    dimensions: r,
    measures: e
  };
}
function EC(n) {
  return Object.values(n).reduce((r, e) => (e.forEach((t) => {
    t.numberFormatConfig && r.set(t.column.name, t.numberFormatConfig);
  }), r), /* @__PURE__ */ new Map());
}
function MC(n, r) {
  const e = EC(r);
  return n.rows = n.rows.map(
    (t) => t.map((a, o) => {
      const i = e.get(n.columns[o].name);
      return i ? E(w({}, a), {
        text: ou(rm(i), a.data)
      }) : a;
    })
  ), n;
}
function CT({
  dataSource: n,
  dataOptions: r,
  filters: e,
  highlights: t
}) {
  const { dimensions: a, measures: o } = SC(r), {
    data: i,
    isLoading: s,
    isError: l
  } = dv({
    dataSource: n,
    dimensions: a,
    measures: o,
    filters: e,
    highlights: t
  });
  return { data: pe(() => i && MC(i, r), [i, r]), isLoading: s, isError: l };
}
const PC = (n, r) => {
  const e = w({}, n);
  return e.filters = r, e;
}, AC = (n, r) => {
  const e = w({}, n);
  return e.filters || (e.filters = []), e.filters = [...e.filters, r], e;
}, OC = (n, r) => {
  const e = w({}, n);
  return e.filters || (e.filters = []), e.filters = [...e.filters, ...r], e;
}, NC = (n, r, e) => {
  const t = w({}, n);
  return t.filters || (t.filters = []), t.filters = t.filters.map(
    (a) => a.guid === r.guid ? e : a
  ), t;
}, RC = (n, r) => {
  const e = w({}, n);
  return e.filters || (e.filters = []), e.filters = e.filters.filter((t) => t.guid !== r.guid), e;
}, TT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addFilter: AC,
  addFilters: OC,
  modifyFilter: NC,
  removeFilter: RC,
  replaceFilters: PC
}, Symbol.toStringTag, { value: "Module" }));
function FC(n, r) {
  return Ee(this, null, function* () {
    try {
      const e = yield r.httpClient.get(
        `api/v1/formulas/${n}?flat=true`,
        void 0,
        { skipTrackingParam: !0 }
      );
      return e ? nu(e) : null;
    } catch (e) {
      throw new ne("errors.sharedFormula.failedToFetch");
    }
  });
}
function IC(n, r, e) {
  return Ee(this, null, function* () {
    try {
      const t = yield e.httpClient.get(
        `api/v1/formulas?datasource=${Ln(r)}&flat=true`,
        void 0,
        { skipTrackingParam: !0 }
      ), a = t == null ? void 0 : t.find((o) => o.title === n);
      return a ? nu(a) : null;
    } catch (t) {
      throw new ne("errors.sharedFormula.failedToFetch");
    }
  });
}
const ST = mt("useGetSharedFormula")(LC);
function LC(n) {
  const { name: r, dataSource: e, oid: t } = n;
  if (!(t || r && e))
    throw new ne("errors.sharedFormula.identifierExpected");
  const a = _t(n, ["oid", "name", "dataSource"]), o = hn(n, a), [i, s] = Ht(Dt, {
    isLoading: !0,
    isError: !1,
    isSuccess: !1,
    status: "loading",
    error: void 0,
    data: void 0
  }), { isInitialized: l, app: c } = Ye();
  return ge(() => {
    if (l || s({
      type: "error",
      error: new ne("errors.sisenseContextNotFound")
    }), o(c)) {
      s({ type: "loading" });
      let u = Promise.resolve(null);
      t ? u = FC(t, c) : r && e && (u = IC(r, e, c)), u.then((d) => {
        s({ type: "success", data: d });
      }).catch((d) => {
        s({ type: "error", error: d });
      });
    }
  }, [c, l, r, e, t, o]), i.data && a ? Ml(Dt(i, { type: "loading" })) : Ml(i);
}
function Ml(n) {
  const t = n, { data: r } = t, e = Re(t, ["data"]);
  return E(w({}, e), {
    formula: r
  });
}
const ET = mt("useFetch")(
  (n, r, e) => {
    var i;
    const { app: t } = Ye(), a = t == null ? void 0 : t.httpClient, o = (i = e == null ? void 0 : e.enabled) != null ? i : !0;
    return qp({
      queryKey: ["fetch", n, r, e == null ? void 0 : e.requestConfig],
      queryFn: () => Ee(void 0, null, function* () {
        if (!a)
          throw new ne("errors.httpClientNotFound");
        return a.call(a.url + n, r != null ? r : {}, E(w({}, e == null ? void 0 : e.requestConfig), {
          skipTrackingParam: !0
        }));
      }),
      enabled: o && !!a
      // Ensure the query is enabled only when httpClient is available
    });
  }
);
export {
  lT as AreaChart,
  _T as AreaRangeChart,
  wT as AreamapChart,
  dT as BarChart,
  KC as BasicMemberFilterTile,
  bT as BoxplotChart,
  xx as CascadingFilterTile,
  Ze as Chart,
  jl as ChartWidget,
  cT as ColumnChart,
  AT as ContextMenu,
  vf as CriteriaFilterTile,
  _f as CustomFilterTile,
  xT as CustomPluginsProvider,
  DT as CustomSisenseContextProvider,
  kT as CustomThemeProvider,
  pC as Dashboard,
  XC as DashboardById,
  ZC as DashboardWidget,
  ox as DateFilter,
  gf as DateRangeFilterTile,
  Qp as DrilldownBreadcrumbs,
  iT as DrilldownWidget,
  eT as ExecuteQuery,
  rT as ExecuteQueryByWidgetId,
  Ax as FiltersPanel,
  Cx as FiltersPanelTile,
  fT as FunnelChart,
  mT as IndicatorChart,
  sT as LineChart,
  OT as LoadingIndicator,
  Hl as LoadingOverlay,
  xd as MemberFilterTile,
  uT as PieChart,
  Sy as PivotTable,
  Qu as PivotTableWidget,
  pT as PolarChart,
  bf as RelativeDateFilterTile,
  hT as ScatterChart,
  vT as ScattermapChart,
  oT as SisenseContextProvider,
  yT as SunburstChart,
  NT as Table,
  RT as TableWidget,
  hd as TextWidget,
  Da as ThemeProvider,
  gT as TreemapChart,
  rv as Widget,
  FT as boxWhiskerProcessResult,
  Vg as createClientApplication,
  hp as createDataOptionsFromPanels,
  TT as dashboardHelpers,
  GC as dashboardModelTranslator,
  Dt as dataLoadStateReducer,
  Ai as executeQuery,
  xC as executeQueryByWidgetId,
  JC as extractCombinedFilters,
  SC as extractDimensionsAndMeasures,
  IC as fetchFormula,
  FC as fetchFormulaByOid,
  Ey as getDashboardModel,
  My as getDashboardModels,
  $f as getDefaultThemeSettings,
  IT as getHierarchyModels,
  So as getSortType,
  LT as getThemeSettingsByOid,
  Ry as getWidgetModel,
  YT as isThemeOid,
  WT as processDrilldownSelections,
  ii as queryStateReducer,
  HT as trackHook,
  gc as translateToDashboardResponse,
  yc as translateToDashboardsResponse,
  Ml as translateToFormulaResponse,
  fC as useComposedDashboard,
  $x as useDashboardTheme,
  tT as useExecuteCsvQuery,
  qC as useExecutePivotQuery,
  CT as useExecutePluginQuery,
  dv as useExecuteQuery,
  nT as useExecuteQueryByWidgetId,
  ET as useFetch,
  Py as useGetDashboardModel,
  jC as useGetDashboardModels,
  $T as useGetHierarchyModels,
  ST as useGetSharedFormula,
  LC as useGetSharedFormulaInternal,
  zC as useGetWidgetModel,
  ev as usePlugins,
  aT as useQueryCache,
  ve as useThemeContext,
  VC as widgetModelTranslator
};
(function(){"use strict";try{if(typeof document!="undefined"){var e=document.createElement("style");e.appendChild(document.createTextNode('@charset "UTF-8";.csdk-treemap-tooltip-wrapper{min-width:210px;color:#acacac;font-size:14px;line-height:16px;background:#fff;border-radius:10px;overflow:hidden;margin-right:-1px;padding-bottom:10px}.csdk-treemap-tooltip-level{display:flex;align-items:center;position:relative;padding:8px;font-size:14px;border-bottom:1px solid #ccc}.csdk-treemap-tooltip-level span{padding:0 2px}.csdk-treemap-tooltip-value{padding:10px 10px 0;font-size:12px;line-height:16px}.highcharts-sunburst-series.highcharts-legend-item{pointer-events:none!important}.csdk-boxplot-tooltip-row{display:flex;justify-content:space-between}.csdk-boxplot-tooltip-row>*{margin-right:10px}.csdk-boxplot-tooltip-row>*:last-child{margin-right:0}[class|=csdk],[class|=csdk]:before,[class|=csdk]:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:#d5d5d5;font-family:inherit}*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }.csdk-absolute{position:absolute}.csdk-relative{position:relative}.csdk-left-2{left:.5rem}.csdk-right-0{right:0}.csdk-right-\\[-15px\\]{right:-15px}.csdk-right-\\[-5px\\]{right:-5px}.csdk-right-\\[0px\\]{right:0}.csdk-right-\\[4px\\]{right:4px}.csdk-top-1\\/2{top:50%}.csdk-top-\\[3px\\]{top:3px}.csdk-top-\\[7px\\]{top:7px}.csdk-z-\\[401\\]{z-index:401}.csdk-m-3{margin:.75rem}.csdk-m-auto{margin:auto}.csdk-m-checkbox,.csdk-m-radio{margin:6px 10px 6px 6px}.csdk-mx-auto{margin-left:auto;margin-right:auto}.csdk-my-1{margin-top:.25rem;margin-bottom:.25rem}.csdk-my-2{margin-top:.5rem;margin-bottom:.5rem}.csdk-my-\\[2px\\]{margin-top:2px;margin-bottom:2px}.csdk-my-\\[5px\\]{margin-top:5px;margin-bottom:5px}.csdk-mb-1{margin-bottom:.25rem}.csdk-mb-\\[10px\\]{margin-bottom:10px}.csdk-mb-\\[3px\\]{margin-bottom:3px}.csdk-mb-\\[4px\\]{margin-bottom:4px}.csdk-mb-px{margin-bottom:1px}.csdk-ml-1{margin-left:.25rem}.csdk-ml-1\\.5{margin-left:.375rem}.csdk-ml-2{margin-left:.5rem}.csdk-ml-\\[10px\\]{margin-left:10px}.csdk-ml-\\[4px\\]{margin-left:4px}.csdk-ml-\\[5px\\]{margin-left:5px}.csdk-ml-\\[6px\\]{margin-left:6px}.csdk-ml-\\[7px\\]{margin-left:7px}.csdk-ml-auto{margin-left:auto}.csdk-mr-2{margin-right:.5rem}.csdk-mr-\\[5px\\]{margin-right:5px}.csdk-mr-\\[7px\\]{margin-right:7px}.csdk-mt-2{margin-top:.5rem}.csdk-mt-3{margin-top:.75rem}.csdk-mt-\\[-2px\\]{margin-top:-2px}.csdk-mt-\\[2px\\]{margin-top:2px}.csdk-mt-\\[6px\\]{margin-top:6px}.csdk-box-border{box-sizing:border-box}.csdk-line-clamp-5{overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:5}.csdk-flex{display:flex}.csdk-grid{display:grid}.csdk-h-5{height:1.25rem}.csdk-h-6{height:1.5rem}.csdk-h-\\[100\\%\\]{height:100%}.csdk-h-\\[10px\\]{height:10px}.csdk-h-\\[18px\\]{height:18px}.csdk-h-\\[20px\\]{height:20px}.csdk-h-\\[245px\\]{height:245px}.csdk-h-button{height:28px}.csdk-h-checkbox{height:12px}.csdk-h-full{height:100%}.csdk-h-radio{height:12px}.csdk-h-screen{height:100vh}.csdk-max-h-32{max-height:8rem}.csdk-max-h-\\[150px\\]{max-height:150px}.csdk-min-h-\\[20px\\]{min-height:20px}.csdk-min-h-\\[32px\\]{min-height:32px}.csdk-w-5{width:1.25rem}.csdk-w-\\[100\\%\\]{width:100%}.csdk-w-\\[10px\\]{width:10px}.csdk-w-\\[152px\\]{width:152px}.csdk-w-\\[18px\\]{width:18px}.csdk-w-\\[240px\\]{width:240px}.csdk-w-\\[28px\\]{width:28px}.csdk-w-\\[300px\\]{width:300px}.csdk-w-\\[60px\\]{width:60px}.csdk-w-checkbox{width:12px}.csdk-w-fit{width:-moz-fit-content;width:fit-content}.csdk-w-full{width:100%}.csdk-w-radio{width:12px}.csdk-min-w-fit{min-width:-moz-fit-content;min-width:fit-content}.csdk-max-w-xs{max-width:20rem}.csdk-grow{flex-grow:1}.-csdk-translate-y-1\\/2{--tw-translate-y: -50%;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.csdk-translate-x-1\\/2{--tw-translate-x: 50%;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.-csdk-rotate-90{--tw-rotate: -90deg;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.csdk-rotate-45{--tw-rotate: 45deg;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.csdk-scale-x-\\[-1\\]{--tw-scale-x: -1;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.csdk-transform{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}@keyframes csdk-spin{to{transform:rotate(360deg)}}.csdk-animate-spin{animation:csdk-spin 1s linear infinite}.csdk-cursor-pointer{cursor:pointer}.csdk-select-none{-webkit-user-select:none;-moz-user-select:none;user-select:none}.csdk-grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.csdk-flex-row{flex-direction:row}.csdk-flex-col{flex-direction:column}.csdk-flex-wrap{flex-wrap:wrap}.csdk-items-center{align-items:center}.csdk-justify-end{justify-content:flex-end}.csdk-justify-center{justify-content:center}.csdk-justify-between{justify-content:space-between}.csdk-justify-evenly{justify-content:space-evenly}.csdk-gap-1{gap:.25rem}.csdk-gap-2{gap:.5rem}.csdk-gap-\\[5px\\]{gap:5px}.csdk-gap-x-1{-moz-column-gap:.25rem;column-gap:.25rem}.csdk-gap-x-2{-moz-column-gap:.5rem;column-gap:.5rem}.csdk-gap-y-0{row-gap:0px}.csdk-gap-y-0\\.5{row-gap:.125rem}.csdk-gap-y-4{row-gap:1rem}.csdk-self-center{align-self:center}.csdk-overflow-auto{overflow:auto}.csdk-overflow-hidden{overflow:hidden}.\\!csdk-overflow-visible{overflow:visible!important}.csdk-whitespace-nowrap{white-space:nowrap}.csdk-whitespace-pre-wrap{white-space:pre-wrap}.csdk-rounded{border-radius:.25rem}.csdk-rounded-\\[4px\\]{border-radius:4px}.csdk-rounded-full{border-radius:9999px}.csdk-rounded-md{border-radius:.375rem}.csdk-border{border-width:1px}.csdk-border-0{border-width:0px}.csdk-border-input{border-width:1px}.csdk-border-b{border-bottom-width:1px}.csdk-border-l{border-left-width:1px}.csdk-border-l-\\[70px\\]{border-left-width:70px}.csdk-border-r-\\[70px\\]{border-right-width:70px}.csdk-border-t{border-top-width:1px}.csdk-border-t-\\[13px\\]{border-top-width:13px}.csdk-border-solid{border-style:solid}.csdk-border-none{border-style:none}.csdk-border-UI-default{--tw-border-opacity: 1;border-color:rgb(110 115 125 / var(--tw-border-opacity))}.csdk-border-\\[\\#e4e4e4\\]{--tw-border-opacity: 1;border-color:rgb(228 228 228 / var(--tw-border-opacity))}.csdk-border-transparent{border-color:transparent}.csdk-border-l-\\[transparent\\]{border-left-color:transparent}.csdk-border-r-\\[transparent\\]{border-right-color:transparent}.csdk-bg-\\[\\#f4f4f8\\]{--tw-bg-opacity: 1;background-color:rgb(244 244 248 / var(--tw-bg-opacity))}.csdk-bg-background-priority{background-color:#f4f4f8}.csdk-bg-primary-primary{background-color:#ffcb05}.csdk-bg-transparent{background-color:transparent}.csdk-bg-white{--tw-bg-opacity: 1;background-color:rgb(255 255 255 / var(--tw-bg-opacity))}.csdk-p-1{padding:.25rem}.csdk-p-1\\.5{padding:.375rem}.csdk-p-3{padding:.75rem}.csdk-p-\\[10px\\]{padding:10px}.csdk-p-\\[12px\\]{padding:12px}.csdk-p-\\[20px\\]{padding:20px}.csdk-p-\\[4px\\]{padding:4px}.csdk-p-button{padding:4px 24px}.csdk-p-px{padding:1px}.csdk-px-1{padding-left:.25rem;padding-right:.25rem}.csdk-px-2{padding-left:.5rem;padding-right:.5rem}.csdk-px-4{padding-left:1rem;padding-right:1rem}.csdk-px-\\[12px\\]{padding-left:12px;padding-right:12px}.csdk-px-\\[20px\\]{padding-left:20px;padding-right:20px}.csdk-px-\\[40px\\]{padding-left:40px;padding-right:40px}.csdk-px-\\[8px\\]{padding-left:8px;padding-right:8px}.csdk-py-\\[14\\.5px\\]{padding-top:14.5px;padding-bottom:14.5px}.csdk-py-\\[30px\\]{padding-top:30px;padding-bottom:30px}.csdk-py-\\[5px\\]{padding-top:5px;padding-bottom:5px}.csdk-py-\\[6px\\]{padding-top:6px;padding-bottom:6px}.csdk-py-\\[7px\\]{padding-top:7px;padding-bottom:7px}.csdk-pb-\\[0px\\]{padding-bottom:0}.csdk-pl-1{padding-left:.25rem}.csdk-pl-2{padding-left:.5rem}.csdk-pl-2\\.5{padding-left:.625rem}.csdk-pl-3{padding-left:.75rem}.csdk-pr-10{padding-right:2.5rem}.csdk-pt-48{padding-top:12rem}.csdk-text-left{text-align:left}.csdk-text-center{text-align:center}.csdk-text-\\[13px\\]{font-size:13px}.csdk-text-ai-lg{font-size:18px;line-height:22px}.csdk-text-ai-sm{font-size:13px;line-height:18px}.csdk-text-ai-xs{font-size:11px;line-height:18px}.csdk-text-xs{font-size:.75rem;line-height:1rem}.csdk-font-normal{font-weight:400}.csdk-leading-4{line-height:1rem}.csdk-leading-\\[16px\\]{line-height:16px}.csdk-leading-\\[18px\\]{line-height:18px}.csdk-leading-\\[26px\\]{line-height:26px}.csdk-leading-none{line-height:1}.csdk-text-UI-default{--tw-text-opacity: 1;color:rgb(110 115 125 / var(--tw-text-opacity))}.csdk-text-semantic-error{color:#e74727}.csdk-text-text-active{color:#262e3d}.csdk-text-text-content{color:#262e3dcc}.csdk-text-text-link{color:#36a3d9}.csdk-text-text-linkButton{--tw-text-opacity: 1;color:rgb(30 175 243 / var(--tw-text-opacity))}.csdk-accent-UI-default{accent-color:#6e737d}.csdk-opacity-0{opacity:0}.csdk-opacity-100{opacity:1}.csdk-opacity-50{opacity:.5}.csdk-opacity-80{opacity:.8}.csdk-shadow-md{--tw-shadow: 0 4px 6px -1px rgb(0 0 0 / .1), 0 2px 4px -2px rgb(0 0 0 / .1);--tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.csdk-shadow-gray-500{--tw-shadow-color: #6b7280;--tw-shadow: var(--tw-shadow-colored)}.csdk-outline-0{outline-width:0px}.csdk-transition{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.csdk-transition-opacity{transition-property:opacity;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.csdk-delay-150{transition-delay:.15s}.csdk-duration-500{transition-duration:.5s}.invalid\\:csdk-border-input:invalid{border-width:1px}.invalid\\:csdk-border-solid:invalid{border-style:solid}.invalid\\:csdk-border-semantic-error:invalid{border-color:#e74727}.hover\\:csdk-border-2:hover{border-width:2px}.hover\\:csdk-bg-interaction-primaryHovered:hover{background-color:#f2b900}.hover\\:csdk-bg-row-hover:hover{background-color:#e0e0e04d}.focus\\:csdk-border-input:focus{border-width:1px}.focus\\:csdk-border-solid:focus{border-style:solid}.focus\\:csdk-border-UI-default:focus{--tw-border-opacity: 1;border-color:rgb(110 115 125 / var(--tw-border-opacity))}.disabled\\:csdk-cursor-not-allowed:disabled{cursor:not-allowed}.disabled\\:csdk-opacity-30:disabled{opacity:.3}._container_1wquj_1{display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;padding:0 20px;text-align:center;margin:15px}._container_1wquj_1 ._card_1wquj_11{position:relative;padding:10px;box-shadow:0 2px 4px #0000001a;border-radius:4px;z-index:1;width:100%}._container_1wquj_1 ._text_1wquj_19{font-size:13px;text-align:center;font-weight:700;word-wrap:break-word}.highcharts-series.highcharts-area-series.area-series--without-pointer-events .highcharts-area{pointer-events:none}.leaflet-pane,.leaflet-tile,.leaflet-marker-icon,.leaflet-marker-shadow,.leaflet-tile-container,.leaflet-pane>svg,.leaflet-pane>canvas,.leaflet-zoom-box,.leaflet-image-layer,.leaflet-layer{position:absolute;left:0;top:0}.leaflet-container{overflow:hidden}.leaflet-tile,.leaflet-marker-icon,.leaflet-marker-shadow{-webkit-user-select:none;-moz-user-select:none;user-select:none;-webkit-user-drag:none}.leaflet-tile::-moz-selection{background:transparent}.leaflet-tile::selection{background:transparent}.leaflet-safari .leaflet-tile{image-rendering:-webkit-optimize-contrast}.leaflet-safari .leaflet-tile-container{width:1600px;height:1600px;-webkit-transform-origin:0 0}.leaflet-marker-icon,.leaflet-marker-shadow{display:block}.leaflet-container .leaflet-overlay-pane svg{max-width:none!important;max-height:none!important}.leaflet-container .leaflet-marker-pane img,.leaflet-container .leaflet-shadow-pane img,.leaflet-container .leaflet-tile-pane img,.leaflet-container img.leaflet-image-layer,.leaflet-container .leaflet-tile{max-width:none!important;max-height:none!important;width:auto;padding:0}.leaflet-container img.leaflet-tile{mix-blend-mode:plus-lighter}.leaflet-container.leaflet-touch-zoom{touch-action:pan-x pan-y}.leaflet-container.leaflet-touch-drag{touch-action:none;touch-action:pinch-zoom}.leaflet-container.leaflet-touch-drag.leaflet-touch-zoom{touch-action:none}.leaflet-container{-webkit-tap-highlight-color:transparent}.leaflet-container a{-webkit-tap-highlight-color:rgba(51,181,229,.4)}.leaflet-tile{filter:inherit;visibility:hidden}.leaflet-tile-loaded{visibility:inherit}.leaflet-zoom-box{width:0;height:0;box-sizing:border-box;z-index:800}.leaflet-overlay-pane svg{-moz-user-select:none}.leaflet-pane{z-index:400}.leaflet-tile-pane{z-index:200}.leaflet-overlay-pane{z-index:400}.leaflet-shadow-pane{z-index:500}.leaflet-marker-pane{z-index:600}.leaflet-tooltip-pane{z-index:650}.leaflet-popup-pane{z-index:700}.leaflet-map-pane canvas{z-index:100}.leaflet-map-pane svg{z-index:200}.leaflet-vml-shape{width:1px;height:1px}.lvml{behavior:url(#default#VML);display:inline-block;position:absolute}.leaflet-control{position:relative;z-index:800;pointer-events:visiblePainted;pointer-events:auto}.leaflet-top,.leaflet-bottom{position:absolute;z-index:1000;pointer-events:none}.leaflet-top{top:0}.leaflet-right{right:0}.leaflet-bottom{bottom:0}.leaflet-left{left:0}.leaflet-control{float:left;clear:both}.leaflet-right .leaflet-control{float:right}.leaflet-top .leaflet-control{margin-top:10px}.leaflet-bottom .leaflet-control{margin-bottom:10px}.leaflet-left .leaflet-control{margin-left:10px}.leaflet-right .leaflet-control{margin-right:10px}.leaflet-fade-anim .leaflet-popup{opacity:0;transition:opacity .2s linear}.leaflet-fade-anim .leaflet-map-pane .leaflet-popup{opacity:1}.leaflet-zoom-animated{transform-origin:0 0}svg.leaflet-zoom-animated{will-change:transform}.leaflet-zoom-anim .leaflet-zoom-animated{transition:transform .25s cubic-bezier(0,0,.25,1)}.leaflet-zoom-anim .leaflet-tile,.leaflet-pan-anim .leaflet-tile{transition:none}.leaflet-zoom-anim .leaflet-zoom-hide{visibility:hidden}.leaflet-interactive{cursor:pointer}.leaflet-grab{cursor:grab}.leaflet-crosshair,.leaflet-crosshair .leaflet-interactive{cursor:crosshair}.leaflet-popup-pane,.leaflet-control{cursor:auto}.leaflet-dragging .leaflet-grab,.leaflet-dragging .leaflet-grab .leaflet-interactive,.leaflet-dragging .leaflet-marker-draggable{cursor:move;cursor:grabbing}.leaflet-marker-icon,.leaflet-marker-shadow,.leaflet-image-layer,.leaflet-pane>svg path,.leaflet-tile-container{pointer-events:none}.leaflet-marker-icon.leaflet-interactive,.leaflet-image-layer.leaflet-interactive,.leaflet-pane>svg path.leaflet-interactive,svg.leaflet-image-layer.leaflet-interactive path{pointer-events:visiblePainted;pointer-events:auto}.leaflet-container{background:#ddd;outline-offset:1px}.leaflet-container a{color:#0078a8}.leaflet-zoom-box{border:2px dotted #38f;background:#ffffff80}.leaflet-container{font-family:Helvetica Neue,Arial,Helvetica,sans-serif;font-size:12px;font-size:.75rem;line-height:1.5}.leaflet-bar{box-shadow:0 1px 5px #000000a6;border-radius:4px}.leaflet-bar a{background-color:#fff;border-bottom:1px solid #ccc;width:26px;height:26px;line-height:26px;display:block;text-align:center;text-decoration:none;color:#000}.leaflet-bar a,.leaflet-control-layers-toggle{background-position:50% 50%;background-repeat:no-repeat;display:block}.leaflet-bar a:hover,.leaflet-bar a:focus{background-color:#f4f4f4}.leaflet-bar a:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.leaflet-bar a:last-child{border-bottom-left-radius:4px;border-bottom-right-radius:4px;border-bottom:none}.leaflet-bar a.leaflet-disabled{cursor:default;background-color:#f4f4f4;color:#bbb}.leaflet-touch .leaflet-bar a{width:30px;height:30px;line-height:30px}.leaflet-touch .leaflet-bar a:first-child{border-top-left-radius:2px;border-top-right-radius:2px}.leaflet-touch .leaflet-bar a:last-child{border-bottom-left-radius:2px;border-bottom-right-radius:2px}.leaflet-control-zoom-in,.leaflet-control-zoom-out{font:700 18px Lucida Console,Monaco,monospace;text-indent:1px}.leaflet-touch .leaflet-control-zoom-in,.leaflet-touch .leaflet-control-zoom-out{font-size:22px}.leaflet-control-layers{box-shadow:0 1px 5px #0006;background:#fff;border-radius:5px}.leaflet-control-layers-toggle{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAQAAAADQ4RFAAACf0lEQVR4AY1UM3gkARTePdvdoTxXKc+qTl3aU5U6b2Kbkz3Gtq3Zw6ziLGNPzrYx7946Tr6/ee/XeCQ4D3ykPtL5tHno4n0d/h3+xfuWHGLX81cn7r0iTNzjr7LrlxCqPtkbTQEHeqOrTy4Yyt3VCi/IOB0v7rVC7q45Q3Gr5K6jt+3Gl5nCoDD4MtO+j96Wu8atmhGqcNGHObuf8OM/x3AMx38+4Z2sPqzCxRFK2aF2e5Jol56XTLyggAMTL56XOMoS1W4pOyjUcGGQdZxU6qRh7B9Zp+PfpOFlqt0zyDZckPi1ttmIp03jX8gyJ8a/PG2yutpS/Vol7peZIbZcKBAEEheEIAgFbDkz5H6Zrkm2hVWGiXKiF4Ycw0RWKdtC16Q7qe3X4iOMxruonzegJzWaXFrU9utOSsLUmrc0YjeWYjCW4PDMADElpJSSQ0vQvA1Tm6/JlKnqFs1EGyZiFCqnRZTEJJJiKRYzVYzJck2Rm6P4iH+cmSY0YzimYa8l0EtTODFWhcMIMVqdsI2uiTvKmTisIDHJ3od5GILVhBCarCfVRmo4uTjkhrhzkiBV7SsaqS+TzrzM1qpGGUFt28pIySQHR6h7F6KSwGWm97ay+Z+ZqMcEjEWebE7wxCSQwpkhJqoZA5ivCdZDjJepuJ9IQjGGUmuXJdBFUygxVqVsxFsLMbDe8ZbDYVCGKxs+W080max1hFCarCfV+C1KATwcnvE9gRRuMP2prdbWGowm1KB1y+zwMMENkM755cJ2yPDtqhTI6ED1M/82yIDtC/4j4BijjeObflpO9I9MwXTCsSX8jWAFeHr05WoLTJ5G8IQVS/7vwR6ohirYM7f6HzYpogfS3R2OAAAAAElFTkSuQmCC);width:36px;height:36px}.leaflet-retina .leaflet-control-layers-toggle{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAQAAABvcdNgAAAEsklEQVR4AWL4TydIhpZK1kpWOlg0w3ZXP6D2soBtG42jeI6ZmQTHzAxiTbSJsYLjO9HhP+WOmcuhciVnmHVQcJnp7DFvScowZorad/+V/fVzMdMT2g9Cv9guXGv/7pYOrXh2U+RRR3dSd9JRx6bIFc/ekqHI29JC6pJ5ZEh1yWkhkbcFeSjxgx3L2m1cb1C7bceyxA+CNjT/Ifff+/kDk2u/w/33/IeCMOSaWZ4glosqT3DNnNZQ7Cs58/3Ce5HL78iZH/vKVIaYlqzfdLu8Vi7dnvUbEza5Idt36tquZFldl6N5Z/POLof0XLK61mZCmJSWjVF9tEjUluu74IUXvgttuVIHE7YxSkaYhJZam7yiM9Pv82JYfl9nptxZaxMJE4YSPty+vF0+Y2up9d3wwijfjZbabqm/3bZ9ecKHsiGmRflnn1MW4pjHf9oLufyn2z3y1D6n8g8TZhxyzipLNPnAUpsOiuWimg52psrTZYnOWYNDTMuWBWa0tJb4rgq1UvmutpaYEbZlwU3CLJm/ayYjHW5/h7xWLn9Hh1vepDkyf7dE7MtT5LR4e7yYpHrkhOUpEfssBLq2pPhAqoSWKUkk7EDqkmK6RrCEzqDjhNDWNE+XSMvkJRDWlZTmCW0l0PHQGRZY5t1L83kT0Y3l2SItk5JAWHl2dCOBm+fPu3fo5/3v61RMCO9Jx2EEYYhb0rmNQMX/vm7gqOEJLcXTGw3CAuRNeyaPWwjR8PRqKQ1PDA/dpv+on9Shox52WFnx0KY8onHayrJzm87i5h9xGw/tfkev0jGsQizqezUKjk12hBMKJ4kbCqGPVNXudyyrShovGw5CgxsRICxF6aRmSjlBnHRzg7Gx8fKqEubI2rahQYdR1YgDIRQO7JvQyD52hoIQx0mxa0ODtW2Iozn1le2iIRdzwWewedyZzewidueOGqlsn1MvcnQpuVwLGG3/IR1hIKxCjelIDZ8ldqWz25jWAsnldEnK0Zxro19TGVb2ffIZEsIO89EIEDvKMPrzmBOQcKQ+rroye6NgRRxqR4U8EAkz0CL6uSGOm6KQCdWjvjRiSP1BPalCRS5iQYiEIvxuBMJEWgzSoHADcVMuN7IuqqTeyUPq22qFimFtxDyBBJEwNyt6TM88blFHao/6tWWhuuOM4SAK4EI4QmFHA+SEyWlp4EQoJ13cYGzMu7yszEIBOm2rVmHUNqwAIQabISNMRstmdhNWcFLsSm+0tjJH1MdRxO5Nx0WDMhCtgD6OKgZeljJqJKc9po8juskR9XN0Y1lZ3mWjLR9JCO1jRDMd0fpYC2VnvjBSEFg7wBENc0R9HFlb0xvF1+TBEpF68d+DHR6IOWVv2BECtxo46hOFUBd/APU57WIoEwJhIi2CdpyZX0m93BZicktMj1AS9dClteUFAUNUIEygRZCtik5zSxI9MubTBH1GOiHsiLJ3OCoSZkILa9PxiN0EbvhsAo8tdAf9Seepd36lGWHmtNANTv5Jd0z4QYyeo/UEJqxKRpg5LZx6btLPsOaEmdMyxYdlc8LMaJnikDlhclqmPiQnTEpLUIZEwkRagjYkEibQErwhkTAKCLQEbUgkzJQWc/0PstHHcfEdQ+UAAAAASUVORK5CYII=);background-size:26px 26px}.leaflet-touch .leaflet-control-layers-toggle{width:44px;height:44px}.leaflet-control-layers .leaflet-control-layers-list,.leaflet-control-layers-expanded .leaflet-control-layers-toggle{display:none}.leaflet-control-layers-expanded .leaflet-control-layers-list{display:block;position:relative}.leaflet-control-layers-expanded{padding:6px 10px 6px 6px;color:#333;background:#fff}.leaflet-control-layers-scrollbar{overflow-y:scroll;overflow-x:hidden;padding-right:5px}.leaflet-control-layers-selector{margin-top:2px;position:relative;top:1px}.leaflet-control-layers label{display:block;font-size:13px;font-size:1.08333em}.leaflet-control-layers-separator{height:0;border-top:1px solid #ddd;margin:5px -10px 5px -6px}.leaflet-default-icon-path{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAApCAYAAADAk4LOAAAFgUlEQVR4Aa1XA5BjWRTN2oW17d3YaZtr2962HUzbDNpjszW24mRt28p47v7zq/bXZtrp/lWnXr337j3nPCe85NcypgSFdugCpW5YoDAMRaIMqRi6aKq5E3YqDQO3qAwjVWrD8Ncq/RBpykd8oZUb/kaJutow8r1aP9II0WmLKLIsJyv1w/kqw9Ch2MYdB++12Onxee/QMwvf4/Dk/Lfp/i4nxTXtOoQ4pW5Aj7wpici1A9erdAN2OH64x8OSP9j3Ft3b7aWkTg/Fm91siTra0f9on5sQr9INejH6CUUUpavjFNq1B+Oadhxmnfa8RfEmN8VNAsQhPqF55xHkMzz3jSmChWU6f7/XZKNH+9+hBLOHYozuKQPxyMPUKkrX/K0uWnfFaJGS1QPRtZsOPtr3NsW0uyh6NNCOkU3Yz+bXbT3I8G3xE5EXLXtCXbbqwCO9zPQYPRTZ5vIDXD7U+w7rFDEoUUf7ibHIR4y6bLVPXrz8JVZEql13trxwue/uDivd3fkWRbS6/IA2bID4uk0UpF1N8qLlbBlXs4Ee7HLTfV1j54APvODnSfOWBqtKVvjgLKzF5YdEk5ewRkGlK0i33Eofffc7HT56jD7/6U+qH3Cx7SBLNntH5YIPvODnyfIXZYRVDPqgHtLs5ABHD3YzLuespb7t79FY34DjMwrVrcTuwlT55YMPvOBnRrJ4VXTdNnYug5ucHLBjEpt30701A3Ts+HEa73u6dT3FNWwflY86eMHPk+Yu+i6pzUpRrW7SNDg5JHR4KapmM5Wv2E8Tfcb1HoqqHMHU+uWDD7zg54mz5/2BSnizi9T1Dg4QQXLToGNCkb6tb1NU+QAlGr1++eADrzhn/u8Q2YZhQVlZ5+CAOtqfbhmaUCS1ezNFVm2imDbPmPng5wmz+gwh+oHDce0eUtQ6OGDIyR0uUhUsoO3vfDmmgOezH0mZN59x7MBi++WDL1g/eEiU3avlidO671bkLfwbw5XV2P8Pzo0ydy4t2/0eu33xYSOMOD8hTf4CrBtGMSoXfPLchX+J0ruSePw3LZeK0juPJbYzrhkH0io7B3k164hiGvawhOKMLkrQLyVpZg8rHFW7E2uHOL888IBPlNZ1FPzstSJM694fWr6RwpvcJK60+0HCILTBzZLFNdtAzJaohze60T8qBzyh5ZuOg5e7uwQppofEmf2++DYvmySqGBuKaicF1blQjhuHdvCIMvp8whTTfZzI7RldpwtSzL+F1+wkdZ2TBOW2gIF88PBTzD/gpeREAMEbxnJcaJHNHrpzji0gQCS6hdkEeYt9DF/2qPcEC8RM28Hwmr3sdNyht00byAut2k3gufWNtgtOEOFGUwcXWNDbdNbpgBGxEvKkOQsxivJx33iow0Vw5S6SVTrpVq11ysA2Rp7gTfPfktc6zhtXBBC+adRLshf6sG2RfHPZ5EAc4sVZ83yCN00Fk/4kggu40ZTvIEm5g24qtU4KjBrx/BTTH8ifVASAG7gKrnWxJDcU7x8X6Ecczhm3o6YicvsLXWfh3Ch1W0k8x0nXF+0fFxgt4phz8QvypiwCCFKMqXCnqXExjq10beH+UUA7+nG6mdG/Pu0f3LgFcGrl2s0kNNjpmoJ9o4B29CMO8dMT4Q5ox8uitF6fqsrJOr8qnwNbRzv6hSnG5wP+64C7h9lp30hKNtKdWjtdkbuPA19nJ7Tz3zR/ibgARbhb4AlhavcBebmTHcFl2fvYEnW0ox9xMxKBS8btJ+KiEbq9zA4RthQXDhPa0T9TEe69gWupwc6uBUphquXgf+/FrIjweHQS4/pduMe5ERUMHUd9xv8ZR98CxkS4F2n3EUrUZ10EYNw7BWm9x1GiPssi3GgiGRDKWRYZfXlON+dfNbM+GgIwYdwAAAAASUVORK5CYII=)}.leaflet-container .leaflet-control-attribution{background:#fff;background:#fffc;margin:0}.leaflet-control-attribution,.leaflet-control-scale-line{padding:0 5px;color:#333;line-height:1.4}.leaflet-control-attribution a{text-decoration:none}.leaflet-control-attribution a:hover,.leaflet-control-attribution a:focus{text-decoration:underline}.leaflet-attribution-flag{display:inline!important;vertical-align:baseline!important;width:1em;height:.6669em}.leaflet-left .leaflet-control-scale{margin-left:5px}.leaflet-bottom .leaflet-control-scale{margin-bottom:5px}.leaflet-control-scale-line{border:2px solid #777;border-top:none;line-height:1.1;padding:2px 5px 1px;white-space:nowrap;box-sizing:border-box;background:#fffc;text-shadow:1px 1px #fff}.leaflet-control-scale-line:not(:first-child){border-top:2px solid #777;border-bottom:none;margin-top:-2px}.leaflet-control-scale-line:not(:first-child):not(:last-child){border-bottom:2px solid #777}.leaflet-touch .leaflet-control-attribution,.leaflet-touch .leaflet-control-layers,.leaflet-touch .leaflet-bar{box-shadow:none}.leaflet-touch .leaflet-control-layers,.leaflet-touch .leaflet-bar{border:2px solid rgba(0,0,0,.2);background-clip:padding-box}.leaflet-popup{position:absolute;text-align:center;margin-bottom:20px}.leaflet-popup-content-wrapper{padding:1px;text-align:left;border-radius:12px}.leaflet-popup-content{margin:13px 24px 13px 20px;line-height:1.3;font-size:13px;font-size:1.08333em;min-height:1px}.leaflet-popup-content p{margin:1.3em 0}.leaflet-popup-tip-container{width:40px;height:20px;position:absolute;left:50%;margin-top:-1px;margin-left:-20px;overflow:hidden;pointer-events:none}.leaflet-popup-tip{width:17px;height:17px;padding:1px;margin:-10px auto 0;pointer-events:auto;transform:rotate(45deg)}.leaflet-popup-content-wrapper,.leaflet-popup-tip{background:#fff;color:#333;box-shadow:0 3px 14px #0006}.leaflet-container a.leaflet-popup-close-button{position:absolute;top:0;right:0;border:none;text-align:center;width:24px;height:24px;font:16px/24px Tahoma,Verdana,sans-serif;color:#757575;text-decoration:none;background:transparent}.leaflet-container a.leaflet-popup-close-button:hover,.leaflet-container a.leaflet-popup-close-button:focus{color:#585858}.leaflet-popup-scrolled{overflow:auto}.leaflet-oldie .leaflet-popup-content-wrapper{-ms-zoom:1}.leaflet-oldie .leaflet-popup-tip{width:24px;margin:0 auto;-ms-filter:"progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678, M12=0.70710678, M21=-0.70710678, M22=0.70710678)";filter:progid:DXImageTransform.Microsoft.Matrix(M11=.70710678,M12=.70710678,M21=-.70710678,M22=.70710678)}.leaflet-oldie .leaflet-control-zoom,.leaflet-oldie .leaflet-control-layers,.leaflet-oldie .leaflet-popup-content-wrapper,.leaflet-oldie .leaflet-popup-tip{border:1px solid #999}.leaflet-div-icon{background:#fff;border:1px solid #666}.leaflet-tooltip{position:absolute;padding:6px;background-color:#fff;border:1px solid #fff;border-radius:3px;color:#222;white-space:nowrap;-webkit-user-select:none;-moz-user-select:none;user-select:none;pointer-events:none;box-shadow:0 1px 3px #0006}.leaflet-tooltip.leaflet-interactive{cursor:pointer;pointer-events:auto}.leaflet-tooltip-top:before,.leaflet-tooltip-bottom:before,.leaflet-tooltip-left:before,.leaflet-tooltip-right:before{position:absolute;pointer-events:none;border:6px solid transparent;background:transparent;content:""}.leaflet-tooltip-bottom{margin-top:6px}.leaflet-tooltip-top{margin-top:-6px}.leaflet-tooltip-bottom:before,.leaflet-tooltip-top:before{left:50%;margin-left:-6px}.leaflet-tooltip-top:before{bottom:0;margin-bottom:-12px;border-top-color:#fff}.leaflet-tooltip-bottom:before{top:0;margin-top:-12px;margin-left:-6px;border-bottom-color:#fff}.leaflet-tooltip-left{margin-left:-6px}.leaflet-tooltip-right{margin-left:6px}.leaflet-tooltip-left:before,.leaflet-tooltip-right:before{top:50%;margin-top:-6px}.leaflet-tooltip-left:before{right:0;margin-right:-12px;border-left-color:#fff}.leaflet-tooltip-right:before{left:0;margin-left:-12px;border-right-color:#fff}@media print{.leaflet-control{-webkit-print-color-adjust:exact;print-color-adjust:exact}}.csdk-map-container .leaflet-interactive{outline:none}.csdk-scattermap-tooltip-row{display:flex;justify-content:space-between}._alert_box_10ttx_1{position:absolute;display:flex;justify-content:center;z-index:1;margin-top:1%}._alert_box_10ttx_1 ._content_10ttx_8{background-color:#616161;padding:5px;border-radius:3px;text-align:center}._alert_box_10ttx_1 ._content_10ttx_8 ._alert_10ttx_1{color:#fff;margin:0 8px;line-height:1;font-size:12px}._wrapper_g0ngm_1{width:100%;height:100%;position:relative}._title_g0ngm_7{font-size:18px;color:#9ea2ab;letter-spacing:normal;text-align:center;position:absolute;width:100%;top:11%}._image_g0ngm_18{width:66.6%;height:100%;margin:0 auto;display:block}.fixedDataTableCellGroupLayout_cellGroup{backface-visibility:hidden;left:0;overflow:hidden;position:absolute;top:0;white-space:nowrap}.fixedDataTable_isRTL .fixedDataTableCellGroupLayout_cellGroup{right:0;left:auto}.fixedDataTableCellGroupLayout_cellGroup>.public_fixedDataTableCell_main{display:inline-block;vertical-align:top;white-space:normal}.fixedDataTableCellGroupLayout_cellGroupWrapper{position:absolute;top:0}.fixedDataTableCellLayout_main{border-right-style:solid;border-right-width:1px;border-width:0 1px 0 0;box-sizing:border-box;display:block;overflow:hidden;position:absolute;white-space:normal}.fixedDataTable_isRTL .fixedDataTableCellLayout_main{border-right-width:0;border-left-style:solid;border-left-width:1px}.fixedDataTableCellLayout_lastChild{border-width:0 1px 1px 0}.fixedDataTableCellLayout_alignRight{text-align:right}.fixedDataTableCellLayout_alignCenter{text-align:center}.fixedDataTableCellLayout_wrap{display:table-cell;vertical-align:middle;box-sizing:border-box}.fixedDataTableCellLayout_wrap1{display:table}.fixedDataTableCellLayout_wrap2{display:table-row}.fixedDataTableCellLayout_wrap3{display:table-cell;vertical-align:middle}.fixedDataTableCellLayout_columnResizerContainer{position:absolute;right:0;width:6px;z-index:1}.fixedDataTable_isRTL .fixedDataTableCellLayout_columnResizerContainer{left:0;right:auto}.fixedDataTableCellLayout_columnResizerContainer:hover{cursor:ew-resize}.fixedDataTableCellLayout_columnResizerContainer:hover .fixedDataTableCellLayout_columnResizerKnob{visibility:visible}.fixedDataTableCellLayout_columnResizerKnob{position:absolute;right:0;visibility:hidden;width:4px}.fixedDataTable_isRTL .fixedDataTableCellLayout_columnResizerKnob{left:0;right:auto}.fixedDataTableColumnResizerLineLayout_mouseArea{cursor:ew-resize;position:absolute;right:-5px;width:12px}.fixedDataTable_isRTL .fixedDataTableColumnResizerLineLayout_mouseArea{right:auto;left:-5px}.fixedDataTableColumnResizerLineLayout_main{border-right-style:solid;border-right-width:1px;box-sizing:border-box;position:absolute;z-index:10;pointer-events:none}.fixedDataTable_isRTL .fixedDataTableColumnResizerLineLayout_main{border-right-width:0;border-left-style:solid;border-left-width:1px}.fixedDataTableColumnResizerLineLayout_hiddenElem{display:none!important}.fixedDataTableLayout_main{border-style:solid;border-width:1px;box-sizing:border-box;overflow:hidden;position:relative}.fixedDataTableLayout_header,.fixedDataTableLayout_hasBottomBorder{border-bottom-style:solid;border-bottom-width:1px}.fixedDataTableLayout_footer .public_fixedDataTableCell_main{border-top-style:solid;border-top-width:1px}.fixedDataTableLayout_topShadow,.fixedDataTableLayout_bottomShadow{height:4px;left:0;position:absolute;right:0;z-index:1}.fixedDataTableLayout_bottomShadow{margin-top:-4px}.fixedDataTableLayout_rowsContainer{overflow:hidden;position:relative}.fixedDataTableRowLayout_main{box-sizing:border-box;overflow:hidden;position:absolute;top:0}.fixedDataTableRowLayout_body{left:0;right:0;position:absolute;top:0}.fixedDataTableRowLayout_rowExpanded{box-sizing:border-box;left:0;position:absolute}.fixedDataTableRowLayout_fixedColumnsDivider{backface-visibility:hidden;border-left-style:solid;border-left-width:1px;left:0;position:absolute;top:0;width:0}.fixedDataTable_isRTL .fixedDataTableRowLayout_fixedColumnsDivider{border-left-width:0;border-right-style:solid;border-right-width:1px}.fixedDataTableRowLayout_columnsShadow{position:absolute;width:4px}.fixedDataTableRowLayout_columnsRightShadow{right:1px}.fixedDataTable_isRTL .fixedDataTableRowLayout_columnsRightShadow{left:1px;right:auto}.fixedDataTableRowLayout_rowWrapper{position:absolute;top:0}.ScrollbarLayout_main{box-sizing:border-box;outline:none;overflow:hidden;position:absolute;-webkit-user-select:none;-moz-user-select:none;user-select:none}.ScrollbarLayout_mainVertical{bottom:0;right:0;top:0;width:15px}.ScrollbarLayout_mainHorizontal{height:15px;left:0;transition-property:background-color height}.ScrollbarLayout_mainHorizontal.public_Scrollbar_mainActive,.ScrollbarLayout_mainHorizontal:hover{height:17px}.ScrollbarLayout_face{left:0;overflow:hidden;position:absolute;z-index:1;transition-duration:.25s;transition-timing-function:ease;transition-property:width}.ScrollbarLayout_face:after{border-radius:6px;content:"";display:block;position:absolute;transition:background-color .25s ease}.ScrollbarLayout_faceHorizontal{bottom:0;left:0;top:0}.ScrollbarLayout_faceHorizontal:after{bottom:4px;left:0;top:4px;width:100%}.fixedDataTable_isRTL .ScrollbarLayout_faceHorizontal,.fixedDataTable_isRTL .ScrollbarLayout_faceHorizontal:after{right:0;left:auto}.ScrollbarLayout_faceHorizontal.public_Scrollbar_faceActive:after,.ScrollbarLayout_main:hover .ScrollbarLayout_faceHorizontal:after{bottom:2px}.ScrollbarLayout_faceVertical{left:0;right:0;top:0}.ScrollbarLayout_faceVertical:after{height:100%;left:4px;right:4px;top:0}.ScrollbarLayout_main:hover .ScrollbarLayout_faceVertical:after,.ScrollbarLayout_faceVertical.public_Scrollbar_faceActive:after{left:2px;right:2px}.public_fixedDataTable_main,.public_fixedDataTable_header,.public_fixedDataTable_hasBottomBorder{border-color:#d3d3d3}.public_fixedDataTable_header .public_fixedDataTableCell_main{font-weight:700}.public_fixedDataTable_header,.public_fixedDataTable_scrollbarSpacer,.public_fixedDataTable_header .public_fixedDataTableCell_main{background-color:#f6f7f8;background-image:linear-gradient(#fff,#efefef)}.public_fixedDataTable_scrollbarSpacer{position:absolute;z-index:99;top:0}.public_fixedDataTable_footer .public_fixedDataTableCell_main{background-color:#f6f7f8;border-color:#d3d3d3}.public_fixedDataTable_topShadow{background-image:linear-gradient(180deg,#0000001a,#0000)}.public_fixedDataTable_bottomShadow{background-image:linear-gradient(0deg,#0000001a,#0000)}.public_fixedDataTable_horizontalScrollbar .public_Scrollbar_mainHorizontal{background-color:#fff}.public_fixedDataTableCell_main{background-color:#fff;border-color:#d3d3d3}.public_fixedDataTableCell_highlighted{background-color:#f4f4f4}.public_fixedDataTableCell_cellContent{padding:8px}.public_fixedDataTableCell_columnResizerKnob{background-color:#0284ff}.public_fixedDataTableCell_hasReorderHandle .public_fixedDataTableCell_wrap1 .public_fixedDataTableCell_cellContent{margin-left:12px}.public_fixedDataTableCell_hasReorderHandle .public_fixedDataTableCell_wrap.public_fixedDataTableCell_cellContent{padding-left:20px}.fixedDataTable_isRTL .public_fixedDataTableCell_hasReorderHandle .public_fixedDataTableCell_wrap1 .public_fixedDataTableCell_cellContent{margin-left:auto;margin-right:12px}.fixedDataTable_isRTL .public_fixedDataTableCell_hasReorderHandle .public_fixedDataTableCell_wrap.public_fixedDataTableCell_cellContent{padding-right:20px}.fixedDataTableCellLayout_columnReorderContainer{border-color:#0284ff;background-color:#0000001a;width:12px;margin-right:-12px;float:left;cursor:move}.fixedDataTable_isRTL .fixedDataTableCellLayout_columnReorderContainer{margin-right:auto;margin-left:-12px;float:right}.fixedDataTableCellLayout_columnReorderContainer:after{content:"::";position:absolute;top:50%;left:1px;transform:translateY(-50%)}.fixedDataTable_isRTL .fixedDataTableCellLayout_columnReorderContainer:after{left:auto;right:1px}.public_fixedDataTableColumnResizerLine_main{border-color:#0284ff}.public_fixedDataTableRow_main{background-color:#fff}.public_fixedDataTableRow_highlighted,.public_fixedDataTableRow_highlighted .public_fixedDataTableCell_main{background-color:#f6f7f8}.public_fixedDataTableRow_fixedColumnsDivider{border-color:#d3d3d3}.public_fixedDataTableRow_columnsShadow{background-image:linear-gradient(90deg,#0000001a,#0000)}.fixedDataTable_isRTL .public_fixedDataTableRow_columnsShadow{background-image:linear-gradient(270deg,#0000001a,#0000)}.public_fixedDataTableRow_columnsRightShadow{transform:rotate(180deg)}.public_Scrollbar_main.public_Scrollbar_mainActive,.public_Scrollbar_main{background-color:#fff;border-left:1px solid #d3d3d3}.fixedDataTable_isRTL .public_Scrollbar_main.public_Scrollbar_mainActive,.fixedDataTable_isRTL .public_Scrollbar_main{border-right:1px solid #d3d3d3;border-left-width:0}.public_Scrollbar_mainOpaque,.public_Scrollbar_mainOpaque.public_Scrollbar_mainActive,.public_Scrollbar_mainOpaque:hover{background-color:#fff}.public_Scrollbar_face:after{background-color:#c2c2c2}.public_Scrollbar_main:hover .public_Scrollbar_face:after,.public_Scrollbar_mainActive .public_Scrollbar_face:after,.public_Scrollbar_faceActive:after{background-color:#7d7d7d}._tableWrapper_1ode4_16 .public_fixedDataTable_header,._tableWrapper_1ode4_16 .public_fixedDataTable_scrollbarSpacer,._tableWrapper_1ode4_16 .public_fixedDataTable_header .public_fixedDataTableCell_main{background-color:transparent;background-image:none;border-bottom:1px solid #edeef1}._tableWrapper_1ode4_16 .public_fixedDataTable_scrollbarSpacer{margin-left:3px}._tableWrapper_1ode4_16 .public_fixedDataTable_main,._tableWrapper_1ode4_16 .fixedDataTableLayout_main{border:none}._tableWrapper_1ode4_16 .public_fixedDataTableRow_highlighted,._tableWrapper_1ode4_16 .public_fixedDataTableRow_highlighted .public_fixedDataTableCell_main,._tableWrapper_1ode4_16 .public_fixedDataTableRow_main{background-color:transparent}._tableWrapper_1ode4_16 .public_fixedDataTableCell_main{background-color:transparent;border-color:#edeef1}._tableWrapper_1ode4_16 .public_fixedDataTable_header,._tableWrapper_1ode4_16 .public_fixedDataTable_hasBottomBorder,._tableWrapper_1ode4_16 .public_fixedDataTable_scrollbarSpacer{border-bottom:none}._tableWrapper_1ode4_16 .public_fixedDataTable_header .fixedDataTableCellGroupLayout_cellGroup{border-top:1px solid #edeef1;border-bottom:1px solid #edeef1;box-sizing:border-box}._tableWrapper_1ode4_16 .public_Scrollbar_main{border-left:none;background-color:transparent}._tableWrapper_1ode4_16 .fixedDataTableRowLayout_rowWrapper{border-left:1px solid #edeef1}._tableWrapper_1ode4_16 .public_Scrollbar_main.public_Scrollbar_mainOpaque{left:-1px}._tableWrapper_1ode4_16 .public_fixedDataTableCell_cellContent{padding:0 24px 0 12px}._tableWrapper_1ode4_16{height:100%;width:100%;box-sizing:border-box;-webkit-user-select:text;-moz-user-select:text;user-select:text}._table_1ode4_16{background:transparent;font-size:13px;border:none}._tableHeader_1ode4_78{color:#5c6372;background-color:transparent;margin:0;border:none;width:100%;overflow:hidden;box-sizing:border-box}._tableCell_1ode4_88{color:#5c6372;background-color:transparent;border:none;border-right:1px solid #edeef1;border-bottom:1px solid #edeef1;overflow:hidden;width:100%;box-sizing:border-box}._tableCellContent_1ode4_99{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}._headerColor_1ode4_105,._rowColor_1ode4_109{background-color:#f9f9fb}._headerCell_2qf2w_16{display:flex;justify-content:left;align-items:center;margin-left:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:400;width:100%;cursor:pointer}._headerCell_2qf2w_16:hover ._noSort_2qf2w_29._standard_2qf2w_29{background-image:url(data:image/svg+xml;charset=utf8;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjMxMyAxN2g3LjY2N2EuNDkuNDkgMCAwMS40NzkuNS40OS40OSAwIDAxLS40OC41SDQuMzE0YS40OS40OSAwIDAxLS40NzktLjVjMC0uMjc2LjIxNS0uNS40OC0uNXptNS43NS0zaC01Ljc1YS40OS40OSAwIDAwLS40NzkuNWMwIC4yNzYuMjE1LjUuNDguNWg1Ljc1YS40OS40OSAwIDAwLjQ3OC0uNS40OS40OSAwIDAwLS40NzktLjV6bS01Ljc1LTNoMy44MzNhLjQ5LjQ5IDAgMDEuNDguNS40OS40OSAwIDAxLS40OC41SDQuMzEzYS40OS40OSAwIDAxLS40NzktLjVjMC0uMjc2LjIxNS0uNS40OC0uNXptMC0zSDYuMjNhLjQ5LjQ5IDAgMDEuNDc5LjUuNDkuNDkgMCAwMS0uNDguNUg0LjMxNGEuNDkuNDkgMCAwMS0uNDc5LS41YzAtLjI3Ni4yMTUtLjUuNDgtLjV6bTEwLjU0MiAwYS40OS40OSAwIDAwLS40OC41djQuNzkzbC0yLjA1Ny0yLjE0N2EuNDY1LjQ2NSAwIDAwLS42NzggMCAuNTE1LjUxNSAwIDAwMCAuNzA4bDIuODY2IDIuOTlhLjQ2OC40NjggMCAwMC42OTYgMGwyLjg2Ni0yLjk5YS41MTYuNTE2IDAgMDAwLS43MDguNDY1LjQ2NSAwIDAwLS42NzggMGwtMi4wNTYgMi4xNDZWOC41YS40OS40OSAwIDAwLS40OC0uNXoiIGZpbGw9IiM1QzYzNzIiLz48L3N2Zz4K)}._headerCell_2qf2w_16:hover ._noSort_2qf2w_29._caret_2qf2w_33{background-image:url(data:image/svg+xml;charset=utf8;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTExLjk5OSAxMy44NGwzLjE3NS0yLjcxOWEuNS41IDAgMDEuNjUuNzZsLTMuNSAyLjk5OGEuNS41IDAgMDEtLjY1IDBsLTMuNS0yLjk5OGEuNS41IDAgMDEuNjUtLjc2TDEyIDEzLjg0MXoiIGZpbGw9IiM1QjYzNzIiLz48L3N2Zz4K);transform:rotate(180deg)}._headerLabel_2qf2w_38{text-align:left;overflow:hidden}._icon_2qf2w_43{margin-right:10px;width:20px;box-sizing:border-box;display:inline-block}._numberIcon_2qf2w_50{background-image:url(data:image/svg+xml;charset=utf8;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE3IDVINmEyIDIgMCAwIDAtMiAydjEwYTIgMiAwIDAgMCAyIDJoMTFhMiAyIDAgMCAwIDItMlY3YTIgMiAwIDAgMC0yLTJ6TTUgN2ExIDEgMCAwIDEgMS0xaDExYTEgMSAwIDAgMSAxIDF2MTBhMSAxIDAgMCAxLTEgMUg2YTEgMSAwIDAgMS0xLTFWN3ptNC41IDRoLjc2NmwtLjU3MiAySDguNWEuNS41IDAgMCAwIDAgMWguOTA5bC0uMzkgMS4zNjNhLjUuNSAwIDAgMCAuOTYyLjI3NEwxMC40NDkgMTRoMS45NmwtLjM5IDEuMzYzYS41LjUgMCAwIDAgLjk2Mi4yNzRMMTMuNDQ5IDE0SDE0LjVhLjUuNSAwIDAgMCAwLTFoLS43NjZsLjU3Mi0ySDE1LjVhLjUuNSAwIDAgMCAwLTFoLS45MDlsLjM5LTEuMzYzYS41LjUgMCAwIDAtLjk2Mi0uMjc0TDEzLjU1MSAxMGgtMS45NmwuMzktMS4zNjNhLjUuNSAwIDAgMC0uOTYyLS4yNzRMMTAuNTUxIDEwSDkuNWEuNS41IDAgMCAwIDAgMXptMy43NjYgMGgtMS45NmwtLjU3MiAyaDEuOTZsLjU3Mi0yeiIgZmlsbD0iIzVCNjM3MiIvPjwvc3ZnPgo=)}._dateIcon_2qf2w_54{background-image:url(data:image/svg+xml;charset=utf8;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTkgNVYzLjVhLjUuNSAwIDAgMSAxIDBWNWgzVjMuNWEuNS41IDAgMCAxIDEgMFY1aDNhMiAyIDAgMCAxIDIgMnYxMGEyIDIgMCAwIDEtMiAySDZhMiAyIDAgMCAxLTItMlY3YTIgMiAwIDAgMSAyLTJoM3ptMSAxaDN2LjVhLjUuNSAwIDAgMCAxIDBWNmgzYTEgMSAwIDAgMSAxIDF2MUg1VjdhMSAxIDAgMCAxIDEtMWgzdi41YS41LjUgMCAwIDAgMSAwVjZ6TTUgMTdWOWgxM3Y4YTEgMSAwIDAgMS0xIDFINmExIDEgMCAwIDEtMS0xem05LjUtNWgtNmEuNS41IDAgMCAxIDAtMWg2YS41LjUgMCAwIDEgMCAxem0tNiAyaDZhLjUuNSAwIDAgMCAwLTFoLTZhLjUuNSAwIDAgMCAwIDF6bTYgMmgtNmEuNS41IDAgMCAxIDAtMWg2YS41LjUgMCAwIDEgMCAxeiIgZmlsbD0iIzVCNjM3MiIvPjwvc3ZnPgo=)}._textIcon_2qf2w_58{background-image:url(data:image/svg+xml;charset=utf8;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTYgNWgxMWEyIDIgMCAwIDEgMiAydjEwYTIgMiAwIDAgMS0yIDJINmEyIDIgMCAwIDEtMi0yVjdhMiAyIDAgMCAxIDItMnptMCAxYTEgMSAwIDAgMC0xIDF2MTBhMSAxIDAgMCAwIDEgMWgxMWExIDEgMCAwIDAgMS0xVjdhMSAxIDAgMCAwLTEtMUg2em04IDEwSDlhLjUuNSAwIDAgMSAwLTFoMlY5SDguNWEuNS41IDAgMCAwLS41LjV2MmEuNS41IDAgMCAxLTEgMHYtMkExLjUgMS41IDAgMCAxIDguNSA4aDZBMS41IDEuNSAwIDAgMSAxNiA5LjV2MmEuNS41IDAgMCAxLTEgMHYtMmEuNS41IDAgMCAwLS41LS41SDEydjZoMmEuNS41IDAgMCAxIDAgMXoiIGZpbGw9IiM1QjYzNzIiLz48L3N2Zz4K)}._booleanIcon_2qf2w_62{background-image:url(data:image/svg+xml;charset=utf8;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE3IDVINmEyIDIgMCAwIDAtMiAydjEwYTIgMiAwIDAgMCAyIDJoMTFhMiAyIDAgMCAwIDItMlY3YTIgMiAwIDAgMC0yLTJ6TTUgN2ExIDEgMCAwIDEgMS0xaDExYTEgMSAwIDAgMSAxIDF2MTBhMSAxIDAgMCAxLTEgMUg2YTEgMSAwIDAgMS0xLTFWN3oiIGZpbGw9IiM1QjYzNzIiLz48cGF0aCBkPSJNOC44IDE1LjM5NGEuNS41IDAgMCAxLS4xLS43TDEzLjQyOCA4LjRhLjUuNSAwIDEgMSAuOC42TDkuNSAxNS4yOTRhLjUuNSAwIDAgMS0uNy4xeiIgZmlsbD0iIzVCNjM3MiIvPjxyZWN0IHg9IjYiIHk9IjgiIHdpZHRoPSI1IiBoZWlnaHQ9IjEiIHJ4PSIuNSIgZmlsbD0iIzVCNjM3MiIvPjxwYXRoIGQ9Ik04LjUgOGEuNS41IDAgMCAxIC41LjV2NGEuNS41IDAgMCAxLTEgMHYtNGEuNS41IDAgMCAxIC41LS41eiIgZmlsbD0iIzVCNjM3MiIvPjxyZWN0IHg9IjEzIiB5PSIxMiIgd2lkdGg9IjQiIGhlaWdodD0iMSIgcng9Ii41IiBmaWxsPSIjNUI2MzcyIi8+PHJlY3QgeD0iMTMiIHk9IjE0IiB3aWR0aD0iMyIgaGVpZ2h0PSIxIiByeD0iLjUiIGZpbGw9IiM1QjYzNzIiLz48cGF0aCBkPSJNMTMuNSAxMmEuNS41IDAgMCAxIC41LjV2NGEuNS41IDAgMCAxLTEgMHYtNGEuNS41IDAgMCAxIC41LS41eiIgZmlsbD0iIzVCNjM3MiIvPjwvc3ZnPgo=)}._sortIcon_2qf2w_66{position:absolute;right:0;width:24px;height:24px;background-repeat:no-repeat}._sortAscending_2qf2w_74._standard_2qf2w_29{background-image:url(data:image/svg+xml;charset=utf8;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjMxMyAxN2g3LjY2N2EuNDkuNDkgMCAwMS40NzkuNS40OS40OSAwIDAxLS40OC41SDQuMzE0YS40OS40OSAwIDAxLS40NzktLjVjMC0uMjc2LjIxNS0uNS40OC0uNXptNS43NS0zaC01Ljc1YS40OS40OSAwIDAwLS40NzkuNWMwIC4yNzYuMjE1LjUuNDguNWg1Ljc1YS40OS40OSAwIDAwLjQ3OC0uNS40OS40OSAwIDAwLS40NzktLjV6bS01Ljc1LTNoMy44MzNhLjQ5LjQ5IDAgMDEuNDguNS40OS40OSAwIDAxLS40OC41SDQuMzEzYS40OS40OSAwIDAxLS40NzktLjVjMC0uMjc2LjIxNS0uNS40OC0uNXptMC0zSDYuMjNhLjQ5LjQ5IDAgMDEuNDc5LjUuNDkuNDkgMCAwMS0uNDguNUg0LjMxNGEuNDkuNDkgMCAwMS0uNDc5LS41YzAtLjI3Ni4yMTUtLjUuNDgtLjV6bTEwLjU0MiAwYS40OS40OSAwIDAwLS40OC41djQuNzkzbC0yLjA1Ny0yLjE0N2EuNDY1LjQ2NSAwIDAwLS42NzggMCAuNTE1LjUxNSAwIDAwMCAuNzA4bDIuODY2IDIuOTlhLjQ2OC40NjggMCAwMC42OTYgMGwyLjg2Ni0yLjk5YS41MTYuNTE2IDAgMDAwLS43MDguNDY1LjQ2NSAwIDAwLS42NzggMGwtMi4wNTYgMi4xNDZWOC41YS40OS40OSAwIDAwLS40OC0uNXoiIGZpbGw9IiM1QzYzNzIiLz48L3N2Zz4K)}._sortDescending_2qf2w_78._standard_2qf2w_29{background-image:url(data:image/svg+xml;charset=utf8;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjMxMyA3aDcuNjY3YS40OS40OSAwIDAwLjQ3OS0uNS40OS40OSAwIDAwLS40OC0uNUg0LjMxNGEuNDkuNDkgMCAwMC0uNDc5LjVjMCAuMjc2LjIxNS41LjQ4LjV6bTUuNzUgM2gtNS43NWEuNDkuNDkgMCAwMS0uNDc5LS41YzAtLjI3Ni4yMTUtLjUuNDgtLjVoNS43NWEuNDkuNDkgMCAwMS40NzguNS40OS40OSAwIDAxLS40NzkuNXptLTUuNzUgM2gzLjgzM2EuNDkuNDkgMCAwMC40OC0uNS40OS40OSAwIDAwLS40OC0uNUg0LjMxM2EuNDkuNDkgMCAwMC0uNDc5LjVjMCAuMjc2LjIxNS41LjQ4LjV6bTAgM0g2LjIzYS40OS40OSAwIDAwLjQ3OS0uNS40OS40OSAwIDAwLS40OC0uNUg0LjMxNGEuNDkuNDkgMCAwMC0uNDc5LjVjMCAuMjc2LjIxNS41LjQ4LjV6bTEwLjU0MiAwYS40OS40OSAwIDAxLS40OC0uNXYtNC43OTNsLTIuMDU3IDIuMTQ3YS40NjUuNDY1IDAgMDEtLjY3OCAwIC41MTUuNTE1IDAgMDEwLS43MDhsMi44NjYtMi45OWEuNDY4LjQ2OCAwIDAxLjY5NiAwbDIuODY2IDIuOTlhLjUxNi41MTYgMCAwMTAgLjcwOC40NjUuNDY1IDAgMDEtLjY3OCAwbC0yLjA1Ni0yLjE0NlYxNS41YS40OS40OSAwIDAxLS40OC41eiIgZmlsbD0iIzVDNjM3MiIvPjwvc3ZnPgo=)}._sortAscending_2qf2w_74._caret_2qf2w_33{background-image:url(data:image/svg+xml;charset=utf8;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTExLjk5OSAxMy44NGwzLjE3NS0yLjcxOWEuNS41IDAgMDEuNjUuNzZsLTMuNSAyLjk5OGEuNS41IDAgMDEtLjY1IDBsLTMuNS0yLjk5OGEuNS41IDAgMDEuNjUtLjc2TDEyIDEzLjg0MXoiIGZpbGw9IiM1QjYzNzIiLz48L3N2Zz4K);transform:rotate(180deg)}._sortAscending_2qf2w_74._caret_2qf2w_33:hover{transform:rotate(0)}._sortDescending_2qf2w_78._caret_2qf2w_33{background-image:url(data:image/svg+xml;charset=utf8;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTExLjk5OSAxMy44NGwzLjE3NS0yLjcxOWEuNS41IDAgMDEuNjUuNzZsLTMuNSAyLjk5OGEuNS41IDAgMDEtLjY1IDBsLTMuNS0yLjk5OGEuNS41IDAgMDEuNjUtLjc2TDEyIDEzLjg0MXoiIGZpbGw9IiM1QjYzNzIiLz48L3N2Zz4K)}._sortDescending_2qf2w_78._caret_2qf2w_33:hover{transform:rotate(180deg)}._headerLabel_2qf2w_38{text-align:left;flex-grow:1}._headerLabel_2qf2w_38,._headerLabel_2qf2w_38 *{overflow:hidden;text-overflow:ellipsis}._icon_t30x8_1{width:24px;height:24px;margin-right:5px;box-sizing:border-box;display:inline-block;background-repeat:no-repeat;flex-grow:0}._numberIcon_t30x8_11{background-image:url(data:image/svg+xml;charset=utf8;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE3IDVINmEyIDIgMCAwIDAtMiAydjEwYTIgMiAwIDAgMCAyIDJoMTFhMiAyIDAgMCAwIDItMlY3YTIgMiAwIDAgMC0yLTJ6TTUgN2ExIDEgMCAwIDEgMS0xaDExYTEgMSAwIDAgMSAxIDF2MTBhMSAxIDAgMCAxLTEgMUg2YTEgMSAwIDAgMS0xLTFWN3ptNC41IDRoLjc2NmwtLjU3MiAySDguNWEuNS41IDAgMCAwIDAgMWguOTA5bC0uMzkgMS4zNjNhLjUuNSAwIDAgMCAuOTYyLjI3NEwxMC40NDkgMTRoMS45NmwtLjM5IDEuMzYzYS41LjUgMCAwIDAgLjk2Mi4yNzRMMTMuNDQ5IDE0SDE0LjVhLjUuNSAwIDAgMCAwLTFoLS43NjZsLjU3Mi0ySDE1LjVhLjUuNSAwIDAgMCAwLTFoLS45MDlsLjM5LTEuMzYzYS41LjUgMCAwIDAtLjk2Mi0uMjc0TDEzLjU1MSAxMGgtMS45NmwuMzktMS4zNjNhLjUuNSAwIDAgMC0uOTYyLS4yNzRMMTAuNTUxIDEwSDkuNWEuNS41IDAgMCAwIDAgMXptMy43NjYgMGgtMS45NmwtLjU3MiAyaDEuOTZsLjU3Mi0yeiIgZmlsbD0iIzVCNjM3MiIvPjwvc3ZnPgo=)}._dateIcon_t30x8_15{background-image:url(data:image/svg+xml;charset=utf8;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTkgNVYzLjVhLjUuNSAwIDAgMSAxIDBWNWgzVjMuNWEuNS41IDAgMCAxIDEgMFY1aDNhMiAyIDAgMCAxIDIgMnYxMGEyIDIgMCAwIDEtMiAySDZhMiAyIDAgMCAxLTItMlY3YTIgMiAwIDAgMSAyLTJoM3ptMSAxaDN2LjVhLjUuNSAwIDAgMCAxIDBWNmgzYTEgMSAwIDAgMSAxIDF2MUg1VjdhMSAxIDAgMCAxIDEtMWgzdi41YS41LjUgMCAwIDAgMSAwVjZ6TTUgMTdWOWgxM3Y4YTEgMSAwIDAgMS0xIDFINmExIDEgMCAwIDEtMS0xem05LjUtNWgtNmEuNS41IDAgMCAxIDAtMWg2YS41LjUgMCAwIDEgMCAxem0tNiAyaDZhLjUuNSAwIDAgMCAwLTFoLTZhLjUuNSAwIDAgMCAwIDF6bTYgMmgtNmEuNS41IDAgMCAxIDAtMWg2YS41LjUgMCAwIDEgMCAxeiIgZmlsbD0iIzVCNjM3MiIvPjwvc3ZnPgo=)}._textIcon_t30x8_19{background-image:url(data:image/svg+xml;charset=utf8;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTYgNWgxMWEyIDIgMCAwIDEgMiAydjEwYTIgMiAwIDAgMS0yIDJINmEyIDIgMCAwIDEtMi0yVjdhMiAyIDAgMCAxIDItMnptMCAxYTEgMSAwIDAgMC0xIDF2MTBhMSAxIDAgMCAwIDEgMWgxMWExIDEgMCAwIDAgMS0xVjdhMSAxIDAgMCAwLTEtMUg2em04IDEwSDlhLjUuNSAwIDAgMSAwLTFoMlY5SDguNWEuNS41IDAgMCAwLS41LjV2MmEuNS41IDAgMCAxLTEgMHYtMkExLjUgMS41IDAgMCAxIDguNSA4aDZBMS41IDEuNSAwIDAgMSAxNiA5LjV2MmEuNS41IDAgMCAxLTEgMHYtMmEuNS41IDAgMCAwLS41LS41SDEydjZoMmEuNS41IDAgMCAxIDAgMXoiIGZpbGw9IiM1QjYzNzIiLz48L3N2Zz4K)}._booleanIcon_t30x8_23{background-image:url(data:image/svg+xml;charset=utf8;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE3IDVINmEyIDIgMCAwIDAtMiAydjEwYTIgMiAwIDAgMCAyIDJoMTFhMiAyIDAgMCAwIDItMlY3YTIgMiAwIDAgMC0yLTJ6TTUgN2ExIDEgMCAwIDEgMS0xaDExYTEgMSAwIDAgMSAxIDF2MTBhMSAxIDAgMCAxLTEgMUg2YTEgMSAwIDAgMS0xLTFWN3oiIGZpbGw9IiM1QjYzNzIiLz48cGF0aCBkPSJNOC44IDE1LjM5NGEuNS41IDAgMCAxLS4xLS43TDEzLjQyOCA4LjRhLjUuNSAwIDEgMSAuOC42TDkuNSAxNS4yOTRhLjUuNSAwIDAgMS0uNy4xeiIgZmlsbD0iIzVCNjM3MiIvPjxyZWN0IHg9IjYiIHk9IjgiIHdpZHRoPSI1IiBoZWlnaHQ9IjEiIHJ4PSIuNSIgZmlsbD0iIzVCNjM3MiIvPjxwYXRoIGQ9Ik04LjUgOGEuNS41IDAgMCAxIC41LjV2NGEuNS41IDAgMCAxLTEgMHYtNGEuNS41IDAgMCAxIC41LS41eiIgZmlsbD0iIzVCNjM3MiIvPjxyZWN0IHg9IjEzIiB5PSIxMiIgd2lkdGg9IjQiIGhlaWdodD0iMSIgcng9Ii41IiBmaWxsPSIjNUI2MzcyIi8+PHJlY3QgeD0iMTMiIHk9IjE0IiB3aWR0aD0iMyIgaGVpZ2h0PSIxIiByeD0iLjUiIGZpbGw9IiM1QjYzNzIiLz48cGF0aCBkPSJNMTMuNSAxMmEuNS41IDAgMCAxIC41LjV2NGEuNS41IDAgMCAxLTEgMHYtNGEuNS41IDAgMCAxIC41LS41eiIgZmlsbD0iIzVCNjM3MiIvPjwvc3ZnPgo=)}._component_1rw9b_1{flex-grow:1;font-family:Open Sans}.csdk-drilldown-hierarchy-nested-menu-item .csdk-menu-item-content{position:relative;padding-left:13px}.csdk-drilldown-hierarchy-nested-menu-item .csdk-menu-item-content:before{top:2px;left:0;position:absolute;content:"";display:block;height:14px;width:1px;background:#c3c3c3}.react-datepicker__year-read-view--down-arrow,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__navigation-icon:before{border-color:#ccc;border-style:solid;border-width:3px 3px 0 0;content:"";display:block;height:9px;position:absolute;top:6px;width:9px}.react-datepicker-wrapper{display:inline-block;padding:0;border:0}.react-datepicker{font-family:Helvetica Neue,helvetica,arial,sans-serif;font-size:.8rem;background-color:#fff;color:#000;border:1px solid #aeaeae;border-radius:.3rem;display:inline-block;position:relative;line-height:initial}.react-datepicker--time-only .react-datepicker__time-container{border-left:0}.react-datepicker--time-only .react-datepicker__time,.react-datepicker--time-only .react-datepicker__time-box{border-bottom-left-radius:.3rem;border-bottom-right-radius:.3rem}.react-datepicker-popper{z-index:1;line-height:0}.react-datepicker-popper .react-datepicker__triangle{stroke:#aeaeae}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle{fill:#f0f0f0;color:#f0f0f0}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle{fill:#fff;color:#fff}.react-datepicker__header{text-align:center;background-color:#f0f0f0;border-bottom:1px solid #aeaeae;border-top-left-radius:.3rem;padding:8px 0;position:relative}.react-datepicker__header--time{padding-bottom:8px;padding-left:5px;padding-right:5px}.react-datepicker__header--time:not(.react-datepicker__header--time--only){border-top-left-radius:0}.react-datepicker__header:not(.react-datepicker__header--has-time-select){border-top-right-radius:.3rem}.react-datepicker__year-dropdown-container--select,.react-datepicker__month-dropdown-container--select,.react-datepicker__month-year-dropdown-container--select,.react-datepicker__year-dropdown-container--scroll,.react-datepicker__month-dropdown-container--scroll,.react-datepicker__month-year-dropdown-container--scroll{display:inline-block;margin:0 15px}.react-datepicker__current-month,.react-datepicker-time__header,.react-datepicker-year-header{margin-top:0;color:#000;font-weight:700;font-size:.944rem}h2.react-datepicker__current-month{padding:0;margin:0}.react-datepicker-time__header{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.react-datepicker__navigation{align-items:center;background:none;display:flex;justify-content:center;text-align:center;cursor:pointer;position:absolute;top:2px;padding:0;border:none;z-index:1;height:32px;width:32px;text-indent:-999em;overflow:hidden}.react-datepicker__navigation--previous{left:2px}.react-datepicker__navigation--next{right:2px}.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button){right:85px}.react-datepicker__navigation--years{position:relative;top:0;display:block;margin-left:auto;margin-right:auto}.react-datepicker__navigation--years-previous{top:4px}.react-datepicker__navigation--years-upcoming{top:-4px}.react-datepicker__navigation:hover *:before{border-color:#a6a6a6}.react-datepicker__navigation-icon{position:relative;top:-1px;font-size:20px;width:0}.react-datepicker__navigation-icon--next{left:-2px}.react-datepicker__navigation-icon--next:before{transform:rotate(45deg);left:-7px}.react-datepicker__navigation-icon--previous{right:-2px}.react-datepicker__navigation-icon--previous:before{transform:rotate(225deg);right:-7px}.react-datepicker__month-container{float:left}.react-datepicker__year{margin:.4rem;text-align:center}.react-datepicker__year-wrapper{display:flex;flex-wrap:wrap;max-width:180px}.react-datepicker__year .react-datepicker__year-text{display:inline-block;width:4rem;margin:2px}.react-datepicker__month{margin:.4rem;text-align:center}.react-datepicker__month .react-datepicker__month-text,.react-datepicker__month .react-datepicker__quarter-text{display:inline-block;width:4rem;margin:2px}.react-datepicker__input-time-container{clear:both;width:100%;float:left;margin:5px 0 10px 15px;text-align:left}.react-datepicker__input-time-container .react-datepicker-time__caption,.react-datepicker__input-time-container .react-datepicker-time__input-container{display:inline-block}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input{display:inline-block;margin-left:10px}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input{width:auto}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-inner-spin-button,.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]{-moz-appearance:textfield}.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__delimiter{margin-left:5px;display:inline-block}.react-datepicker__time-container{float:right;border-left:1px solid #aeaeae;width:85px}.react-datepicker__time-container--with-today-button{display:inline;border:1px solid #aeaeae;border-radius:.3rem;position:absolute;right:-87px;top:0}.react-datepicker__time-container .react-datepicker__time{position:relative;background:#fff;border-bottom-right-radius:.3rem}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box{width:85px;overflow-x:hidden;margin:0 auto;text-align:center;border-bottom-right-radius:.3rem}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list{list-style:none;margin:0;height:calc(195px + .85rem);overflow-y:scroll;padding-right:0;padding-left:0;width:100%;box-sizing:content-box}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item{height:30px;padding:5px 10px;white-space:nowrap}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover{cursor:pointer;background-color:#f0f0f0}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected{background-color:#216ba5;color:#fff;font-weight:700}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover{background-color:#216ba5}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled{color:#ccc}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover{cursor:default;background-color:transparent}.react-datepicker__week-number{color:#ccc;display:inline-block;width:1.7rem;line-height:1.7rem;text-align:center;margin:.166rem}.react-datepicker__week-number.react-datepicker__week-number--clickable{cursor:pointer}.react-datepicker__week-number.react-datepicker__week-number--clickable:not(.react-datepicker__week-number--selected,.react-datepicker__week-number--keyboard-selected):hover{border-radius:.3rem;background-color:#f0f0f0}.react-datepicker__week-number--selected{border-radius:.3rem;background-color:#216ba5;color:#fff}.react-datepicker__week-number--selected:hover{background-color:#1d5d90}.react-datepicker__week-number--keyboard-selected{border-radius:.3rem;background-color:#2a87d0;color:#fff}.react-datepicker__week-number--keyboard-selected:hover{background-color:#1d5d90}.react-datepicker__day-names{white-space:nowrap;margin-bottom:-8px}.react-datepicker__week{white-space:nowrap}.react-datepicker__day-name,.react-datepicker__day,.react-datepicker__time-name{color:#000;display:inline-block;width:1.7rem;line-height:1.7rem;text-align:center;margin:.166rem}.react-datepicker__day,.react-datepicker__month-text,.react-datepicker__quarter-text,.react-datepicker__year-text{cursor:pointer}.react-datepicker__day:hover,.react-datepicker__month-text:hover,.react-datepicker__quarter-text:hover,.react-datepicker__year-text:hover{border-radius:.3rem;background-color:#f0f0f0}.react-datepicker__day--today,.react-datepicker__month-text--today,.react-datepicker__quarter-text--today,.react-datepicker__year-text--today{font-weight:700}.react-datepicker__day--highlighted,.react-datepicker__month-text--highlighted,.react-datepicker__quarter-text--highlighted,.react-datepicker__year-text--highlighted{border-radius:.3rem;background-color:#3dcc4a;color:#fff}.react-datepicker__day--highlighted:hover,.react-datepicker__month-text--highlighted:hover,.react-datepicker__quarter-text--highlighted:hover,.react-datepicker__year-text--highlighted:hover{background-color:#32be3f}.react-datepicker__day--highlighted-custom-1,.react-datepicker__month-text--highlighted-custom-1,.react-datepicker__quarter-text--highlighted-custom-1,.react-datepicker__year-text--highlighted-custom-1{color:#f0f}.react-datepicker__day--highlighted-custom-2,.react-datepicker__month-text--highlighted-custom-2,.react-datepicker__quarter-text--highlighted-custom-2,.react-datepicker__year-text--highlighted-custom-2{color:green}.react-datepicker__day--holidays,.react-datepicker__month-text--holidays,.react-datepicker__quarter-text--holidays,.react-datepicker__year-text--holidays{position:relative;border-radius:.3rem;background-color:#ff6803;color:#fff}.react-datepicker__day--holidays .overlay,.react-datepicker__month-text--holidays .overlay,.react-datepicker__quarter-text--holidays .overlay,.react-datepicker__year-text--holidays .overlay{position:absolute;bottom:100%;left:50%;transform:translate(-50%);background-color:#333;color:#fff;padding:4px;border-radius:4px;white-space:nowrap;visibility:hidden;opacity:0;transition:visibility 0s,opacity .3s ease-in-out}.react-datepicker__day--holidays:hover,.react-datepicker__month-text--holidays:hover,.react-datepicker__quarter-text--holidays:hover,.react-datepicker__year-text--holidays:hover{background-color:#cf5300}.react-datepicker__day--holidays:hover .overlay,.react-datepicker__month-text--holidays:hover .overlay,.react-datepicker__quarter-text--holidays:hover .overlay,.react-datepicker__year-text--holidays:hover .overlay{visibility:visible;opacity:1}.react-datepicker__day--selected,.react-datepicker__day--in-selecting-range,.react-datepicker__day--in-range,.react-datepicker__month-text--selected,.react-datepicker__month-text--in-selecting-range,.react-datepicker__month-text--in-range,.react-datepicker__quarter-text--selected,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__quarter-text--in-range,.react-datepicker__year-text--selected,.react-datepicker__year-text--in-selecting-range,.react-datepicker__year-text--in-range{border-radius:.3rem;background-color:#216ba5;color:#fff}.react-datepicker__day--selected:hover,.react-datepicker__day--in-selecting-range:hover,.react-datepicker__day--in-range:hover,.react-datepicker__month-text--selected:hover,.react-datepicker__month-text--in-selecting-range:hover,.react-datepicker__month-text--in-range:hover,.react-datepicker__quarter-text--selected:hover,.react-datepicker__quarter-text--in-selecting-range:hover,.react-datepicker__quarter-text--in-range:hover,.react-datepicker__year-text--selected:hover,.react-datepicker__year-text--in-selecting-range:hover,.react-datepicker__year-text--in-range:hover{background-color:#1d5d90}.react-datepicker__day--keyboard-selected,.react-datepicker__month-text--keyboard-selected,.react-datepicker__quarter-text--keyboard-selected,.react-datepicker__year-text--keyboard-selected{border-radius:.3rem;background-color:#bad9f1;color:#000}.react-datepicker__day--keyboard-selected:hover,.react-datepicker__month-text--keyboard-selected:hover,.react-datepicker__quarter-text--keyboard-selected:hover,.react-datepicker__year-text--keyboard-selected:hover{background-color:#1d5d90}.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range,.react-datepicker__month-text--in-range,.react-datepicker__quarter-text--in-range,.react-datepicker__year-text--in-range),.react-datepicker__month-text--in-selecting-range:not(.react-datepicker__day--in-range,.react-datepicker__month-text--in-range,.react-datepicker__quarter-text--in-range,.react-datepicker__year-text--in-range),.react-datepicker__quarter-text--in-selecting-range:not(.react-datepicker__day--in-range,.react-datepicker__month-text--in-range,.react-datepicker__quarter-text--in-range,.react-datepicker__year-text--in-range),.react-datepicker__year-text--in-selecting-range:not(.react-datepicker__day--in-range,.react-datepicker__month-text--in-range,.react-datepicker__quarter-text--in-range,.react-datepicker__year-text--in-range){background-color:#216ba580}.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__year-text--in-selecting-range),.react-datepicker__year--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__year-text--in-selecting-range),.react-datepicker__month--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__year-text--in-selecting-range),.react-datepicker__year--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__year-text--in-selecting-range),.react-datepicker__month--selecting-range .react-datepicker__quarter-text--in-range:not(.react-datepicker__day--in-selecting-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__year-text--in-selecting-range),.react-datepicker__year--selecting-range .react-datepicker__quarter-text--in-range:not(.react-datepicker__day--in-selecting-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__year-text--in-selecting-range),.react-datepicker__month--selecting-range .react-datepicker__year-text--in-range:not(.react-datepicker__day--in-selecting-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__year-text--in-selecting-range),.react-datepicker__year--selecting-range .react-datepicker__year-text--in-range:not(.react-datepicker__day--in-selecting-range,.react-datepicker__month-text--in-selecting-range,.react-datepicker__quarter-text--in-selecting-range,.react-datepicker__year-text--in-selecting-range){background-color:#f0f0f0;color:#000}.react-datepicker__day--disabled,.react-datepicker__month-text--disabled,.react-datepicker__quarter-text--disabled,.react-datepicker__year-text--disabled{cursor:default;color:#ccc}.react-datepicker__day--disabled:hover,.react-datepicker__month-text--disabled:hover,.react-datepicker__quarter-text--disabled:hover,.react-datepicker__year-text--disabled:hover{background-color:transparent}.react-datepicker__day--disabled .overlay,.react-datepicker__month-text--disabled .overlay,.react-datepicker__quarter-text--disabled .overlay,.react-datepicker__year-text--disabled .overlay{position:absolute;bottom:70%;left:50%;transform:translate(-50%);background-color:#333;color:#fff;padding:4px;border-radius:4px;white-space:nowrap;visibility:hidden;opacity:0;transition:visibility 0s,opacity .3s ease-in-out}.react-datepicker__input-container{position:relative;display:inline-block;width:100%}.react-datepicker__input-container .react-datepicker__calendar-icon{position:absolute;padding:.5rem;box-sizing:content-box}.react-datepicker__view-calendar-icon input{padding:6px 10px 5px 25px}.react-datepicker__year-read-view,.react-datepicker__month-read-view,.react-datepicker__month-year-read-view{border:1px solid transparent;border-radius:.3rem;position:relative}.react-datepicker__year-read-view:hover,.react-datepicker__month-read-view:hover,.react-datepicker__month-year-read-view:hover{cursor:pointer}.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow{border-top-color:#b3b3b3}.react-datepicker__year-read-view--down-arrow,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow{transform:rotate(135deg);right:-16px;top:0}.react-datepicker__year-dropdown,.react-datepicker__month-dropdown,.react-datepicker__month-year-dropdown{background-color:#f0f0f0;position:absolute;width:50%;left:25%;top:30px;z-index:1;text-align:center;border-radius:.3rem;border:1px solid #aeaeae}.react-datepicker__year-dropdown:hover,.react-datepicker__month-dropdown:hover,.react-datepicker__month-year-dropdown:hover{cursor:pointer}.react-datepicker__year-dropdown--scrollable,.react-datepicker__month-dropdown--scrollable,.react-datepicker__month-year-dropdown--scrollable{height:150px;overflow-y:scroll}.react-datepicker__year-option,.react-datepicker__month-option,.react-datepicker__month-year-option{line-height:20px;width:100%;display:block;margin-left:auto;margin-right:auto}.react-datepicker__year-option:first-of-type,.react-datepicker__month-option:first-of-type,.react-datepicker__month-year-option:first-of-type{border-top-left-radius:.3rem;border-top-right-radius:.3rem}.react-datepicker__year-option:last-of-type,.react-datepicker__month-option:last-of-type,.react-datepicker__month-year-option:last-of-type{-webkit-user-select:none;-moz-user-select:none;user-select:none;border-bottom-left-radius:.3rem;border-bottom-right-radius:.3rem}.react-datepicker__year-option:hover,.react-datepicker__month-option:hover,.react-datepicker__month-year-option:hover{background-color:#ccc}.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming{border-bottom-color:#b3b3b3}.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous{border-top-color:#b3b3b3}.react-datepicker__year-option--selected,.react-datepicker__month-option--selected,.react-datepicker__month-year-option--selected{position:absolute;left:15px}.react-datepicker__close-icon{cursor:pointer;background-color:transparent;border:0;outline:0;padding:0 6px 0 0;position:absolute;top:0;right:0;height:100%;display:table-cell;vertical-align:middle}.react-datepicker__close-icon:after{cursor:pointer;background-color:#216ba5;color:#fff;border-radius:50%;height:16px;width:16px;padding:2px;font-size:12px;line-height:1;text-align:center;display:table-cell;vertical-align:middle;content:"×"}.react-datepicker__close-icon--disabled{cursor:default}.react-datepicker__close-icon--disabled:after{cursor:default;background-color:#ccc}.react-datepicker__today-button{background:#f0f0f0;border-top:1px solid #aeaeae;cursor:pointer;text-align:center;font-weight:700;padding:5px 0;clear:left}.react-datepicker__portal{position:fixed;width:100vw;height:100vh;background-color:#000c;left:0;top:0;justify-content:center;align-items:center;display:flex;z-index:2147483647}.react-datepicker__portal .react-datepicker__day-name,.react-datepicker__portal .react-datepicker__day,.react-datepicker__portal .react-datepicker__time-name{width:3rem;line-height:3rem}@media (max-width: 400px),(max-height: 550px){.react-datepicker__portal .react-datepicker__day-name,.react-datepicker__portal .react-datepicker__day,.react-datepicker__portal .react-datepicker__time-name{width:2rem;line-height:2rem}}.react-datepicker__portal .react-datepicker__current-month,.react-datepicker__portal .react-datepicker-time__header{font-size:1.44rem}.react-datepicker__children-container{width:13.8rem;margin:.4rem;padding-right:.2rem;padding-left:.2rem;height:auto}.react-datepicker__aria-live{position:absolute;clip-path:circle(0);border:0;height:1px;margin:-1px;overflow:hidden;padding:0;width:1px;white-space:nowrap}.react-datepicker__calendar-icon{width:1em;height:1em;vertical-align:-.125em}')),document.head.appendChild(e)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
